/* tslint:disable */
/* eslint-disable */
/**
 * Api Alarmero
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import type {ExtendedAxiosRequestConfig} from './common';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, setBearerAuthToFormData } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export const defaultExtendedAxiosRequestConfig : ExtendedAxiosRequestConfig = {extensions: {}}

/**
 * 
 * @export
 * @interface ActivosActuacionRm
 */
export interface ActivosActuacionRm {
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Estado': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'EstadoAgrupacion': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Partner': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'CodigoPostal': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'NpedidoXcustomer': string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'NoportunidadXcustomer': string;
    /**
     * 
     * @type {number}
     * @memberof ActivosActuacionRm
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {number}
     * @memberof ActivosActuacionRm
     */
    'Potencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Zona': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'IdUbicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRm
     */
    'Ubicacion': string | null;
}
/**
 * 
 * @export
 * @interface ActivosActuacionRmListResponseDTO
 */
export interface ActivosActuacionRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ActivosActuacionRm>}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'Data'?: Array<ActivosActuacionRm>;
    /**
     * 
     * @type {any}
     * @memberof ActivosActuacionRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ActualizarPlanificacionTecnicoInspeccionVisualModel
 */
export interface ActualizarPlanificacionTecnicoInspeccionVisualModel {
    /**
     * 
     * @type {string}
     * @memberof ActualizarPlanificacionTecnicoInspeccionVisualModel
     */
    'IdTecnico': string;
    /**
     * 
     * @type {string}
     * @memberof ActualizarPlanificacionTecnicoInspeccionVisualModel
     */
    'FechaProgramada': string;
    /**
     * 
     * @type {Array<InspeccionVisualPlanificadaModel>}
     * @memberof ActualizarPlanificacionTecnicoInspeccionVisualModel
     */
    'InspeccionesVisuales': Array<InspeccionVisualPlanificadaModel>;
}
/**
 * 
 * @export
 * @interface AddCargadoresUbicacionModel
 */
export interface AddCargadoresUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof AddCargadoresUbicacionModel
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddCargadoresUbicacionModel
     */
    'IdsCargadores': Array<string>;
}
/**
 * 
 * @export
 * @interface AddSuscripcionPorUsuarioModel
 */
export interface AddSuscripcionPorUsuarioModel {
    /**
     * 
     * @type {string}
     * @memberof AddSuscripcionPorUsuarioModel
     */
    'IdUsuario': string | null;
    /**
     * 
     * @type {string}
     * @memberof AddSuscripcionPorUsuarioModel
     */
    'Email': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddSuscripcionPorUsuarioModel
     */
    'IdsTenants': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddSuscripcionPorUsuarioModel
     */
    'IdsCargadores': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AddSuscripcionPorUsuarioModel
     */
    'SuscritoHorario': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddSuscripcionPorUsuarioModel
     */
    'SuscritoAlarmas': boolean;
}
/**
 * 
 * @export
 * @interface AdjuntoActuacionRm
 */
export interface AdjuntoActuacionRm {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoActuacionRm
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoActuacionRm
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoActuacionRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface AdjuntoCentroTransformacionModel
 */
export interface AdjuntoCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'IdTipoFicheroAdjuntoOca': number;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'TipoFicheroCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'TipoFicheroDenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'NombreFichero': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'UrlFichero': string;
    /**
     * 
     * @type {FicheroAdjuntoUbicacionOrigenEnum}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'Origen': FicheroAdjuntoUbicacionOrigenEnum;
    /**
     * 
     * @type {Date}
     * @memberof AdjuntoCentroTransformacionModel
     */
    'FechaAlta': Date;
}


/**
 * 
 * @export
 * @interface AdjuntoCentroTransformacionModelListResponseDTO
 */
export interface AdjuntoCentroTransformacionModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<AdjuntoCentroTransformacionModel>}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'Data'?: Array<AdjuntoCentroTransformacionModel>;
    /**
     * 
     * @type {any}
     * @memberof AdjuntoCentroTransformacionModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface AdjuntoIntevencionModel
 */
export interface AdjuntoIntevencionModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoIntevencionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoIntevencionModel
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoAdjuntoIntervencionEnum}
     * @memberof AdjuntoIntevencionModel
     */
    'Tipo': TipoAdjuntoIntervencionEnum;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoIntevencionModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoIntevencionModel
     */
    'Descripcion': string | null;
}


/**
 * 
 * @export
 * @interface AdjuntoMensajeModel
 */
export interface AdjuntoMensajeModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoMensajeModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoMensajeModel
     */
    'Url': string;
}
/**
 * 
 * @export
 * @interface AdjuntoPartnerModel
 */
export interface AdjuntoPartnerModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoPartnerModel
     */
    'Id': string;
    /**
     * 
     * @type {CategoriaAdjuntoPartnerApiEnum}
     * @memberof AdjuntoPartnerModel
     */
    'Categoria': CategoriaAdjuntoPartnerApiEnum;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoPartnerModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoPartnerModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoPartnerModel
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdjuntoPartnerModel
     */
    'FechaAdjunto': Date;
}


/**
 * 
 * @export
 * @interface AdjuntoPartnerTemporalModel
 */
export interface AdjuntoPartnerTemporalModel {
    /**
     * 
     * @type {CategoriaAdjuntoPartnerApiEnum}
     * @memberof AdjuntoPartnerTemporalModel
     */
    'Categoria': CategoriaAdjuntoPartnerApiEnum;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoPartnerTemporalModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoPartnerTemporalModel
     */
    'Url': string;
}


/**
 * 
 * @export
 * @interface AdjuntoTicketRm
 */
export interface AdjuntoTicketRm {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoTicketRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoTicketRm
     */
    'IdTicket': string;
    /**
     * 
     * @type {CategoriaAdjuntoTicketEnum}
     * @memberof AdjuntoTicketRm
     */
    'IdCategoria': CategoriaAdjuntoTicketEnum;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoTicketRm
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoTicketRm
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoTicketRm
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdjuntoTicketRm
     */
    'FechaAdjunto': Date;
}


/**
 * 
 * @export
 * @interface AdjuntoUbicacionModel
 */
export interface AdjuntoUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoUbicacionModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof AdjuntoUbicacionModel
     */
    'IdTipoFicheroAdjuntoOca': number;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoUbicacionModel
     */
    'TipoFicheroCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoUbicacionModel
     */
    'TipoFicheroDenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoUbicacionModel
     */
    'NombreFichero': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoUbicacionModel
     */
    'UrlFichero': string;
    /**
     * 
     * @type {FicheroAdjuntoUbicacionOrigenEnum}
     * @memberof AdjuntoUbicacionModel
     */
    'Origen': FicheroAdjuntoUbicacionOrigenEnum;
    /**
     * 
     * @type {Date}
     * @memberof AdjuntoUbicacionModel
     */
    'FechaAlta': Date;
}


/**
 * 
 * @export
 * @interface AdjuntoUbicacionModelListResponseDTO
 */
export interface AdjuntoUbicacionModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<AdjuntoUbicacionModel>}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'Data'?: Array<AdjuntoUbicacionModel>;
    /**
     * 
     * @type {any}
     * @memberof AdjuntoUbicacionModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface AdjuntoVisitaModel
 */
export interface AdjuntoVisitaModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoVisitaModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof AdjuntoVisitaModel
     */
    'IdTipoFicheroAdjuntoOca': number;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoVisitaModel
     */
    'TipoFicheroCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoVisitaModel
     */
    'TipoFicheroDenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoVisitaModel
     */
    'NombreFichero': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoVisitaModel
     */
    'UrlFichero': string;
    /**
     * 
     * @type {Date}
     * @memberof AdjuntoVisitaModel
     */
    'FechaAlta': Date;
}
/**
 * 
 * @export
 * @interface AdjuntoVisitaModelListResponseDTO
 */
export interface AdjuntoVisitaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<AdjuntoVisitaModel>}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'Data'?: Array<AdjuntoVisitaModel>;
    /**
     * 
     * @type {any}
     * @memberof AdjuntoVisitaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface AsignarFechaActuacionModel
 */
export interface AsignarFechaActuacionModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof AsignarFechaActuacionModel
     */
    'IdActuaciones': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AsignarFechaActuacionModel
     */
    'Fecha': string;
}
/**
 * 
 * @export
 * @interface AsignarPrevisionActuacionExternoModel
 */
export interface AsignarPrevisionActuacionExternoModel {
    /**
     * 
     * @type {string}
     * @memberof AsignarPrevisionActuacionExternoModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof AsignarPrevisionActuacionExternoModel
     */
    'FechaActuacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof AsignarPrevisionActuacionExternoModel
     */
    'IdUsuarioTecnico': string;
}
/**
 * 
 * @export
 * @interface AsignarTecnicoActuacionModel
 */
export interface AsignarTecnicoActuacionModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof AsignarTecnicoActuacionModel
     */
    'IdActuaciones': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AsignarTecnicoActuacionModel
     */
    'IdTecnico': string;
}
/**
 * 
 * @export
 * @interface B2cInstalacionRm
 */
export interface B2cInstalacionRm {
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'IdImportacionMes': string;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'Mes': number;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'IdPds': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'PartnerNombre': string;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'PartnerExcel': string;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'NumeroFilaExcel': number;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'Oportunidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'WorkOrder': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'Acuerdo': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'Pod': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'Metros': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'PackCliente': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'FacturadoCliente': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'Pack': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'PackImporte': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'Meter40': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'ImporteCie': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'CaloHormigon': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'ImporteCalosHormigon': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'CaloLadrillo': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'ImporteCalosLadrillo': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'PicaTomaTierra': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'ImportePicaTomaTierra': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'Juicemeter301': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'TieneOtrosExtras': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'ImporteOtrosExtras': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'ImporteTotalSinPenalizacion': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'Penalizacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cInstalacionRm
     */
    'ImporteTotalConPenalizacion': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'OkKoGestor': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'OkKoValidacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'OkKoFactJlr': string | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cInstalacionRm
     */
    'FechaInstalacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof B2cInstalacionRm
     */
    'TriMono': string | null;
}
/**
 * 
 * @export
 * @interface B2cMesImportadoRm
 */
export interface B2cMesImportadoRm {
    /**
     * 
     * @type {number}
     * @memberof B2cMesImportadoRm
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof B2cMesImportadoRm
     */
    'Mes': number;
    /**
     * 
     * @type {string}
     * @memberof B2cMesImportadoRm
     */
    'Label': string;
}
/**
 * 
 * @export
 * @interface B2cMesImportadoRmListResponseDTO
 */
export interface B2cMesImportadoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<B2cMesImportadoRm>}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'Data'?: Array<B2cMesImportadoRm>;
    /**
     * 
     * @type {any}
     * @memberof B2cMesImportadoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface B2cPdteC3Rm
 */
export interface B2cPdteC3Rm {
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'IdImportacionMes': string;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'Mes': number;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'IdPds': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'PartnerNombre': string;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'PartnerExcel': string;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'NumeroFilaExcel': number;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'Oportunidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'WorkOrder': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'Acuerdo': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'Metros': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'FacturadoCliente': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'Pack': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'Meter40': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'ImporteCie': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'CaloHormigon': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'ImporteCalosHormigon': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'CaloLadrillo': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'ImporteCalosLadrillo': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'PicaTomaTierra': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'ImportePicaTomaTierra': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'Juicemeter301': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'Antena': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'TieneOtrosExtras': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'ImporteOtrosExtras': number | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'ImporteTotalSinPenalizacion': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'Penalizacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cPdteC3Rm
     */
    'ImporteTotalConPenalizacion': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'OkKoGestor': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'OkKoValidacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cPdteC3Rm
     */
    'OkKoFactJlr': string | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cPdteC3Rm
     */
    'FechaInstalacion': Date | null;
}
/**
 * 
 * @export
 * @interface B2cReparacionRm
 */
export interface B2cReparacionRm {
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'IdImportacionMes': string;
    /**
     * 
     * @type {number}
     * @memberof B2cReparacionRm
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof B2cReparacionRm
     */
    'Mes': number;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'IdPds': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'PartnerNombre': string;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'PartnerExcel': string;
    /**
     * 
     * @type {number}
     * @memberof B2cReparacionRm
     */
    'NumeroFilaExcel': number;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'NumeroOrdenTrabajo': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'Cuenta': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'TipoSolicitudServicio': string | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cReparacionRm
     */
    'FechaFinalizacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cReparacionRm
     */
    'FechaCreacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cReparacionRm
     */
    'AssignmentDate': Date | null;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'Comentarios': string | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cReparacionRm
     */
    'FechaInstalacionActivo': Date | null;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'Activo': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'GarantiaPds': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cReparacionRm
     */
    'Importe': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cReparacionRm
     */
    'OkKo': string | null;
}
/**
 * 
 * @export
 * @interface B2cVisitaRm
 */
export interface B2cVisitaRm {
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'IdImportacionMes': string;
    /**
     * 
     * @type {number}
     * @memberof B2cVisitaRm
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof B2cVisitaRm
     */
    'Mes': number;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'IdPds': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'PartnerNombre': string;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'PartnerExcel': string;
    /**
     * 
     * @type {number}
     * @memberof B2cVisitaRm
     */
    'NumeroFilaExcel': number;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'NumeroOrdenTrabajo': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'Oportunidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'Cuenta': string | null;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'TipoOrdenTrabajo': string | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cVisitaRm
     */
    'FechaCreacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof B2cVisitaRm
     */
    'FechaFinalizacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'Estado': string | null;
    /**
     * 
     * @type {number}
     * @memberof B2cVisitaRm
     */
    'Importe': number | null;
    /**
     * 
     * @type {string}
     * @memberof B2cVisitaRm
     */
    'OkKo': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BaremoPreciosEnum = {
    Elecnor: 'Elecnor',
    Circutor: 'Circutor'
} as const;

export type BaremoPreciosEnum = typeof BaremoPreciosEnum[keyof typeof BaremoPreciosEnum];


/**
 * 
 * @export
 * @interface BooleanResponseDTO
 */
export interface BooleanResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof BooleanResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof BooleanResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof BooleanResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof BooleanResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'Data'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof BooleanResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface BusinessModelComboRm
 */
export interface BusinessModelComboRm {
    /**
     * 
     * @type {number}
     * @memberof BusinessModelComboRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessModelComboRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface BusinessModelComboRmListResponseDTO
 */
export interface BusinessModelComboRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<BusinessModelComboRm>}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'Data'?: Array<BusinessModelComboRm>;
    /**
     * 
     * @type {any}
     * @memberof BusinessModelComboRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CanalEntradaRm
 */
export interface CanalEntradaRm {
    /**
     * 
     * @type {number}
     * @memberof CanalEntradaRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CanalEntradaRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof CanalEntradaRm
     */
    'DenoDefecto': string;
}
/**
 * 
 * @export
 * @interface CanalEntradaRmListResponseDTO
 */
export interface CanalEntradaRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CanalEntradaRm>}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'Data'?: Array<CanalEntradaRm>;
    /**
     * 
     * @type {any}
     * @memberof CanalEntradaRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CargadorAsociadoEntidadOcaModel
 */
export interface CargadorAsociadoEntidadOcaModel {
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'Nombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'Direccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'Potencia': number | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'FechaActivacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'FechaDesactivado': Date | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'Revenue': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'EstadoActualCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'EstadoActualAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'IdPartner': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'BusinessModelDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'Modelo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'ProvinciaDenominacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'TipoInfraestructuraDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModel
     */
    'TenantId': string | null;
}
/**
 * 
 * @export
 * @interface CargadorAsociadoEntidadOcaModelListResponseDTO
 */
export interface CargadorAsociadoEntidadOcaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CargadorAsociadoEntidadOcaModel>}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'Data'?: Array<CargadorAsociadoEntidadOcaModel>;
    /**
     * 
     * @type {any}
     * @memberof CargadorAsociadoEntidadOcaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CargadorComplianceInspeccionVisualRm
 */
export interface CargadorComplianceInspeccionVisualRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'IdInspeccion': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'Modelo': string;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'Excluido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'EnSiguienteInspeccion': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'EstadoActualCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'EstadoActualAgrupacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'NumKos': number;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorComplianceInspeccionVisualRm
     */
    'AptoInspeccionVisual': boolean;
}
/**
 * 
 * @export
 * @interface CargadorEventoRm
 */
export interface CargadorEventoRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'IdTicket': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorEventoRm
     */
    'NumeroTicket': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'TipoTicketDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'TipoTicketCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'EstadoTicket': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'CodigoEstadoTicket': string | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorEventoRm
     */
    'FechaAperturaTicket': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorEventoRm
     */
    'FechaCierreTicket': Date | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {number}
     * @memberof CargadorEventoRm
     */
    'IdTipoEvento': number;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'TipoEvento': string;
    /**
     * 
     * @type {number}
     * @memberof CargadorEventoRm
     */
    'IdSubestadoActual': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorEventoRm
     */
    'IdSubestadoAnterior': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'SubestadoActual': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'SubestadoAnterior': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorEventoRm
     */
    'IdColaAnterior': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'NombreColaAnterior': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorEventoRm
     */
    'IdColaUsuario': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'NombreColaUsuario': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'IdResponsableAnterior': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'NombreResponsableAnterior': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'IdResponsableNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'NombreResponsableNuevo': string | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorEventoRm
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'IdUsuarioCreacion': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'NombreAutor': string;
    /**
     * 
     * @type {Date}
     * @memberof CargadorEventoRm
     */
    'FechaModificacion': Date;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'IdUsuarioModificacion': string;
    /**
     * 
     * @type {Date}
     * @memberof CargadorEventoRm
     */
    'FechaBaja': Date | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'IdUsuarioBaja': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorEventoRm
     */
    'HorasDesdeEventoAnterior': number;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'Mensaje': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRm
     */
    'Observacion': string | null;
}
/**
 * 
 * @export
 * @interface CargadorEventoRmListResponseDTO
 */
export interface CargadorEventoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CargadorEventoRm>}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'Data'?: Array<CargadorEventoRm>;
    /**
     * 
     * @type {any}
     * @memberof CargadorEventoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CargadorForGridPorPartnerRm
 */
export interface CargadorForGridPorPartnerRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'TenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Direccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'EstadoActualCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'EstadoActualAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'EstadoCincoMinCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'EstadoCincoMinAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Modelo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Fabricante': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Nombre': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Potencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'IdPartner': string;
    /**
     * 
     * @type {Date}
     * @memberof CargadorForGridPorPartnerRm
     */
    'FechaActivacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorForGridPorPartnerRm
     */
    'FechaUltimaActualizacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Latitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Longitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'BusinessModel': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridPorPartnerRm
     */
    'UptimePctUltimo': number | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorForGridPorPartnerRm
     */
    'UptimeFechaUltimo': Date | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridPorPartnerRm
     */
    'UptimePctAcumulado': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Epf': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridPorPartnerRm
     */
    'KwhUltimas24h': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridPorPartnerRm
     */
    'KwhUltimaSemana': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'Ubicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridPorPartnerRm
     */
    'CentroTransformacion': string | null;
}
/**
 * 
 * @export
 * @interface CargadorForGridRm
 */
export interface CargadorForGridRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'TenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Direccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'EstadoActualCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'EstadoActualAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'EstadoCincoMinCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'EstadoCincoMinAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Modelo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Fabricante': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Nombre': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'Potencia': number | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorForGridRm
     */
    'FechaActivacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorForGridRm
     */
    'FechaUltimaActualizacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'IdPartner': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'IdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Zona': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'ObservacionDismissed': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorForGridRm
     */
    'IncluidoDashboardActivos': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'EstadoDashboardCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'ObservacionDismissedNormalizada': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'NoportunidadXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'TipoInfraestructura': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Latitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Longitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'BusinessModel': string | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'UptimePctUltimo': number | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorForGridRm
     */
    'UptimeFechaUltimo': Date | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'UptimePctAcumulado': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'Epf': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'KwhUltimas24h': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadorForGridRm
     */
    'KwhUltimaSemana': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'Ubicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorForGridRm
     */
    'CentroTransformacion': string | null;
}
/**
 * 
 * @export
 * @interface CargadorHistoricoEstadoRm
 */
export interface CargadorHistoricoEstadoRm {
    /**
     * 
     * @type {number}
     * @memberof CargadorHistoricoEstadoRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CargadorHistoricoEstadoRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {Date}
     * @memberof CargadorHistoricoEstadoRm
     */
    'FechaCambio': Date;
    /**
     * 
     * @type {string}
     * @memberof CargadorHistoricoEstadoRm
     */
    'EstadoAnteriorCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorHistoricoEstadoRm
     */
    'EstadoAnteriorAgrupacion': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorHistoricoEstadoRm
     */
    'EstadoNuevoCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorHistoricoEstadoRm
     */
    'EstadoNuevoAgrupacion': string;
}
/**
 * 
 * @export
 * @interface CargadorMobilityRm
 */
export interface CargadorMobilityRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Latitud': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Longitud': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Direccion2': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'EstadoActualCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'EstadoActualAgrupacion': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'CuId': string;
    /**
     * 
     * @type {number}
     * @memberof CargadorMobilityRm
     */
    'Potencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Familia': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Modelo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorMobilityRm
     */
    'Tenant': string;
    /**
     * 
     * @type {number}
     * @memberof CargadorMobilityRm
     */
    'IdTipoTenant': number;
    /**
     * 
     * @type {Date}
     * @memberof CargadorMobilityRm
     */
    'FechaDesactivado': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorMobilityRm
     */
    'FechaUltimaActualizacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CargadorMobilityRm
     */
    'FechaActivacion': Date | null;
}
/**
 * 
 * @export
 * @interface CargadorPeriodoPrivadoRm
 */
export interface CargadorPeriodoPrivadoRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorPeriodoPrivadoRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorPeriodoPrivadoRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorPeriodoPrivadoRm
     */
    'FechaInicio': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorPeriodoPrivadoRm
     */
    'FechaFin': string;
    /**
     * 
     * @type {Date}
     * @memberof CargadorPeriodoPrivadoRm
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface CargadorRm
 */
export interface CargadorRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'IdTenant': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'TenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'Latitud': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'Longitud': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'CuId': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'EstadoActual': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorRm
     */
    'EstadoAnterior': string;
}
/**
 * 
 * @export
 * @interface CargadorSinUbicacionRm
 */
export interface CargadorSinUbicacionRm {
    /**
     * 
     * @type {string}
     * @memberof CargadorSinUbicacionRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorSinUbicacionRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorSinUbicacionRm
     */
    'Nombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorSinUbicacionRm
     */
    'EstadoActualCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorSinUbicacionRm
     */
    'EstadoActualAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorSinUbicacionRm
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof CargadorSinUbicacionRm
     */
    'Direccion': string | null;
}
/**
 * 
 * @export
 * @interface CargadorTipoUnavailableDto
 */
export interface CargadorTipoUnavailableDto {
    /**
     * 
     * @type {number}
     * @memberof CargadorTipoUnavailableDto
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CargadorTipoUnavailableDto
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorTipoUnavailableDto
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof CargadorTipoUnavailableDto
     */
    'Observaciones': string | null;
}
/**
 * 
 * @export
 * @interface CargadorTipoUnavailableDtoIListResponseDTO
 */
export interface CargadorTipoUnavailableDtoIListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CargadorTipoUnavailableDto>}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'Data'?: Array<CargadorTipoUnavailableDto>;
    /**
     * 
     * @type {any}
     * @memberof CargadorTipoUnavailableDtoIListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CargadoresComplianceInspeccionVisualDto
 */
export interface CargadoresComplianceInspeccionVisualDto {
    /**
     * 
     * @type {Array<CargadorComplianceInspeccionVisualRm>}
     * @memberof CargadoresComplianceInspeccionVisualDto
     */
    'Cargadores': Array<CargadorComplianceInspeccionVisualRm>;
    /**
     * 
     * @type {Array<WoAsignadaComplianceInspeccionVisualRm>}
     * @memberof CargadoresComplianceInspeccionVisualDto
     */
    'WosAsignadas': Array<WoAsignadaComplianceInspeccionVisualRm>;
}
/**
 * 
 * @export
 * @interface CargadoresComplianceInspeccionVisualDtoResponseDTO
 */
export interface CargadoresComplianceInspeccionVisualDtoResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {CargadoresComplianceInspeccionVisualDto}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'Data'?: CargadoresComplianceInspeccionVisualDto;
    /**
     * 
     * @type {any}
     * @memberof CargadoresComplianceInspeccionVisualDtoResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CargadoresMobilityModel
 */
export interface CargadoresMobilityModel {
    /**
     * 
     * @type {Array<CargadorMobilityRm>}
     * @memberof CargadoresMobilityModel
     */
    'Data': Array<CargadorMobilityRm>;
    /**
     * 
     * @type {number}
     * @memberof CargadoresMobilityModel
     */
    'TotalItems': number;
    /**
     * 
     * @type {number}
     * @memberof CargadoresMobilityModel
     */
    'PageNumber': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadoresMobilityModel
     */
    'PageSize': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadoresMobilityModel
     */
    'TotalPages': number | null;
    /**
     * 
     * @type {number}
     * @memberof CargadoresMobilityModel
     */
    'ReturnedItems': number;
}
/**
 * 
 * @export
 * @interface CargadoresMobilityModelResponseDTO
 */
export interface CargadoresMobilityModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {CargadoresMobilityModel}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'Data'?: CargadoresMobilityModel;
    /**
     * 
     * @type {any}
     * @memberof CargadoresMobilityModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CasosRm
 */
export interface CasosRm {
    /**
     * 
     * @type {string}
     * @memberof CasosRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof CasosRm
     */
    'IdCasoXcustomer': number;
}
/**
 * 
 * @export
 * @interface CasosRmListResponseDTO
 */
export interface CasosRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CasosRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CasosRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CasosRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CasosRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CasosRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CasosRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CasosRm>}
     * @memberof CasosRmListResponseDTO
     */
    'Data'?: Array<CasosRm>;
    /**
     * 
     * @type {any}
     * @memberof CasosRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CategoriaAdjuntoPartnerApiEnum = {
    TarjetaCif: 'TARJETA_CIF',
    CertificadoCuentaBancaria: 'CERTIFICADO_CUENTA_BANCARIA',
    Contrato: 'CONTRATO'
} as const;

export type CategoriaAdjuntoPartnerApiEnum = typeof CategoriaAdjuntoPartnerApiEnum[keyof typeof CategoriaAdjuntoPartnerApiEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const CategoriaAdjuntoTicketApiEnum = {
    OfertaFabricante: 'OFERTA_FABRICANTE',
    DocumentoLogs: 'DOCUMENTO_LOGS',
    FotosEquipo: 'FOTOS_EQUIPO'
} as const;

export type CategoriaAdjuntoTicketApiEnum = typeof CategoriaAdjuntoTicketApiEnum[keyof typeof CategoriaAdjuntoTicketApiEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const CategoriaAdjuntoTicketEnum = {
    OfertaFabricante: 'OfertaFabricante',
    DocumentoLogs: 'DocumentoLogs',
    FotosEquipo: 'FotosEquipo'
} as const;

export type CategoriaAdjuntoTicketEnum = typeof CategoriaAdjuntoTicketEnum[keyof typeof CategoriaAdjuntoTicketEnum];


/**
 * 
 * @export
 * @interface CategoriaFotoGeneralAsociadaInspeccionVisualModel
 */
export interface CategoriaFotoGeneralAsociadaInspeccionVisualModel {
    /**
     * 
     * @type {string}
     * @memberof CategoriaFotoGeneralAsociadaInspeccionVisualModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof CategoriaFotoGeneralAsociadaInspeccionVisualModel
     */
    'IdCargador': string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoriaFotoGeneralAsociadaInspeccionVisualModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof CategoriaFotoGeneralAsociadaInspeccionVisualModel
     */
    'Nombre': string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoriaFotoGeneralAsociadaInspeccionVisualModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {number}
     * @memberof CategoriaFotoGeneralAsociadaInspeccionVisualModel
     */
    'Orden': number;
    /**
     * 
     * @type {Array<InspeccionFicheroDetalleModel>}
     * @memberof CategoriaFotoGeneralAsociadaInspeccionVisualModel
     */
    'Ficheros': Array<InspeccionFicheroDetalleModel>;
}
/**
 * 
 * @export
 * @interface CentroTransformacionFicheroAdjuntoInputModel
 */
export interface CentroTransformacionFicheroAdjuntoInputModel {
    /**
     * 
     * @type {number}
     * @memberof CentroTransformacionFicheroAdjuntoInputModel
     */
    'IdTipoFicheroAdjuntoOca': number;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionFicheroAdjuntoInputModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionFicheroAdjuntoInputModel
     */
    'Url': string;
}
/**
 * 
 * @export
 * @interface CentroTransformacionRm
 */
export interface CentroTransformacionRm {
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'IdCt': string;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'MatriculaCt': string;
    /**
     * 
     * @type {number}
     * @memberof CentroTransformacionRm
     */
    'IdBusinessModel': number | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'Municipio': string;
    /**
     * 
     * @type {number}
     * @memberof CentroTransformacionRm
     */
    'IdProvincia': number;
    /**
     * 
     * @type {number}
     * @memberof CentroTransformacionRm
     */
    'DelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'Titular': string | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'CifTitular': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CentroTransformacionRm
     */
    'Activa': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CentroTransformacionRm
     */
    'TieneOca': boolean;
    /**
     * 
     * @type {Date}
     * @memberof CentroTransformacionRm
     */
    'FechaAlta': Date;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'IdUsuarioAlta': string;
    /**
     * 
     * @type {Date}
     * @memberof CentroTransformacionRm
     */
    'FechaModificacion': Date;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'IdUsuarioModificacion': string;
    /**
     * 
     * @type {Date}
     * @memberof CentroTransformacionRm
     */
    'FechaBaja': Date | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'IdUsuarioBaja': string | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'BusinessModelCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'BusinessModelDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'ProvinciaDenominacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof CentroTransformacionRm
     */
    'IdComunidadAutonoma': number | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'ComunidadAutonomaDenominacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof CentroTransformacionRm
     */
    'IdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'ZonaDescripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRm
     */
    'NumSeriePrimerCargador': string | null;
    /**
     * 
     * @type {number}
     * @memberof CentroTransformacionRm
     */
    'NumCargadoresAsociados': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CentroTransformacionRm
     */
    'IdsCargadores': Array<string>;
}
/**
 * 
 * @export
 * @interface CentroTransformacionRmResponseDTO
 */
export interface CentroTransformacionRmResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {CentroTransformacionRm}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'Data'?: CentroTransformacionRm;
    /**
     * 
     * @type {any}
     * @memberof CentroTransformacionRmResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ColaUsuarioRm
 */
export interface ColaUsuarioRm {
    /**
     * 
     * @type {number}
     * @memberof ColaUsuarioRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof ColaUsuarioRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface ColaUsuarioRmListResponseDTO
 */
export interface ColaUsuarioRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ColaUsuarioRm>}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'Data'?: Array<ColaUsuarioRm>;
    /**
     * 
     * @type {any}
     * @memberof ColaUsuarioRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ComparaActivosPeriodoRm
 */
export interface ComparaActivosPeriodoRm {
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {boolean}
     * @memberof ComparaActivosPeriodoRm
     */
    'EsAlta': boolean;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'Zona': string | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'Ubicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'NombreActivo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'Modelo': string | null;
    /**
     * 
     * @type {number}
     * @memberof ComparaActivosPeriodoRm
     */
    'EstadoWoPuestaMarcha': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComparaActivosPeriodoRm
     */
    'IdNumericoPuestaMarcha': number | null;
    /**
     * 
     * @type {Date}
     * @memberof ComparaActivosPeriodoRm
     */
    'FechaPuestaMarcha': Date | null;
    /**
     * 
     * @type {number}
     * @memberof ComparaActivosPeriodoRm
     */
    'IdXcustomerPuestaMarcha': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComparaActivosPeriodoRm
     */
    'Cantidad': number | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'EstadoActivo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ComparaActivosPeriodoRm
     */
    'UltimaModificacion': string | null;
}
/**
 * 
 * @export
 * @interface CompletarInformeTecnicoIvModel
 */
export interface CompletarInformeTecnicoIvModel {
    /**
     * 
     * @type {string}
     * @memberof CompletarInformeTecnicoIvModel
     */
    'FechaModificacion': string;
    /**
     * 
     * @type {string}
     * @memberof CompletarInformeTecnicoIvModel
     */
    'Conclusiones': string | null;
}
/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosActuacionModel
 */
export interface ConfiguracionAdjuntosActuacionModel {
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosActuacionModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoAdjuntoIntervencionEnum}
     * @memberof ConfiguracionAdjuntosActuacionModel
     */
    'Tipo': TipoAdjuntoIntervencionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosActuacionModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosActuacionModel
     */
    'Destacado': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConfiguracionAdjuntosActuacionModel
     */
    'Orden': number;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosActuacionModelListResponseDTO
 */
export interface ConfiguracionAdjuntosActuacionModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosActuacionModel>}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'Data'?: Array<ConfiguracionAdjuntosActuacionModel>;
    /**
     * 
     * @type {any}
     * @memberof ConfiguracionAdjuntosActuacionModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosCentroTransformacionModel
 */
export interface ConfiguracionAdjuntosCentroTransformacionModel {
    /**
     * 
     * @type {number}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModel
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModel
     */
    'Requerido': boolean;
}
/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
 */
export interface ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosCentroTransformacionModel>}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'Data'?: Array<ConfiguracionAdjuntosCentroTransformacionModel>;
    /**
     * 
     * @type {any}
     * @memberof ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosPartnerModel
 */
export interface ConfiguracionAdjuntosPartnerModel {
    /**
     * 
     * @type {CategoriaAdjuntoPartnerApiEnum}
     * @memberof ConfiguracionAdjuntosPartnerModel
     */
    'Categoria': CategoriaAdjuntoPartnerApiEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosPartnerModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosPartnerModel
     */
    'Destacado': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConfiguracionAdjuntosPartnerModel
     */
    'Orden': number;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosTicketModel
 */
export interface ConfiguracionAdjuntosTicketModel {
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosTicketModel
     */
    'Id': string;
    /**
     * 
     * @type {CategoriaAdjuntoTicketApiEnum}
     * @memberof ConfiguracionAdjuntosTicketModel
     */
    'Categoria': CategoriaAdjuntoTicketApiEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosTicketModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosTicketModel
     */
    'Destacado': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConfiguracionAdjuntosTicketModel
     */
    'Orden': number;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosTicketModelListResponseDTO
 */
export interface ConfiguracionAdjuntosTicketModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosTicketModel>}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'Data'?: Array<ConfiguracionAdjuntosTicketModel>;
    /**
     * 
     * @type {any}
     * @memberof ConfiguracionAdjuntosTicketModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosUbicacionModel
 */
export interface ConfiguracionAdjuntosUbicacionModel {
    /**
     * 
     * @type {number}
     * @memberof ConfiguracionAdjuntosUbicacionModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosUbicacionModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosUbicacionModel
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosUbicacionModel
     */
    'Requerido': boolean;
}
/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosUbicacionModelListResponseDTO
 */
export interface ConfiguracionAdjuntosUbicacionModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosUbicacionModel>}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'Data'?: Array<ConfiguracionAdjuntosUbicacionModel>;
    /**
     * 
     * @type {any}
     * @memberof ConfiguracionAdjuntosUbicacionModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosVisitaModel
 */
export interface ConfiguracionAdjuntosVisitaModel {
    /**
     * 
     * @type {number}
     * @memberof ConfiguracionAdjuntosVisitaModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosVisitaModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosVisitaModel
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosVisitaModel
     */
    'Requerido': boolean;
}
/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosVisitaModelListResponseDTO
 */
export interface ConfiguracionAdjuntosVisitaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosVisitaModel>}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'Data'?: Array<ConfiguracionAdjuntosVisitaModel>;
    /**
     * 
     * @type {any}
     * @memberof ConfiguracionAdjuntosVisitaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosWoModel
 */
export interface ConfiguracionAdjuntosWoModel {
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosWoModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoAdjuntoIntervencionEnum}
     * @memberof ConfiguracionAdjuntosWoModel
     */
    'Tipo': TipoAdjuntoIntervencionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosWoModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosWoModel
     */
    'Destacado': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConfiguracionAdjuntosWoModel
     */
    'Orden': number;
}


/**
 * 
 * @export
 * @interface ConfiguracionAdjuntosWoModelListResponseDTO
 */
export interface ConfiguracionAdjuntosWoModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosWoModel>}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'Data'?: Array<ConfiguracionAdjuntosWoModel>;
    /**
     * 
     * @type {any}
     * @memberof ConfiguracionAdjuntosWoModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CrearObservacionOcaModel
 */
export interface CrearObservacionOcaModel {
    /**
     * 
     * @type {string}
     * @memberof CrearObservacionOcaModel
     */
    'IdOca': string;
    /**
     * 
     * @type {string}
     * @memberof CrearObservacionOcaModel
     */
    'Texto': string;
}
/**
 * 
 * @export
 * @interface CrearVisitaCentroTransformacionModel
 */
export interface CrearVisitaCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof CrearVisitaCentroTransformacionModel
     */
    'IdOca': string;
    /**
     * 
     * @type {Date}
     * @memberof CrearVisitaCentroTransformacionModel
     */
    'FechaProgramacion': Date;
    /**
     * 
     * @type {string}
     * @memberof CrearVisitaCentroTransformacionModel
     */
    'NumeroPedido': string | null;
}
/**
 * 
 * @export
 * @interface CrearVisitaUbicacionModel
 */
export interface CrearVisitaUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof CrearVisitaUbicacionModel
     */
    'IdOca': string;
    /**
     * 
     * @type {Date}
     * @memberof CrearVisitaUbicacionModel
     */
    'FechaProgramacion': Date;
    /**
     * 
     * @type {string}
     * @memberof CrearVisitaUbicacionModel
     */
    'Expediente': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrearVisitaUbicacionModel
     */
    'GenerarWoAcompanamiento': boolean;
}
/**
 * 
 * @export
 * @interface CrearWoDeficienciaVisitaModel
 */
export interface CrearWoDeficienciaVisitaModel {
    /**
     * 
     * @type {string}
     * @memberof CrearWoDeficienciaVisitaModel
     */
    'IdVisita': string;
}
/**
 * 
 * @export
 * @interface CreateActivoModel
 */
export interface CreateActivoModel {
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'Latitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'Longitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof CreateActivoModel
     */
    'Potencia': number;
    /**
     * 
     * @type {Date}
     * @memberof CreateActivoModel
     */
    'FechaActivacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'CodigoPostal': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'Provincia': string;
    /**
     * 
     * @type {number}
     * @memberof CreateActivoModel
     */
    'IdProvincia': number;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateActivoModel
     */
    'NumEnchufes': number;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'NoportunidadXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'IdUbicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActivoModel
     */
    'IdCentroTransformacion': string | null;
}
/**
 * 
 * @export
 * @interface CreateActuacionModel
 */
export interface CreateActuacionModel {
    /**
     * 
     * @type {TipoWoEnum}
     * @memberof CreateActuacionModel
     */
    'TipoWo': TipoWoEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateActuacionModel
     */
    'Asunto': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActuacionModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof CreateActuacionModel
     */
    'CodigoPostal': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateActuacionModel
     */
    'CrearPreventivo': boolean;
    /**
     * 
     * @type {TipoIntervaloEnum}
     * @memberof CreateActuacionModel
     */
    'TipoIntervalo': TipoIntervaloEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateActuacionModel
     */
    'Ubicaciones': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateActuacionModel
     */
    'Activos': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateActuacionModel
     */
    'Trabajador': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateActuacionModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateActuacionModel
     */
    'FechaMinInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateActuacionModel
     */
    'FechaMaxInicial': Date;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CreateActuacionModel
     */
    'Casos': { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateActuacionModel
     */
    'Pds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateActuacionModel
     */
    'EsUrgente': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateActuacionModel
     */
    'EsCorrectivoPrecioCerrado': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateActuacionModel
     */
    'CosteTotal': number | null;
    /**
     * 
     * @type {DocumentoAdjuntoDto}
     * @memberof CreateActuacionModel
     */
    'DocumentoTemporalPrecioCerrado': DocumentoAdjuntoDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateActuacionModel
     */
    'RelacionadaConOca': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateActuacionModel
     */
    'IdOca': string | null;
}


/**
 * 
 * @export
 * @interface CreateCampanaModel
 */
export interface CreateCampanaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateCampanaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampanaModel
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateCampanaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateCampanaModel
     */
    'FechaFinPrevista': Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCampanaModel
     */
    'Cargadores': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateCargadorEventoCambioResponsableModel
 */
export interface CreateCargadorEventoCambioResponsableModel {
    /**
     * 
     * @type {string}
     * @memberof CreateCargadorEventoCambioResponsableModel
     */
    'IdTicket': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCargadorEventoCambioResponsableModel
     */
    'IdUsuarioResponsable': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCargadorEventoCambioResponsableModel
     */
    'Observaciones': string | null;
}
/**
 * 
 * @export
 * @interface CreateCargadorPeriodoPrivadoModel
 */
export interface CreateCargadorPeriodoPrivadoModel {
    /**
     * 
     * @type {string}
     * @memberof CreateCargadorPeriodoPrivadoModel
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCargadorPeriodoPrivadoModel
     */
    'FechaInicio': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCargadorPeriodoPrivadoModel
     */
    'FechaFin': string;
}
/**
 * 
 * @export
 * @interface CreateCentroTransformacionModel
 */
export interface CreateCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateCentroTransformacionModel
     */
    'MatriculaCt': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCentroTransformacionModel
     */
    'IdBusinessModel': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCentroTransformacionModel
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCentroTransformacionModel
     */
    'Municipio': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCentroTransformacionModel
     */
    'IdProvincia': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCentroTransformacionModel
     */
    'DelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCentroTransformacionModel
     */
    'Titular': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCentroTransformacionModel
     */
    'CifTitular': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCentroTransformacionModel
     */
    'IdsCargadores': Array<string>;
    /**
     * 
     * @type {Array<CentroTransformacionFicheroAdjuntoInputModel>}
     * @memberof CreateCentroTransformacionModel
     */
    'FicherosAdjuntos': Array<CentroTransformacionFicheroAdjuntoInputModel>;
}
/**
 * 
 * @export
 * @interface CreateEquipoMedidaModel
 */
export interface CreateEquipoMedidaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateEquipoMedidaModel
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipoMedidaModel
     */
    'Marca': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipoMedidaModel
     */
    'Modelo': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipoMedidaModel
     */
    'FechaCalibracion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipoMedidaModel
     */
    'FechaProximaCalibracion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipoMedidaModel
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipoMedidaModel
     */
    'IdPds': string | null;
}
/**
 * 
 * @export
 * @interface CreateGrupoActuacionesModel
 */
export interface CreateGrupoActuacionesModel {
    /**
     * 
     * @type {string}
     * @memberof CreateGrupoActuacionesModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGrupoActuacionesModel
     */
    'DescripcionGrupo': string | null;
    /**
     * 
     * @type {TipoWoEnum}
     * @memberof CreateGrupoActuacionesModel
     */
    'Tipo': TipoWoEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateGrupoActuacionesModel
     */
    'Prioridad': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateGrupoActuacionesModel
     */
    'Asunto': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGrupoActuacionesModel
     */
    'DescripcionActuacion': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGrupoActuacionesModel
     */
    'Activos': Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof CreateGrupoActuacionesModel
     */
    'FechaMinInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateGrupoActuacionesModel
     */
    'FechaMaxInicial': Date;
    /**
     * 
     * @type {string}
     * @memberof CreateGrupoActuacionesModel
     */
    'Observaciones': string | null;
}


/**
 * 
 * @export
 * @interface CreateHistoricoEdicionTicketModel
 */
export interface CreateHistoricoEdicionTicketModel {
    /**
     * 
     * @type {string}
     * @memberof CreateHistoricoEdicionTicketModel
     */
    'Mensaje': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHistoricoEdicionTicketModel
     */
    'Observacion': string | null;
}
/**
 * 
 * @export
 * @interface CreateHistoricoTicketModel
 */
export interface CreateHistoricoTicketModel {
    /**
     * 
     * @type {string}
     * @memberof CreateHistoricoTicketModel
     */
    'IdTicket': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateHistoricoTicketModel
     */
    'IdUsuarioCreacion': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateHistoricoTicketModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateHistoricoTicketModel
     */
    'IdSubestado': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateHistoricoTicketModel
     */
    'IdColaUsuario': number | null;
}
/**
 * 
 * @export
 * @interface CreateInspeccionVisualExternaModel
 */
export interface CreateInspeccionVisualExternaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateInspeccionVisualExternaModel
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInspeccionVisualExternaModel
     */
    'IdPds': string;
    /**
     * 
     * @type {number}
     * @memberof CreateInspeccionVisualExternaModel
     */
    'IdTipoIntervalo': number;
    /**
     * 
     * @type {string}
     * @memberof CreateInspeccionVisualExternaModel
     */
    'FechaObjetivo': string;
}
/**
 * 
 * @export
 * @interface CreateInspeccionVisualInternaModel
 */
export interface CreateInspeccionVisualInternaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateInspeccionVisualInternaModel
     */
    'IdUbicacion': string;
}
/**
 * 
 * @export
 * @interface CreateMensajeTransaccionModel
 */
export interface CreateMensajeTransaccionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateMensajeTransaccionModel
     */
    'Mensaje': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMensajeTransaccionModel
     */
    'NumeroFactura': string | null;
    /**
     * 
     * @type {Array<AdjuntoMensajeModel>}
     * @memberof CreateMensajeTransaccionModel
     */
    'Adjuntos': Array<AdjuntoMensajeModel>;
}
/**
 * 
 * @export
 * @interface CreateOcaCentroTransformacionModel
 */
export interface CreateOcaCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateOcaCentroTransformacionModel
     */
    'IdCentroTransformacion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaCentroTransformacionModel
     */
    'IdPdsOca': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaCentroTransformacionModel
     */
    'IdUsuarioResponsable': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaCentroTransformacionModel
     */
    'FechaLimiteOca': string;
}
/**
 * 
 * @export
 * @interface CreateOcaUbicacionModel
 */
export interface CreateOcaUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateOcaUbicacionModel
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaUbicacionModel
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaUbicacionModel
     */
    'IdPdsOca': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaUbicacionModel
     */
    'IdUsuarioResponsable': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaUbicacionModel
     */
    'FechaLimiteOca': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOcaUbicacionModel
     */
    'IdOcaOrigen': string | null;
}
/**
 * 
 * @export
 * @interface CreatePartnerModel
 */
export interface CreatePartnerModel {
    /**
     * 
     * @type {string}
     * @memberof CreatePartnerModel
     */
    'Cif': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePartnerModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePartnerModel
     */
    'PeriodoInformes': number;
    /**
     * 
     * @type {string}
     * @memberof CreatePartnerModel
     */
    'IdBd': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePartnerModel
     */
    'EmailsContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePartnerModel
     */
    'FechaUltimoInforme': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePartnerModel
     */
    'Acreedor': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePartnerModel
     */
    'AfectaCanarias': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePartnerModel
     */
    'TerminoEnergia': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePartnerModel
     */
    'CantidadEnergia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePartnerModel
     */
    'TerminoPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePartnerModel
     */
    'CantidadPotencia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePartnerModel
     */
    'Privado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePartnerModel
     */
    'EnviarActualizacionWo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePartnerModel
     */
    'PermitirVerEstadoWo': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePartnerModel
     */
    'PeriodicidadFijo': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePartnerModel
     */
    'PrecioFijoSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePartnerModel
     */
    'PrecioFijoTotal': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePartnerModel
     */
    'IncluyeIrpf': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePartnerModel
     */
    'IdBusinessModelRevenueFijo': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePartnerModel
     */
    'FechaUltimoInformeFijo': string | null;
    /**
     * 
     * @type {Array<AdjuntoPartnerTemporalModel>}
     * @memberof CreatePartnerModel
     */
    'AdjuntosTemporales': Array<AdjuntoPartnerTemporalModel>;
}
/**
 * 
 * @export
 * @interface CreatePdsModel
 */
export interface CreatePdsModel {
    /**
     * 
     * @type {ModeloPagoEnum}
     * @memberof CreatePdsModel
     */
    'IdModeloPago': ModeloPagoEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'Cif': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'EmailsContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'ResponsablesIds': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'Zona': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'CodigosPostales': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'TelefonoMudanza': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'TelefonoGuardia': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'PersonaContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePdsModel
     */
    'IdUsuarioKim': string | null;
    /**
     * 
     * @type {Array<TipoPrestadorEnum>}
     * @memberof CreatePdsModel
     */
    'TiposPrestador': Array<TipoPrestadorEnum>;
    /**
     * 
     * @type {Array<PdsAsignacionProvinciaItem>}
     * @memberof CreatePdsModel
     */
    'AsignacionesProvincia': Array<PdsAsignacionProvinciaItem>;
}


/**
 * 
 * @export
 * @interface CreateTicketModel
 */
export interface CreateTicketModel {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'IdInspeccionVisual': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTicketModel
     */
    'IdsRespuestasKo': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'IdCargador': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdColaUsuario': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdOrigenTicket': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdTipoTicket': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdPrioridadTicket': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'NumeroPedido': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'NumeroConformidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'NumeroTicketFabricante': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'IdPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketModel
     */
    'AsistenciaPerdida': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'Importe': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'CanalEntrada': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdSubestado': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTicketModel
     */
    'IdUsuarioResponsable': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'IdWoCreacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketModel
     */
    'FirmwareActualizado': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketModel
     */
    'EsFcr': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'MotivoNoFcr': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketModel
     */
    'DesconocimientoPrestador': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'ObservacionDesconocimientoPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'TiempoAtencion': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdCanalEntrada': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdTipologiaIncidencia': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketModel
     */
    'IdSubtipologiaIncidencia': number;
}
/**
 * 
 * @export
 * @interface CreateUbicacionModel
 */
export interface CreateUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'Matricula': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUbicacionModel
     */
    'IdBusinessModel': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'Municipio': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUbicacionModel
     */
    'IdProvincia': number;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'CodigoPostal': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUbicacionModel
     */
    'DelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'Titular': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'CifTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'Cups': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'Cove': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUbicacionModel
     */
    'FechaCaducidad': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUbicacionModel
     */
    'IdTipoInfraestructuraCargador': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUbicacionModel
     */
    'IdsCargadores': Array<string>;
    /**
     * 
     * @type {Array<UbicacionFicheroAdjuntoInputModel>}
     * @memberof CreateUbicacionModel
     */
    'FicherosAdjuntos': Array<UbicacionFicheroAdjuntoInputModel>;
}
/**
 * 
 * @export
 * @interface CreateUserGmaoModel
 */
export interface CreateUserGmaoModel {
    /**
     * 
     * @type {string}
     * @memberof CreateUserGmaoModel
     */
    'UserName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGmaoModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGmaoModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGmaoModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGmaoModel
     */
    'Rol': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGmaoModel
     */
    'Dni': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGmaoModel
     */
    'IdPdsAsociado': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUserGmaoModel
     */
    'IdColaUsuario': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserGmaoModel
     */
    'PuedeUsarIa': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateUserGmaoModel
     */
    'SaldoDisponibleIa': number;
}
/**
 * 
 * @export
 * @interface CreateUserModel
 */
export interface CreateUserModel {
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'UserName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Rol': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserModel
     */
    'IdPartnersAsociados': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserModel
     */
    'IdPartnersAsociadosConUsuarioBd': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserModel
     */
    'PuedeUsarIa': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateUserModel
     */
    'SaldoDisponibleIa': number;
}
/**
 * 
 * @export
 * @interface CreateWoModel
 */
export interface CreateWoModel {
    /**
     * 
     * @type {string}
     * @memberof CreateWoModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWoModel
     */
    'IdActivo': string;
    /**
     * 
     * @type {TipoWoEnum}
     * @memberof CreateWoModel
     */
    'TipoWo': TipoWoEnum;
}


/**
 * 
 * @export
 * @interface DXLoadOptions
 */
export interface DXLoadOptions {
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireTotalCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireGroupCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isCountQuery'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isSummaryQuery'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'skip'?: number;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'take'?: number;
    /**
     * 
     * @type {Array<SortingInfo>}
     * @memberof DXLoadOptions
     */
    'sort'?: Array<SortingInfo> | null;
    /**
     * 
     * @type {Array<GroupingInfo>}
     * @memberof DXLoadOptions
     */
    'group'?: Array<GroupingInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'totalSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'groupSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'select'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'preSelect'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteSelect'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteGrouping'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'expandLinqSumType'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'primaryKey'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DXLoadOptions
     */
    'defaultSort'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'stringToLower'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'paginateViaPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'sortByPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'allowAsyncOverSync'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof DXLoadOptions
     */
    'filter'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface DashboardActivosModel
 */
export interface DashboardActivosModel {
    /**
     * 
     * @type {GraficaAgrupacionModel}
     * @memberof DashboardActivosModel
     */
    'Ok': GraficaAgrupacionModel;
    /**
     * 
     * @type {GraficaAgrupacionModel}
     * @memberof DashboardActivosModel
     */
    'Unavailable': GraficaAgrupacionModel;
    /**
     * 
     * @type {GraficaAgrupacionModel}
     * @memberof DashboardActivosModel
     */
    'Ko': GraficaAgrupacionModel;
    /**
     * 
     * @type {GraficaAgrupacionModel}
     * @memberof DashboardActivosModel
     */
    'Dismissed': GraficaAgrupacionModel;
}
/**
 * 
 * @export
 * @interface DashboardActivosModelResponseDTO
 */
export interface DashboardActivosModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DashboardActivosModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DashboardActivosModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardActivosModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardActivosModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DashboardActivosModel}
     * @memberof DashboardActivosModelResponseDTO
     */
    'Data'?: DashboardActivosModel;
    /**
     * 
     * @type {any}
     * @memberof DashboardActivosModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DashboardActivosRm
 */
export interface DashboardActivosRm {
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosRm
     */
    'IdPartner': string;
    /**
     * 
     * @type {number}
     * @memberof DashboardActivosRm
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardActivosRm
     */
    'IdZona': number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardActivosRm
     */
    'IdTipoInfraestructuraCargador': number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosRm
     */
    'EstadoAgrupacion': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosRm
     */
    'EstadoCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosRm
     */
    'EstadoDeno': string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardActivosRm
     */
    'IdTipoUnavailable': number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardActivosRm
     */
    'ObservacionDismissed': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardActivosRm
     */
    'TieneTicketAbierto': boolean;
}
/**
 * 
 * @export
 * @interface DashboardCampanaModel
 */
export interface DashboardCampanaModel {
    /**
     * 
     * @type {GraficaEstadoWoCampanaModel}
     * @memberof DashboardCampanaModel
     */
    'GraficaEstadoWos': GraficaEstadoWoCampanaModel;
    /**
     * 
     * @type {GraficaEstadoCargadorCampanaModel}
     * @memberof DashboardCampanaModel
     */
    'GraficaEstadoCargadores': GraficaEstadoCargadorCampanaModel;
}
/**
 * 
 * @export
 * @interface DashboardCampanaModelResponseDTO
 */
export interface DashboardCampanaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DashboardCampanaModel}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'Data'?: DashboardCampanaModel;
    /**
     * 
     * @type {any}
     * @memberof DashboardCampanaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DashboardKpiGmaoModel
 */
export interface DashboardKpiGmaoModel {
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'AnioCivilKpi': number;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardKpiGmaoModel
     */
    'AvisoKpiAnioCivil': boolean;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'HorasAsistenciaUrgente': number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'NumWoAsistenciaUrgente': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'DiasAsistenciaNoUrgente': number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'NumWoAsistenciaNoUrgente': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'PctCumplimientoPreventivosPublic': number | null;
    /**
     * 
     * @type {KpiPreventivosCantidadModel}
     * @memberof DashboardKpiGmaoModel
     */
    'PreventivosPublicCantidades': KpiPreventivosCantidadModel | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'PctCumplimientoPreventivosPrivate': number | null;
    /**
     * 
     * @type {KpiPreventivosCantidadModel}
     * @memberof DashboardKpiGmaoModel
     */
    'PreventivosPrivateCantidades': KpiPreventivosCantidadModel | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'PctCumplimientoOcas': number | null;
    /**
     * 
     * @type {KpiCantidadModel}
     * @memberof DashboardKpiGmaoModel
     */
    'OcasCantidades': KpiCantidadModel | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'PctEquiposDismiss': number | null;
    /**
     * 
     * @type {KpiCantidadModel}
     * @memberof DashboardKpiGmaoModel
     */
    'EquiposDismissCantidades': KpiCantidadModel | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'PctEquiposFallo': number | null;
    /**
     * 
     * @type {KpiCantidadModel}
     * @memberof DashboardKpiGmaoModel
     */
    'EquiposFalloCantidades': KpiCantidadModel | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardKpiGmaoModel
     */
    'InspeccionesCampoKim': number;
    /**
     * 
     * @type {KpiCantidadModel}
     * @memberof DashboardKpiGmaoModel
     */
    'InspeccionesCampoCantidades': KpiCantidadModel | null;
    /**
     * 
     * @type {Array<EnergiaTecnologiaKpiModel>}
     * @memberof DashboardKpiGmaoModel
     */
    'EnergiaPorTecnologia': Array<EnergiaTecnologiaKpiModel>;
    /**
     * 
     * @type {Array<EnergiaTecnologiaMesKpiModel>}
     * @memberof DashboardKpiGmaoModel
     */
    'EnergiaPorTecnologiaMes': Array<EnergiaTecnologiaMesKpiModel>;
}
/**
 * 
 * @export
 * @interface DashboardKpiGmaoModelResponseDTO
 */
export interface DashboardKpiGmaoModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DashboardKpiGmaoModel}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'Data'?: DashboardKpiGmaoModel;
    /**
     * 
     * @type {any}
     * @memberof DashboardKpiGmaoModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DashboardOcasModel
 */
export interface DashboardOcasModel {
    /**
     * 
     * @type {GraficaOcaAgrupacionModel}
     * @memberof DashboardOcasModel
     */
    'Estados': GraficaOcaAgrupacionModel;
    /**
     * 
     * @type {GraficaOcaAgrupacionModel}
     * @memberof DashboardOcasModel
     */
    'FechaLimite': GraficaOcaAgrupacionModel;
    /**
     * 
     * @type {GraficaOcaAgrupacionModel}
     * @memberof DashboardOcasModel
     */
    'DeficienciasTecnicas': GraficaOcaAgrupacionModel;
    /**
     * 
     * @type {GraficaOcaAgrupacionModel}
     * @memberof DashboardOcasModel
     */
    'DeficienciasDocumentales': GraficaOcaAgrupacionModel;
    /**
     * 
     * @type {number}
     * @memberof DashboardOcasModel
     */
    'DeficienciasSinResolver': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardOcasModel
     */
    'UbicacionesSinOca': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardOcasModel
     */
    'CentrosTransformacionSinOca': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardOcasModel
     */
    'OcasConDeficiencias': number;
}
/**
 * 
 * @export
 * @interface DashboardOcasModelResponseDTO
 */
export interface DashboardOcasModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DashboardOcasModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DashboardOcasModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardOcasModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardOcasModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardOcasModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardOcasModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DashboardOcasModel}
     * @memberof DashboardOcasModelResponseDTO
     */
    'Data'?: DashboardOcasModel;
    /**
     * 
     * @type {any}
     * @memberof DashboardOcasModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DatosActuacionCargadorPoi
 */
export interface DatosActuacionCargadorPoi {
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'NombreEmpresa': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'Sector': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'Coste': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'WcDisponible': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'Vigilancia': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'Adaptado': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'Area': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'OcioCercano': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'ZonaTechada': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'ServicioRestauracion': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'Wifi': string;
    /**
     * 
     * @type {string}
     * @memberof DatosActuacionCargadorPoi
     */
    'Horario': string;
    /**
     * 
     * @type {Array<DiaHorario>}
     * @memberof DatosActuacionCargadorPoi
     */
    'HorariosDias': Array<DiaHorario>;
}
/**
 * 
 * @export
 * @interface DatosInformeComunicacionDto
 */
export interface DatosInformeComunicacionDto {
    /**
     * 
     * @type {string}
     * @memberof DatosInformeComunicacionDto
     */
    'IP': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeComunicacionDto
     */
    'ICCID': string | null;
    /**
     * 
     * @type {number}
     * @memberof DatosInformeComunicacionDto
     */
    'Puerto': number | null;
}
/**
 * 
 * @export
 * @interface DatosInformeRadioButtonDto
 */
export interface DatosInformeRadioButtonDto {
    /**
     * 
     * @type {string}
     * @memberof DatosInformeRadioButtonDto
     */
    'Valor': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeRadioButtonDto
     */
    'Observaciones': string | null;
}
/**
 * 
 * @export
 * @interface DatosInformeRadioButtonNumericoDto
 */
export interface DatosInformeRadioButtonNumericoDto {
    /**
     * 
     * @type {string}
     * @memberof DatosInformeRadioButtonNumericoDto
     */
    'Valor': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeRadioButtonNumericoDto
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {number}
     * @memberof DatosInformeRadioButtonNumericoDto
     */
    'ValorNumerico': number | null;
}
/**
 * 
 * @export
 * @interface DatosInformeTecnicoActuacion
 */
export interface DatosInformeTecnicoActuacion {
    /**
     * 
     * @type {ValorConObservaciones}
     * @memberof DatosInformeTecnicoActuacion
     */
    'ClienteConsideraInstrucciones': ValorConObservaciones;
    /**
     * 
     * @type {ValorConObservaciones}
     * @memberof DatosInformeTecnicoActuacion
     */
    'DeterminaMedidas': ValorConObservaciones;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'NombreEmpresa': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Sector': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Coste': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'NumeroPlanta': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'NumeroPlaza': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'AccesoParking': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'WcDisponible': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Vigilancia': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Adaptado': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Area': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'OcioCercano': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'ZonaTechada': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'ServicioRestauracion': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Wifi': string;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTecnicoActuacion
     */
    'Horario': string;
    /**
     * 
     * @type {Array<DiaHorario>}
     * @memberof DatosInformeTecnicoActuacion
     */
    'HorariosDias': Array<DiaHorario>;
    /**
     * 
     * @type {number}
     * @memberof DatosInformeTecnicoActuacion
     */
    'IdTipoUrgenciaActuacion': number;
}
/**
 * 
 * @export
 * @interface DatosInformeTextBoxDto
 */
export interface DatosInformeTextBoxDto {
    /**
     * 
     * @type {string}
     * @memberof DatosInformeTextBoxDto
     */
    'Valor': string;
}
/**
 * 
 * @export
 * @interface DatosInformeWo
 */
export interface DatosInformeWo {
    /**
     * 
     * @type {DatosInformeWoPem}
     * @memberof DatosInformeWo
     */
    'PuestaEnMarcha': DatosInformeWoPem | null;
    /**
     * 
     * @type {DatosInformeWoPreventivo}
     * @memberof DatosInformeWo
     */
    'Preventivo': DatosInformeWoPreventivo | null;
    /**
     * 
     * @type {DatosInformeWoCorrectivo}
     * @memberof DatosInformeWo
     */
    'Correctivo': DatosInformeWoCorrectivo | null;
}
/**
 * 
 * @export
 * @interface DatosInformeWoCorrectivo
 */
export interface DatosInformeWoCorrectivo {
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'LiberacionCable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'ReparacionSustitucionComponenteInSitu': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'ReparacionSustitucionComponenteEnTaller': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'RearmeProteccionesSetaEmergencia': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'ReposicionSenaleticaDecoracion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'SustitucionCompletaPuntoRecarga': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'RestauracionSenalesVerticalesVialesProteccion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'PinturaPlazaSinInterior': boolean;
    /**
     * 
     * @type {number}
     * @memberof DatosInformeWoCorrectivo
     */
    'NumPlazasPintadasSinInterior': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'PinturaPlazaConInterior': boolean;
    /**
     * 
     * @type {number}
     * @memberof DatosInformeWoCorrectivo
     */
    'NumPlazasPintadasConInterior': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'PuestaEnServicioPuntoRecargaConPrueba': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'ModificacionPeanaPernosAnclaje': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'Desinsectacion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'AcompanamientoOCA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'EstudioTermografico': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'LimpiezaPuntoAlrededores': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'ActualizacionSoftware': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'Monitorizacion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'DesinstalacionPuntoRecarga': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'PruebaCargaTodosMetodosAutenticacion': boolean;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoCorrectivo
     */
    'HaCambiadoPiezas': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatosInformeWoCorrectivo
     */
    'ListaWoPiezas': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeWoCorrectivo
     */
    'SimIpNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeWoCorrectivo
     */
    'SimIccidNuevo': string | null;
    /**
     * 
     * @type {number}
     * @memberof DatosInformeWoCorrectivo
     */
    'SimPuertoNuevo': number | null;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeWoCorrectivo
     */
    'SimIpAntiguo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeWoCorrectivo
     */
    'SimIccidAntiguo': string | null;
    /**
     * 
     * @type {number}
     * @memberof DatosInformeWoCorrectivo
     */
    'SimPuertoAntiguo': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DatosInformeWoCorrectivo
     */
    'IdsMotivoCierreWo': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeWoCorrectivo
     */
    'ConclusionesGenerales': string;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoCorrectivo
     */
    'CargadorOperativo': boolean | null;
    /**
     * 
     * @type {DatosInformeRadioButtonNumericoDto}
     * @memberof DatosInformeWoCorrectivo
     */
    'HorasExtra': DatosInformeRadioButtonNumericoDto;
    /**
     * 
     * @type {DatosInformeRadioButtonNumericoDto}
     * @memberof DatosInformeWoCorrectivo
     */
    'MaterialExtra': DatosInformeRadioButtonNumericoDto;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoDto>}
     * @memberof DatosInformeWoCorrectivo
     */
    'ItemsMaterialesElecnor': Array<ItemElecnorSeleccionadoDto> | null;
    /**
     * 
     * @type {Array<ItemCircutorSeleccionadoDto>}
     * @memberof DatosInformeWoCorrectivo
     */
    'ItemsMaterialesCircutor': Array<ItemCircutorSeleccionadoDto> | null;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoDto>}
     * @memberof DatosInformeWoCorrectivo
     */
    'ItemsCorrectivosElecnor': Array<ItemElecnorSeleccionadoDto> | null;
}
/**
 * 
 * @export
 * @interface DatosInformeWoPem
 */
export interface DatosInformeWoPem {
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'EstadoGeneralPdr': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'FarolaReloj': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'EstadoArquetas': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'EstadoPintadoAparcamiento': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'SenaleticaSeguridad': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'AdhesivosGenerales': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'NumPegatina': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CableadoInterior': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CalibradoSensibilidad': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CalibradoTiempo': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'ComprobacionIntensidadPdr': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'BotonEmergencia': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'ProbarBotonTest': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'EsquemaUnifilar': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'ResistenciaTierra': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'ResistenciaAislamiento': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'TiempoDiferencial': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'VoltajeL1N': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'VoltajeL2N': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'VoltajeL3N': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'VoltajeNeutroTierra': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'CorrientesFuga': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'EstadoGeneralArmario': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CierreSeccionamiento': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'ConexionesCcs': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CableadoCcs': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'EstadoGeneralCaja': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'InstalacionFusibles': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'ConexionesEquipoMedida': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CableadoEquipoMedida': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'TransformadoresIntensidad': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'EstadoEmbarrado': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'ProteccionIntensidad': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'ComprobacionPat': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'Tubulares': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'TornillerasBornas': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'VerificacionAppSAT': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'VerificacionVersionSAT': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'PruebaCargaSAT': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'Latitud': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'Longitud': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'LatitudNueva': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'LongitudNueva': DatosInformeTextBoxDto;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoPem
     */
    'SustituirUbicacion': boolean;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'Tipo': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'NumeroPlanta': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'NumeroPlaza': DatosInformeTextBoxDto;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoPem
     */
    'PlazaNoNumerada': boolean;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'AccesoParking': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'ConfiguracionCarga': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CargaAppEndesa': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CargaRfidEndesa': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CargaTpv': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'PruebaTermoGrafica': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'PotenciaTeorica': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'PotenciaMaxima': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeComunicacionDto}
     * @memberof DatosInformeWoPem
     */
    'DatosComunicacion': DatosInformeComunicacionDto;
    /**
     * 
     * @type {DatosInformeComunicacionDto}
     * @memberof DatosInformeWoPem
     */
    'DatosSustitucionSIM': DatosInformeComunicacionDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'NivelesCobertura': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPem
     */
    'BreveExplicacion': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'HolguraConexionManguera': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPem
     */
    'CargaFuncionaConHolgura': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoPem
     */
    'CargadorOperativo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeWoPem
     */
    'ConclusionesGenerales': string;
    /**
     * 
     * @type {DatosInformeRadioButtonNumericoDto}
     * @memberof DatosInformeWoPem
     */
    'HorasExtra': DatosInformeRadioButtonNumericoDto;
    /**
     * 
     * @type {DatosInformeRadioButtonNumericoDto}
     * @memberof DatosInformeWoPem
     */
    'MaterialExtra': DatosInformeRadioButtonNumericoDto;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoDto>}
     * @memberof DatosInformeWoPem
     */
    'ItemsMaterialesElecnor': Array<ItemElecnorSeleccionadoDto> | null;
    /**
     * 
     * @type {Array<ItemCircutorSeleccionadoDto>}
     * @memberof DatosInformeWoPem
     */
    'ItemsMaterialesCircutor': Array<ItemCircutorSeleccionadoDto> | null;
}
/**
 * 
 * @export
 * @interface DatosInformeWoPreventivo
 */
export interface DatosInformeWoPreventivo {
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'EstadoGeneralPdr': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'ManguerasConectores': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'PinesConductores': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'GomasJuntas': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'AspiradoFiltros': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'LimpiezaExterior': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'BalizasIluminacion': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'RfidDisplay': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'FarolaReloj': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'LimpiezaFiltros': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'SenaleticaSeguridad': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'PintadoPlaza': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'AdhesivoInstrucciones': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'AdhesivoQR': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'AdhesivosGenerales': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'NumPegatina': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CableadoBornas': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'Magnetotermicos': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CalibradoDiferencial': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'BotonEmergencia': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'TestDiferencial': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'ResistenciaTierra': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'ResistenciaAislamiento': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeL1N': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeL2N': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeL3N': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeNeutroTierra': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CorrientesFuga': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'TensionesFuentes': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'PruebaCarga': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'LimpiezaExteriorArmario': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'TestInterruptorDiferencial': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'MagnetotermicosCPM': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'AislantesConductores': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'ConexionesProtecciones': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'LimpiezaInteriorArmario': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'ResistenciaTierraCPM': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'TiempoDisparoDiferencial': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeL1NCPM': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeL2NCPM': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeL3NCPM': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VoltajeNeutroTierraCPM': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'EstadoFusibles': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'ConexionesCgpEquipo': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CableadoCgpEquipo': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'EstadoEmbarrado': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'ComprobacionPat': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'Tubulares': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VerificacionAppSAT': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VerificacionVersionSAT': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'PruebaCargaSAT': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'Latitud': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'Longitud': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'LatitudNueva': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'LongitudNueva': DatosInformeTextBoxDto;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoPreventivo
     */
    'SustituirUbicacion': boolean;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'Tipo': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'NumeroPlaza': DatosInformeTextBoxDto;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoPreventivo
     */
    'PlazaNoNumerada': boolean;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'NumeroPlanta': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'AccesoParking': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'UbicacionCargador': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CargaAppEndesa': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CargaRfidEndesa': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CargaTpv': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'PruebaTermografica': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'VerificacionPotenciaTeorica': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeTextBoxDto}
     * @memberof DatosInformeWoPreventivo
     */
    'PotenciaMaxima': DatosInformeTextBoxDto;
    /**
     * 
     * @type {DatosInformeComunicacionDto}
     * @memberof DatosInformeWoPreventivo
     */
    'DatosComunicacion': DatosInformeComunicacionDto;
    /**
     * 
     * @type {DatosInformeComunicacionDto}
     * @memberof DatosInformeWoPreventivo
     */
    'DatosSustitucionSIM': DatosInformeComunicacionDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'HolguraConexionManguera': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {DatosInformeRadioButtonDto}
     * @memberof DatosInformeWoPreventivo
     */
    'CargaFuncionaConHolgura': DatosInformeRadioButtonDto;
    /**
     * 
     * @type {boolean}
     * @memberof DatosInformeWoPreventivo
     */
    'CargadorOperativo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DatosInformeWoPreventivo
     */
    'ConclusionesGenerales': string;
    /**
     * 
     * @type {DatosInformeRadioButtonNumericoDto}
     * @memberof DatosInformeWoPreventivo
     */
    'HorasExtra': DatosInformeRadioButtonNumericoDto;
    /**
     * 
     * @type {DatosInformeRadioButtonNumericoDto}
     * @memberof DatosInformeWoPreventivo
     */
    'MaterialExtra': DatosInformeRadioButtonNumericoDto;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoDto>}
     * @memberof DatosInformeWoPreventivo
     */
    'ItemsPreventivosElecnor': Array<ItemElecnorSeleccionadoDto> | null;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoDto>}
     * @memberof DatosInformeWoPreventivo
     */
    'ItemsMaterialesElecnor': Array<ItemElecnorSeleccionadoDto> | null;
    /**
     * 
     * @type {Array<ItemCircutorSeleccionadoDto>}
     * @memberof DatosInformeWoPreventivo
     */
    'ItemsMaterialesCircutor': Array<ItemCircutorSeleccionadoDto> | null;
}
/**
 * 
 * @export
 * @interface DatosSiguienteCargadorIvModel
 */
export interface DatosSiguienteCargadorIvModel {
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteCargadorIvModel
     */
    'IdSiguienteCargador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteCargadorIvModel
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteCargadorIvModel
     */
    'Modelo': string | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSiguienteCargadorIvModel
     */
    'Indice': number;
    /**
     * 
     * @type {number}
     * @memberof DatosSiguienteCargadorIvModel
     */
    'Total': number;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSiguienteCargadorIvModel
     */
    'EsUltimo': boolean;
}
/**
 * 
 * @export
 * @interface DatosSiguienteCargadorIvModelResponseDTO
 */
export interface DatosSiguienteCargadorIvModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DatosSiguienteCargadorIvModel}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'Data'?: DatosSiguienteCargadorIvModel;
    /**
     * 
     * @type {any}
     * @memberof DatosSiguienteCargadorIvModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DatosSiguienteCompliance
 */
export interface DatosSiguienteCompliance {
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteCompliance
     */
    'IdWo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteCompliance
     */
    'IdActuacion': string | null;
}
/**
 * 
 * @export
 * @interface DatosSiguienteComplianceResponseDTO
 */
export interface DatosSiguienteComplianceResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DatosSiguienteCompliance}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'Data'?: DatosSiguienteCompliance;
    /**
     * 
     * @type {any}
     * @memberof DatosSiguienteComplianceResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DatosSiguienteWo
 */
export interface DatosSiguienteWo {
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteWo
     */
    'IdSiguienteWo': string;
    /**
     * 
     * @type {number}
     * @memberof DatosSiguienteWo
     */
    'IndexSiguienteWo': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSiguienteWo
     */
    'CountTotalWos': number;
}
/**
 * 
 * @export
 * @interface DatosSiguienteWoResponseDTO
 */
export interface DatosSiguienteWoResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DatosSiguienteWo}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'Data'?: DatosSiguienteWo;
    /**
     * 
     * @type {any}
     * @memberof DatosSiguienteWoResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DatosWoCargadorPoi
 */
export interface DatosWoCargadorPoi {
    /**
     * 
     * @type {string}
     * @memberof DatosWoCargadorPoi
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DatosWoCargadorPoi
     */
    'NumeroPlanta': string;
    /**
     * 
     * @type {string}
     * @memberof DatosWoCargadorPoi
     */
    'NumeroPlaza': string;
    /**
     * 
     * @type {string}
     * @memberof DatosWoCargadorPoi
     */
    'AccesoParking': string;
    /**
     * 
     * @type {boolean}
     * @memberof DatosWoCargadorPoi
     */
    'PlazaNoNumerada': boolean;
}
/**
 * 
 * @export
 * @interface DatosWoCargadorPoiWrap
 */
export interface DatosWoCargadorPoiWrap {
    /**
     * 
     * @type {DatosWoCargadorPoi}
     * @memberof DatosWoCargadorPoiWrap
     */
    'DatosWo': DatosWoCargadorPoi;
}
/**
 * 
 * @export
 * @interface DefaultResponseDTO
 */
export interface DefaultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DefaultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DefaultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'CorrelationId'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatus = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    UnhandledException: 'UnhandledException',
    InvalidArguments: 'InvalidArguments',
    ConcurrencyError: 'ConcurrencyError',
    OutOfService: 'OutOfService',
    Unauthorized: 'Unauthorized'
} as const;

export type DefaultResponseStatus = typeof DefaultResponseStatus[keyof typeof DefaultResponseStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatusCategory = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    TransientError: 'TransientError',
    PermanentError: 'PermanentError'
} as const;

export type DefaultResponseStatusCategory = typeof DefaultResponseStatusCategory[keyof typeof DefaultResponseStatusCategory];


/**
 * 
 * @export
 * @interface DeficienciaAsociadaVisitaModel
 */
export interface DeficienciaAsociadaVisitaModel {
    /**
     * 
     * @type {number}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'Subambito': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'GeneraWorkOrder': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'IsResuelta': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'FechaResolucion': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaAsociadaVisitaModel
     */
    'EsFaltaLeve': boolean;
}
/**
 * 
 * @export
 * @interface DeficienciaComplianceRm
 */
export interface DeficienciaComplianceRm {
    /**
     * 
     * @type {string}
     * @memberof DeficienciaComplianceRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaComplianceRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface DeficienciaComplianceRmListResponseDTO
 */
export interface DeficienciaComplianceRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<DeficienciaComplianceRm>}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'Data'?: Array<DeficienciaComplianceRm>;
    /**
     * 
     * @type {any}
     * @memberof DeficienciaComplianceRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DeficienciaResolucionInputModel
 */
export interface DeficienciaResolucionInputModel {
    /**
     * 
     * @type {number}
     * @memberof DeficienciaResolucionInputModel
     */
    'IdDeficienciaVisita': number;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaResolucionInputModel
     */
    'IsResuelta': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaResolucionInputModel
     */
    'FechaResolucion': string | null;
}
/**
 * 
 * @export
 * @interface DeficienciaVisitaMaestraModel
 */
export interface DeficienciaVisitaMaestraModel {
    /**
     * 
     * @type {number}
     * @memberof DeficienciaVisitaMaestraModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaVisitaMaestraModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaVisitaMaestraModel
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaVisitaMaestraModel
     */
    'Ambito': string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaVisitaMaestraModel
     */
    'Subambito': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaVisitaMaestraModel
     */
    'GeneraWorkOrder': boolean;
}
/**
 * 
 * @export
 * @interface DeficienciaVisitaMaestraModelListResponseDTO
 */
export interface DeficienciaVisitaMaestraModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<DeficienciaVisitaMaestraModel>}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'Data'?: Array<DeficienciaVisitaMaestraModel>;
    /**
     * 
     * @type {any}
     * @memberof DeficienciaVisitaMaestraModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DeleteEquipoMedidaModel
 */
export interface DeleteEquipoMedidaModel {
    /**
     * 
     * @type {string}
     * @memberof DeleteEquipoMedidaModel
     */
    'IdEquipoMedida': string;
}
/**
 * 
 * @export
 * @interface DeleteSuscripcionesPorUsuarioModel
 */
export interface DeleteSuscripcionesPorUsuarioModel {
    /**
     * 
     * @type {string}
     * @memberof DeleteSuscripcionesPorUsuarioModel
     */
    'IdUsuario': string;
}
/**
 * 
 * @export
 * @interface DeleteUserModel
 */
export interface DeleteUserModel {
    /**
     * 
     * @type {string}
     * @memberof DeleteUserModel
     */
    'IdUsuario': string;
}
/**
 * 
 * @export
 * @interface DetailActuacionModel
 */
export interface DetailActuacionModel {
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'IdNumerico': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Asunto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof DetailActuacionModel
     */
    'CosteTotal': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Observacion': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailActuacionModel
     */
    'CrearPreventivo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'IdTipoIntervalo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'IdResponsable': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Responsable': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Ubicacion': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Pds': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'IdTecnico': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Tecnico': string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Estado': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailActuacionModel
     */
    'FechaCreacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailActuacionModel
     */
    'FechaMinInicial': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailActuacionModel
     */
    'FechaMaxInicial': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailActuacionModel
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {number}
     * @memberof DetailActuacionModel
     */
    'IdTipoDesplazamiento': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailActuacionModel
     */
    'Km': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'FirmaTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'FirmaCliente': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailActuacionModel
     */
    'ClienteAusente': boolean;
    /**
     * 
     * @type {DatosInformeTecnicoActuacion}
     * @memberof DetailActuacionModel
     */
    'DatosInformeTecnico': DatosInformeTecnicoActuacion | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailActuacionModel
     */
    'EquiposMedida': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailActuacionModel
     */
    'EsUrgente': boolean;
    /**
     * 
     * @type {Array<AdjuntoIntevencionModel>}
     * @memberof DetailActuacionModel
     */
    'Adjuntos': Array<AdjuntoIntevencionModel>;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'RutaInformeEconomico': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailActuacionModel
     */
    'IdTipoUrgenciaTecnico': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailActuacionModel
     */
    'IdTipoUrgenciaAdministrador': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'FechaActuacion': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailActuacionModel
     */
    'EsCorrectivoPrecioCerrado': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'ObservacionValidacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'ZonaPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'ZonaProvincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'IdPds': string;
    /**
     * 
     * @type {BaremoPreciosEnum}
     * @memberof DetailActuacionModel
     */
    'IdBaremoPrecios': BaremoPreciosEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'CodigoPedidoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'CodigoConformidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModel
     */
    'Partner': string | null;
    /**
     * 
     * @type {DatosActuacionCargadorPoi}
     * @memberof DetailActuacionModel
     */
    'DatosActuacion': DatosActuacionCargadorPoi | null;
}


/**
 * 
 * @export
 * @interface DetailActuacionModelResponseDTO
 */
export interface DetailActuacionModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailActuacionModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailActuacionModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailActuacionModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailActuacionModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailActuacionModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailActuacionModel}
     * @memberof DetailActuacionModelResponseDTO
     */
    'Data'?: DetailActuacionModel;
    /**
     * 
     * @type {any}
     * @memberof DetailActuacionModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailCampanaCargadorModel
 */
export interface DetailCampanaCargadorModel {
    /**
     * 
     * @type {string}
     * @memberof DetailCampanaCargadorModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailCampanaCargadorModel
     */
    'SerialNumber': string;
}
/**
 * 
 * @export
 * @interface DetailCampanaModel
 */
export interface DetailCampanaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailCampanaModel
     */
    'Id': string;
    /**
     * 
     * @type {EstadoCampanaEnum}
     * @memberof DetailCampanaModel
     */
    'Estado': EstadoCampanaEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailCampanaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailCampanaModel
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailCampanaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailCampanaModel
     */
    'FechaFinPrevista': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailCampanaModel
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailCampanaModel
     */
    'FechaAlta': Date | null;
    /**
     * 
     * @type {Array<DetailCampanaCargadorModel>}
     * @memberof DetailCampanaModel
     */
    'Cargadores': Array<DetailCampanaCargadorModel>;
}


/**
 * 
 * @export
 * @interface DetailCampanaModelResponseDTO
 */
export interface DetailCampanaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailCampanaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailCampanaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCampanaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCampanaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailCampanaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailCampanaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailCampanaModel}
     * @memberof DetailCampanaModelResponseDTO
     */
    'Data'?: DetailCampanaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailCampanaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailCargadorModel
 */
export interface DetailCargadorModel {
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'TenantId': string;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Direccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'SimIp': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'SimIccd': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'SimPuerto': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Latitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Longitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'EstadoActualCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'EstadoActualAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'EstadoCincoMinCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'EstadoCincoMinAgrupacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'IdCargadorTipoUnavailable': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'CargadorTipoUnavailableCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Modelo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Nombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'BusinessModel': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'Revenue': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'Potencia': number | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailCargadorModel
     */
    'FechaActivacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailCargadorModel
     */
    'FechaUltimaActualizacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'IdPartner': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'NoportunidadXcustomer': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'NumeroIntervenciones': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'TotalImporteReal': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'TipoInfraestructura': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Zona': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'VersionFirmware': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'IdPdsAsociado': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'NombrePdsAsociado': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCargadorModel
     */
    'NumEnchufes': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'IdUbicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModel
     */
    'IdCentroTransformacion': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCargadorModel
     */
    'AptoInspeccionVisual': boolean;
}
/**
 * 
 * @export
 * @interface DetailCargadorModelResponseDTO
 */
export interface DetailCargadorModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailCargadorModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailCargadorModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCargadorModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCargadorModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailCargadorModel}
     * @memberof DetailCargadorModelResponseDTO
     */
    'Data'?: DetailCargadorModel;
    /**
     * 
     * @type {any}
     * @memberof DetailCargadorModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailCargadorPoiModel
 */
export interface DetailCargadorPoiModel {
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'NombreEmpresa': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Sector': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Coste': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'WcDisponible': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Vigilancia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Adaptado': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Area': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'OcioCercano': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'ZonaTechada': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'ServicioRestauracion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Wifi': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Horario': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'HorariosDias': string | null;
    /**
     * 
     * @type {Array<DiaHorario>}
     * @memberof DetailCargadorPoiModel
     */
    'HorariosDiasArray': Array<DiaHorario> | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'Tipo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'NumeroPlanta': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'NumeroPlaza': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModel
     */
    'AccesoParking': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCargadorPoiModel
     */
    'PlazaNoNumerada': boolean;
}
/**
 * 
 * @export
 * @interface DetailCargadorPoiModelResponseDTO
 */
export interface DetailCargadorPoiModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailCargadorPoiModel}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'Data'?: DetailCargadorPoiModel;
    /**
     * 
     * @type {any}
     * @memberof DetailCargadorPoiModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailPartnerModel
 */
export interface DetailPartnerModel {
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'Cif': string;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DetailPartnerModel
     */
    'PeriodoInformes': number;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'IdBd': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'BusinessModel': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'EmailsContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'ApellidosBd': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'NombreBd': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailPartnerModel
     */
    'FechaUltimoInforme': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'Acreedor': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'AfectaCanarias': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'TerminoEnergia': boolean;
    /**
     * 
     * @type {number}
     * @memberof DetailPartnerModel
     */
    'CantidadEnergia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'TerminoPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof DetailPartnerModel
     */
    'CantidadPotencia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'Privado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'EnviarActualizacionWo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'PermitirVerEstadoWo': boolean;
    /**
     * 
     * @type {number}
     * @memberof DetailPartnerModel
     */
    'PeriodicidadFijo': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailPartnerModel
     */
    'PrecioFijoSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailPartnerModel
     */
    'PrecioFijoTotal': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'IncluyeIrpf': boolean;
    /**
     * 
     * @type {Date}
     * @memberof DetailPartnerModel
     */
    'FechaUltimoInformeFijo': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'TieneInformesVariable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModel
     */
    'TieneInformesFijo': boolean;
    /**
     * 
     * @type {number}
     * @memberof DetailPartnerModel
     */
    'IdBusinessModelRevenueFijo': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModel
     */
    'BusinessModelRevenueFijoNombre': string | null;
    /**
     * 
     * @type {Array<AdjuntoPartnerModel>}
     * @memberof DetailPartnerModel
     */
    'Adjuntos': Array<AdjuntoPartnerModel>;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosPartnerModel>}
     * @memberof DetailPartnerModel
     */
    'ConfiguracionAdjuntos': Array<ConfiguracionAdjuntosPartnerModel>;
}
/**
 * 
 * @export
 * @interface DetailPartnerModelResponseDTO
 */
export interface DetailPartnerModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailPartnerModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailPartnerModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailPartnerModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailPartnerModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailPartnerModel}
     * @memberof DetailPartnerModelResponseDTO
     */
    'Data'?: DetailPartnerModel;
    /**
     * 
     * @type {any}
     * @memberof DetailPartnerModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailTransaccionModel
 */
export interface DetailTransaccionModel {
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'IdPartner': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'NombrePartner': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'CifPartner': string;
    /**
     * 
     * @type {number}
     * @memberof DetailTransaccionModel
     */
    'IdEstado': number;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'CodigoEstado': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'EstadoDenoDefecto': string;
    /**
     * 
     * @type {number}
     * @memberof DetailTransaccionModel
     */
    'CodigoSecuencial': number;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'Region': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'TipoInforme': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailTransaccionModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailTransaccionModel
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailTransaccionModel
     */
    'FechaAlerta': Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailTransaccionModel
     */
    'FicherosAdjuntos': Array<string>;
    /**
     * 
     * @type {Array<TransaccionMensajeModel>}
     * @memberof DetailTransaccionModel
     */
    'Mensajes': Array<TransaccionMensajeModel>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTransaccionModel
     */
    'PuedeEscribirMensajes': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'Periodo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'Acreedor': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTransaccionModel
     */
    'ImporteTotal': number;
    /**
     * 
     * @type {number}
     * @memberof DetailTransaccionModel
     */
    'ImporteSinImpuestos': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTransaccionModel
     */
    'IncluyeIrpf': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTransaccionModel
     */
    'IsVariable': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModel
     */
    'NumeroFactura': string | null;
}
/**
 * 
 * @export
 * @interface DetailTransaccionModelResponseDTO
 */
export interface DetailTransaccionModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailTransaccionModel}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'Data'?: DetailTransaccionModel;
    /**
     * 
     * @type {any}
     * @memberof DetailTransaccionModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailWoModel
 */
export interface DetailWoModel {
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'IdNumerico': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'IdXcustomerWo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'IdCasoXcustomer': string;
    /**
     * 
     * @type {number}
     * @memberof DetailWoModel
     */
    'IdXcustomerCaso': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'Estado': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'Subestado': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailWoModel
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailWoModel
     */
    'FechaAlta': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'UsuarioCreador': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModel
     */
    'AsociadoDesplazamiento': boolean;
    /**
     * 
     * @type {number}
     * @memberof DetailWoModel
     */
    'ImporteWo': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'Activo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'CpCargador': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'ModeloPdrCargador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'NumSerieTpv': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'ObservacionPrestador': string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'IdPds': string;
    /**
     * 
     * @type {DatosInformeWo}
     * @memberof DetailWoModel
     */
    'DatosInforme': DatosInformeWo | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'RutaInformeTecnico': string | null;
    /**
     * 
     * @type {Array<AdjuntoIntevencionModel>}
     * @memberof DetailWoModel
     */
    'Adjuntos': Array<AdjuntoIntevencionModel>;
    /**
     * 
     * @type {number}
     * @memberof DetailWoModel
     */
    'IdTipoWo': number;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'TipoWo': string;
    /**
     * 
     * @type {number}
     * @memberof DetailWoModel
     */
    'CosteTotal': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'RutaInformeEconomico': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'ObservacionValidacion': string | null;
    /**
     * 
     * @type {EstadoComplianceEnum}
     * @memberof DetailWoModel
     */
    'EstadoCompliance': EstadoComplianceEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'ObservacionCompliance': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailWoModel
     */
    'FechaCompliance': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModel
     */
    'CreadaCaliente': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'CodigoPedidoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'CodigoConformidad': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModel
     */
    'FacturarMovilidad': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModel
     */
    'EsCapex': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModel
     */
    'EnGarantia': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof DetailWoModel
     */
    'NumPlazas': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailWoModel
     */
    'IdMotivoIncidencia': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailWoModel
     */
    'IdSubmotivoIncidencia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModel
     */
    'EsFavorable': boolean;
    /**
     * 
     * @type {DatosWoCargadorPoiWrap}
     * @memberof DetailWoModel
     */
    'DatosWo': DatosWoCargadorPoiWrap | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'NumeroSerieNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModel
     */
    'IdCargadorNuevo': string | null;
}


/**
 * 
 * @export
 * @interface DetailWoModelResponseDTO
 */
export interface DetailWoModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailWoModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailWoModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailWoModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailWoModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailWoModel}
     * @memberof DetailWoModelResponseDTO
     */
    'Data'?: DetailWoModel;
    /**
     * 
     * @type {any}
     * @memberof DetailWoModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetalleActuacionExternaDto
 */
export interface DetalleActuacionExternaDto {
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof DetalleActuacionExternaDto
     */
    'IdNumerico': number;
    /**
     * 
     * @type {number}
     * @memberof DetalleActuacionExternaDto
     */
    'IdTipoActuacion': number;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'TipoActuacionNombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'Asunto': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'Descripcion': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'Estado': string;
    /**
     * 
     * @type {Date}
     * @memberof DetalleActuacionExternaDto
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetalleActuacionExternaDto
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetalleActuacionExternaDto
     */
    'FechaUltimaActualizacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'FechaMinimaInicial': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'FechaMaximaInicial': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'FechaActuacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'CodigoPostal': string;
    /**
     * 
     * @type {number}
     * @memberof DetalleActuacionExternaDto
     */
    'CosteTotal': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetalleActuacionExternaDto
     */
    'KmDesplazamiento': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetalleActuacionExternaDto
     */
    'IdEstadoActuacion': number;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'Ubicacion': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'ZonaDescripcion': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetalleActuacionExternaDto
     */
    'IdTipoIntervalo': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'TipoIntervaloNombre': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetalleActuacionExternaDto
     */
    'IdTipoUrgenciaTecnico': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'UrgenciaTecnicoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'UrgenciaTecnicoDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'UrgenciaAdminCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'UrgenciaAdminDenoDefecto': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleActuacionExternaDto
     */
    'Validado': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'ObservacionValidacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetalleActuacionExternaDto
     */
    'FechaAutorizacionMaestroPagos': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleActuacionExternaDto
     */
    'IdUsuarioTecnico': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleActuacionExternaDto
     */
    'ClienteAusente': boolean | null;
    /**
     * 
     * @type {Array<WoExternaDto>}
     * @memberof DetalleActuacionExternaDto
     */
    'Wos': Array<WoExternaDto>;
}
/**
 * 
 * @export
 * @interface DetalleTicketRm
 */
export interface DetalleTicketRm {
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {number}
     * @memberof DetalleTicketRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {number}
     * @memberof DetalleTicketRm
     */
    'IdEstado': number;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {number}
     * @memberof DetalleTicketRm
     */
    'Potencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NoportunidadXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombrePartner': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombreModeloCargador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombreBusinessModel': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'CanalEntrada': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'IdWoCreacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetalleTicketRm
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'IdWoCierre': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetalleTicketRm
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetalleTicketRm
     */
    'FechaModificacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetalleTicketRm
     */
    'FechaBaja': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'IdUsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'IdUsuarioBaja': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombreUsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'ApellidosUsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombreUsuarioCreacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'ApellidosUsuarioCreacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombreCola': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'SubestadoDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'SubestadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'EstadoDenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'EstadoCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'CodigoPostalCargador': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetalleTicketRm
     */
    'IdOrigenTicket': number;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'OrigenDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'OrigenCodigo': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetalleTicketRm
     */
    'Importe': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NumeroPedido': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NumeroConformidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NumeroTicketFabricante': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'IdPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'Prestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'Tecnico': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleTicketRm
     */
    'AsistenciaPerdida': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'PrioridadDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'PrioridadCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombreFabricanteCargador': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleTicketRm
     */
    'FirmwareActualizado': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'FirmwareVersion': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleTicketRm
     */
    'EsFcr': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'MotivoNoFcr': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleTicketRm
     */
    'DesconocimientoPrestador': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'ObservacionDesconocimientoPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'TiempoAtencion': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetalleTicketRm
     */
    'IdTipologiaIncidencia': number;
    /**
     * 
     * @type {number}
     * @memberof DetalleTicketRm
     */
    'IdSubtipologiaIncidencia': number;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'TipologiaSubtipologiaEtiqueta': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'TipoTicketDenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'TipoTicketCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'NombreCompletoKim': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'DireccionActivo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'ProvinciaActivo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRm
     */
    'CodigoPostalActivo': string | null;
    /**
     * 
     * @type {Array<AdjuntoTicketRm>}
     * @memberof DetalleTicketRm
     */
    'Adjuntos': Array<AdjuntoTicketRm>;
}
/**
 * 
 * @export
 * @interface DetalleTicketRmResponseDTO
 */
export interface DetalleTicketRmResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetalleTicketRmResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetalleTicketRmResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleTicketRmResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleTicketRmResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRmResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetalleTicketRmResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetalleTicketRm}
     * @memberof DetalleTicketRmResponseDTO
     */
    'Data'?: DetalleTicketRm;
    /**
     * 
     * @type {any}
     * @memberof DetalleTicketRmResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetalleWosTecnicoMaestroPagosModel
 */
export interface DetalleWosTecnicoMaestroPagosModel {
    /**
     * 
     * @type {Array<WoTecnicoMaestroPagosModel>}
     * @memberof DetalleWosTecnicoMaestroPagosModel
     */
    'WosCerradas': Array<WoTecnicoMaestroPagosModel>;
    /**
     * 
     * @type {Array<WoTecnicoMaestroPagosModel>}
     * @memberof DetalleWosTecnicoMaestroPagosModel
     */
    'WosRechazadas': Array<WoTecnicoMaestroPagosModel>;
}
/**
 * 
 * @export
 * @interface DetalleWosTecnicoMaestroPagosModelResponseDTO
 */
export interface DetalleWosTecnicoMaestroPagosModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetalleWosTecnicoMaestroPagosModel}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'Data'?: DetalleWosTecnicoMaestroPagosModel;
    /**
     * 
     * @type {any}
     * @memberof DetalleWosTecnicoMaestroPagosModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DiaHorario
 */
export interface DiaHorario {
    /**
     * 
     * @type {string}
     * @memberof DiaHorario
     */
    'Dia': string;
    /**
     * 
     * @type {string}
     * @memberof DiaHorario
     */
    'Apertura': string;
    /**
     * 
     * @type {string}
     * @memberof DiaHorario
     */
    'Cierre': string;
}
/**
 * 
 * @export
 * @interface DocumentoAdjuntoDto
 */
export interface DocumentoAdjuntoDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentoAdjuntoDto
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoAdjuntoDto
     */
    'Url': string;
}
/**
 * 
 * @export
 * @interface DocumentosAsociadosOca
 */
export interface DocumentosAsociadosOca {
    /**
     * 
     * @type {number}
     * @memberof DocumentosAsociadosOca
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAsociadosOca
     */
    'Matricula': string | null;
    /**
     * 
     * @type {Array<DocumentosVisitaOca>}
     * @memberof DocumentosAsociadosOca
     */
    'Visitas': Array<DocumentosVisitaOca>;
}
/**
 * 
 * @export
 * @interface DocumentosAsociadosOcaResponseDTO
 */
export interface DocumentosAsociadosOcaResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DocumentosAsociadosOca}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'Data'?: DocumentosAsociadosOca;
    /**
     * 
     * @type {any}
     * @memberof DocumentosAsociadosOcaResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DocumentosAsociadosWo
 */
export interface DocumentosAsociadosWo {
    /**
     * 
     * @type {FicheroDescarga}
     * @memberof DocumentosAsociadosWo
     */
    'Informe': FicheroDescarga | null;
    /**
     * 
     * @type {FicheroDescarga}
     * @memberof DocumentosAsociadosWo
     */
    'InformeEconomico': FicheroDescarga | null;
    /**
     * 
     * @type {Array<FicheroDescarga>}
     * @memberof DocumentosAsociadosWo
     */
    'DocumentosAdjuntos': Array<FicheroDescarga>;
}
/**
 * 
 * @export
 * @interface DocumentosAsociadosWoResponseDTO
 */
export interface DocumentosAsociadosWoResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DocumentosAsociadosWo}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'Data'?: DocumentosAsociadosWo;
    /**
     * 
     * @type {any}
     * @memberof DocumentosAsociadosWoResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DocumentosVisitaOca
 */
export interface DocumentosVisitaOca {
    /**
     * 
     * @type {number}
     * @memberof DocumentosVisitaOca
     */
    'Numero': number;
    /**
     * 
     * @type {Array<FicheroDescarga>}
     * @memberof DocumentosVisitaOca
     */
    'Ficheros': Array<FicheroDescarga>;
}
/**
 * 
 * @export
 * @interface EditActuacionModel
 */
export interface EditActuacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditActuacionModel
     */
    'Id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditActuacionModel
     */
    'IdResponsable': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditActuacionModel
     */
    'IdTecnico': Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof EditActuacionModel
     */
    'FechaMinInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof EditActuacionModel
     */
    'FechaMaxInicial': Date;
    /**
     * 
     * @type {boolean}
     * @memberof EditActuacionModel
     */
    'EsUrgente': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditActuacionModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {string}
     * @memberof EditActuacionModel
     */
    'Asunto': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditActuacionModel
     */
    'Pds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditActuacionModel
     */
    'IdPds': string;
    /**
     * 
     * @type {Date}
     * @memberof EditActuacionModel
     */
    'FechaCierre': Date | null;
}
/**
 * 
 * @export
 * @interface EditActuacionYWorkOrdersModel
 */
export interface EditActuacionYWorkOrdersModel {
    /**
     * 
     * @type {string}
     * @memberof EditActuacionYWorkOrdersModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof EditActuacionYWorkOrdersModel
     */
    'IdUsuarioTecnico': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditActuacionYWorkOrdersModel
     */
    'IdEquipoMedida': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EditActuacionYWorkOrdersModel
     */
    'KmDesplazamiento': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditActuacionYWorkOrdersModel
     */
    'ClienteAusente': boolean | null;
    /**
     * 
     * @type {Array<EditWoExternoItemModel>}
     * @memberof EditActuacionYWorkOrdersModel
     */
    'Wo': Array<EditWoExternoItemModel>;
}
/**
 * 
 * @export
 * @interface EditCampanaModel
 */
export interface EditCampanaModel {
    /**
     * 
     * @type {string}
     * @memberof EditCampanaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditCampanaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditCampanaModel
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof EditCampanaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof EditCampanaModel
     */
    'FechaFinPrevista': Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCampanaModel
     */
    'Cargadores': Array<string>;
}
/**
 * 
 * @export
 * @interface EditCargadorModel
 */
export interface EditCargadorModel {
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'Direccion': string;
    /**
     * 
     * @type {number}
     * @memberof EditCargadorModel
     */
    'IdProvincia': number;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'CodigoPostal': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'Latitud': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'Longitud': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditCargadorModel
     */
    'Potencia': number;
    /**
     * 
     * @type {number}
     * @memberof EditCargadorModel
     */
    'NumEnchufes': number;
    /**
     * 
     * @type {Date}
     * @memberof EditCargadorModel
     */
    'FechaActivacion': Date | null;
    /**
     * 
     * @type {number}
     * @memberof EditCargadorModel
     */
    'Revenue': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'NoportunidadXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'IdUbicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'IdCentroTransformacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorModel
     */
    'IdPartner': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditCargadorModel
     */
    'AptoInspeccionVisual': boolean;
}
/**
 * 
 * @export
 * @interface EditCargadorPeriodoPrivadoModel
 */
export interface EditCargadorPeriodoPrivadoModel {
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPeriodoPrivadoModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPeriodoPrivadoModel
     */
    'FechaInicio': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPeriodoPrivadoModel
     */
    'FechaFin': string;
}
/**
 * 
 * @export
 * @interface EditCargadorPoiModel
 */
export interface EditCargadorPoiModel {
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'NombreEmpresa': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Sector': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Coste': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'WcDisponible': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Vigilancia': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Adaptado': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Area': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'OcioCercano': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'ZonaTechada': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'ServicioRestauracion': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Wifi': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Horario': string;
    /**
     * 
     * @type {Array<DiaHorario>}
     * @memberof EditCargadorPoiModel
     */
    'HorariosDias': Array<DiaHorario>;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'NumeroPlanta': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'NumeroPlaza': string;
    /**
     * 
     * @type {string}
     * @memberof EditCargadorPoiModel
     */
    'AccesoParking': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditCargadorPoiModel
     */
    'PlazaNoNumerada': boolean;
}
/**
 * 
 * @export
 * @interface EditCentroTransformacionModel
 */
export interface EditCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditCentroTransformacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditCentroTransformacionModel
     */
    'MatriculaCt': string;
    /**
     * 
     * @type {number}
     * @memberof EditCentroTransformacionModel
     */
    'IdBusinessModel': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditCentroTransformacionModel
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof EditCentroTransformacionModel
     */
    'Municipio': string;
    /**
     * 
     * @type {number}
     * @memberof EditCentroTransformacionModel
     */
    'IdProvincia': number;
    /**
     * 
     * @type {number}
     * @memberof EditCentroTransformacionModel
     */
    'DelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditCentroTransformacionModel
     */
    'Titular': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCentroTransformacionModel
     */
    'CifTitular': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCentroTransformacionModel
     */
    'IdsCargadores': Array<string>;
    /**
     * 
     * @type {Array<CentroTransformacionFicheroAdjuntoInputModel>}
     * @memberof EditCentroTransformacionModel
     */
    'FicherosAdjuntos': Array<CentroTransformacionFicheroAdjuntoInputModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCentroTransformacionModel
     */
    'IdsFicherosEliminar': Array<string>;
}
/**
 * 
 * @export
 * @interface EditDatosInformeModel
 */
export interface EditDatosInformeModel {
    /**
     * 
     * @type {string}
     * @memberof EditDatosInformeModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditDatosInformeModel
     */
    'NumSerieTpv': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditDatosInformeModel
     */
    'TieneIncidencia': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditDatosInformeModel
     */
    'MensajeIncidencia': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditDatosInformeModel
     */
    'IdMotivoIncidencia': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditDatosInformeModel
     */
    'IdSubmotivoIncidencia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditDatosInformeModel
     */
    'EsFavorable': boolean;
    /**
     * 
     * @type {InformeTecnicoPreventivoModel}
     * @memberof EditDatosInformeModel
     */
    'InformeTecnicoPreventivo': InformeTecnicoPreventivoModel | null;
    /**
     * 
     * @type {InformeTecnicoPemModel}
     * @memberof EditDatosInformeModel
     */
    'InformeTecnicoPem': InformeTecnicoPemModel | null;
    /**
     * 
     * @type {InformeTecnicoCorrectivoModel}
     * @memberof EditDatosInformeModel
     */
    'InformeTecnicoCorrectivo': InformeTecnicoCorrectivoModel | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditDatosInformeModel
     */
    'PoiEditado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditDatosInformeModel
     */
    'EsGuardadoParcial': boolean;
}
/**
 * 
 * @export
 * @interface EditDeficienciasVisitaUbicacionModel
 */
export interface EditDeficienciasVisitaUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditDeficienciasVisitaUbicacionModel
     */
    'IdVisita': string;
    /**
     * 
     * @type {Array<DeficienciaResolucionInputModel>}
     * @memberof EditDeficienciasVisitaUbicacionModel
     */
    'Deficiencias': Array<DeficienciaResolucionInputModel>;
}
/**
 * 
 * @export
 * @interface EditEquipoMedidaModel
 */
export interface EditEquipoMedidaModel {
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'NumeroSerie'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'Marca'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'Modelo'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'FechaCalibracion'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'FechaProximaCalibracion'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'IdTecnico'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditEquipoMedidaModel
     */
    'IdPds'?: string;
}
/**
 * 
 * @export
 * @interface EditEventoCargadorModel
 */
export interface EditEventoCargadorModel {
    /**
     * 
     * @type {string}
     * @memberof EditEventoCargadorModel
     */
    'IdCargadorEvento': string;
    /**
     * 
     * @type {string}
     * @memberof EditEventoCargadorModel
     */
    'Observaciones': string;
}
/**
 * 
 * @export
 * @interface EditInformeTecnicoModel
 */
export interface EditInformeTecnicoModel {
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof EditInformeTecnicoModel
     */
    'IdTipoDesplazamiento': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditInformeTecnicoModel
     */
    'Km': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditInformeTecnicoModel
     */
    'IdTipoUrgenciaTecnico': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditInformeTecnicoModel
     */
    'IdTipoUrgenciaAdministrador': number | null;
    /**
     * 
     * @type {ValorConObservaciones}
     * @memberof EditInformeTecnicoModel
     */
    'ClienteConsideraInstrucciones': ValorConObservaciones;
    /**
     * 
     * @type {ValorConObservaciones}
     * @memberof EditInformeTecnicoModel
     */
    'DeterminaMedidas': ValorConObservaciones;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'NombreEmpresa': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Sector': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Coste': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'WcDisponible': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Vigilancia': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Adaptado': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Area': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'OcioCercano': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'ZonaTechada': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'ServicioRestauracion': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Wifi': string;
    /**
     * 
     * @type {string}
     * @memberof EditInformeTecnicoModel
     */
    'Horario': string;
    /**
     * 
     * @type {Array<DiaHorario>}
     * @memberof EditInformeTecnicoModel
     */
    'HorariosDias': Array<DiaHorario>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditInformeTecnicoModel
     */
    'EquiposMedidaIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EditInformeTecnicoModel
     */
    'PoiEditado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditInformeTecnicoModel
     */
    'EsGuardadoParcial': boolean;
}
/**
 * 
 * @export
 * @interface EditInspeccionVisualModel
 */
export interface EditInspeccionVisualModel {
    /**
     * 
     * @type {string}
     * @memberof EditInspeccionVisualModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditInspeccionVisualModel
     */
    'IdPds': string;
    /**
     * 
     * @type {number}
     * @memberof EditInspeccionVisualModel
     */
    'IdTipoIntervalo': number;
    /**
     * 
     * @type {string}
     * @memberof EditInspeccionVisualModel
     */
    'FechaObjetivo': string;
}
/**
 * 
 * @export
 * @interface EditOcaCentroTransformacionModel
 */
export interface EditOcaCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditOcaCentroTransformacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaCentroTransformacionModel
     */
    'IdCentroTransformacion': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaCentroTransformacionModel
     */
    'IdPdsOca': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaCentroTransformacionModel
     */
    'IdUsuarioResponsable': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaCentroTransformacionModel
     */
    'FechaLimiteOca': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaCentroTransformacionModel
     */
    'FechaPrevistaOca': string;
}
/**
 * 
 * @export
 * @interface EditOcaUbicacionModel
 */
export interface EditOcaUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditOcaUbicacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaUbicacionModel
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaUbicacionModel
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaUbicacionModel
     */
    'IdPdsOca': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaUbicacionModel
     */
    'IdUsuarioResponsable': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaUbicacionModel
     */
    'FechaLimiteOca': string;
    /**
     * 
     * @type {string}
     * @memberof EditOcaUbicacionModel
     */
    'FechaPrevistaOca': string;
}
/**
 * 
 * @export
 * @interface EditPartnerModel
 */
export interface EditPartnerModel {
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'Cif': string;
    /**
     * 
     * @type {number}
     * @memberof EditPartnerModel
     */
    'PeriodoInformes': number;
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'IdBd': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'EmailsContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'FechaUltimoInforme': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'Acreedor': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditPartnerModel
     */
    'AfectaCanarias': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditPartnerModel
     */
    'TerminoEnergia': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditPartnerModel
     */
    'CantidadEnergia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditPartnerModel
     */
    'TerminoPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditPartnerModel
     */
    'CantidadPotencia': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditPartnerModel
     */
    'Privado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditPartnerModel
     */
    'EnviarActualizacionWo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditPartnerModel
     */
    'PermitirVerEstadoWo': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditPartnerModel
     */
    'PeriodicidadFijo': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditPartnerModel
     */
    'PrecioFijoSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditPartnerModel
     */
    'PrecioFijoTotal': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditPartnerModel
     */
    'IncluyeIrpf': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditPartnerModel
     */
    'FechaUltimoInformeFijo': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditPartnerModel
     */
    'IdBusinessModelRevenueFijo': number | null;
    /**
     * 
     * @type {Array<AdjuntoPartnerTemporalModel>}
     * @memberof EditPartnerModel
     */
    'AdjuntosTemporales': Array<AdjuntoPartnerTemporalModel>;
}
/**
 * 
 * @export
 * @interface EditPdsModel
 */
export interface EditPdsModel {
    /**
     * 
     * @type {ModeloPagoEnum}
     * @memberof EditPdsModel
     */
    'IdModeloPago'?: ModeloPagoEnum;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'Cif'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'RazonSocial'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'EmailsContacto'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'ResponsablesIds'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'Zona'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'CodigosPostales'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'TelefonoMudanza'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'TelefonoGuardia'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'Direccion'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'PersonaContacto'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditPdsModel
     */
    'IdUsuarioKim'?: string;
    /**
     * 
     * @type {Array<TipoPrestadorEnum>}
     * @memberof EditPdsModel
     */
    'TiposPrestador'?: Array<TipoPrestadorEnum>;
    /**
     * 
     * @type {Array<PdsAsignacionProvinciaItem>}
     * @memberof EditPdsModel
     */
    'AsignacionesProvincia'?: Array<PdsAsignacionProvinciaItem>;
}


/**
 * 
 * @export
 * @interface EditSuscripcionPorUsuarioModel
 */
export interface EditSuscripcionPorUsuarioModel {
    /**
     * 
     * @type {string}
     * @memberof EditSuscripcionPorUsuarioModel
     */
    'IdUsuario': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditSuscripcionPorUsuarioModel
     */
    'Email': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditSuscripcionPorUsuarioModel
     */
    'IdsTenants': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditSuscripcionPorUsuarioModel
     */
    'IdsCargadores': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EditSuscripcionPorUsuarioModel
     */
    'SuscritoHorario': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditSuscripcionPorUsuarioModel
     */
    'SuscritoAlarmas': boolean;
}
/**
 * 
 * @export
 * @interface EditTicketModel
 */
export interface EditTicketModel {
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'IdTicket': string;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'IdEstado': number;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'IdSubestado': number;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'IdColaUsuario': number;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'IdPrioridadTicket': number;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'NumeroPedido': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'NumeroConformidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'NumeroTicketFabricante': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'IdPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditTicketModel
     */
    'AsistenciaPerdida': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'Importe': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditTicketModel
     */
    'IdUsuarioResponsable': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditTicketModel
     */
    'FirmwareActualizado': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditTicketModel
     */
    'EsFcr': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'MotivoNoFcr': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditTicketModel
     */
    'DesconocimientoPrestador': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'ObservacionDesconocimientoPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'TiempoAtencion': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'IdTipologiaIncidencia': number;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'IdSubtipologiaIncidencia': number;
    /**
     * 
     * @type {string}
     * @memberof EditTicketModel
     */
    'CanalEntrada': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditTicketModel
     */
    'IdOrigenTicket': number;
}
/**
 * 
 * @export
 * @interface EditUbicacionModel
 */
export interface EditUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'Matricula': string;
    /**
     * 
     * @type {number}
     * @memberof EditUbicacionModel
     */
    'IdBusinessModel': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'Municipio': string;
    /**
     * 
     * @type {number}
     * @memberof EditUbicacionModel
     */
    'IdProvincia': number;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'CodigoPostal': string;
    /**
     * 
     * @type {number}
     * @memberof EditUbicacionModel
     */
    'DelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'Titular': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'CifTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'Cups': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'Cove': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUbicacionModel
     */
    'FechaCaducidad': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditUbicacionModel
     */
    'IdTipoInfraestructuraCargador': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUbicacionModel
     */
    'IdsCargadores': Array<string>;
    /**
     * 
     * @type {Array<UbicacionFicheroAdjuntoInputModel>}
     * @memberof EditUbicacionModel
     */
    'FicherosAdjuntos': Array<UbicacionFicheroAdjuntoInputModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUbicacionModel
     */
    'IdsFicherosEliminar': Array<string>;
}
/**
 * 
 * @export
 * @interface EditUserGmaoModel
 */
export interface EditUserGmaoModel {
    /**
     * 
     * @type {string}
     * @memberof EditUserGmaoModel
     */
    'IdUsuario': string;
    /**
     * 
     * @type {string}
     * @memberof EditUserGmaoModel
     */
    'Nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserGmaoModel
     */
    'Apellidos'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserGmaoModel
     */
    'Rol'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserGmaoModel
     */
    'Dni'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserGmaoModel
     */
    'IdPdsAsociado': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditUserGmaoModel
     */
    'IdColaUsuario': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditUserGmaoModel
     */
    'PuedeUsarIa'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditUserGmaoModel
     */
    'SaldoDisponibleIa'?: number;
}
/**
 * 
 * @export
 * @interface EditUserModel
 */
export interface EditUserModel {
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'IdUsuario': string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Apellidos'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Rol'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUserModel
     */
    'IdPartnersAsociados': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUserModel
     */
    'IdPartnersAsociadosConUsuarioBd': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EditUserModel
     */
    'PuedeUsarIa'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditUserModel
     */
    'SaldoDisponibleIa'?: number;
}
/**
 * 
 * @export
 * @interface EditVisitaCentroTransformacionModel
 */
export interface EditVisitaCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'IdVisita': string;
    /**
     * 
     * @type {number}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'IdResultadoVisitaOca': number;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'FechaCertificacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'TieneDeficienciaTecnica': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'ObservacionesDeficienciaTecnica': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'IdsDeficienciasTecnica': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'TieneDeficienciaDocumental': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'ObservacionesDeficienciaDocumental': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'IdsDeficienciasDocumental': Array<number>;
    /**
     * 
     * @type {Array<VisitaFicheroAdjuntoInputModel>}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'FicherosAdjuntos': Array<VisitaFicheroAdjuntoInputModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditVisitaCentroTransformacionModel
     */
    'IdsFicherosEliminar': Array<string>;
}
/**
 * 
 * @export
 * @interface EditVisitaUbicacionModel
 */
export interface EditVisitaUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditVisitaUbicacionModel
     */
    'IdVisita': string;
    /**
     * 
     * @type {number}
     * @memberof EditVisitaUbicacionModel
     */
    'IdResultadoVisitaOca': number;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaUbicacionModel
     */
    'FechaCertificacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaUbicacionModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditVisitaUbicacionModel
     */
    'TieneDeficienciaTecnica': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaUbicacionModel
     */
    'ObservacionesDeficienciaTecnica': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditVisitaUbicacionModel
     */
    'IdsDeficienciasTecnica': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof EditVisitaUbicacionModel
     */
    'TieneDeficienciaDocumental': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaUbicacionModel
     */
    'ObservacionesDeficienciaDocumental': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditVisitaUbicacionModel
     */
    'IdsDeficienciasDocumental': Array<number>;
    /**
     * 
     * @type {Array<VisitaFicheroAdjuntoInputModel>}
     * @memberof EditVisitaUbicacionModel
     */
    'FicherosAdjuntos': Array<VisitaFicheroAdjuntoInputModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditVisitaUbicacionModel
     */
    'IdsFicherosEliminar': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditVisitaUbicacionModel
     */
    'Expediente': string | null;
}
/**
 * 
 * @export
 * @interface EditWoExternoItemModel
 */
export interface EditWoExternoItemModel {
    /**
     * 
     * @type {string}
     * @memberof EditWoExternoItemModel
     */
    'IdWo': string;
    /**
     * 
     * @type {string}
     * @memberof EditWoExternoItemModel
     */
    'Conclusiones': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditWoExternoItemModel
     */
    'EsFavorable': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof EditWoExternoItemModel
     */
    'IdTipologiaIncidencia': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditWoExternoItemModel
     */
    'IdSubtipologiaIncidencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditWoExternoItemModel
     */
    'MensajeIncidencia': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditWoExternoItemModel
     */
    'SustitucionCompletaPuntoRecarga': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EditWoExternoItemModel
     */
    'NumeroSerieNuevo': string | null;
}
/**
 * 
 * @export
 * @interface EditWoModel
 */
export interface EditWoModel {
    /**
     * 
     * @type {string}
     * @memberof EditWoModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof EditWoModel
     */
    'IdSubestado': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditWoModel
     */
    'ObservacionPrestador': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditWoModel
     */
    'IdXcustomerWo': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditWoModel
     */
    'IdXcustomerCaso': number | null;
    /**
     * 
     * @type {Date}
     * @memberof EditWoModel
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditWoModel
     */
    'EsCapex': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditWoModel
     */
    'EnGarantia': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditWoModel
     */
    'FacturarMovilidad': boolean | null;
}
/**
 * 
 * @export
 * @interface EditarImporteFijoTransaccionModel
 */
export interface EditarImporteFijoTransaccionModel {
    /**
     * 
     * @type {string}
     * @memberof EditarImporteFijoTransaccionModel
     */
    'IdTransaccion': string;
    /**
     * 
     * @type {number}
     * @memberof EditarImporteFijoTransaccionModel
     */
    'TotalSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditarImporteFijoTransaccionModel
     */
    'TotalConImpuestos': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditarImporteFijoTransaccionModel
     */
    'IncluyeIrpf': boolean;
}
/**
 * 
 * @export
 * @interface EditarObservacionOcaModel
 */
export interface EditarObservacionOcaModel {
    /**
     * 
     * @type {string}
     * @memberof EditarObservacionOcaModel
     */
    'Texto': string;
}
/**
 * 
 * @export
 * @interface EnergiaTecnologiaKpiModel
 */
export interface EnergiaTecnologiaKpiModel {
    /**
     * 
     * @type {string}
     * @memberof EnergiaTecnologiaKpiModel
     */
    'Tecnologia': string;
    /**
     * 
     * @type {number}
     * @memberof EnergiaTecnologiaKpiModel
     */
    'EnergiaMwh': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnergiaTecnologiaKpiModel
     */
    'EnergiaRelativaPorSesionKwh': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnergiaTecnologiaKpiModel
     */
    'NumSesiones': number;
}
/**
 * 
 * @export
 * @interface EnergiaTecnologiaMesKpiModel
 */
export interface EnergiaTecnologiaMesKpiModel {
    /**
     * 
     * @type {number}
     * @memberof EnergiaTecnologiaMesKpiModel
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof EnergiaTecnologiaMesKpiModel
     */
    'Mes': number;
    /**
     * 
     * @type {string}
     * @memberof EnergiaTecnologiaMesKpiModel
     */
    'Tecnologia': string;
    /**
     * 
     * @type {number}
     * @memberof EnergiaTecnologiaMesKpiModel
     */
    'EnergiaMwh': number | null;
}
/**
 * 
 * @export
 * @interface EnviarMensajeOcaModel
 */
export interface EnviarMensajeOcaModel {
    /**
     * 
     * @type {string}
     * @memberof EnviarMensajeOcaModel
     */
    'IdOca': string;
    /**
     * 
     * @type {string}
     * @memberof EnviarMensajeOcaModel
     */
    'Mensaje': string;
}
/**
 * 
 * @export
 * @interface EquipoMedidaExternoDto
 */
export interface EquipoMedidaExternoDto {
    /**
     * 
     * @type {string}
     * @memberof EquipoMedidaExternoDto
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EquipoMedidaExternoDto
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof EquipoMedidaExternoDto
     */
    'Marca': string;
    /**
     * 
     * @type {string}
     * @memberof EquipoMedidaExternoDto
     */
    'Modelo': string;
    /**
     * 
     * @type {Date}
     * @memberof EquipoMedidaExternoDto
     */
    'FechaCalibracion': Date;
    /**
     * 
     * @type {Date}
     * @memberof EquipoMedidaExternoDto
     */
    'FechaProximaCalibracion': Date;
    /**
     * 
     * @type {string}
     * @memberof EquipoMedidaExternoDto
     */
    'IdTecnico': string;
    /**
     * 
     * @type {string}
     * @memberof EquipoMedidaExternoDto
     */
    'Tecnico': string;
}
/**
 * 
 * @export
 * @interface EsquemaUnifilarUbicacionActivoModel
 */
export interface EsquemaUnifilarUbicacionActivoModel {
    /**
     * 
     * @type {boolean}
     * @memberof EsquemaUnifilarUbicacionActivoModel
     */
    'TieneEsquema': boolean;
    /**
     * 
     * @type {string}
     * @memberof EsquemaUnifilarUbicacionActivoModel
     */
    'UrlFichero': string | null;
    /**
     * 
     * @type {string}
     * @memberof EsquemaUnifilarUbicacionActivoModel
     */
    'NombreFichero': string | null;
}
/**
 * 
 * @export
 * @interface EsquemaUnifilarUbicacionActivoModelResponseDTO
 */
export interface EsquemaUnifilarUbicacionActivoModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {EsquemaUnifilarUbicacionActivoModel}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'Data'?: EsquemaUnifilarUbicacionActivoModel;
    /**
     * 
     * @type {any}
     * @memberof EsquemaUnifilarUbicacionActivoModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface EstadisticasTecnicoMaestroPagosModel
 */
export interface EstadisticasTecnicoMaestroPagosModel {
    /**
     * 
     * @type {string}
     * @memberof EstadisticasTecnicoMaestroPagosModel
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof EstadisticasTecnicoMaestroPagosModel
     */
    'Tecnico': string;
    /**
     * 
     * @type {number}
     * @memberof EstadisticasTecnicoMaestroPagosModel
     */
    'WoCerradas': number;
    /**
     * 
     * @type {number}
     * @memberof EstadisticasTecnicoMaestroPagosModel
     */
    'WoRechazadas': number;
    /**
     * 
     * @type {number}
     * @memberof EstadisticasTecnicoMaestroPagosModel
     */
    'PorcentajeIncidencia': number;
    /**
     * 
     * @type {number}
     * @memberof EstadisticasTecnicoMaestroPagosModel
     */
    'Total': number;
    /**
     * 
     * @type {number}
     * @memberof EstadisticasTecnicoMaestroPagosModel
     */
    'MediaWo': number;
}
/**
 * 
 * @export
 * @interface EstadisticasTecnicoMaestroPagosModelListResponseDTO
 */
export interface EstadisticasTecnicoMaestroPagosModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<EstadisticasTecnicoMaestroPagosModel>}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'Data'?: Array<EstadisticasTecnicoMaestroPagosModel>;
    /**
     * 
     * @type {any}
     * @memberof EstadisticasTecnicoMaestroPagosModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoCampanaEnum = {
    Borrador: 'Borrador',
    Activa: 'Activa',
    Cerrada: 'Cerrada'
} as const;

export type EstadoCampanaEnum = typeof EstadoCampanaEnum[keyof typeof EstadoCampanaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoComplianceEnum = {
    Ok: 'OK',
    Ko: 'KO',
    Cancelada: 'CANCELADA'
} as const;

export type EstadoComplianceEnum = typeof EstadoComplianceEnum[keyof typeof EstadoComplianceEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoComplianceInspeccionVisualEnum = {
    Pendiente: 'PENDIENTE',
    Ok: 'OK',
    PeriodicidadPausada: 'PERIODICIDAD_PAUSADA'
} as const;

export type EstadoComplianceInspeccionVisualEnum = typeof EstadoComplianceInspeccionVisualEnum[keyof typeof EstadoComplianceInspeccionVisualEnum];


/**
 * 
 * @export
 * @interface EstadoTicketsRm
 */
export interface EstadoTicketsRm {
    /**
     * 
     * @type {number}
     * @memberof EstadoTicketsRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof EstadoTicketsRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof EstadoTicketsRm
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {boolean}
     * @memberof EstadoTicketsRm
     */
    'EsCierreTicket': boolean;
}
/**
 * 
 * @export
 * @interface EstadoTicketsRmListResponseDTO
 */
export interface EstadoTicketsRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<EstadoTicketsRm>}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'Data'?: Array<EstadoTicketsRm>;
    /**
     * 
     * @type {any}
     * @memberof EstadoTicketsRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface FechasImportacion
 */
export interface FechasImportacion {
    /**
     * 
     * @type {string}
     * @memberof FechasImportacion
     */
    'UltimaImportacion': string;
    /**
     * 
     * @type {string}
     * @memberof FechasImportacion
     */
    'AnteriorImportacion': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FicheroAdjuntoUbicacionOrigenEnum = {
    Echarger: 'ECHARGER',
    Dg: 'DG'
} as const;

export type FicheroAdjuntoUbicacionOrigenEnum = typeof FicheroAdjuntoUbicacionOrigenEnum[keyof typeof FicheroAdjuntoUbicacionOrigenEnum];


/**
 * 
 * @export
 * @interface FicheroDescarga
 */
export interface FicheroDescarga {
    /**
     * 
     * @type {string}
     * @memberof FicheroDescarga
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroDescarga
     */
    'RutaDescarga': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroDescarga
     */
    'NombreFichero': string;
}
/**
 * 
 * @export
 * @interface FicheroModel
 */
export interface FicheroModel {
    /**
     * 
     * @type {string}
     * @memberof FicheroModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof FicheroModel
     */
    'IdTipoFicheroAdjuntoOca': number;
    /**
     * 
     * @type {string}
     * @memberof FicheroModel
     */
    'TipoFicheroCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroModel
     */
    'TipoFicheroDenoDefecto': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroModel
     */
    'Extension': string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheroModel
     */
    'MimeType': string | null;
    /**
     * 
     * @type {number}
     * @memberof FicheroModel
     */
    'Tamano': number | null;
    /**
     * 
     * @type {Date}
     * @memberof FicheroModel
     */
    'FechaSubida': Date;
    /**
     * 
     * @type {string}
     * @memberof FicheroModel
     */
    'UrlDescarga': string;
    /**
     * 
     * @type {FicheroAdjuntoUbicacionOrigenEnum}
     * @memberof FicheroModel
     */
    'Origen': FicheroAdjuntoUbicacionOrigenEnum;
}


/**
 * 
 * @export
 * @interface FileStreamResultResponseDTO
 */
export interface FileStreamResultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof FileStreamResultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof FileStreamResultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FileStreamResultResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileStreamResultResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof FileStreamResultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileStreamResultResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {File}
     * @memberof FileStreamResultResponseDTO
     */
    'Data'?: File;
    /**
     * 
     * @type {any}
     * @memberof FileStreamResultResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface FirmarActuacionModel
 */
export interface FirmarActuacionModel {
    /**
     * 
     * @type {string}
     * @memberof FirmarActuacionModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof FirmarActuacionModel
     */
    'FirmaTecnico': string;
    /**
     * 
     * @type {string}
     * @memberof FirmarActuacionModel
     */
    'FirmaCliente': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FirmarActuacionModel
     */
    'ClienteAusente': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FirmarActuacionModel
     */
    'EsGuardadoParcial': boolean;
}
/**
 * 
 * @export
 * @interface GetCargadoresModel
 */
export interface GetCargadoresModel {
    /**
     * 
     * @type {Array<CargadorRm>}
     * @memberof GetCargadoresModel
     */
    'Cargadores': Array<CargadorRm>;
    /**
     * 
     * @type {number}
     * @memberof GetCargadoresModel
     */
    'TotalCount': number;
}
/**
 * 
 * @export
 * @interface GetCargadoresModelResponseDTO
 */
export interface GetCargadoresModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetCargadoresModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetCargadoresModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetCargadoresModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCargadoresModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCargadoresModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargadoresModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetCargadoresModel}
     * @memberof GetCargadoresModelResponseDTO
     */
    'Data'?: GetCargadoresModel;
    /**
     * 
     * @type {any}
     * @memberof GetCargadoresModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GetEquiposMedidaPorPdsUsuarioResponse
 */
export interface GetEquiposMedidaPorPdsUsuarioResponse {
    /**
     * 
     * @type {Array<EquipoMedidaExternoDto>}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponse
     */
    'Items': Array<EquipoMedidaExternoDto>;
}
/**
 * 
 * @export
 * @interface GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
 */
export interface GetEquiposMedidaPorPdsUsuarioResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetEquiposMedidaPorPdsUsuarioResponse}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'Data'?: GetEquiposMedidaPorPdsUsuarioResponse;
    /**
     * 
     * @type {any}
     * @memberof GetEquiposMedidaPorPdsUsuarioResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GetListadoActuacionesExternasResponse
 */
export interface GetListadoActuacionesExternasResponse {
    /**
     * 
     * @type {Array<DetalleActuacionExternaDto>}
     * @memberof GetListadoActuacionesExternasResponse
     */
    'Items': Array<DetalleActuacionExternaDto>;
    /**
     * 
     * @type {number}
     * @memberof GetListadoActuacionesExternasResponse
     */
    'TotalCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetListadoActuacionesExternasResponse
     */
    'Page': number;
    /**
     * 
     * @type {number}
     * @memberof GetListadoActuacionesExternasResponse
     */
    'PageSize': number;
}
/**
 * 
 * @export
 * @interface GetListadoActuacionesExternasResponseResponseDTO
 */
export interface GetListadoActuacionesExternasResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetListadoActuacionesExternasResponse}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'Data'?: GetListadoActuacionesExternasResponse;
    /**
     * 
     * @type {any}
     * @memberof GetListadoActuacionesExternasResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GetNotificacionesModel
 */
export interface GetNotificacionesModel {
    /**
     * 
     * @type {Array<NotificacionModel>}
     * @memberof GetNotificacionesModel
     */
    'NotificacionesSinLeer': Array<NotificacionModel>;
    /**
     * 
     * @type {Array<NotificacionModel>}
     * @memberof GetNotificacionesModel
     */
    'NotificacionesLeidas': Array<NotificacionModel>;
}
/**
 * 
 * @export
 * @interface GetNotificacionesModelResponseDTO
 */
export interface GetNotificacionesModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetNotificacionesModel}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Data'?: GetNotificacionesModel;
    /**
     * 
     * @type {any}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GetTenantsModel
 */
export interface GetTenantsModel {
    /**
     * 
     * @type {Array<TenantRm>}
     * @memberof GetTenantsModel
     */
    'Tenants': Array<TenantRm>;
    /**
     * 
     * @type {number}
     * @memberof GetTenantsModel
     */
    'TotalCount': number;
}
/**
 * 
 * @export
 * @interface GetTenantsModelResponseDTO
 */
export interface GetTenantsModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetTenantsModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetTenantsModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantsModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTenantsModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTenantsModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTenantsModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetTenantsModel}
     * @memberof GetTenantsModelResponseDTO
     */
    'Data'?: GetTenantsModel;
    /**
     * 
     * @type {any}
     * @memberof GetTenantsModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GetTipologiasSubtipologiasIncidenciaExternoResponse
 */
export interface GetTipologiasSubtipologiasIncidenciaExternoResponse {
    /**
     * 
     * @type {Array<TipologiaSubtipologiaIncidenciaRm>}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponse
     */
    'Items': Array<TipologiaSubtipologiaIncidenciaRm>;
}
/**
 * 
 * @export
 * @interface GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
 */
export interface GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetTipologiasSubtipologiasIncidenciaExternoResponse}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'Data'?: GetTipologiasSubtipologiasIncidenciaExternoResponse;
    /**
     * 
     * @type {any}
     * @memberof GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GetUsuariosTecnicosPorPdsUsuarioResponse
 */
export interface GetUsuariosTecnicosPorPdsUsuarioResponse {
    /**
     * 
     * @type {Array<UsuarioTecnicoExternoDto>}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponse
     */
    'Items': Array<UsuarioTecnicoExternoDto>;
}
/**
 * 
 * @export
 * @interface GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
 */
export interface GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetUsuariosTecnicosPorPdsUsuarioResponse}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'Data'?: GetUsuariosTecnicosPorPdsUsuarioResponse;
    /**
     * 
     * @type {any}
     * @memberof GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GraficaAgrupacionModel
 */
export interface GraficaAgrupacionModel {
    /**
     * 
     * @type {number}
     * @memberof GraficaAgrupacionModel
     */
    'Total': number;
    /**
     * 
     * @type {Array<GraficaSegmentoModel>}
     * @memberof GraficaAgrupacionModel
     */
    'Segmentos': Array<GraficaSegmentoModel>;
}
/**
 * 
 * @export
 * @interface GraficaEstadoActualWoRm
 */
export interface GraficaEstadoActualWoRm {
    /**
     * 
     * @type {string}
     * @memberof GraficaEstadoActualWoRm
     */
    'TipoWo': string;
    /**
     * 
     * @type {Date}
     * @memberof GraficaEstadoActualWoRm
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {string}
     * @memberof GraficaEstadoActualWoRm
     */
    'Prestador': string;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'TotalWos': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'TotalAsignadas': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'TotalCerradas': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'TotalPdteAutorizacion': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'TotalRechazadas': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'TotalAsignadasVencidasRecientes': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'TotalAsignadasVencidasCriticas': number;
    /**
     * 
     * @type {string}
     * @memberof GraficaEstadoActualWoRm
     */
    'IdPartner': string | null;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoActualWoRm
     */
    'IdZona': number | null;
}
/**
 * 
 * @export
 * @interface GraficaEstadoActualWoRmListResponseDTO
 */
export interface GraficaEstadoActualWoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<GraficaEstadoActualWoRm>}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'Data'?: Array<GraficaEstadoActualWoRm>;
    /**
     * 
     * @type {any}
     * @memberof GraficaEstadoActualWoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GraficaEstadoCargadorCampanaModel
 */
export interface GraficaEstadoCargadorCampanaModel {
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoCargadorCampanaModel
     */
    'TotalCargadores': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoCargadorCampanaModel
     */
    'TotalUnavailables': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoCargadorCampanaModel
     */
    'TotalOks': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoCargadorCampanaModel
     */
    'TotalKos': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoCargadorCampanaModel
     */
    'TotalNoAplica': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoCargadorCampanaModel
     */
    'TotalInstalled': number;
}
/**
 * 
 * @export
 * @interface GraficaEstadoWoCampanaModel
 */
export interface GraficaEstadoWoCampanaModel {
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalWos': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalAsignadas': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalCerradas': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalCanceladas': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalPdteAutorizacion': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalRechazadas': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalAsignadasVencidasRecientes': number;
    /**
     * 
     * @type {number}
     * @memberof GraficaEstadoWoCampanaModel
     */
    'TotalAsignadasVencidasCriticas': number;
}
/**
 * 
 * @export
 * @interface GraficaOcaAgrupacionModel
 */
export interface GraficaOcaAgrupacionModel {
    /**
     * 
     * @type {number}
     * @memberof GraficaOcaAgrupacionModel
     */
    'Total': number;
    /**
     * 
     * @type {Array<GraficaOcaSegmentoModel>}
     * @memberof GraficaOcaAgrupacionModel
     */
    'Segmentos': Array<GraficaOcaSegmentoModel>;
}
/**
 * 
 * @export
 * @interface GraficaOcaSegmentoModel
 */
export interface GraficaOcaSegmentoModel {
    /**
     * 
     * @type {string}
     * @memberof GraficaOcaSegmentoModel
     */
    'Codigo': string;
    /**
     * 
     * @type {number}
     * @memberof GraficaOcaSegmentoModel
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface GraficaRetrasosWosMediaRm
 */
export interface GraficaRetrasosWosMediaRm {
    /**
     * 
     * @type {string}
     * @memberof GraficaRetrasosWosMediaRm
     */
    'TipoWo': string;
    /**
     * 
     * @type {Date}
     * @memberof GraficaRetrasosWosMediaRm
     */
    'Mes': Date;
    /**
     * 
     * @type {number}
     * @memberof GraficaRetrasosWosMediaRm
     */
    'MediaRetraso': number;
}
/**
 * 
 * @export
 * @interface GraficaRetrasosWosMediaRmListResponseDTO
 */
export interface GraficaRetrasosWosMediaRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<GraficaRetrasosWosMediaRm>}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'Data'?: Array<GraficaRetrasosWosMediaRm>;
    /**
     * 
     * @type {any}
     * @memberof GraficaRetrasosWosMediaRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GraficaSegmentoModel
 */
export interface GraficaSegmentoModel {
    /**
     * 
     * @type {string}
     * @memberof GraficaSegmentoModel
     */
    'Codigo': string;
    /**
     * 
     * @type {number}
     * @memberof GraficaSegmentoModel
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface GraficoVolumenPorEmpresaModel
 */
export interface GraficoVolumenPorEmpresaModel {
    /**
     * 
     * @type {string}
     * @memberof GraficoVolumenPorEmpresaModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {number}
     * @memberof GraficoVolumenPorEmpresaModel
     */
    'NumWoPendientes': number;
    /**
     * 
     * @type {number}
     * @memberof GraficoVolumenPorEmpresaModel
     */
    'ImporteRealTotal': number | null;
    /**
     * 
     * @type {number}
     * @memberof GraficoVolumenPorEmpresaModel
     */
    'ImporteTotal': number;
}
/**
 * 
 * @export
 * @interface GraficoVolumenPorEmpresaModelListResponseDTO
 */
export interface GraficoVolumenPorEmpresaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<GraficoVolumenPorEmpresaModel>}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'Data'?: Array<GraficoVolumenPorEmpresaModel>;
    /**
     * 
     * @type {any}
     * @memberof GraficoVolumenPorEmpresaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GroupingInfo
 */
export interface GroupingInfo {
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'desc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'groupInterval'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'isExpanded'?: boolean | null;
}
/**
 * 
 * @export
 * @interface GuardarMspInteroperabilidadModel
 */
export interface GuardarMspInteroperabilidadModel {
    /**
     * 
     * @type {string}
     * @memberof GuardarMspInteroperabilidadModel
     */
    'Id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspInteroperabilidadModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspInteroperabilidadModel
     */
    'NombreComercial': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspInteroperabilidadModel
     */
    'Protocolo': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GuardarMspInteroperabilidadModel
     */
    'AcuerdoActivo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspInteroperabilidadModel
     */
    'IdTarifa': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspInteroperabilidadModel
     */
    'FechaInicioAsignacion': string | null;
}
/**
 * 
 * @export
 * @interface GuardarMspTarifaInteroperabilidadModel
 */
export interface GuardarMspTarifaInteroperabilidadModel {
    /**
     * 
     * @type {string}
     * @memberof GuardarMspTarifaInteroperabilidadModel
     */
    'Id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspTarifaInteroperabilidadModel
     */
    'IdMsp': string;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspTarifaInteroperabilidadModel
     */
    'IdTarifa': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarMspTarifaInteroperabilidadModel
     */
    'FechaInicio': string;
}
/**
 * 
 * @export
 * @interface GuardarPasoInformeTecnicoIvItemModel
 */
export interface GuardarPasoInformeTecnicoIvItemModel {
    /**
     * 
     * @type {string}
     * @memberof GuardarPasoInformeTecnicoIvItemModel
     */
    'IdRespuesta': string;
    /**
     * 
     * @type {string}
     * @memberof GuardarPasoInformeTecnicoIvItemModel
     */
    'ResultadoItemCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarPasoInformeTecnicoIvItemModel
     */
    'Comentario': string | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarPasoInformeTecnicoIvItemModel
     */
    'ValorNumerico': number | null;
}
/**
 * 
 * @export
 * @interface GuardarPasoInformeTecnicoIvModel
 */
export interface GuardarPasoInformeTecnicoIvModel {
    /**
     * 
     * @type {boolean}
     * @memberof GuardarPasoInformeTecnicoIvModel
     */
    'Parcial': boolean;
    /**
     * 
     * @type {string}
     * @memberof GuardarPasoInformeTecnicoIvModel
     */
    'FechaModificacion': string;
    /**
     * 
     * @type {string}
     * @memberof GuardarPasoInformeTecnicoIvModel
     */
    'Incidencia': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarPasoInformeTecnicoIvModel
     */
    'Conclusiones': string | null;
    /**
     * 
     * @type {Array<GuardarPasoInformeTecnicoIvItemModel>}
     * @memberof GuardarPasoInformeTecnicoIvModel
     */
    'Items': Array<GuardarPasoInformeTecnicoIvItemModel>;
    /**
     * 
     * @type {Array<NuevoAdjuntoPasoIvModel>}
     * @memberof GuardarPasoInformeTecnicoIvModel
     */
    'Adjuntos': Array<NuevoAdjuntoPasoIvModel>;
    /**
     * 
     * @type {Array<RetirarAdjuntoPasoIvModel>}
     * @memberof GuardarPasoInformeTecnicoIvModel
     */
    'RetirarAdjuntos': Array<RetirarAdjuntoPasoIvModel>;
}
/**
 * 
 * @export
 * @interface GuardarRecargaTarifaInteroperabilidadModel
 */
export interface GuardarRecargaTarifaInteroperabilidadModel {
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaInteroperabilidadModel
     */
    'Id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaInteroperabilidadModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaInteroperabilidadModel
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface GuardarRecargaTarifaPrecioInteroperabilidadModel
 */
export interface GuardarRecargaTarifaPrecioInteroperabilidadModel {
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'Id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'IdTarifa': string;
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'TipoPotencia': string;
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'FechaInicio': string;
    /**
     * 
     * @type {boolean}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {string}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'TipoPrecio': string | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'CuotaMensualSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioDiaSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioNocheSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioDiaDescuentoSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioNocheDescuentoSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioDiaConIva': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioNocheConIva': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioDiaConIgic': number | null;
    /**
     * 
     * @type {number}
     * @memberof GuardarRecargaTarifaPrecioInteroperabilidadModel
     */
    'PrecioNocheConIgic': number | null;
}
/**
 * 
 * @export
 * @interface GuidResponseDTO
 */
export interface GuidResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GuidResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GuidResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GuidResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GuidResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GuidResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidResponseDTO
     */
    'Data'?: string;
    /**
     * 
     * @type {any}
     * @memberof GuidResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface HistoricoOcaUbicacionItemModel
 */
export interface HistoricoOcaUbicacionItemModel {
    /**
     * 
     * @type {string}
     * @memberof HistoricoOcaUbicacionItemModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof HistoricoOcaUbicacionItemModel
     */
    'IdNumerico': number;
    /**
     * 
     * @type {Date}
     * @memberof HistoricoOcaUbicacionItemModel
     */
    'FechaActuacion': Date | null;
    /**
     * 
     * @type {number}
     * @memberof HistoricoOcaUbicacionItemModel
     */
    'NumVisitas': number;
    /**
     * 
     * @type {Array<HistoricoVisitaOcaItemModel>}
     * @memberof HistoricoOcaUbicacionItemModel
     */
    'Visitas': Array<HistoricoVisitaOcaItemModel>;
}
/**
 * 
 * @export
 * @interface HistoricoOcasUbicacionModel
 */
export interface HistoricoOcasUbicacionModel {
    /**
     * 
     * @type {string}
     * @memberof HistoricoOcasUbicacionModel
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {number}
     * @memberof HistoricoOcasUbicacionModel
     */
    'NumOcas': number;
    /**
     * 
     * @type {Array<HistoricoOcaUbicacionItemModel>}
     * @memberof HistoricoOcasUbicacionModel
     */
    'Ocas': Array<HistoricoOcaUbicacionItemModel>;
}
/**
 * 
 * @export
 * @interface HistoricoOcasUbicacionModelResponseDTO
 */
export interface HistoricoOcasUbicacionModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {HistoricoOcasUbicacionModel}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'Data'?: HistoricoOcasUbicacionModel;
    /**
     * 
     * @type {any}
     * @memberof HistoricoOcasUbicacionModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface HistoricoVisitaOcaItemModel
 */
export interface HistoricoVisitaOcaItemModel {
    /**
     * 
     * @type {string}
     * @memberof HistoricoVisitaOcaItemModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof HistoricoVisitaOcaItemModel
     */
    'Numero': number;
    /**
     * 
     * @type {Date}
     * @memberof HistoricoVisitaOcaItemModel
     */
    'FechaProgramacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricoVisitaOcaItemModel
     */
    'ResultadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricoVisitaOcaItemModel
     */
    'ResultadoDenoDefecto': string | null;
    /**
     * 
     * @type {Array<AdjuntoVisitaModel>}
     * @memberof HistoricoVisitaOcaItemModel
     */
    'Ficheros': Array<AdjuntoVisitaModel>;
}
/**
 * 
 * @export
 * @interface IdNameItem
 */
export interface IdNameItem {
    /**
     * 
     * @type {number}
     * @memberof IdNameItem
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof IdNameItem
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface IdNameItemListResponseDTO
 */
export interface IdNameItemListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof IdNameItemListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof IdNameItemListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof IdNameItemListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdNameItemListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof IdNameItemListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdNameItemListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<IdNameItem>}
     * @memberof IdNameItemListResponseDTO
     */
    'Data'?: Array<IdNameItem>;
    /**
     * 
     * @type {any}
     * @memberof IdNameItemListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ImportacionPartnersModel
 */
export interface ImportacionPartnersModel {
    /**
     * 
     * @type {string}
     * @memberof ImportacionPartnersModel
     */
    'IdCorrelacion': string;
    /**
     * 
     * @type {Date}
     * @memberof ImportacionPartnersModel
     */
    'FechaRealizacion': Date;
    /**
     * 
     * @type {string}
     * @memberof ImportacionPartnersModel
     */
    'NombreFicheroActivos': string;
    /**
     * 
     * @type {string}
     * @memberof ImportacionPartnersModel
     */
    'NombreFicheroOportunidades': string;
    /**
     * 
     * @type {string}
     * @memberof ImportacionPartnersModel
     */
    'NombreFicheroContactos': string;
    /**
     * 
     * @type {string}
     * @memberof ImportacionPartnersModel
     */
    'Log': string | null;
}
/**
 * 
 * @export
 * @interface ImportacionPartnersModelResponseDTO
 */
export interface ImportacionPartnersModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ImportacionPartnersModel}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'Data'?: ImportacionPartnersModel;
    /**
     * 
     * @type {any}
     * @memberof ImportacionPartnersModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface InformeCheckBox
 */
export interface InformeCheckBox {
    /**
     * 
     * @type {string}
     * @memberof InformeCheckBox
     */
    'Valor': string;
    /**
     * 
     * @type {string}
     * @memberof InformeCheckBox
     */
    'Observaciones': string | null;
}
/**
 * 
 * @export
 * @interface InformeCheckBoxCampoNumerico
 */
export interface InformeCheckBoxCampoNumerico {
    /**
     * 
     * @type {string}
     * @memberof InformeCheckBoxCampoNumerico
     */
    'Valor': string;
    /**
     * 
     * @type {string}
     * @memberof InformeCheckBoxCampoNumerico
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {number}
     * @memberof InformeCheckBoxCampoNumerico
     */
    'ValorNumerico': number | null;
}
/**
 * 
 * @export
 * @interface InformeTecnicoComunicacionModel
 */
export interface InformeTecnicoComunicacionModel {
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoComunicacionModel
     */
    'IP': string | null;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoComunicacionModel
     */
    'ICCID': string | null;
    /**
     * 
     * @type {number}
     * @memberof InformeTecnicoComunicacionModel
     */
    'Puerto': number | null;
}
/**
 * 
 * @export
 * @interface InformeTecnicoCorrectivoModel
 */
export interface InformeTecnicoCorrectivoModel {
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'LiberacionCable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ReparacionSustitucionComponenteInSitu': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ReparacionSustitucionComponenteEnTaller': boolean;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'HaCambiadoPiezas': InformeCheckBox;
    /**
     * 
     * @type {Array<string>}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ListaWoPiezas': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'RearmeProteccionesSetaEmergencia': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ReposicionSenaleticaDecoracion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'SustitucionCompletaPuntoRecarga': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'RestauracionSenalesVerticalesVialesProteccion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'PinturaPlazaSinInterior': boolean;
    /**
     * 
     * @type {number}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'NumPlazasPintadasSinInterior': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'PinturaPlazaConInterior': boolean;
    /**
     * 
     * @type {number}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'NumPlazasPintadasConInterior': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'PuestaEnServicioPuntoRecargaConPrueba': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ModificacionPeanaPernosAnclaje': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'Desinsectacion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'AcompanamientoOCA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'EstudioTermografico': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'LimpiezaPuntoAlrededores': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ActualizacionSoftware': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'Monitorizacion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'DesinstalacionPuntoRecarga': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'PruebaCargaTodosMetodosAutenticacion': boolean;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'SimIpNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'SimIccidNuevo': string | null;
    /**
     * 
     * @type {number}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'SimPuertoNuevo': number | null;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'SimIpAntiguo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'SimIccidAntiguo': string | null;
    /**
     * 
     * @type {number}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'SimPuertoAntiguo': number | null;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'NumeroSerieNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'IdCargadorNuevo': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'IdsMotivoCierreWo': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ConclusionesGenerales': string;
    /**
     * 
     * @type {InformeCheckBoxCampoNumerico}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'HorasExtra': InformeCheckBoxCampoNumerico;
    /**
     * 
     * @type {InformeCheckBoxCampoNumerico}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'MaterialExtra': InformeCheckBoxCampoNumerico;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoModel>}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ItemsMaterialesElecnor': Array<ItemElecnorSeleccionadoModel> | null;
    /**
     * 
     * @type {Array<ItemCircutorSeleccionadoModel>}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ItemsMaterialesCircutor': Array<ItemCircutorSeleccionadoModel> | null;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoModel>}
     * @memberof InformeTecnicoCorrectivoModel
     */
    'ItemsCorrectivosElecnor': Array<ItemElecnorSeleccionadoModel> | null;
}
/**
 * 
 * @export
 * @interface InformeTecnicoPemModel
 */
export interface InformeTecnicoPemModel {
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'EstadoGeneralPdr': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'FarolaReloj': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'EstadoArquetas': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'EstadoPintadoAparcamiento': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'SenaleticaSeguridad': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'AdhesivosGenerales': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'NumPegatina': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CableadoInterior': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CalibradoSensibilidad': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CalibradoTiempo': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'ComprobacionIntensidadPdr': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'BotonEmergencia': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'ProbarBotonTest': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'EsquemaUnifilar': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'ResistenciaTierra': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'ResistenciaAislamiento': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'TiempoDiferencial': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'VoltajeL1N': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'VoltajeL2N': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'VoltajeL3N': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'VoltajeNeutroTierra': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'CorrientesFuga': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'EstadoGeneralArmario': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CierreSeccionamiento': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'ConexionesCcs': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CableadoCcs': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'EstadoGeneralCaja': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'InstalacionFusibles': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'ConexionesEquipoMedida': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CableadoEquipoMedida': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'TransformadoresIntensidad': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'EstadoEmbarrado': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'ProteccionIntensidad': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'ComprobacionPat': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'Tubulares': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'TornillerasBornas': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'VerificacionAppSAT': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'VerificacionVersionSAT': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'PruebaCargaSAT': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'Latitud': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'Longitud': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'LatitudNueva': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'LongitudNueva': InformeTextBox;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoPemModel
     */
    'SustituirUbicacion': boolean;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'Tipo': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'NumeroPlanta': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'NumeroPlaza': InformeTextBox;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoPemModel
     */
    'PlazaNoNumerada': boolean;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'AccesoParking': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'ConfiguracionCarga': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CargaAppEndesa': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CargaRfidEndesa': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CargaTpv': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'PruebaTermoGrafica': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'PotenciaTeorica': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'PotenciaMaxima': InformeTextBox;
    /**
     * 
     * @type {InformeTecnicoComunicacionModel}
     * @memberof InformeTecnicoPemModel
     */
    'DatosComunicacion': InformeTecnicoComunicacionModel;
    /**
     * 
     * @type {InformeTecnicoComunicacionModel}
     * @memberof InformeTecnicoPemModel
     */
    'DatosSustitucionSIM': InformeTecnicoComunicacionModel;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'NivelesCobertura': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPemModel
     */
    'BreveExplicacion': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'HolguraConexionManguera': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPemModel
     */
    'CargaFuncionaConHolgura': InformeCheckBox;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoPemModel
     */
    'ConclusionesGenerales': string;
    /**
     * 
     * @type {InformeCheckBoxCampoNumerico}
     * @memberof InformeTecnicoPemModel
     */
    'HorasExtra': InformeCheckBoxCampoNumerico;
    /**
     * 
     * @type {InformeCheckBoxCampoNumerico}
     * @memberof InformeTecnicoPemModel
     */
    'MaterialExtra': InformeCheckBoxCampoNumerico;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoModel>}
     * @memberof InformeTecnicoPemModel
     */
    'ItemsMaterialesElecnor': Array<ItemElecnorSeleccionadoModel> | null;
    /**
     * 
     * @type {Array<ItemCircutorSeleccionadoModel>}
     * @memberof InformeTecnicoPemModel
     */
    'ItemsMaterialesCircutor': Array<ItemCircutorSeleccionadoModel> | null;
}
/**
 * 
 * @export
 * @interface InformeTecnicoPreventivoModel
 */
export interface InformeTecnicoPreventivoModel {
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ManguerasConectores': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'EstadoGeneralPdr': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'PinesConductores': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'GomasJuntas': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'AspiradoFiltros': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'LimpiezaExterior': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'BalizasIluminacion': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'RfidDisplay': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'FarolaReloj': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'LimpiezaFiltros': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'SenaleticaSeguridad': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'PintadoPlaza': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'AdhesivoInstrucciones': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'AdhesivoQR': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'AdhesivosGenerales': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'NumPegatina': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CableadoBornas': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'Magnetotermicos': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CalibradoDiferencial': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'BotonEmergencia': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'TestDiferencial': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ResistenciaTierra': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ResistenciaAislamiento': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeL1N': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeL2N': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeL3N': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeNeutroTierra': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CorrientesFuga': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'TensionesFuentes': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'PruebaCarga': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'LimpiezaExteriorArmario': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'TestInterruptorDiferencial': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'MagnetotermicosCPM': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'AislantesConductores': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ConexionesProtecciones': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'LimpiezaInteriorArmario': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ResistenciaTierraCPM': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'TiempoDisparoDiferencial': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeL1NCPM': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeL2NCPM': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeL3NCPM': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VoltajeNeutroTierraCPM': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'EstadoFusibles': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ConexionesCgpEquipo': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CableadoCgpEquipo': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'EstadoEmbarrado': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ComprobacionPat': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'Tubulares': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VerificacionAppSAT': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VerificacionVersionSAT': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'PruebaCargaSAT': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'Latitud': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'Longitud': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'LatitudNueva': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'LongitudNueva': InformeTextBox;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoPreventivoModel
     */
    'SustituirUbicacion': boolean;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'Tipo': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'NumeroPlanta': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'NumeroPlaza': InformeTextBox;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoPreventivoModel
     */
    'PlazaNoNumerada': boolean;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'AccesoParking': InformeTextBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'UbicacionCargador': InformeTextBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CargaAppEndesa': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CargaRfidEndesa': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CargaTpv': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'PruebaTermografica': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'SustitucionSim': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'VerificacionPotenciaTeorica': InformeCheckBox;
    /**
     * 
     * @type {InformeTextBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'PotenciaMaxima': InformeTextBox;
    /**
     * 
     * @type {InformeTecnicoComunicacionModel}
     * @memberof InformeTecnicoPreventivoModel
     */
    'DatosComunicacion': InformeTecnicoComunicacionModel;
    /**
     * 
     * @type {InformeTecnicoComunicacionModel}
     * @memberof InformeTecnicoPreventivoModel
     */
    'DatosSustitucionSIM': InformeTecnicoComunicacionModel;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'HolguraConexionManguera': InformeCheckBox;
    /**
     * 
     * @type {InformeCheckBox}
     * @memberof InformeTecnicoPreventivoModel
     */
    'CargaFuncionaConHolgura': InformeCheckBox;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ConclusionesGenerales': string;
    /**
     * 
     * @type {InformeCheckBoxCampoNumerico}
     * @memberof InformeTecnicoPreventivoModel
     */
    'HorasExtra': InformeCheckBoxCampoNumerico;
    /**
     * 
     * @type {InformeCheckBoxCampoNumerico}
     * @memberof InformeTecnicoPreventivoModel
     */
    'MaterialExtra': InformeCheckBoxCampoNumerico;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoModel>}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ItemsPreventivosElecnor': Array<ItemElecnorSeleccionadoModel> | null;
    /**
     * 
     * @type {Array<ItemElecnorSeleccionadoModel>}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ItemsMaterialesElecnor': Array<ItemElecnorSeleccionadoModel> | null;
    /**
     * 
     * @type {Array<ItemCircutorSeleccionadoModel>}
     * @memberof InformeTecnicoPreventivoModel
     */
    'ItemsMaterialesCircutor': Array<ItemCircutorSeleccionadoModel> | null;
}
/**
 * 
 * @export
 * @interface InformeTecnicoSustitucionRevenueDto
 */
export interface InformeTecnicoSustitucionRevenueDto {
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoSustitucionRevenueDto
     */
    'RutaDescarga': string;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoSustitucionRevenueDto
     */
    'Nombre': string | null;
}
/**
 * 
 * @export
 * @interface InformeTecnicoSustitucionRevenueDtoResponseDTO
 */
export interface InformeTecnicoSustitucionRevenueDtoResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {InformeTecnicoSustitucionRevenueDto}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'Data'?: InformeTecnicoSustitucionRevenueDto;
    /**
     * 
     * @type {any}
     * @memberof InformeTecnicoSustitucionRevenueDtoResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface InformeTextBox
 */
export interface InformeTextBox {
    /**
     * 
     * @type {string}
     * @memberof InformeTextBox
     */
    'Valor': string;
}
/**
 * 
 * @export
 * @interface InformesActuacionRm
 */
export interface InformesActuacionRm {
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'RutaInformeEconomicoActuacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'IdPds': string;
    /**
     * 
     * @type {number}
     * @memberof InformesActuacionRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {number}
     * @memberof InformesActuacionRm
     */
    'IdXcustomerWo': number | null;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'RutaInformeEconomicoWo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'RutaInformeTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'IdWo': string | null;
    /**
     * 
     * @type {number}
     * @memberof InformesActuacionRm
     */
    'IdTipoWo': number | null;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRm
     */
    'TipoWo': string | null;
    /**
     * 
     * @type {Array<AdjuntoActuacionRm>}
     * @memberof InformesActuacionRm
     */
    'AdjuntosActuacion': Array<AdjuntoActuacionRm> | null;
    /**
     * 
     * @type {Array<AdjuntoActuacionRm>}
     * @memberof InformesActuacionRm
     */
    'AdjuntosWo': Array<AdjuntoActuacionRm> | null;
}
/**
 * 
 * @export
 * @interface InformesActuacionRmListResponseDTO
 */
export interface InformesActuacionRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<InformesActuacionRm>}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'Data'?: Array<InformesActuacionRm>;
    /**
     * 
     * @type {any}
     * @memberof InformesActuacionRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface InspeccionCargadorDetalleModel
 */
export interface InspeccionCargadorDetalleModel {
    /**
     * 
     * @type {string}
     * @memberof InspeccionCargadorDetalleModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionCargadorDetalleModel
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionCargadorDetalleModel
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionCargadorDetalleModel
     */
    'Modelo': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionCargadorDetalleModel
     */
    'Incidencia': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionCargadorDetalleModel
     */
    'ReporteUrgente': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionCargadorDetalleModel
     */
    'Completo': boolean;
    /**
     * 
     * @type {InspeccionFicheroDetalleModel}
     * @memberof InspeccionCargadorDetalleModel
     */
    'Informe': InspeccionFicheroDetalleModel | null;
}
/**
 * 
 * @export
 * @interface InspeccionFicheroDetalleModel
 */
export interface InspeccionFicheroDetalleModel {
    /**
     * 
     * @type {string}
     * @memberof InspeccionFicheroDetalleModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof InspeccionFicheroDetalleModel
     */
    'IdTipo': number;
    /**
     * 
     * @type {string}
     * @memberof InspeccionFicheroDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionFicheroDetalleModel
     */
    'Url': string | null;
}
/**
 * 
 * @export
 * @interface InspeccionRespuestaDetalleModel
 */
export interface InspeccionRespuestaDetalleModel {
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemDescripcion': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemAmbito': string;
    /**
     * 
     * @type {number}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemOrden': number;
    /**
     * 
     * @type {number}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'IdCategoria': number;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemCategoriaCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemCategoriaDenoDefecto': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemCritico': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemRequiereValor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemRequiereFactura': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemObligatorio': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ItemPermiteNoAplica': boolean;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'IdCargador': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'IdResultadoItem': number | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ResultadoItemCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'Comentario': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'ValorNumerico': number | null;
    /**
     * 
     * @type {Array<InspeccionFicheroDetalleModel>}
     * @memberof InspeccionRespuestaDetalleModel
     */
    'Ficheros': Array<InspeccionFicheroDetalleModel>;
}
/**
 * 
 * @export
 * @interface InspeccionVisualCabeceraModel
 */
export interface InspeccionVisualCabeceraModel {
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualCabeceraModel
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'UbicacionMatricula': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'PdsCif': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'PdsRazonSocial': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualCabeceraModel
     */
    'IdTipoIntervalo': number;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'TipoIntervaloNombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'FechaObjetivo': string;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualCabeceraModel
     */
    'IdEstado': number;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModel
     */
    'EstadoCodigo': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualCabeceraModel
     */
    'Editable': boolean;
}
/**
 * 
 * @export
 * @interface InspeccionVisualCabeceraModelResponseDTO
 */
export interface InspeccionVisualCabeceraModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {InspeccionVisualCabeceraModel}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'Data'?: InspeccionVisualCabeceraModel;
    /**
     * 
     * @type {any}
     * @memberof InspeccionVisualCabeceraModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface InspeccionVisualDetalleModel
 */
export interface InspeccionVisualDetalleModel {
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'FechaModificacion': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdInspeccionAnterior': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdNumericoInspeccionAnterior': number | null;
    /**
     * 
     * @type {TipoEmpresaInspeccionVisualEnum}
     * @memberof InspeccionVisualDetalleModel
     */
    'CodigoTipoEmpresa': TipoEmpresaInspeccionVisualEnum;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionMatricula': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionCategoria': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionBusinessModel': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionCifTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionCove': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionFechaCaducidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionTipoInfraestructura': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionDireccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionMunicipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionCodigoPostal': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionDelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'UbicacionNpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'ZonaDescripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdPds': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'PdsCif': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'PdsRazonSocial': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'Tecnico': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdEstado': number;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'EstadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'EstadoDenoDefecto': string | null;
    /**
     * 
     * @type {EstadoComplianceInspeccionVisualEnum}
     * @memberof InspeccionVisualDetalleModel
     */
    'CodigoEstadoCompliance': EstadoComplianceInspeccionVisualEnum;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'EstadoComplianceDenoDefecto': string;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdResultado': number | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'ResultadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'ResultadoDenoDefecto': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdTipoIntervaloEfectivo': number | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'TipoIntervaloEfectivoNombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'FechaSiguienteInspeccionVisual': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdTipoIntervalo': number | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'TipoIntervaloNombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'FechaObjetivo': string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'FechaProgramada': string | null;
    /**
     * 
     * @type {Date}
     * @memberof InspeccionVisualDetalleModel
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModel
     */
    'CalidadCorrecta': boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InspeccionVisualDetalleModel
     */
    'IdsDeficienciasCompliance': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'ObservacionesCompliance': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'Conclusiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModel
     */
    'Incidencia': string | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'NumKo': number | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'NumKoCriticos': number | null;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'NumOk': number;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'NumCargadores': number;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualDetalleModel
     */
    'NumCargadoresExcluidos': number;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModel
     */
    'TieneInformePreparado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModel
     */
    'PuedeProgramarFecha': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModel
     */
    'PuedeEditarInforme': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModel
     */
    'PuedeCerrar': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModel
     */
    'PuedeCompletarInforme': boolean;
    /**
     * 
     * @type {Array<CategoriaFotoGeneralAsociadaInspeccionVisualModel>}
     * @memberof InspeccionVisualDetalleModel
     */
    'CategoriasFotosGenerales': Array<CategoriaFotoGeneralAsociadaInspeccionVisualModel>;
    /**
     * 
     * @type {InspeccionFicheroDetalleModel}
     * @memberof InspeccionVisualDetalleModel
     */
    'InformeTecnico': InspeccionFicheroDetalleModel | null;
    /**
     * 
     * @type {Array<ConfiguracionAdjuntosUbicacionModel>}
     * @memberof InspeccionVisualDetalleModel
     */
    'ConfigAdjuntosUbicacion': Array<ConfiguracionAdjuntosUbicacionModel>;
    /**
     * 
     * @type {Array<AdjuntoUbicacionModel>}
     * @memberof InspeccionVisualDetalleModel
     */
    'AdjuntosUbicacion': Array<AdjuntoUbicacionModel>;
    /**
     * 
     * @type {Array<InspeccionCargadorDetalleModel>}
     * @memberof InspeccionVisualDetalleModel
     */
    'Cargadores': Array<InspeccionCargadorDetalleModel>;
    /**
     * 
     * @type {Array<InspeccionRespuestaDetalleModel>}
     * @memberof InspeccionVisualDetalleModel
     */
    'Respuestas': Array<InspeccionRespuestaDetalleModel>;
}


/**
 * 
 * @export
 * @interface InspeccionVisualDetalleModelResponseDTO
 */
export interface InspeccionVisualDetalleModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {InspeccionVisualDetalleModel}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'Data'?: InspeccionVisualDetalleModel;
    /**
     * 
     * @type {any}
     * @memberof InspeccionVisualDetalleModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface InspeccionVisualPlanificadaModel
 */
export interface InspeccionVisualPlanificadaModel {
    /**
     * 
     * @type {string}
     * @memberof InspeccionVisualPlanificadaModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof InspeccionVisualPlanificadaModel
     */
    'Orden': number;
}
/**
 * 
 * @export
 * @interface Int32ListResponseDTO
 */
export interface Int32ListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof Int32ListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof Int32ListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof Int32ListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof Int32ListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Int32ListResponseDTO
     */
    'Data'?: Array<number>;
    /**
     * 
     * @type {any}
     * @memberof Int32ListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface Int32ResponseDTO
 */
export interface Int32ResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof Int32ResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof Int32ResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof Int32ResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof Int32ResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Int32ResponseDTO
     */
    'Data'?: number;
    /**
     * 
     * @type {any}
     * @memberof Int32ResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface InteroperabilidadHistoricoRm
 */
export interface InteroperabilidadHistoricoRm {
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'Clave': string;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'TipoEntidad': string;
    /**
     * 
     * @type {number}
     * @memberof InteroperabilidadHistoricoRm
     */
    'IdCambio': number;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'IdOperacion': string;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'EntidadId': string;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'TipoOperacion': string;
    /**
     * 
     * @type {Date}
     * @memberof InteroperabilidadHistoricoRm
     */
    'FechaCambio': Date;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'IdUsuarioCambio': string | null;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'Usuario': string | null;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'NombrePropiedad': string;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'ValorAnterior': string | null;
    /**
     * 
     * @type {string}
     * @memberof InteroperabilidadHistoricoRm
     */
    'ValorNuevo': string | null;
}
/**
 * 
 * @export
 * @interface ItemCircutorSeleccionadoDto
 */
export interface ItemCircutorSeleccionadoDto {
    /**
     * 
     * @type {number}
     * @memberof ItemCircutorSeleccionadoDto
     */
    'IdItemEconomicoCircutor': number;
    /**
     * 
     * @type {number}
     * @memberof ItemCircutorSeleccionadoDto
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface ItemCircutorSeleccionadoModel
 */
export interface ItemCircutorSeleccionadoModel {
    /**
     * 
     * @type {number}
     * @memberof ItemCircutorSeleccionadoModel
     */
    'IdItemEconomicoCircutor': number;
    /**
     * 
     * @type {number}
     * @memberof ItemCircutorSeleccionadoModel
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface ItemCorrectivoElecnorDto
 */
export interface ItemCorrectivoElecnorDto {
    /**
     * 
     * @type {number}
     * @memberof ItemCorrectivoElecnorDto
     */
    'IdItemEconomicoElecnor': number;
    /**
     * 
     * @type {string}
     * @memberof ItemCorrectivoElecnorDto
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof ItemCorrectivoElecnorDto
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoUnidadMedidaElecnorEnum}
     * @memberof ItemCorrectivoElecnorDto
     */
    'TipoUnidadMedida': TipoUnidadMedidaElecnorEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ItemCorrectivoElecnorDto
     */
    'UnidadMedidaNombre': string | null;
}


/**
 * 
 * @export
 * @interface ItemCorrectivoElecnorDtoListResponseDTO
 */
export interface ItemCorrectivoElecnorDtoListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ItemCorrectivoElecnorDto>}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'Data'?: Array<ItemCorrectivoElecnorDto>;
    /**
     * 
     * @type {any}
     * @memberof ItemCorrectivoElecnorDtoListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ItemElecnorSeleccionadoDto
 */
export interface ItemElecnorSeleccionadoDto {
    /**
     * 
     * @type {number}
     * @memberof ItemElecnorSeleccionadoDto
     */
    'IdItemEconomicoElecnor': number;
    /**
     * 
     * @type {number}
     * @memberof ItemElecnorSeleccionadoDto
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface ItemElecnorSeleccionadoModel
 */
export interface ItemElecnorSeleccionadoModel {
    /**
     * 
     * @type {number}
     * @memberof ItemElecnorSeleccionadoModel
     */
    'IdItemEconomicoElecnor': number;
    /**
     * 
     * @type {number}
     * @memberof ItemElecnorSeleccionadoModel
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface ItemMaterialCircutorDto
 */
export interface ItemMaterialCircutorDto {
    /**
     * 
     * @type {number}
     * @memberof ItemMaterialCircutorDto
     */
    'IdItemEconomicoCircutor': number;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialCircutorDto
     */
    'PartNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialCircutorDto
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface ItemMaterialCircutorDtoListResponseDTO
 */
export interface ItemMaterialCircutorDtoListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ItemMaterialCircutorDto>}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'Data'?: Array<ItemMaterialCircutorDto>;
    /**
     * 
     * @type {any}
     * @memberof ItemMaterialCircutorDtoListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ItemMaterialElecnorDto
 */
export interface ItemMaterialElecnorDto {
    /**
     * 
     * @type {number}
     * @memberof ItemMaterialElecnorDto
     */
    'IdItemEconomicoElecnor': number;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialElecnorDto
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialElecnorDto
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoUnidadMedidaElecnorEnum}
     * @memberof ItemMaterialElecnorDto
     */
    'TipoUnidadMedida': TipoUnidadMedidaElecnorEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialElecnorDto
     */
    'UnidadMedidaNombre': string | null;
}


/**
 * 
 * @export
 * @interface ItemMaterialElecnorDtoListResponseDTO
 */
export interface ItemMaterialElecnorDtoListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ItemMaterialElecnorDto>}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'Data'?: Array<ItemMaterialElecnorDto>;
    /**
     * 
     * @type {any}
     * @memberof ItemMaterialElecnorDtoListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ItemPreventivoElecnorDto
 */
export interface ItemPreventivoElecnorDto {
    /**
     * 
     * @type {number}
     * @memberof ItemPreventivoElecnorDto
     */
    'IdItemEconomicoElecnor': number;
    /**
     * 
     * @type {string}
     * @memberof ItemPreventivoElecnorDto
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof ItemPreventivoElecnorDto
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoUnidadMedidaElecnorEnum}
     * @memberof ItemPreventivoElecnorDto
     */
    'TipoUnidadMedida': TipoUnidadMedidaElecnorEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ItemPreventivoElecnorDto
     */
    'UnidadMedidaNombre': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ItemPreventivoElecnorDto
     */
    'RequiereCantidad': boolean;
}


/**
 * 
 * @export
 * @interface ItemPreventivoElecnorDtoListResponseDTO
 */
export interface ItemPreventivoElecnorDtoListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ItemPreventivoElecnorDto>}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'Data'?: Array<ItemPreventivoElecnorDto>;
    /**
     * 
     * @type {any}
     * @memberof ItemPreventivoElecnorDtoListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IvEstadoEnum = {
    PendienteProgramacion: 'PendienteProgramacion',
    Programada: 'Programada',
    EnCurso: 'EnCurso',
    Cerrada: 'Cerrada',
    Cancelada: 'Cancelada'
} as const;

export type IvEstadoEnum = typeof IvEstadoEnum[keyof typeof IvEstadoEnum];


/**
 * 
 * @export
 * @interface KpiCantidadModel
 */
export interface KpiCantidadModel {
    /**
     * 
     * @type {number}
     * @memberof KpiCantidadModel
     */
    'Numerador': number;
    /**
     * 
     * @type {number}
     * @memberof KpiCantidadModel
     */
    'Denominador': number;
}
/**
 * 
 * @export
 * @interface KpiPreventivosCantidadModel
 */
export interface KpiPreventivosCantidadModel {
    /**
     * 
     * @type {number}
     * @memberof KpiPreventivosCantidadModel
     */
    'Numerador': number;
    /**
     * 
     * @type {number}
     * @memberof KpiPreventivosCantidadModel
     */
    'Denominador': number;
    /**
     * 
     * @type {number}
     * @memberof KpiPreventivosCantidadModel
     */
    'PendientesSinCaducar': number;
    /**
     * 
     * @type {number}
     * @memberof KpiPreventivosCantidadModel
     */
    'PendientesCaducados': number;
}
/**
 * 
 * @export
 * @interface ListadoActuacionesRm
 */
export interface ListadoActuacionesRm {
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoActuacionesRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Responsable': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Ubicacion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Pds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Tecnico': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoActuacionesRm
     */
    'IdEstado': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Estado': string;
    /**
     * 
     * @type {Date}
     * @memberof ListadoActuacionesRm
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof ListadoActuacionesRm
     */
    'FechaMinInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof ListadoActuacionesRm
     */
    'FechaMaxInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof ListadoActuacionesRm
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'FechaActuacion': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoActuacionesRm
     */
    'EsUrgente': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Municipio': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'Provincia': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'NombreXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'ZonaPrestador': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'ZonaProvincia': string;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoActuacionesRm
     */
    'TieneWoPendienteValidacion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoActuacionesRm
     */
    'EsCorrectivoPrecioCerrado': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'EstadoSemaforo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'NombreCampana': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoActuacionesRm
     */
    'NombreCampanaGrupoActuacion': string | null;
}
/**
 * 
 * @export
 * @interface ListadoEquipoMedidaRm
 */
export interface ListadoEquipoMedidaRm {
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'Marca': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'Modelo': string;
    /**
     * 
     * @type {Date}
     * @memberof ListadoEquipoMedidaRm
     */
    'FechaCalibracion': Date;
    /**
     * 
     * @type {Date}
     * @memberof ListadoEquipoMedidaRm
     */
    'FechaProximaCalibracion': Date;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'IdTecnico': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'Tecnico': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'Pds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoEquipoMedidaRm
     */
    'Prestador': string;
}
/**
 * 
 * @export
 * @interface ListadoInspeccionesVisualesActivoRm
 */
export interface ListadoInspeccionesVisualesActivoRm {
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'TieneIncidencia': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'TipoEmpresaCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'UbicacionMatricula': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'UbicacionDireccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'UbicacionMunicipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'UbicacionCodigoPostal': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'Provincia': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'ZonaDescripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdPds': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'PdsIdNumerico': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'PdsCif': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'PdsRazonSocial': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'PdsIdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'PdsZonaDescripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'Tecnico': string | null;
    /**
     * 
     * @type {IvEstadoEnum}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdEstado': IvEstadoEnum;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'EstadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'EstadoDenoDefecto': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'NumCargadores': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'NumerosSerieCargadores': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdResultado': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'ResultadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'ResultadoDenoDefecto': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdEstadoCompliance': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'EstadoComplianceCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'EstadoComplianceDenoDefecto': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdTipoIntervalo': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'TipoIntervaloNombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'FechaObjetivo': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'FechaProgramada': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'Orden': number | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'FechaInicioReal': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'Conclusiones': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'NumKo': number | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'NumKoCriticos': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdInspeccionAnterior': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'InspeccionAnteriorIdNumerico': number | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'FechaAlta': Date;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdUsuarioAlta': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'UsuarioAlta': string | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'FechaModificacion': Date;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'IdUsuarioModificacion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'UsuarioModificacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesActivoRm
     */
    'NumKoActivo': number;
}


/**
 * 
 * @export
 * @interface ListadoInspeccionesVisualesRm
 */
export interface ListadoInspeccionesVisualesRm {
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'TieneIncidencia': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'TipoEmpresaCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'UbicacionMatricula': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'UbicacionDireccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'UbicacionMunicipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'UbicacionCodigoPostal': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'Provincia': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'ZonaDescripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdPds': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'PdsIdNumerico': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'PdsCif': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'PdsRazonSocial': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'PdsIdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'PdsZonaDescripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdTecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'Tecnico': string | null;
    /**
     * 
     * @type {IvEstadoEnum}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdEstado': IvEstadoEnum;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'EstadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'EstadoDenoDefecto': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'NumCargadores': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'NumerosSerieCargadores': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdResultado': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'ResultadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'ResultadoDenoDefecto': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdEstadoCompliance': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'EstadoComplianceCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'EstadoComplianceDenoDefecto': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdTipoIntervalo': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'TipoIntervaloNombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'FechaObjetivo': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'FechaProgramada': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'Orden': number | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'FechaInicioReal': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'Conclusiones': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'NumKo': number | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'NumKoCriticos': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdInspeccionAnterior': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'InspeccionAnteriorIdNumerico': number | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'FechaAlta': Date;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdUsuarioAlta': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'UsuarioAlta': string | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'FechaModificacion': Date;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'IdUsuarioModificacion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoInspeccionesVisualesRm
     */
    'UsuarioModificacion': string | null;
}


/**
 * 
 * @export
 * @interface ListadoPdsRm
 */
export interface ListadoPdsRm {
    /**
     * 
     * @type {ModeloPagoEnum}
     * @memberof ListadoPdsRm
     */
    'IdModeloPago': ModeloPagoEnum;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'Cif': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'EmailsContacto': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'Zona': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'CodigosPostales': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'TelefonoMudanza': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'TelefonoGuardia': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'ResponsablesPds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'ResponsablesIds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'PersonaContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'IdUsuarioKim': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'UsuarioKim': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'UsuarioAlta': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'TiposPrestadorIds': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'TiposPrestadorCodigos': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoPdsRm
     */
    'TiposPrestadorDenoDefecto': string | null;
}


/**
 * 
 * @export
 * @interface ListadoTrabajoTecnicoDto
 */
export interface ListadoTrabajoTecnicoDto {
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'TipoRegistro': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'Ubicacion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'Estado': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'FechaPlanificacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'Orden': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoTrabajoTecnicoDto
     */
    'EsUrgente': boolean;
}
/**
 * 
 * @export
 * @interface ListadoTrabajoTecnicoDtoListResponseDTO
 */
export interface ListadoTrabajoTecnicoDtoListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ListadoTrabajoTecnicoDto>}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'Data'?: Array<ListadoTrabajoTecnicoDto>;
    /**
     * 
     * @type {any}
     * @memberof ListadoTrabajoTecnicoDtoListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ListadoWoRevenueRm
 */
export interface ListadoWoRevenueRm {
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRevenueRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoRevenueRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRevenueRm
     */
    'TipoWo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRevenueRm
     */
    'Estado': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRevenueRm
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRevenueRm
     */
    'Ubicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRevenueRm
     */
    'FechaActuacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoRevenueRm
     */
    'FechaMinInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoRevenueRm
     */
    'FechaMaxInicial': Date;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRevenueRm
     */
    'TieneIncidencia': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRevenueRm
     */
    'MensajeIncidencia': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRevenueRm
     */
    'EsFavorable': boolean;
}
/**
 * 
 * @export
 * @interface ListadoWoRm
 */
export interface ListadoWoRm {
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'IdPartner': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoRm
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoRm
     */
    'IdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Modelo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Fabricante': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Responsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Tecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'UsuarioCreador': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Prestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Estado': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Subestado': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'FechaActuacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoRm
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoRm
     */
    'FechaMinInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoRm
     */
    'FechaMaxInicial': Date;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'EnPlazoFechaMax': boolean;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoRm
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'IdActuacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'IdTicket': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoRm
     */
    'IdXcustomerWo': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'TipoWo': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'EsUrgente': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'AsociadoDesplazamiento': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Importe': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'NombreXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'ZonaPrestador': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'ZonaProvincia': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoRm
     */
    'CosteTotal': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Ubicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'DescripcionActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'ObservacionPrestador': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'TienePruebaTermografica': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'EstadoCompliance': string | null;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoRm
     */
    'ImporteReal': number | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'PlanTrabajo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'MotivosCierre': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'TieneIncidencia': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'MensajeIncidencia': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'FacturarMovilidad': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'EsCapex': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'EnGarantia': boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoRm
     */
    'FechaCompliance': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'TipoInfraestructura': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListadoWoRm
     */
    'EsFavorable': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'NombreCampana': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoRm
     */
    'NombreCampanaGrupoActuacion': string | null;
}
/**
 * 
 * @export
 * @interface ListadoWoSustitucionRm
 */
export interface ListadoWoSustitucionRm {
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'IdActuacion': string;
    /**
     * 
     * @type {number}
     * @memberof ListadoWoSustitucionRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {Date}
     * @memberof ListadoWoSustitucionRm
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'NumeroSerieAntiguo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'ModeloAntiguo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'NumeroSerieNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'ModeloNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'Ubicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'Partner': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'IdPartnerCargadorAntiguo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListadoWoSustitucionRm
     */
    'IdPartnerCargadorNuevo': string | null;
}
/**
 * 
 * @export
 * @interface LoadResult
 */
export interface LoadResult {
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'data'?: Array<any> | null;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'groupCount'?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'summary'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface LoadResultResponseDTO
 */
export interface LoadResultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof LoadResultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof LoadResultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof LoadResultResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoadResultResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoadResultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoadResultResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {LoadResult}
     * @memberof LoadResultResponseDTO
     */
    'Data'?: LoadResult;
    /**
     * 
     * @type {any}
     * @memberof LoadResultResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MaestroPagosInspeccionVisualRm
 */
export interface MaestroPagosInspeccionVisualRm {
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'Tecnico': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'Matricula': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'NumerosSerie': string | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'NumCargadores': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'IdProvincia': number;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'Provincia': string;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'IdZona': number;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'Zona': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'Prestador': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'FechaObjetivo': string;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'FechaCierre': Date;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'Importe': number;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'CodigoPedidoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosInspeccionVisualRm
     */
    'CodigoConformidad': string | null;
}
/**
 * 
 * @export
 * @interface MaestroPagosPorPdsMesRm
 */
export interface MaestroPagosPorPdsMesRm {
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'RazonSocial': string;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'Mes': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'NumWo': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'NumActuaciones': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'ImporteTotal': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'NumWoPendientes': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorPdsMesRm
     */
    'ImporteRealTotal': number | null;
}
/**
 * 
 * @export
 * @interface MaestroPagosPorPdsMesRmListResponseDTO
 */
export interface MaestroPagosPorPdsMesRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<MaestroPagosPorPdsMesRm>}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'Data'?: Array<MaestroPagosPorPdsMesRm>;
    /**
     * 
     * @type {any}
     * @memberof MaestroPagosPorPdsMesRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MaestroPagosPorWoRm
 */
export interface MaestroPagosPorWoRm {
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'HorasCalculoKpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteTarifaPlana': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteHorasExtra': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteMaterialesExtra': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteMalusMateriales': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteMalusHorasExtra': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteMalusServicio': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'PorcentajeMalusMateriales': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'PagoPendiente': number;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'IdWo': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'IdPds': string;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'IdZona': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'IdTipoWo': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'IdNumericoWo': number;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'TipoWo': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'Zona': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'Prestador': string;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'EsUrgente': boolean;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosPorWoRm
     */
    'FechaMinimaInicial': Date;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosPorWoRm
     */
    'FechaMaximaInicial': Date;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'Kpi1': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'Kpi2': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'Kpi3': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'SinBonusMalusPorCodigoPostal': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'SinBonusMalusPorPrecioCerrado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'SinBonusMalusPorWoCalientePreventivoAutomatico': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'SinBonusMalusPorAcompanamientoOca': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'SinBonusMalusPorCampana': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'BonusLimitadoPorMaximoAnual': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'MalusCompensadoPorBonusNoCobrado': boolean;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosPorWoRm
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosPorWoRm
     */
    'FechaInicio': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosPorWoRm
     */
    'FechaCierre': Date;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosPorWoRm
     */
    'FechaCompliance': Date;
    /**
     * 
     * @type {Date}
     * @memberof MaestroPagosPorWoRm
     */
    'FechaComplianceActuacion': Date;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteRealKpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteAjustadoBonus': number | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'ImporteReal': number | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'PotenciaCargador': number | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'TipoInfraestructuraCargador': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'CodigoPedidoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'CodigoConformidad': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'EnGarantia': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'FacturarMovilidad': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaestroPagosPorWoRm
     */
    'EsCapex': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MaestroPagosPorWoRm
     */
    'IdXcustomerWo': number | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'ObservacionesPrestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaestroPagosPorWoRm
     */
    'Partner': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MaestroPagosTierEnum = {
    Oro: 'Oro',
    Plata: 'Plata',
    Bronce: 'Bronce',
    Carbon: 'Carbon'
} as const;

export type MaestroPagosTierEnum = typeof MaestroPagosTierEnum[keyof typeof MaestroPagosTierEnum];


/**
 * 
 * @export
 * @interface MedalleroPorPdsModel
 */
export interface MedalleroPorPdsModel {
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'Kpi1': number | null;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'Kpi2': number | null;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'Kpi3': number | null;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'Nota': number;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'BonusMalus': number;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'ImporteBonusAplicado': number;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'MediaNacional': number | null;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'PosicionNacional': number | null;
    /**
     * 
     * @type {number}
     * @memberof MedalleroPorPdsModel
     */
    'TotalPdsNacional': number | null;
    /**
     * 
     * @type {MaestroPagosTierEnum}
     * @memberof MedalleroPorPdsModel
     */
    'Tier': MaestroPagosTierEnum;
}


/**
 * 
 * @export
 * @interface MedalleroPorPdsModelResponseDTO
 */
export interface MedalleroPorPdsModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {MedalleroPorPdsModel}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'Data'?: MedalleroPorPdsModel;
    /**
     * 
     * @type {any}
     * @memberof MedalleroPorPdsModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MediaMedalleroPdsPorMesModel
 */
export interface MediaMedalleroPdsPorMesModel {
    /**
     * 
     * @type {string}
     * @memberof MediaMedalleroPdsPorMesModel
     */
    'NombreEmpresa': string;
    /**
     * 
     * @type {number}
     * @memberof MediaMedalleroPdsPorMesModel
     */
    'Media': number;
    /**
     * 
     * @type {boolean}
     * @memberof MediaMedalleroPdsPorMesModel
     */
    'EsMediaNacional': boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaMedalleroPdsPorMesModel
     */
    'Mes': number;
    /**
     * 
     * @type {number}
     * @memberof MediaMedalleroPdsPorMesModel
     */
    'Anyo': number;
}
/**
 * 
 * @export
 * @interface MediaMedalleroPdsPorMesModelListResponseDTO
 */
export interface MediaMedalleroPdsPorMesModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<MediaMedalleroPdsPorMesModel>}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'Data'?: Array<MediaMedalleroPdsPorMesModel>;
    /**
     * 
     * @type {any}
     * @memberof MediaMedalleroPdsPorMesModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MediaMensualPdsAnonimizadoModel
 */
export interface MediaMensualPdsAnonimizadoModel {
    /**
     * 
     * @type {string}
     * @memberof MediaMensualPdsAnonimizadoModel
     */
    'NombreEmpresa': string;
    /**
     * 
     * @type {number}
     * @memberof MediaMensualPdsAnonimizadoModel
     */
    'Media': number;
    /**
     * 
     * @type {boolean}
     * @memberof MediaMensualPdsAnonimizadoModel
     */
    'EsEmpresaSolicitada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaMensualPdsAnonimizadoModel
     */
    'EsMediaNacional': boolean;
}
/**
 * 
 * @export
 * @interface MediaMensualPdsAnonimizadoModelListResponseDTO
 */
export interface MediaMensualPdsAnonimizadoModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<MediaMensualPdsAnonimizadoModel>}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'Data'?: Array<MediaMensualPdsAnonimizadoModel>;
    /**
     * 
     * @type {any}
     * @memberof MediaMensualPdsAnonimizadoModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MensajeOcaModel
 */
export interface MensajeOcaModel {
    /**
     * 
     * @type {string}
     * @memberof MensajeOcaModel
     */
    'Texto': string;
    /**
     * 
     * @type {string}
     * @memberof MensajeOcaModel
     */
    'UsuarioAutor': string;
    /**
     * 
     * @type {Date}
     * @memberof MensajeOcaModel
     */
    'Fecha': Date;
    /**
     * 
     * @type {boolean}
     * @memberof MensajeOcaModel
     */
    'EsMensajePropio': boolean;
    /**
     * 
     * @type {string}
     * @memberof MensajeOcaModel
     */
    'EtiquetaOrigen': string | null;
}
/**
 * 
 * @export
 * @interface MensajeOcaModelListResponseDTO
 */
export interface MensajeOcaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<MensajeOcaModel>}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'Data'?: Array<MensajeOcaModel>;
    /**
     * 
     * @type {any}
     * @memberof MensajeOcaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ModeloPagoEnum = {
    KpiEstandar: 'KpiEstandar',
    CircutorPorWo: 'CircutorPorWo'
} as const;

export type ModeloPagoEnum = typeof ModeloPagoEnum[keyof typeof ModeloPagoEnum];


/**
 * 
 * @export
 * @interface ModeloPagoEnumResponseDTO
 */
export interface ModeloPagoEnumResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ModeloPagoEnum}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'Data'?: ModeloPagoEnum;
    /**
     * 
     * @type {any}
     * @memberof ModeloPagoEnumResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ModificacionesActivosPeriodoRm
 */
export interface ModificacionesActivosPeriodoRm {
    /**
     * 
     * @type {string}
     * @memberof ModificacionesActivosPeriodoRm
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {number}
     * @memberof ModificacionesActivosPeriodoRm
     */
    'CpAnterior': number | null;
    /**
     * 
     * @type {number}
     * @memberof ModificacionesActivosPeriodoRm
     */
    'CpNuevo': number | null;
}
/**
 * 
 * @export
 * @interface MotivoCierreWoRm
 */
export interface MotivoCierreWoRm {
    /**
     * 
     * @type {number}
     * @memberof MotivoCierreWoRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof MotivoCierreWoRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof MotivoCierreWoRm
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof MotivoCierreWoRm
     */
    'IdTipoWo': number;
    /**
     * 
     * @type {string}
     * @memberof MotivoCierreWoRm
     */
    'TipoWo': string;
}
/**
 * 
 * @export
 * @interface MotivoCierreWoRmListResponseDTO
 */
export interface MotivoCierreWoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<MotivoCierreWoRm>}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'Data'?: Array<MotivoCierreWoRm>;
    /**
     * 
     * @type {any}
     * @memberof MotivoCierreWoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MspRm
 */
export interface MspRm {
    /**
     * 
     * @type {string}
     * @memberof MspRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof MspRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof MspRm
     */
    'NombreComercial': string | null;
    /**
     * 
     * @type {string}
     * @memberof MspRm
     */
    'Protocolo': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MspRm
     */
    'AcuerdoActivo': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MspRm
     */
    'OrdenAcuerdoActivo': number;
    /**
     * 
     * @type {string}
     * @memberof MspRm
     */
    'TarifaActual': string | null;
    /**
     * 
     * @type {string}
     * @memberof MspRm
     */
    'AsignacionDesde': string | null;
}
/**
 * 
 * @export
 * @interface MspRmListResponseDTO
 */
export interface MspRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof MspRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof MspRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MspRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MspRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof MspRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof MspRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<MspRm>}
     * @memberof MspRmListResponseDTO
     */
    'Data'?: Array<MspRm>;
    /**
     * 
     * @type {any}
     * @memberof MspRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MspTarifaRm
 */
export interface MspTarifaRm {
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'IdMsp': string;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'IdTarifa': string | null;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'FechaInicio': string;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'MspCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'MspNombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'TarifaCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'TarifaNombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof MspTarifaRm
     */
    'FechaFinExclusiva': string | null;
}
/**
 * 
 * @export
 * @interface NotificacionModel
 */
export interface NotificacionModel {
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Tipo': string;
    /**
     * 
     * @type {Date}
     * @memberof NotificacionModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Titulo': string;
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Mensaje': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificacionModel
     */
    'Referencias': Array<string>;
}
/**
 * 
 * @export
 * @interface NuevoAdjuntoPasoIvModel
 */
export interface NuevoAdjuntoPasoIvModel {
    /**
     * 
     * @type {string}
     * @memberof NuevoAdjuntoPasoIvModel
     */
    'IdRespuesta': string | null;
    /**
     * 
     * @type {string}
     * @memberof NuevoAdjuntoPasoIvModel
     */
    'IdCategoriaFotoGeneral': string | null;
    /**
     * 
     * @type {number}
     * @memberof NuevoAdjuntoPasoIvModel
     */
    'Tipo': number;
    /**
     * 
     * @type {number}
     * @memberof NuevoAdjuntoPasoIvModel
     */
    'IndiceArchivo': number;
}
/**
 * 
 * @export
 * @interface ObjectResponseDTO
 */
export interface ObjectResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ObjectResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ObjectResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ObjectResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ObjectResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ObjectResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {any}
     * @memberof ObjectResponseDTO
     */
    'Data'?: any;
    /**
     * 
     * @type {any}
     * @memberof ObjectResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ObservacionOcaModel
 */
export interface ObservacionOcaModel {
    /**
     * 
     * @type {string}
     * @memberof ObservacionOcaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ObservacionOcaModel
     */
    'Texto': string;
    /**
     * 
     * @type {string}
     * @memberof ObservacionOcaModel
     */
    'NombreAutor': string;
    /**
     * 
     * @type {Date}
     * @memberof ObservacionOcaModel
     */
    'Fecha': Date;
    /**
     * 
     * @type {boolean}
     * @memberof ObservacionOcaModel
     */
    'EsPropia': boolean;
}
/**
 * 
 * @export
 * @interface ObservacionOcaModelListResponseDTO
 */
export interface ObservacionOcaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ObservacionOcaModel>}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'Data'?: Array<ObservacionOcaModel>;
    /**
     * 
     * @type {any}
     * @memberof ObservacionOcaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OcaDetailCentroTransformacionModel
 */
export interface OcaDetailCentroTransformacionModel {
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'IdPdsOca': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'IdUsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'PrestadorOca': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'Responsable': string | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'FechaLimite': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'FechaPrevista': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'FechaProgramada': Date | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'ObservacionDocumentaGestor': string | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'FechaAnulacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'EstadoOca': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'NumeroPedido': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'IdCentroTransformacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtMatricula': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtBusinessModel': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtCifTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtDireccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtMunicipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtProvincia': string | null;
    /**
     * 
     * @type {number}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtDelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtNpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtZona': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'CtComunidadAutonoma': string | null;
    /**
     * 
     * @type {number}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'NumCargadores': number;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'NumSeriePrimerCargador': string | null;
    /**
     * 
     * @type {Array<FicheroModel>}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'Ficheros': Array<FicheroModel>;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'PuedeGestionarVisita': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'PuedeEditarDeficienciasVisita': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailCentroTransformacionModel
     */
    'PuedeReeditarVisitaDeclarada': boolean;
}
/**
 * 
 * @export
 * @interface OcaDetailCentroTransformacionModelResponseDTO
 */
export interface OcaDetailCentroTransformacionModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OcaDetailCentroTransformacionModel}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'Data'?: OcaDetailCentroTransformacionModel;
    /**
     * 
     * @type {any}
     * @memberof OcaDetailCentroTransformacionModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OcaDetailModel
 */
export interface OcaDetailModel {
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof OcaDetailModel
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'IdPds': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'IdPdsOca': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'IdUsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'Prestador': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'PrestadorOca': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'Responsable': string | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailModel
     */
    'FechaLimite': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailModel
     */
    'FechaPrevista': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailModel
     */
    'FechaProgramada': Date | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'ObservacionDocumentaGestor': string | null;
    /**
     * 
     * @type {Date}
     * @memberof OcaDetailModel
     */
    'FechaAnulacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'EstadoOca': string | null;
    /**
     * 
     * @type {number}
     * @memberof OcaDetailModel
     */
    'NumCargadores': number;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'IdUbicacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionMatricula': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionCategoria': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionBusinessModel': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionCifTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionCove': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionFechaCaducidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionTipoInfraestructura': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionDireccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionMunicipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionProvincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionCodigoPostal': string | null;
    /**
     * 
     * @type {number}
     * @memberof OcaDetailModel
     */
    'UbicacionDelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionNpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModel
     */
    'UbicacionZona': string | null;
    /**
     * 
     * @type {Array<FicheroModel>}
     * @memberof OcaDetailModel
     */
    'Ficheros': Array<FicheroModel>;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailModel
     */
    'PuedeGestionarVisita': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailModel
     */
    'PuedeEditarDeficienciasVisita': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailModel
     */
    'PuedeReeditarVisitaDeclarada': boolean;
}
/**
 * 
 * @export
 * @interface OcaDetailModelResponseDTO
 */
export interface OcaDetailModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OcaDetailModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OcaDetailModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaDetailModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcaDetailModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OcaDetailModel}
     * @memberof OcaDetailModelResponseDTO
     */
    'Data'?: OcaDetailModel;
    /**
     * 
     * @type {any}
     * @memberof OcaDetailModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OcaSeguimientoComposicionSemanalModel
 */
export interface OcaSeguimientoComposicionSemanalModel {
    /**
     * 
     * @type {Array<OcaSeguimientoResultadosSemanaModel>}
     * @memberof OcaSeguimientoComposicionSemanalModel
     */
    'Resultados': Array<OcaSeguimientoResultadosSemanaModel>;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoComposicionSemanalModelResponseDTO
 */
export interface OcaSeguimientoComposicionSemanalModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OcaSeguimientoComposicionSemanalModel}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'Data'?: OcaSeguimientoComposicionSemanalModel;
    /**
     * 
     * @type {any}
     * @memberof OcaSeguimientoComposicionSemanalModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OcaSeguimientoHeatmapVisitaEstadoModel
 */
export interface OcaSeguimientoHeatmapVisitaEstadoModel {
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'Favorable': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'Condicionada': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'Negativa': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'Cancelada': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'PendienteProgramacion': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'Programada': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'SinResultado': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaResultadoEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaEstadoModel
     */
    'Total': OcaSeguimientoHeatmapVisitaResultadoEstadoModel;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoHeatmapVisitaModel
 */
export interface OcaSeguimientoHeatmapVisitaModel {
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'AnioReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'SemanaReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'AnioComparacion': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'SemanaComparacion': number;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'Favorable': OcaSeguimientoHeatmapVisitaEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'Condicionada': OcaSeguimientoHeatmapVisitaEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'Negativa': OcaSeguimientoHeatmapVisitaEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'Cancelada': OcaSeguimientoHeatmapVisitaEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'PendienteProgramacion': OcaSeguimientoHeatmapVisitaEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'Programada': OcaSeguimientoHeatmapVisitaEstadoModel;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaEstadoModel}
     * @memberof OcaSeguimientoHeatmapVisitaModel
     */
    'SinResultado': OcaSeguimientoHeatmapVisitaEstadoModel;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoHeatmapVisitaModelResponseDTO
 */
export interface OcaSeguimientoHeatmapVisitaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OcaSeguimientoHeatmapVisitaModel}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'Data'?: OcaSeguimientoHeatmapVisitaModel;
    /**
     * 
     * @type {any}
     * @memberof OcaSeguimientoHeatmapVisitaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OcaSeguimientoHeatmapVisitaResultadoEstadoModel
 */
export interface OcaSeguimientoHeatmapVisitaResultadoEstadoModel {
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoHeatmapVisitaResultadoEstadoModel
     */
    'ValorReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoHeatmapVisitaResultadoEstadoModel
     */
    'ValorComparacion': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoHeatmapVisitaResultadoEstadoModel
     */
    'Variacion': number;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoKpiModel
 */
export interface OcaSeguimientoKpiModel {
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoKpiModel
     */
    'ValorReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoKpiModel
     */
    'ValorComparacion': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoKpiModel
     */
    'Variacion': number;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoKpisModel
 */
export interface OcaSeguimientoKpisModel {
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoKpisModel
     */
    'AnioReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoKpisModel
     */
    'SemanaReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoKpisModel
     */
    'AnioComparacion': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoKpisModel
     */
    'SemanaComparacion': number;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'Favorables': OcaSeguimientoKpiModel;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'Condicionadas': OcaSeguimientoKpiModel;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'Negativas': OcaSeguimientoKpiModel;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'Canceladas': OcaSeguimientoKpiModel;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'Anuladas': OcaSeguimientoKpiModel;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'SinVisitas': OcaSeguimientoKpiModel;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'PendientesProgramacion': OcaSeguimientoKpiModel;
    /**
     * 
     * @type {OcaSeguimientoKpiModel}
     * @memberof OcaSeguimientoKpisModel
     */
    'Programadas': OcaSeguimientoKpiModel;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoKpisModelResponseDTO
 */
export interface OcaSeguimientoKpisModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OcaSeguimientoKpisModel}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'Data'?: OcaSeguimientoKpisModel;
    /**
     * 
     * @type {any}
     * @memberof OcaSeguimientoKpisModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OcaSeguimientoResultadosSemanaModel
 */
export interface OcaSeguimientoResultadosSemanaModel {
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Semana': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Favorables': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Condicionadas': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Negativas': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Canceladas': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Anuladas': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'SinVisitas': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'PendientesProgramacion': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoResultadosSemanaModel
     */
    'Programadas': number;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoSemanaModel
 */
export interface OcaSeguimientoSemanaModel {
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoSemanaModel
     */
    'Anio': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoSemanaModel
     */
    'Semana': number;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoSemanaModel
     */
    'FechaInicioSemana': string;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoSemanaModel
     */
    'FechaFinSemana': string;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoSemanaModelIEnumerableResponseDTO
 */
export interface OcaSeguimientoSemanaModelIEnumerableResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<OcaSeguimientoSemanaModel>}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'Data'?: Array<OcaSeguimientoSemanaModel>;
    /**
     * 
     * @type {any}
     * @memberof OcaSeguimientoSemanaModelIEnumerableResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OcaSeguimientoTipoEnum = {
    Kpi: 'Kpi',
    TransicionEstados: 'TransicionEstados'
} as const;

export type OcaSeguimientoTipoEnum = typeof OcaSeguimientoTipoEnum[keyof typeof OcaSeguimientoTipoEnum];


/**
 * 
 * @export
 * @interface OcaSeguimientoTransicionModel
 */
export interface OcaSeguimientoTransicionModel {
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoTransicionModel
     */
    'EstadoInicial': string;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoTransicionModel
     */
    'EstadoTransitado': string;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoTransicionModel
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoTransicionesModel
 */
export interface OcaSeguimientoTransicionesModel {
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoTransicionesModel
     */
    'AnioReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoTransicionesModel
     */
    'SemanaReferencia': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoTransicionesModel
     */
    'AnioComparacion': number;
    /**
     * 
     * @type {number}
     * @memberof OcaSeguimientoTransicionesModel
     */
    'SemanaComparacion': number;
    /**
     * 
     * @type {Array<OcaSeguimientoTransicionModel>}
     * @memberof OcaSeguimientoTransicionesModel
     */
    'Transiciones': Array<OcaSeguimientoTransicionModel>;
}
/**
 * 
 * @export
 * @interface OcaSeguimientoTransicionesModelResponseDTO
 */
export interface OcaSeguimientoTransicionesModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OcaSeguimientoTransicionesModel}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'Data'?: OcaSeguimientoTransicionesModel;
    /**
     * 
     * @type {any}
     * @memberof OcaSeguimientoTransicionesModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OrigenTicketsRm
 */
export interface OrigenTicketsRm {
    /**
     * 
     * @type {number}
     * @memberof OrigenTicketsRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof OrigenTicketsRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof OrigenTicketsRm
     */
    'DenoDefecto': string;
}
/**
 * 
 * @export
 * @interface OrigenTicketsRmListResponseDTO
 */
export interface OrigenTicketsRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<OrigenTicketsRm>}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'Data'?: Array<OrigenTicketsRm>;
    /**
     * 
     * @type {any}
     * @memberof OrigenTicketsRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PartnerComboRm
 */
export interface PartnerComboRm {
    /**
     * 
     * @type {string}
     * @memberof PartnerComboRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerComboRm
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerComboRm
     */
    'Cif': string;
}
/**
 * 
 * @export
 * @interface PartnerComboRmListResponseDTO
 */
export interface PartnerComboRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PartnerComboRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PartnerComboRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerComboRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerComboRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerComboRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerComboRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<PartnerComboRm>}
     * @memberof PartnerComboRmListResponseDTO
     */
    'Data'?: Array<PartnerComboRm>;
    /**
     * 
     * @type {any}
     * @memberof PartnerComboRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PartnerDevengadoGridRm
 */
export interface PartnerDevengadoGridRm {
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'IdPartner': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'CifPartner': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'NombrePartner': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'ModelosNegocio': string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'Fecha': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'Periodo': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoGridRm
     */
    'PeriodoAnio': number;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoGridRm
     */
    'Region': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoGridRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoGridRm
     */
    'ImporteConImpuestos': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoGridRm
     */
    'Kwh': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoGridRm
     */
    'TotalAcumuladoConImpuestos': number;
}
/**
 * 
 * @export
 * @interface PartnerDevengadoPorAnioRm
 */
export interface PartnerDevengadoPorAnioRm {
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'IdPartner': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'CifPartner': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'NombrePartner': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'ModelosNegocio': string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'PeriodoAnio': number;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'Region': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'ImporteConImpuestos': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorAnioRm
     */
    'Kwh': number;
}
/**
 * 
 * @export
 * @interface PartnerDevengadoPorSociedadAnioRm
 */
export interface PartnerDevengadoPorSociedadAnioRm {
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorSociedadAnioRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorSociedadAnioRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorSociedadAnioRm
     */
    'PeriodoAnio': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorSociedadAnioRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorSociedadAnioRm
     */
    'ImporteConImpuestos': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorSociedadAnioRm
     */
    'Kwh': number;
}
/**
 * 
 * @export
 * @interface PartnerDevengadoPorSociedadRm
 */
export interface PartnerDevengadoPorSociedadRm {
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorSociedadRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorSociedadRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerDevengadoPorSociedadRm
     */
    'Periodo': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorSociedadRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorSociedadRm
     */
    'ImporteConImpuestos': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerDevengadoPorSociedadRm
     */
    'Kwh': number;
}
/**
 * 
 * @export
 * @interface PdsAsignacionProvinciaDto
 */
export interface PdsAsignacionProvinciaDto {
    /**
     * 
     * @type {number}
     * @memberof PdsAsignacionProvinciaDto
     */
    'IdProvincia': number;
    /**
     * 
     * @type {string}
     * @memberof PdsAsignacionProvinciaDto
     */
    'Provincia': string;
    /**
     * 
     * @type {number}
     * @memberof PdsAsignacionProvinciaDto
     */
    'PotenciaMinima': number;
}
/**
 * 
 * @export
 * @interface PdsAsignacionProvinciaItem
 */
export interface PdsAsignacionProvinciaItem {
    /**
     * 
     * @type {number}
     * @memberof PdsAsignacionProvinciaItem
     */
    'IdProvincia': number;
    /**
     * 
     * @type {number}
     * @memberof PdsAsignacionProvinciaItem
     */
    'PotenciaMinima': number;
}
/**
 * 
 * @export
 * @interface PdsByCodigoPostalModel
 */
export interface PdsByCodigoPostalModel {
    /**
     * 
     * @type {Array<PdsModel>}
     * @memberof PdsByCodigoPostalModel
     */
    'PrestadorPublic': Array<PdsModel>;
    /**
     * 
     * @type {Array<PdsModel>}
     * @memberof PdsByCodigoPostalModel
     */
    'PrestadorB2C': Array<PdsModel>;
    /**
     * 
     * @type {Array<PdsModel>}
     * @memberof PdsByCodigoPostalModel
     */
    'PrestadorB2B': Array<PdsModel>;
    /**
     * 
     * @type {Array<PdsModel>}
     * @memberof PdsByCodigoPostalModel
     */
    'PrestadorVentaEENv2': Array<PdsModel>;
}
/**
 * 
 * @export
 * @interface PdsByCodigoPostalModelResponseDTO
 */
export interface PdsByCodigoPostalModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {PdsByCodigoPostalModel}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'Data'?: PdsByCodigoPostalModel;
    /**
     * 
     * @type {any}
     * @memberof PdsByCodigoPostalModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PdsModel
 */
export interface PdsModel {
    /**
     * 
     * @type {ModeloPagoEnum}
     * @memberof PdsModel
     */
    'IdModeloPago': ModeloPagoEnum;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof PdsModel
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'Cif': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'Zona': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'EmailsContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'CodigosPostales': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'TelefonoMudanza': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'TelefonoGuardia': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'PersonaContacto': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'IdUsuarioKim': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'UsuarioKim': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'UsuarioAlta': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'ResponsablesPds': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'ResponsablesIds': string;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'TiposPrestadorIds': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'TiposPrestadorCodigos': string | null;
    /**
     * 
     * @type {string}
     * @memberof PdsModel
     */
    'TiposPrestadorDenoDefecto': string | null;
    /**
     * 
     * @type {Array<TipoPrestadorEnum>}
     * @memberof PdsModel
     */
    'TiposPrestador': Array<TipoPrestadorEnum>;
    /**
     * 
     * @type {Array<PdsAsignacionProvinciaDto>}
     * @memberof PdsModel
     */
    'AsignacionesProvincia': Array<PdsAsignacionProvinciaDto>;
}


/**
 * 
 * @export
 * @interface PdsModelResponseDTO
 */
export interface PdsModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PdsModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PdsModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PdsModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PdsModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PdsModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PdsModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {PdsModel}
     * @memberof PdsModelResponseDTO
     */
    'Data'?: PdsModel;
    /**
     * 
     * @type {any}
     * @memberof PdsModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PiezaWoRm
 */
export interface PiezaWoRm {
    /**
     * 
     * @type {string}
     * @memberof PiezaWoRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof PiezaWoRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface PiezaWoRmListResponseDTO
 */
export interface PiezaWoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PiezaWoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PiezaWoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PiezaWoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PiezaWoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PiezaWoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PiezaWoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<PiezaWoRm>}
     * @memberof PiezaWoRmListResponseDTO
     */
    'Data'?: Array<PiezaWoRm>;
    /**
     * 
     * @type {any}
     * @memberof PiezaWoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PlanificacionTecnicoInspeccionVisualModel
 */
export interface PlanificacionTecnicoInspeccionVisualModel {
    /**
     * 
     * @type {string}
     * @memberof PlanificacionTecnicoInspeccionVisualModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof PlanificacionTecnicoInspeccionVisualModel
     */
    'Orden': number | null;
    /**
     * 
     * @type {number}
     * @memberof PlanificacionTecnicoInspeccionVisualModel
     */
    'IdNumerico': number;
    /**
     * 
     * @type {number}
     * @memberof PlanificacionTecnicoInspeccionVisualModel
     */
    'NumCargadores': number;
    /**
     * 
     * @type {string}
     * @memberof PlanificacionTecnicoInspeccionVisualModel
     */
    'Direccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof PlanificacionTecnicoInspeccionVisualModel
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof PlanificacionTecnicoInspeccionVisualModel
     */
    'Zona': string | null;
}
/**
 * 
 * @export
 * @interface PlanificacionTecnicoInspeccionVisualModelListResponseDTO
 */
export interface PlanificacionTecnicoInspeccionVisualModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<PlanificacionTecnicoInspeccionVisualModel>}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'Data'?: Array<PlanificacionTecnicoInspeccionVisualModel>;
    /**
     * 
     * @type {any}
     * @memberof PlanificacionTecnicoInspeccionVisualModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PlugExternoDto
 */
export interface PlugExternoDto {
    /**
     * 
     * @type {string}
     * @memberof PlugExternoDto
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof PlugExternoDto
     */
    'TipoCorriente': number;
    /**
     * 
     * @type {string}
     * @memberof PlugExternoDto
     */
    'TipoCorrienteNombre': string;
    /**
     * 
     * @type {string}
     * @memberof PlugExternoDto
     */
    'TipoEnchufe': string;
    /**
     * 
     * @type {string}
     * @memberof PlugExternoDto
     */
    'NombreEnchufe': string;
    /**
     * 
     * @type {number}
     * @memberof PlugExternoDto
     */
    'Potencia': number;
}
/**
 * 
 * @export
 * @interface PrecioReferenciaInteroperabilidad
 */
export interface PrecioReferenciaInteroperabilidad {
    /**
     * 
     * @type {RecargaTarifaPrecioRm}
     * @memberof PrecioReferenciaInteroperabilidad
     */
    'Precio': RecargaTarifaPrecioRm | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrecioReferenciaInteroperabilidad
     */
    'EsActivo': boolean;
}
/**
 * 
 * @export
 * @interface PrecioReferenciaInteroperabilidadResponseDTO
 */
export interface PrecioReferenciaInteroperabilidadResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {PrecioReferenciaInteroperabilidad}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'Data'?: PrecioReferenciaInteroperabilidad;
    /**
     * 
     * @type {any}
     * @memberof PrecioReferenciaInteroperabilidadResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PreferenciasNotificacionModel
 */
export interface PreferenciasNotificacionModel {
    /**
     * 
     * @type {boolean}
     * @memberof PreferenciasNotificacionModel
     */
    'NotificarMensajeChatOca': boolean;
}
/**
 * 
 * @export
 * @interface PreferenciasNotificacionModelResponseDTO
 */
export interface PreferenciasNotificacionModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {PreferenciasNotificacionModel}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'Data'?: PreferenciasNotificacionModel;
    /**
     * 
     * @type {any}
     * @memberof PreferenciasNotificacionModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PreviewCalculoCosteActuacionRm
 */
export interface PreviewCalculoCosteActuacionRm {
    /**
     * 
     * @type {string}
     * @memberof PreviewCalculoCosteActuacionRm
     */
    'Strategy': string;
    /**
     * 
     * @type {string}
     * @memberof PreviewCalculoCosteActuacionRm
     */
    'IdPds': string;
    /**
     * 
     * @type {string}
     * @memberof PreviewCalculoCosteActuacionRm
     */
    'PdsRazonSocial': string | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewCalculoCosteActuacionRm
     */
    'CosteTotal': number;
    /**
     * 
     * @type {number}
     * @memberof PreviewCalculoCosteActuacionRm
     */
    'Desplazamiento': number;
    /**
     * 
     * @type {Array<PreviewLineaCosteRm>}
     * @memberof PreviewCalculoCosteActuacionRm
     */
    'Lineas': Array<PreviewLineaCosteRm>;
    /**
     * 
     * @type {Array<PreviewCosteWoRm>}
     * @memberof PreviewCalculoCosteActuacionRm
     */
    'CostesPorWo': Array<PreviewCosteWoRm>;
}
/**
 * 
 * @export
 * @interface PreviewCalculoCosteActuacionRmResponseDTO
 */
export interface PreviewCalculoCosteActuacionRmResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {PreviewCalculoCosteActuacionRm}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'Data'?: PreviewCalculoCosteActuacionRm;
    /**
     * 
     * @type {any}
     * @memberof PreviewCalculoCosteActuacionRmResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface PreviewCosteWoRm
 */
export interface PreviewCosteWoRm {
    /**
     * 
     * @type {string}
     * @memberof PreviewCosteWoRm
     */
    'IdWo': string;
    /**
     * 
     * @type {number}
     * @memberof PreviewCosteWoRm
     */
    'IdNumericoWo': number;
    /**
     * 
     * @type {number}
     * @memberof PreviewCosteWoRm
     */
    'IdTipoWo': number;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewCosteWoRm
     */
    'EsPrimeraWo': boolean;
    /**
     * 
     * @type {number}
     * @memberof PreviewCosteWoRm
     */
    'CosteTotal': number;
    /**
     * 
     * @type {number}
     * @memberof PreviewCosteWoRm
     */
    'Desplazamiento': number;
}
/**
 * 
 * @export
 * @interface PreviewLineaCosteRm
 */
export interface PreviewLineaCosteRm {
    /**
     * 
     * @type {number}
     * @memberof PreviewLineaCosteRm
     */
    'IdItem': number;
    /**
     * 
     * @type {string}
     * @memberof PreviewLineaCosteRm
     */
    'IdItemEconomico': string;
    /**
     * 
     * @type {number}
     * @memberof PreviewLineaCosteRm
     */
    'IdTipoWo': number;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewLineaCosteRm
     */
    'IncluidoSiempre': boolean;
    /**
     * 
     * @type {number}
     * @memberof PreviewLineaCosteRm
     */
    'PotenciaMinima': number;
    /**
     * 
     * @type {number}
     * @memberof PreviewLineaCosteRm
     */
    'Cantidad': number;
    /**
     * 
     * @type {number}
     * @memberof PreviewLineaCosteRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof PreviewLineaCosteRm
     */
    'ImportePorWo': number;
    /**
     * 
     * @type {number}
     * @memberof PreviewLineaCosteRm
     */
    'ImporteSobrante': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PreviewLineaCosteRm
     */
    'IdsWo': Array<number>;
}
/**
 * 
 * @export
 * @interface PrioridadTicketsRm
 */
export interface PrioridadTicketsRm {
    /**
     * 
     * @type {number}
     * @memberof PrioridadTicketsRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof PrioridadTicketsRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof PrioridadTicketsRm
     */
    'DenoDefecto': string;
}
/**
 * 
 * @export
 * @interface PrioridadTicketsRmListResponseDTO
 */
export interface PrioridadTicketsRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<PrioridadTicketsRm>}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'Data'?: Array<PrioridadTicketsRm>;
    /**
     * 
     * @type {any}
     * @memberof PrioridadTicketsRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ProgramarFechaInspeccionVisualModel
 */
export interface ProgramarFechaInspeccionVisualModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramarFechaInspeccionVisualModel
     */
    'Ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramarFechaInspeccionVisualModel
     */
    'FechaProgramada': string;
    /**
     * 
     * @type {string}
     * @memberof ProgramarFechaInspeccionVisualModel
     */
    'IdTecnico': string;
}
/**
 * 
 * @export
 * @interface ProgramarFechaVisitaModel
 */
export interface ProgramarFechaVisitaModel {
    /**
     * 
     * @type {string}
     * @memberof ProgramarFechaVisitaModel
     */
    'IdOca': string;
    /**
     * 
     * @type {Date}
     * @memberof ProgramarFechaVisitaModel
     */
    'FechaProgramacion': Date;
    /**
     * 
     * @type {string}
     * @memberof ProgramarFechaVisitaModel
     */
    'NumeroPedido': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProgramarFechaVisitaModel
     */
    'Expediente': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramarFechaVisitaModel
     */
    'GenerarWoAcompanamiento': boolean;
}
/**
 * 
 * @export
 * @interface ProvinciaComboRm
 */
export interface ProvinciaComboRm {
    /**
     * 
     * @type {number}
     * @memberof ProvinciaComboRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaComboRm
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface ProvinciaComboRmListResponseDTO
 */
export interface ProvinciaComboRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ProvinciaComboRm>}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'Data'?: Array<ProvinciaComboRm>;
    /**
     * 
     * @type {any}
     * @memberof ProvinciaComboRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface RangoFechaLimiteOcasModel
 */
export interface RangoFechaLimiteOcasModel {
    /**
     * 
     * @type {Date}
     * @memberof RangoFechaLimiteOcasModel
     */
    'FechaMinima': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RangoFechaLimiteOcasModel
     */
    'FechaMaxima': Date | null;
}
/**
 * 
 * @export
 * @interface RangoFechaLimiteOcasModelResponseDTO
 */
export interface RangoFechaLimiteOcasModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {RangoFechaLimiteOcasModel}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'Data'?: RangoFechaLimiteOcasModel;
    /**
     * 
     * @type {any}
     * @memberof RangoFechaLimiteOcasModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ReabrirTicketModel
 */
export interface ReabrirTicketModel {
    /**
     * 
     * @type {string}
     * @memberof ReabrirTicketModel
     */
    'IdTicket': string;
    /**
     * 
     * @type {number}
     * @memberof ReabrirTicketModel
     */
    'IdEstado': number;
    /**
     * 
     * @type {number}
     * @memberof ReabrirTicketModel
     */
    'IdSubestado': number;
    /**
     * 
     * @type {number}
     * @memberof ReabrirTicketModel
     */
    'IdColaUsuario': number;
    /**
     * 
     * @type {string}
     * @memberof ReabrirTicketModel
     */
    'Observaciones': string | null;
}
/**
 * 
 * @export
 * @interface ReactivateUserModel
 */
export interface ReactivateUserModel {
    /**
     * 
     * @type {string}
     * @memberof ReactivateUserModel
     */
    'IdUsuario': string;
}
/**
 * 
 * @export
 * @interface RecargaTarifaPrecioRm
 */
export interface RecargaTarifaPrecioRm {
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'IdTarifa': string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'TipoPotencia': string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'FechaInicio': string;
    /**
     * 
     * @type {boolean}
     * @memberof RecargaTarifaPrecioRm
     */
    'Activa': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecargaTarifaPrecioRm
     */
    'VersionActiva': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'TipoPrecio': string | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'CuotaMensualSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioDiaSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioNocheSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioDiaDescuentoSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioNocheDescuentoSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioDiaConIva': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioNocheConIva': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioDiaConIgic': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecargaTarifaPrecioRm
     */
    'PrecioNocheConIgic': number | null;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'TarifaCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'TarifaNombre': string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaPrecioRm
     */
    'FechaFinExclusiva': string | null;
}
/**
 * 
 * @export
 * @interface RecargaTarifaRm
 */
export interface RecargaTarifaRm {
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface RecargaTarifaRmListResponseDTO
 */
export interface RecargaTarifaRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<RecargaTarifaRm>}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'Data'?: Array<RecargaTarifaRm>;
    /**
     * 
     * @type {any}
     * @memberof RecargaTarifaRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface RecuentoActivosPeriodoRm
 */
export interface RecuentoActivosPeriodoRm {
    /**
     * 
     * @type {string}
     * @memberof RecuentoActivosPeriodoRm
     */
    'TipoActivo': string | null;
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosPeriodoRm
     */
    'Cantidad': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosPeriodoRm
     */
    'Variacion': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosPeriodoRm
     */
    'VariacionPct': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosPeriodoRm
     */
    'CantidadCp': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosPeriodoRm
     */
    'VariacionCp': number | null;
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosPeriodoRm
     */
    'VariacionCpPct': number | null;
}
/**
 * 
 * @export
 * @interface RecuentoActivosSemanaSelectorRm
 */
export interface RecuentoActivosSemanaSelectorRm {
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosSemanaSelectorRm
     */
    'PeriodoAno': number;
    /**
     * 
     * @type {number}
     * @memberof RecuentoActivosSemanaSelectorRm
     */
    'PeriodoSemana': number;
    /**
     * 
     * @type {string}
     * @memberof RecuentoActivosSemanaSelectorRm
     */
    'Label': string;
}
/**
 * 
 * @export
 * @interface RecuentoActivosSemanaSelectorRmListResponseDTO
 */
export interface RecuentoActivosSemanaSelectorRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<RecuentoActivosSemanaSelectorRm>}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'Data'?: Array<RecuentoActivosSemanaSelectorRm>;
    /**
     * 
     * @type {any}
     * @memberof RecuentoActivosSemanaSelectorRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ResolvePdsNuevaActuacionCargadorItem
 */
export interface ResolvePdsNuevaActuacionCargadorItem {
    /**
     * 
     * @type {number}
     * @memberof ResolvePdsNuevaActuacionCargadorItem
     */
    'IdProvincia': number | null;
    /**
     * 
     * @type {number}
     * @memberof ResolvePdsNuevaActuacionCargadorItem
     */
    'Potencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvePdsNuevaActuacionCargadorItem
     */
    'CodigoPostal': string | null;
}
/**
 * 
 * @export
 * @interface ResolvePdsNuevaActuacionModel
 */
export interface ResolvePdsNuevaActuacionModel {
    /**
     * 
     * @type {Array<ResolvePdsNuevaActuacionCargadorItem>}
     * @memberof ResolvePdsNuevaActuacionModel
     */
    'Cargadores': Array<ResolvePdsNuevaActuacionCargadorItem>;
}
/**
 * 
 * @export
 * @interface ResolvePdsNuevaActuacionRm
 */
export interface ResolvePdsNuevaActuacionRm {
    /**
     * 
     * @type {string}
     * @memberof ResolvePdsNuevaActuacionRm
     */
    'IdPds': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvePdsNuevaActuacionRm
     */
    'AdvertenciaPrestadoresDistintos': boolean;
}
/**
 * 
 * @export
 * @interface ResolvePdsNuevaActuacionRmResponseDTO
 */
export interface ResolvePdsNuevaActuacionRmResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ResolvePdsNuevaActuacionRm}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'Data'?: ResolvePdsNuevaActuacionRm;
    /**
     * 
     * @type {any}
     * @memberof ResolvePdsNuevaActuacionRmResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ResultadoCompletarDatosPagos
 */
export interface ResultadoCompletarDatosPagos {
    /**
     * 
     * @type {number}
     * @memberof ResultadoCompletarDatosPagos
     */
    'ActuacionesProcesadas': number;
    /**
     * 
     * @type {boolean}
     * @memberof ResultadoCompletarDatosPagos
     */
    'HayMas': boolean;
    /**
     * 
     * @type {number}
     * @memberof ResultadoCompletarDatosPagos
     */
    'SiguientePagina': number;
}
/**
 * 
 * @export
 * @interface ResultadoCompletarDatosPagosResponseDTO
 */
export interface ResultadoCompletarDatosPagosResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ResultadoCompletarDatosPagos}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'Data'?: ResultadoCompletarDatosPagos;
    /**
     * 
     * @type {any}
     * @memberof ResultadoCompletarDatosPagosResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ResultadoLecturaCargadoresAlarmaDto
 */
export interface ResultadoLecturaCargadoresAlarmaDto {
    /**
     * 
     * @type {string}
     * @memberof ResultadoLecturaCargadoresAlarmaDto
     */
    'AlarmStatus': string;
    /**
     * 
     * @type {Date}
     * @memberof ResultadoLecturaCargadoresAlarmaDto
     */
    'LastUpdateDate': Date;
    /**
     * 
     * @type {string}
     * @memberof ResultadoLecturaCargadoresAlarmaDto
     */
    'EventDescription': string;
    /**
     * 
     * @type {number}
     * @memberof ResultadoLecturaCargadoresAlarmaDto
     */
    'TicketCount': number | null;
    /**
     * 
     * @type {string}
     * @memberof ResultadoLecturaCargadoresAlarmaDto
     */
    'UserAssignation': string;
    /**
     * 
     * @type {string}
     * @memberof ResultadoLecturaCargadoresAlarmaDto
     */
    'PlugTypeList': string;
    /**
     * 
     * @type {string}
     * @memberof ResultadoLecturaCargadoresAlarmaDto
     */
    'ConnectorId': string;
}
/**
 * 
 * @export
 * @interface ResumenTiempoColasTicketRm
 */
export interface ResumenTiempoColasTicketRm {
    /**
     * 
     * @type {number}
     * @memberof ResumenTiempoColasTicketRm
     */
    'IdCola': number;
    /**
     * 
     * @type {string}
     * @memberof ResumenTiempoColasTicketRm
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof ResumenTiempoColasTicketRm
     */
    'TotalHoras': number;
}
/**
 * 
 * @export
 * @interface ResumenTiempoColasTicketRmListResponseDTO
 */
export interface ResumenTiempoColasTicketRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ResumenTiempoColasTicketRm>}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'Data'?: Array<ResumenTiempoColasTicketRm>;
    /**
     * 
     * @type {any}
     * @memberof ResumenTiempoColasTicketRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ResumirPeriodicidadInspeccionVisualModel
 */
export interface ResumirPeriodicidadInspeccionVisualModel {
    /**
     * 
     * @type {string}
     * @memberof ResumirPeriodicidadInspeccionVisualModel
     */
    'FechaObjetivo': string;
}
/**
 * 
 * @export
 * @interface RetirarAdjuntoPasoIvModel
 */
export interface RetirarAdjuntoPasoIvModel {
    /**
     * 
     * @type {string}
     * @memberof RetirarAdjuntoPasoIvModel
     */
    'IdRespuesta': string | null;
    /**
     * 
     * @type {string}
     * @memberof RetirarAdjuntoPasoIvModel
     */
    'IdCategoriaFotoGeneral': string | null;
    /**
     * 
     * @type {string}
     * @memberof RetirarAdjuntoPasoIvModel
     */
    'Ruta': string;
}
/**
 * 
 * @export
 * @interface RevenueDashboardGraficaBloqueRm
 */
export interface RevenueDashboardGraficaBloqueRm {
    /**
     * 
     * @type {RevenueDashboardGraficaDonutRm}
     * @memberof RevenueDashboardGraficaBloqueRm
     */
    'EstadoInforme': RevenueDashboardGraficaDonutRm;
    /**
     * 
     * @type {RevenueDashboardGraficaDonutRm}
     * @memberof RevenueDashboardGraficaBloqueRm
     */
    'Incidencias': RevenueDashboardGraficaDonutRm;
}
/**
 * 
 * @export
 * @interface RevenueDashboardGraficaDonutRm
 */
export interface RevenueDashboardGraficaDonutRm {
    /**
     * 
     * @type {number}
     * @memberof RevenueDashboardGraficaDonutRm
     */
    'Total': number;
    /**
     * 
     * @type {Array<RevenueDashboardGraficaSegmentoRm>}
     * @memberof RevenueDashboardGraficaDonutRm
     */
    'Segmentos': Array<RevenueDashboardGraficaSegmentoRm>;
}
/**
 * 
 * @export
 * @interface RevenueDashboardGraficaSegmentoRm
 */
export interface RevenueDashboardGraficaSegmentoRm {
    /**
     * 
     * @type {string}
     * @memberof RevenueDashboardGraficaSegmentoRm
     */
    'Segmento': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueDashboardGraficaSegmentoRm
     */
    'CodigoEstado': string | null;
    /**
     * 
     * @type {number}
     * @memberof RevenueDashboardGraficaSegmentoRm
     */
    'Total': number;
}
/**
 * 
 * @export
 * @interface RevenueDashboardGraficasRm
 */
export interface RevenueDashboardGraficasRm {
    /**
     * 
     * @type {RevenueDashboardGraficaBloqueRm}
     * @memberof RevenueDashboardGraficasRm
     */
    'Variable': RevenueDashboardGraficaBloqueRm;
    /**
     * 
     * @type {RevenueDashboardGraficaBloqueRm}
     * @memberof RevenueDashboardGraficasRm
     */
    'Fijo': RevenueDashboardGraficaBloqueRm;
}
/**
 * 
 * @export
 * @interface RevenueDashboardGraficasRmResponseDTO
 */
export interface RevenueDashboardGraficasRmResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {RevenueDashboardGraficasRm}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'Data'?: RevenueDashboardGraficasRm;
    /**
     * 
     * @type {any}
     * @memberof RevenueDashboardGraficasRmResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface RevenueInformeDashboardGridRm
 */
export interface RevenueInformeDashboardGridRm {
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardGridRm
     */
    'CifPartner': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardGridRm
     */
    'NombrePartner': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardGridRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardGridRm
     */
    'TipoPeriodo': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardGridRm
     */
    'Region': string;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardGridRm
     */
    'TotalSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardGridRm
     */
    'TotalConImpuestos': number;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardGridRm
     */
    'PeriodoAnio': number;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardGridRm
     */
    'Periodo': string;
    /**
     * 
     * @type {boolean}
     * @memberof RevenueInformeDashboardGridRm
     */
    'IsVariable': boolean;
}
/**
 * 
 * @export
 * @interface RevenueInformeDashboardPorAnioRm
 */
export interface RevenueInformeDashboardPorAnioRm {
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'CifPartner': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'NombrePartner': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'PeriodoAnio': number;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'Region': string;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'TotalSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'TotalConImpuestos': number;
    /**
     * 
     * @type {boolean}
     * @memberof RevenueInformeDashboardPorAnioRm
     */
    'IsVariable': boolean;
}
/**
 * 
 * @export
 * @interface RevenueInformeDashboardPorSociedadAnioRm
 */
export interface RevenueInformeDashboardPorSociedadAnioRm {
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorSociedadAnioRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorSociedadAnioRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorSociedadAnioRm
     */
    'PeriodoAnio': number;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorSociedadAnioRm
     */
    'TotalSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorSociedadAnioRm
     */
    'TotalConImpuestos': number;
    /**
     * 
     * @type {boolean}
     * @memberof RevenueInformeDashboardPorSociedadAnioRm
     */
    'IsVariable': boolean;
}
/**
 * 
 * @export
 * @interface RevenueInformeDashboardPorSociedadRm
 */
export interface RevenueInformeDashboardPorSociedadRm {
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorSociedadRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorSociedadRm
     */
    'Sociedad': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorSociedadRm
     */
    'Periodo': string;
    /**
     * 
     * @type {string}
     * @memberof RevenueInformeDashboardPorSociedadRm
     */
    'TipoPeriodo': string;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorSociedadRm
     */
    'TotalSinImpuestos': number | null;
    /**
     * 
     * @type {number}
     * @memberof RevenueInformeDashboardPorSociedadRm
     */
    'TotalConImpuestos': number;
    /**
     * 
     * @type {boolean}
     * @memberof RevenueInformeDashboardPorSociedadRm
     */
    'IsVariable': boolean;
}
/**
 * 
 * @export
 * @interface RolesRm
 */
export interface RolesRm {
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'NormalizedName': string;
}
/**
 * 
 * @export
 * @interface RolesRmListResponseDTO
 */
export interface RolesRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RolesRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RolesRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RolesRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolesRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof RolesRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RolesRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<RolesRm>}
     * @memberof RolesRmListResponseDTO
     */
    'Data'?: Array<RolesRm>;
    /**
     * 
     * @type {any}
     * @memberof RolesRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SelectBoxEntityModel
 */
export interface SelectBoxEntityModel {
    /**
     * 
     * @type {number}
     * @memberof SelectBoxEntityModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface SelectBoxEntityModelArrayResponseDTO
 */
export interface SelectBoxEntityModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SelectBoxEntityModel>}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Data'?: Array<SelectBoxEntityModel>;
    /**
     * 
     * @type {any}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SelectBoxGuidEntityModel
 */
export interface SelectBoxGuidEntityModel {
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface SelectBoxGuidEntityModelArrayResponseDTO
 */
export interface SelectBoxGuidEntityModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SelectBoxGuidEntityModel>}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Data'?: Array<SelectBoxGuidEntityModel>;
    /**
     * 
     * @type {any}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SetCalidadInspeccionVisualModel
 */
export interface SetCalidadInspeccionVisualModel {
    /**
     * 
     * @type {boolean}
     * @memberof SetCalidadInspeccionVisualModel
     */
    'CalidadCorrecta': boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetCalidadInspeccionVisualModel
     */
    'IdsDeficienciasCompliance': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SetCalidadInspeccionVisualModel
     */
    'ObservacionesCompliance': string | null;
}
/**
 * 
 * @export
 * @interface SetCargadorDismissedModel
 */
export interface SetCargadorDismissedModel {
    /**
     * 
     * @type {string}
     * @memberof SetCargadorDismissedModel
     */
    'Observacion': string;
}
/**
 * 
 * @export
 * @interface SetComplianceInspeccionVisualModel
 */
export interface SetComplianceInspeccionVisualModel {
    /**
     * 
     * @type {boolean}
     * @memberof SetComplianceInspeccionVisualModel
     */
    'PausarInspeccion': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetComplianceInspeccionVisualModel
     */
    'CalidadCorrecta': boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetComplianceInspeccionVisualModel
     */
    'IdsDeficienciasCompliance': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SetComplianceInspeccionVisualModel
     */
    'ObservacionesCompliance': string | null;
}
/**
 * 
 * @export
 * @interface SetComplianceWoModel
 */
export interface SetComplianceWoModel {
    /**
     * 
     * @type {EstadoComplianceEnum}
     * @memberof SetComplianceWoModel
     */
    'Estado': EstadoComplianceEnum;
    /**
     * 
     * @type {string}
     * @memberof SetComplianceWoModel
     */
    'Observacion': string | null;
}


/**
 * 
 * @export
 * @interface SortingInfo
 */
export interface SortingInfo {
    /**
     * 
     * @type {string}
     * @memberof SortingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SortingInfo
     */
    'desc'?: boolean;
}
/**
 * 
 * @export
 * @interface StatusCargadorModel
 */
export interface StatusCargadorModel {
    /**
     * 
     * @type {string}
     * @memberof StatusCargadorModel
     */
    'EstadoActualCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof StatusCargadorModel
     */
    'EstadoActualAgrupacion': string;
}
/**
 * 
 * @export
 * @interface StatusCargadorModelResponseDTO
 */
export interface StatusCargadorModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof StatusCargadorModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof StatusCargadorModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof StatusCargadorModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusCargadorModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusCargadorModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusCargadorModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {StatusCargadorModel}
     * @memberof StatusCargadorModelResponseDTO
     */
    'Data'?: StatusCargadorModel;
    /**
     * 
     * @type {any}
     * @memberof StatusCargadorModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface StringResponseDTO
 */
export interface StringResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof StringResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof StringResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof StringResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StringResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'Data'?: string;
    /**
     * 
     * @type {any}
     * @memberof StringResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SubestadoTicketsRm
 */
export interface SubestadoTicketsRm {
    /**
     * 
     * @type {number}
     * @memberof SubestadoTicketsRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof SubestadoTicketsRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof SubestadoTicketsRm
     */
    'DenoDefecto': string;
    /**
     * 
     * @type {boolean}
     * @memberof SubestadoTicketsRm
     */
    'CierraTicket': boolean;
    /**
     * 
     * @type {number}
     * @memberof SubestadoTicketsRm
     */
    'IdColaUsuario': number | null;
    /**
     * 
     * @type {number}
     * @memberof SubestadoTicketsRm
     */
    'Orden': number | null;
    /**
     * 
     * @type {number}
     * @memberof SubestadoTicketsRm
     */
    'SlaHoras': number | null;
    /**
     * 
     * @type {number}
     * @memberof SubestadoTicketsRm
     */
    'IdEstado': number | null;
    /**
     * 
     * @type {string}
     * @memberof SubestadoTicketsRm
     */
    'EstadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubestadoTicketsRm
     */
    'EstadoDenoDefecto': string | null;
}
/**
 * 
 * @export
 * @interface SubestadoTicketsRmListResponseDTO
 */
export interface SubestadoTicketsRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SubestadoTicketsRm>}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'Data'?: Array<SubestadoTicketsRm>;
    /**
     * 
     * @type {any}
     * @memberof SubestadoTicketsRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SubestadosRm
 */
export interface SubestadosRm {
    /**
     * 
     * @type {string}
     * @memberof SubestadosRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof SubestadosRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface SubestadosRmListResponseDTO
 */
export interface SubestadosRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SubestadosRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SubestadosRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SubestadosRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubestadosRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubestadosRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubestadosRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SubestadosRm>}
     * @memberof SubestadosRmListResponseDTO
     */
    'Data'?: Array<SubestadosRm>;
    /**
     * 
     * @type {any}
     * @memberof SubestadosRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SummaryInfo
 */
export interface SummaryInfo {
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'summaryType'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantRm
 */
export interface TenantRm {
    /**
     * 
     * @type {string}
     * @memberof TenantRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRm
     */
    'TenantId': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRm
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRm
     */
    'RutaTenantPadre': string;
}
/**
 * 
 * @export
 * @interface TicketComplianceInspeccionVisualRm
 */
export interface TicketComplianceInspeccionVisualRm {
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'IdInspeccion': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {number}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {number}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'IdEstado': number;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'Prioridad': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'PrioridadCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'Estado': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'EstadoCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'Subestado': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'SubestadoCodigo': string;
    /**
     * 
     * @type {string}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'Cola': string | null;
    /**
     * 
     * @type {Date}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'IdsRespuestas': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TicketComplianceInspeccionVisualRm
     */
    'NumKos': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TipoAdjuntoIntervencionEnum = {
    FotoCuadroElectrico: 'FOTO_CUADRO_ELECTRICO',
    FotoCargador: 'FOTO_CARGADOR',
    FotoNumeroSerie: 'FOTO_NUMERO_SERIE',
    PruebaTermografica: 'PRUEBA_TERMOGRAFICA',
    FotoNuevoNumeroSerie: 'FOTO_NUEVO_NUMERO_SERIE',
    Otros: 'OTROS'
} as const;

export type TipoAdjuntoIntervencionEnum = typeof TipoAdjuntoIntervencionEnum[keyof typeof TipoAdjuntoIntervencionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoEmpresaInspeccionVisualEnum = {
    Externa: 'EXTERNA',
    Interna: 'INTERNA'
} as const;

export type TipoEmpresaInspeccionVisualEnum = typeof TipoEmpresaInspeccionVisualEnum[keyof typeof TipoEmpresaInspeccionVisualEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoInformeWoExternoEnum = {
    Economico: 'ECONOMICO',
    Tecnico: 'TECNICO'
} as const;

export type TipoInformeWoExternoEnum = typeof TipoInformeWoExternoEnum[keyof typeof TipoInformeWoExternoEnum];


/**
 * 
 * @export
 * @interface TipoInfraestructuraCargadorModel
 */
export interface TipoInfraestructuraCargadorModel {
    /**
     * 
     * @type {number}
     * @memberof TipoInfraestructuraCargadorModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof TipoInfraestructuraCargadorModel
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof TipoInfraestructuraCargadorModel
     */
    'DenoDefecto': string;
}
/**
 * 
 * @export
 * @interface TipoInfraestructuraCargadorModelIListResponseDTO
 */
export interface TipoInfraestructuraCargadorModelIListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<TipoInfraestructuraCargadorModel>}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'Data'?: Array<TipoInfraestructuraCargadorModel>;
    /**
     * 
     * @type {any}
     * @memberof TipoInfraestructuraCargadorModelIListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoIntervaloEnum = {
    Semanal: 'Semanal',
    Quincenal: 'Quincenal',
    Mensual: 'Mensual',
    Bimestral: 'Bimestral',
    Trimestral: 'Trimestral',
    Semestral: 'Semestral',
    Anual: 'Anual'
} as const;

export type TipoIntervaloEnum = typeof TipoIntervaloEnum[keyof typeof TipoIntervaloEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoOcaEnum = {
    Ubicacion: 'Ubicacion',
    CentroTransformacion: 'CentroTransformacion'
} as const;

export type TipoOcaEnum = typeof TipoOcaEnum[keyof typeof TipoOcaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoPrestadorEnum = {
    B2C: 'B2C',
    Public: 'Public',
    B2B: 'B2B',
    VentaEeNivel2: 'Venta_EE_Nivel2',
    Oca: 'OCA',
    InspeccionesVisuales: 'InspeccionesVisuales'
} as const;

export type TipoPrestadorEnum = typeof TipoPrestadorEnum[keyof typeof TipoPrestadorEnum];


/**
 * 
 * @export
 * @interface TipoTicketsRm
 */
export interface TipoTicketsRm {
    /**
     * 
     * @type {number}
     * @memberof TipoTicketsRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof TipoTicketsRm
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof TipoTicketsRm
     */
    'DenoDefecto': string;
}
/**
 * 
 * @export
 * @interface TipoTicketsRmListResponseDTO
 */
export interface TipoTicketsRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<TipoTicketsRm>}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'Data'?: Array<TipoTicketsRm>;
    /**
     * 
     * @type {any}
     * @memberof TipoTicketsRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoUnidadMedidaElecnorEnum = {
    Ud: 'Ud',
    H: 'H',
    Ml: 'Ml'
} as const;

export type TipoUnidadMedidaElecnorEnum = typeof TipoUnidadMedidaElecnorEnum[keyof typeof TipoUnidadMedidaElecnorEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoWoEnum = {
    Preventiva: 'Preventiva',
    PuestaMarcha: 'PuestaMarcha',
    Correctivo: 'Correctivo'
} as const;

export type TipoWoEnum = typeof TipoWoEnum[keyof typeof TipoWoEnum];


/**
 * 
 * @export
 * @interface TipologiaSubtipologiaIncidenciaRm
 */
export interface TipologiaSubtipologiaIncidenciaRm {
    /**
     * 
     * @type {number}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'IdSubtipologiaIncidencia': number;
    /**
     * 
     * @type {number}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'IdTipologiaIncidencia': number;
    /**
     * 
     * @type {string}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'Tipologia': string;
    /**
     * 
     * @type {string}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'Subtipologia': string;
    /**
     * 
     * @type {string}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'Etiqueta': string;
    /**
     * 
     * @type {string}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'PalabrasAmigables': string | null;
    /**
     * 
     * @type {number}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'IdSubestadoTicket': number | null;
    /**
     * 
     * @type {number}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'IdEstado': number | null;
    /**
     * 
     * @type {number}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'IdColaUsuario': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'SoloCreacionEdicion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TipologiaSubtipologiaIncidenciaRm
     */
    'SoloAsistenciaSat': boolean;
}
/**
 * 
 * @export
 * @interface TipologiaSubtipologiaIncidenciaRmListResponseDTO
 */
export interface TipologiaSubtipologiaIncidenciaRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<TipologiaSubtipologiaIncidenciaRm>}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'Data'?: Array<TipologiaSubtipologiaIncidenciaRm>;
    /**
     * 
     * @type {any}
     * @memberof TipologiaSubtipologiaIncidenciaRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface TransaccionMensajeModel
 */
export interface TransaccionMensajeModel {
    /**
     * 
     * @type {string}
     * @memberof TransaccionMensajeModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof TransaccionMensajeModel
     */
    'Texto': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransaccionMensajeModel
     */
    'Adjuntos': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TransaccionMensajeModel
     */
    'UsuarioAutor': string;
    /**
     * 
     * @type {Date}
     * @memberof TransaccionMensajeModel
     */
    'Fecha': Date;
    /**
     * 
     * @type {boolean}
     * @memberof TransaccionMensajeModel
     */
    'EsMensajePropio': boolean;
}
/**
 * 
 * @export
 * @interface UbicacionFicheroAdjuntoInputModel
 */
export interface UbicacionFicheroAdjuntoInputModel {
    /**
     * 
     * @type {number}
     * @memberof UbicacionFicheroAdjuntoInputModel
     */
    'IdTipoFicheroAdjuntoOca': number;
    /**
     * 
     * @type {string}
     * @memberof UbicacionFicheroAdjuntoInputModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof UbicacionFicheroAdjuntoInputModel
     */
    'Url': string;
}
/**
 * 
 * @export
 * @interface UbicacionRm
 */
export interface UbicacionRm {
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'IdUbicacion': string;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'Matricula': string;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'Categoria': string | null;
    /**
     * 
     * @type {number}
     * @memberof UbicacionRm
     */
    'IdBusinessModel': number | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'Direccion': string;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'Municipio': string;
    /**
     * 
     * @type {number}
     * @memberof UbicacionRm
     */
    'IdProvincia': number;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'CodigoPostal': string;
    /**
     * 
     * @type {number}
     * @memberof UbicacionRm
     */
    'DelegacionOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'NpedidoXcustomer': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'Titular': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'CifTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'Cups': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'Cove': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'FechaCaducidad': string | null;
    /**
     * 
     * @type {number}
     * @memberof UbicacionRm
     */
    'IdTipoInfraestructuraCargador': number;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'TipoInfraestructuraCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'TipoInfraestructuraDenoDefecto': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UbicacionRm
     */
    'Activa': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UbicacionRm
     */
    'TieneOca': boolean;
    /**
     * 
     * @type {Date}
     * @memberof UbicacionRm
     */
    'FechaAlta': Date;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'IdUsuarioAlta': string;
    /**
     * 
     * @type {Date}
     * @memberof UbicacionRm
     */
    'FechaModificacion': Date;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'IdUsuarioModificacion': string;
    /**
     * 
     * @type {Date}
     * @memberof UbicacionRm
     */
    'FechaBaja': Date | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'IdUsuarioBaja': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'BusinessModelCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'BusinessModelDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'ProvinciaDenominacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof UbicacionRm
     */
    'IdComunidadAutonoma': number | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'ComunidadAutonomaDenominacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof UbicacionRm
     */
    'IdZona': number | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'ZonaDescripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'NumSeriePrimerCargador': string | null;
    /**
     * 
     * @type {number}
     * @memberof UbicacionRm
     */
    'NumCargadoresAsociados': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UbicacionRm
     */
    'IdsCargadores': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRm
     */
    'IdUsuarioResponsableSugerido': string | null;
}
/**
 * 
 * @export
 * @interface UbicacionRmResponseDTO
 */
export interface UbicacionRmResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof UbicacionRmResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof UbicacionRmResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UbicacionRmResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UbicacionRmResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRmResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UbicacionRmResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {UbicacionRm}
     * @memberof UbicacionRmResponseDTO
     */
    'Data'?: UbicacionRm;
    /**
     * 
     * @type {any}
     * @memberof UbicacionRmResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface UbicacionesActivosRm
 */
export interface UbicacionesActivosRm {
    /**
     * 
     * @type {string}
     * @memberof UbicacionesActivosRm
     */
    'Direccion': string;
    /**
     * 
     * @type {number}
     * @memberof UbicacionesActivosRm
     */
    'NumActivos': number;
}
/**
 * 
 * @export
 * @interface UbicacionesActivosRmListResponseDTO
 */
export interface UbicacionesActivosRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<UbicacionesActivosRm>}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'Data'?: Array<UbicacionesActivosRm>;
    /**
     * 
     * @type {any}
     * @memberof UbicacionesActivosRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface UnitResponseDTO
 */
export interface UnitResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof UnitResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof UnitResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UnitResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnitResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof UnitResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnitResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {object}
     * @memberof UnitResponseDTO
     */
    'Data'?: object;
    /**
     * 
     * @type {any}
     * @memberof UnitResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface UpdateIntervaloActuacionModel
 */
export interface UpdateIntervaloActuacionModel {
    /**
     * 
     * @type {string}
     * @memberof UpdateIntervaloActuacionModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateIntervaloActuacionModel
     */
    'IdTipoIntervalo': number;
}
/**
 * 
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'IdUsuario': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'Email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserProfileResponse
     */
    'Permissions': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    'TieneInformesVariable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    'TieneInformesFijo': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserProfileResponse
     */
    'ModulosPds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    'PuedeUsarIa': boolean;
    /**
     * 
     * @type {number}
     * @memberof UserProfileResponse
     */
    'SaldoDisponibleIa': number;
}
/**
 * 
 * @export
 * @interface UserProfileResponseResponseDTO
 */
export interface UserProfileResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof UserProfileResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof UserProfileResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {UserProfileResponse}
     * @memberof UserProfileResponseResponseDTO
     */
    'Data'?: UserProfileResponse;
    /**
     * 
     * @type {any}
     * @memberof UserProfileResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface UsuarioTecnicoExternoDto
 */
export interface UsuarioTecnicoExternoDto {
    /**
     * 
     * @type {string}
     * @memberof UsuarioTecnicoExternoDto
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioTecnicoExternoDto
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioTecnicoExternoDto
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioTecnicoExternoDto
     */
    'Email': string | null;
}
/**
 * 
 * @export
 * @interface ValidacionWoRm
 */
export interface ValidacionWoRm {
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'IdNumerico': string;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'CosteTotal': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionWoRm
     */
    'EsUrgente': boolean;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'IdTipoUrgenciaTecnico': number | null;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'IdTipoUrgenciaAdministrador': number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'IdWo': string;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'IdNumericoWo': string;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'CosteTotalWo': number | null;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'IdEstadoWo': number;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'HorasExtraValor': string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'HorasExtraObservaciones': string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'HorasExtraValorNumerico': number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'MaterialExtraValor': string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'MaterialExtraObservaciones': string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'MaterialExtraValorNumerico': number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRm
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionWoRm
     */
    'CreadaCaliente': boolean;
    /**
     * 
     * @type {number}
     * @memberof ValidacionWoRm
     */
    'IdEstadoActuacion': number;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionWoRm
     */
    'PruebaCargaTodosMetodosAutenticacion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionWoRm
     */
    'TieneItemsMaterialesElecnor': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionWoRm
     */
    'TieneItemsMaterialesCircutor': boolean | null;
}
/**
 * 
 * @export
 * @interface ValidacionWoRmListResponseDTO
 */
export interface ValidacionWoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ValidacionWoRm>}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'Data'?: Array<ValidacionWoRm>;
    /**
     * 
     * @type {any}
     * @memberof ValidacionWoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ValidarActuacionModel
 */
export interface ValidarActuacionModel {
    /**
     * 
     * @type {string}
     * @memberof ValidarActuacionModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidarActuacionModel
     */
    'ValidacionActuacion': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidarActuacionModel
     */
    'Observaciones': string;
    /**
     * 
     * @type {number}
     * @memberof ValidarActuacionModel
     */
    'IdTipoUrgenciaAdministrador': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ValidarActuacionModel
     */
    'GenerarInformeEconomico': boolean | null;
}
/**
 * 
 * @export
 * @interface ValidarWoModel
 */
export interface ValidarWoModel {
    /**
     * 
     * @type {string}
     * @memberof ValidarWoModel
     */
    'IdWo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidarWoModel
     */
    'ValidacionWo': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidarWoModel
     */
    'Observaciones': string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidarWoModel
     */
    'GenerarInformeEconomico': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ValidarWoModel
     */
    'RecalcularEstadoActuacion': boolean;
}
/**
 * 
 * @export
 * @interface ValorConObservaciones
 */
export interface ValorConObservaciones {
    /**
     * 
     * @type {boolean}
     * @memberof ValorConObservaciones
     */
    'Valor': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValorConObservaciones
     */
    'Observaciones': string | null;
}
/**
 * 
 * @export
 * @interface VisitaFicheroAdjuntoInputModel
 */
export interface VisitaFicheroAdjuntoInputModel {
    /**
     * 
     * @type {number}
     * @memberof VisitaFicheroAdjuntoInputModel
     */
    'IdTipoFicheroAdjuntoOca': number;
    /**
     * 
     * @type {string}
     * @memberof VisitaFicheroAdjuntoInputModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof VisitaFicheroAdjuntoInputModel
     */
    'Url': string;
}
/**
 * 
 * @export
 * @interface VisitaOcaDetailModel
 */
export interface VisitaOcaDetailModel {
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof VisitaOcaDetailModel
     */
    'Numero': number;
    /**
     * 
     * @type {Date}
     * @memberof VisitaOcaDetailModel
     */
    'FechaProgramacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'FechaCertificacion': string | null;
    /**
     * 
     * @type {number}
     * @memberof VisitaOcaDetailModel
     */
    'IdResultadoVisitaOca': number | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'ResultadoCodigo': string | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'ResultadoDenoDefecto': string | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VisitaOcaDetailModel
     */
    'TieneDeficienciaTecnica': boolean;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'ObservacionesDeficienciaTecnica': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VisitaOcaDetailModel
     */
    'TieneDeficienciaDocumental': boolean;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'ObservacionesDeficienciaDocumental': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VisitaOcaDetailModel
     */
    'IdsDeficienciasTecnica': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof VisitaOcaDetailModel
     */
    'IdsDeficienciasDocumental': Array<number>;
    /**
     * 
     * @type {Array<DeficienciaAsociadaVisitaModel>}
     * @memberof VisitaOcaDetailModel
     */
    'DeficienciasAsociadas': Array<DeficienciaAsociadaVisitaModel>;
    /**
     * 
     * @type {Array<AdjuntoVisitaModel>}
     * @memberof VisitaOcaDetailModel
     */
    'Ficheros': Array<AdjuntoVisitaModel>;
    /**
     * 
     * @type {Array<number>}
     * @memberof VisitaOcaDetailModel
     */
    'IdsNumericosWoVisita': Array<number>;
    /**
     * 
     * @type {Array<WoVisitaEnlaceModel>}
     * @memberof VisitaOcaDetailModel
     */
    'WosVisita': Array<WoVisitaEnlaceModel>;
    /**
     * 
     * @type {number}
     * @memberof VisitaOcaDetailModel
     */
    'IdNumericoWoVisita': number | null;
    /**
     * 
     * @type {number}
     * @memberof VisitaOcaDetailModel
     */
    'IdNumericoWoDeficienciaTecnica': number | null;
    /**
     * 
     * @type {number}
     * @memberof VisitaOcaDetailModel
     */
    'IdNumericoWoDeficienciaDocumental': number | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'IdWoDeficiencia': string | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'IdActuacionWoDeficiencia': string | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'NumeroPedido': string | null;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModel
     */
    'Expediente': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VisitaOcaDetailModel
     */
    'PuedeCrearWoDeficiencia': boolean;
}
/**
 * 
 * @export
 * @interface VisitaOcaDetailModelListResponseDTO
 */
export interface VisitaOcaDetailModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<VisitaOcaDetailModel>}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'Data'?: Array<VisitaOcaDetailModel>;
    /**
     * 
     * @type {any}
     * @memberof VisitaOcaDetailModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface WoAsignadaComplianceInspeccionVisualRm
 */
export interface WoAsignadaComplianceInspeccionVisualRm {
    /**
     * 
     * @type {string}
     * @memberof WoAsignadaComplianceInspeccionVisualRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof WoAsignadaComplianceInspeccionVisualRm
     */
    'IdInspeccion': string;
    /**
     * 
     * @type {string}
     * @memberof WoAsignadaComplianceInspeccionVisualRm
     */
    'IdCargador': string;
    /**
     * 
     * @type {number}
     * @memberof WoAsignadaComplianceInspeccionVisualRm
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof WoAsignadaComplianceInspeccionVisualRm
     */
    'TipoWo': string;
    /**
     * 
     * @type {Date}
     * @memberof WoAsignadaComplianceInspeccionVisualRm
     */
    'FechaMinInicial': Date | null;
}
/**
 * 
 * @export
 * @interface WoExternaDto
 */
export interface WoExternaDto {
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof WoExternaDto
     */
    'IdNumerico': number;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'IdCargador': string;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'Estado': string;
    /**
     * 
     * @type {number}
     * @memberof WoExternaDto
     */
    'IdEstadoWo': number;
    /**
     * 
     * @type {Date}
     * @memberof WoExternaDto
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof WoExternaDto
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WoExternaDto
     */
    'FechaUltimaActualizacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'TipoWo': string;
    /**
     * 
     * @type {number}
     * @memberof WoExternaDto
     */
    'IdTipoWo': number;
    /**
     * 
     * @type {boolean}
     * @memberof WoExternaDto
     */
    'TieneIncidencia': boolean;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'MensajeIncidencia': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WoExternaDto
     */
    'Validado': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'ObservacionValidacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'Conclusiones': string | null;
    /**
     * 
     * @type {number}
     * @memberof WoExternaDto
     */
    'IdEstadoAutorizacionMaestroPagos': number | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'CodigoAutorizacionMaestroPagos': string | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'NombreAutorizacionMaestroPagos': string | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'ObservacionAutorizacionMaestroPagos': string | null;
    /**
     * 
     * @type {Date}
     * @memberof WoExternaDto
     */
    'FechaAutorizacionMaestroPagos': Date | null;
    /**
     * 
     * @type {number}
     * @memberof WoExternaDto
     */
    'IdTipologiaIncidencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'TipologiaIncidencia': string | null;
    /**
     * 
     * @type {number}
     * @memberof WoExternaDto
     */
    'IdSubtipologiaIncidencia': number | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'SubtipologiaIncidencia': string | null;
    /**
     * 
     * @type {number}
     * @memberof WoExternaDto
     */
    'ImporteWo': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WoExternaDto
     */
    'EsFavorable': boolean;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'NumeroSerieNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'IdCargadorNuevo': string | null;
    /**
     * 
     * @type {string}
     * @memberof WoExternaDto
     */
    'NumeroSerieSustituto': string | null;
    /**
     * 
     * @type {Array<PlugExternoDto>}
     * @memberof WoExternaDto
     */
    'Plugs': Array<PlugExternoDto>;
    /**
     * 
     * @type {Array<PlugExternoDto>}
     * @memberof WoExternaDto
     */
    'PlugsSustituto': Array<PlugExternoDto>;
}
/**
 * 
 * @export
 * @interface WoTecnicoMaestroPagosModel
 */
export interface WoTecnicoMaestroPagosModel {
    /**
     * 
     * @type {string}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'IdWo': string;
    /**
     * 
     * @type {number}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'NumeroWo': number;
    /**
     * 
     * @type {string}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {string}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'TipoWo': string;
    /**
     * 
     * @type {string}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'Estado': string;
    /**
     * 
     * @type {string}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {string}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'Ubicacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'FechaActuacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'FechaMinInicial': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'FechaMaxInicial': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'FechaCierre': Date | null;
    /**
     * 
     * @type {string}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'Tecnico': string;
    /**
     * 
     * @type {boolean}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'TieneIncidencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'CosteTotal': number;
    /**
     * 
     * @type {boolean}
     * @memberof WoTecnicoMaestroPagosModel
     */
    'Validado': boolean | null;
}
/**
 * 
 * @export
 * @interface WoVisitaEnlaceModel
 */
export interface WoVisitaEnlaceModel {
    /**
     * 
     * @type {string}
     * @memberof WoVisitaEnlaceModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof WoVisitaEnlaceModel
     */
    'IdActuacion': string;
    /**
     * 
     * @type {number}
     * @memberof WoVisitaEnlaceModel
     */
    'IdNumerico': number;
}
/**
 * 
 * @export
 * @interface ZonasRm
 */
export interface ZonasRm {
    /**
     * 
     * @type {string}
     * @memberof ZonasRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ZonasRm
     */
    'Descripcion': string;
}
/**
 * 
 * @export
 * @interface ZonasRmListResponseDTO
 */
export interface ZonasRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ZonasRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ZonasRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ZonasRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ZonasRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ZonasRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZonasRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ZonasRm>}
     * @memberof ZonasRmListResponseDTO
     */
    'Data'?: Array<ZonasRm>;
    /**
     * 
     * @type {any}
     * @memberof ZonasRmListResponseDTO
     */
    'Extra'?: any;
}



  
export const ApiApiRoutes = {
    activoCreate: "/api/Commons/Cargador",
    actuacionCreate: "/api/Commons/Actuacion",
    actuacionEdit: "/api/Commons/Actuacion/Editar",
    actuacionesGetRejilla: "/api/Commons/Actuacion/Rejilla",
    actualizarPlanificacionTecnicoInspeccionVisual: "/api/Commons/InspeccionVisual/planificacion",
    addCargadoresUbicacion: "/api/Commons/Oca/ubicaciones/cargadores/add",
    addMensajeTransaccion: "/api/Commons/Transacciones/{id}/message",
    anularOca: "/api/Commons/Oca/ocas/{id}/anular",
    asignarFechaActuacion: "/api/Commons/Actuacion/Fecha",
    asignarPrevisionActuacionExterno: "/api/Commons/ActuacionExterna/planificar",
    asignarTecnicoActuacion: "/api/Commons/Actuacion",
    cambiarEstadoTransaccion: "/api/Commons/Transacciones/{id}/cambiar-estado",
    cancelarActuacion: "/api/Commons/Actuacion/Cancelar",
    cancelarColaTareaProgramada: "/api/Commons/AdminQuely/cola-tareas-programadas/{id}/cancelar",
    cancelarWo: "/api/Commons/Actuacion/CancelarWo",
    cargadorPoiEdit: "/api/Commons/Cargador/edit-poi",
    cargadorSubscribe: "/api/Commons/Cargador/SubscribeCargador",
    cargadorUnsubscribe: "/api/Commons/Cargador/UnsubscribeCargador",
    cargadoresEstadosSuscripciones: "/api/Commons/Cargador/GetCargadoresEstadosSuscripciones",
    cargadoresPorUsuario: "/api/Commons/Cargador/GetCargadoresPorUsuario",
    centroTransformacionCreate: "/api/Commons/Oca/centros-transformacion",
    centroTransformacionEdit: "/api/Commons/Oca/centros-transformacion/editar",
    cerrarInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/cerrar",
    checkNumeroSerieNuevoDisponible: "/api/Commons/Cargador/CheckNumeroSerie",
    checkTicketByIdCargador: "/api/Commons/Ticket/check-ticket-by-id-cargador",
    checkTicketBySerial: "/api/Commons/Ticket/check-ticket-by-serial",
    completarDatosPagos: "/api/Commons/MaestroPagos/CompletarDatosPagos",
    completarInformeTecnicoInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/informe-tecnico/completar",
    crearObservacionOca: "/api/Commons/Oca/ocas/observaciones",
    crearVisitaCentroTransformacion: "/api/Commons/Oca/ocas/visitas-centro-transformacion/nueva",
    crearVisitaUbicacion: "/api/Commons/Oca/ocas/visitas/nueva",
    crearWoDeficienciaVisita: "/api/Commons/Oca/ocas/visitas/crear-wo-deficiencia",
    createCampana: "/api/Commons/Campana",
    createCargadorEventoCambioResponsable: "/api/Commons/Ticket/create-cargador-evento-cambio-responsable",
    createCargadorPeriodoPrivado: "/api/Commons/Cargador/periodos-privado",
    createGrupoActuaciones: "/api/Commons/Campana/{id}/grupo-actuacion",
    createSubestadoHistorico: "/api/Commons/Ticket/create-subestado-historico",
    createTicket: "/api/Commons/Ticket/create-ticket",
    createWo: "/api/Commons/Wo",
    deleteAdjuntoActuacion: "/api/Commons/Actuacion/{id}/adjunto",
    deleteAdjuntoTicket: "/api/Commons/Ticket/{id}/adjunto",
    deleteAdjuntoWo: "/api/Commons/Actuacion/wo/{id}/adjunto",
    deleteCampana: "/api/Commons/Campana/{id}",
    deleteEventoCargador: "/api/Commons/Ticket/delete-evento-cargador",
    deshacerComplianceWo: "/api/Commons/Wo/{id}/compliance/undo",
    detalleCargador: "/api/Commons/Cargador/GetCargadorDetalle",
    documentosGenerateTempUrl: "/api/Commons/Documentos/url",
    downloadDocumentoDg: "/api/Commons/Oca/documento-dg",
    downloadFilesTicket: "/api/Commons/Ticket/{id}/download-files",
    downloadFilesWo: "/api/Commons/Wo/{id}/download-files",
    editActuacionYWorkOrdersExterno: "/api/Commons/ActuacionExterna/editar",
    editCampana: "/api/Commons/Campana",
    editCargador: "/api/Commons/Cargador",
    editCargadorPeriodoPrivado: "/api/Commons/Cargador/periodos-privado/edit",
    editDatosInforme: "/api/Commons/Actuacion/EditarDatosInforme",
    editDeficienciasVisitaUbicacion: "/api/Commons/Oca/ocas/visitas/editar-deficiencias",
    editInformeTecnico: "/api/Commons/Actuacion/EditarInformeTecnico",
    editTicket: "/api/Commons/Ticket/edit-ticket",
    editVisitaCentroTransformacion: "/api/Commons/Oca/ocas/visitas-centro-transformacion/editar",
    editVisitaUbicacion: "/api/Commons/Oca/ocas/visitas/editar",
    editarObservacionOca: "/api/Commons/Oca/ocas/observaciones/{id}",
    eliminarMspInteroperabilidad: "/api/Commons/Interoperabilidad/msps/{id}",
    eliminarMspTarifaInteroperabilidad: "/api/Commons/Interoperabilidad/asignaciones/{id}",
    eliminarObservacionOca: "/api/Commons/Oca/ocas/observaciones/{id}",
    eliminarRecargaTarifaInteroperabilidad: "/api/Commons/Interoperabilidad/tarifas/{id}",
    eliminarRecargaTarifaPrecioInteroperabilidad: "/api/Commons/Interoperabilidad/precios/{id}",
    encolarTareaProgramada: "/api/Commons/AdminQuely/tareas-programadas/{id}/encolar",
    enviarMensajeOca: "/api/Commons/Oca/ocas/mensajes",
    equipoMedidaCreate: "/api/Commons/EquipoMedida",
    equipoMedidaDelete: "/api/Commons/EquipoMedida",
    equipoMedidaEdit: "/api/Commons/EquipoMedida/Editar",
    equipoMedidaGetRejilla: "/api/Commons/EquipoMedida/GetRejillaEquipoMedida",
    existeCargadorAndTipoEnActuacion: "/api/Commons/Wo/ExisteCargadorEnWo",
    existeNumeroSerieExterno: "/api/Commons/ActuacionExterna/cargadores/existe-numero-serie",
    featuresGet: "/features/{featureName}",
    featuresList: "/features",
    fechasImportacion: "/api/Commons/Tenant/GetFechasImportacion",
    firmarActuacion: "/api/Commons/Actuacion/FirmarActuacion",
    generateInformeEconomicoActuacion: "/api/Commons/Actuacion/{id}/generate-informe-economico",
    generateInformeTecnicoWo: "/api/Commons/Actuacion/wo/{id}/generate-informe-tecnico",
    getActivosActuacion: "/api/Commons/Actuacion/ActivosActuacion",
    getActuacionesAbiertas: "/api/Commons/ActuacionExterna/abiertas",
    getActuacionesCerradas: "/api/Commons/ActuacionExterna/cerradas",
    getActuacionesConIncidencia: "/api/Commons/ActuacionExterna/con-incidencia",
    getAllBusinessModelsForCombo: "/api/Commons/Partner/business-models-combo",
    getAllPartnersForCombo: "/api/Commons/Partner/combo",
    getAllProvincias: "/api/Commons/Wo/provincias",
    getAsignacionesInteroperabilidadForGrid: "/api/Commons/Interoperabilidad/asignaciones/grid",
    getCampanas: "/api/Commons/Campana",
    getCampanasForGrid: "/api/Commons/Campana/grid",
    getCanalesEntrada: "/api/Commons/Ticket/canales-entrada",
    getCargadorHistoricoEstadoGrid: "/api/Commons/Cargador/historico-estado/grid",
    getCargadorPeriodosPrivadoGrid: "/api/Commons/Cargador/periodos-privado/grid",
    getCargadoresAll: "/api/Commons/Cargador/All",
    getCargadoresByTenantId: "/api/Commons/Cargador/ByTenantId",
    getCargadoresCampanaForGrid: "/api/Commons/Campana/{id}/grid-cargadores",
    getCargadoresCentroTransformacion: "/api/Commons/Oca/centros-transformacion/{id}/cargadores",
    getCargadoresComplianceInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/compliance/cargadores",
    getCargadoresDismissedForGrid: "/api/Commons/Cargador/dismissed/grid",
    getCargadoresEnel: "/api/Commons/Cargador/Enel",
    getCargadoresForGrid: "/api/Commons/Cargador/grid",
    getCargadoresForGridAdmin: "/api/Commons/Cargador/grid-admin",
    getCargadoresMobility: "/api/Commons/Mobility/cargador",
    getCargadoresOrderSuscrito: "/api/Commons/Cargador/GetCargadoresOrderSuscrito",
    getCargadoresRm: "/api/Commons/Cargador/GetCargadoresRm",
    getCargadoresSinUbicacionForGrid: "/api/Commons/Cargador/sin-ubicacion/grid",
    getCargadoresUbicacion: "/api/Commons/Oca/ubicaciones/{id}/cargadores",
    getCasos: "/api/Commons/Actuacion/Casos",
    getCatalogoItemsCorrectivasElecnor: "/api/Commons/Actuacion/catalogo-elecnor-items-correctivas",
    getCatalogoItemsMaterialesCircutor: "/api/Commons/Actuacion/catalogo-circutor-items-materiales",
    getCatalogoItemsMaterialesElecnor: "/api/Commons/Actuacion/catalogo-elecnor-items-materiales",
    getCatalogoItemsPreventivasElecnor: "/api/Commons/Actuacion/catalogo-elecnor-items-preventivas",
    getCentroTransformacionById: "/api/Commons/Oca/centros-transformacion/detail/{id}",
    getCochesElectricosMobility: "/api/Commons/Mobility/coche-electrico",
    getColaTareaProgramadaForGrid: "/api/Commons/AdminQuely/cola-tareas-programadas/grid",
    getColaUsuario: "/api/Commons/Usuario/cola-usuario",
    getComparacionActivosAltaForGrid: "/api/Commons/XCustomer/grid-comparacion-activos-alta",
    getComparacionActivosBajaForGrid: "/api/Commons/XCustomer/grid-comparacion-activos-baja",
    getConfiguracionAdjuntosActuacion: "/api/Commons/Actuacion/configuracion-adjuntos-actuacion",
    getConfiguracionAdjuntosCentroTransformacion: "/api/Commons/Oca/configuracion-adjuntos-centro-transformacion",
    getConfiguracionAdjuntosTicket: "/api/Commons/Ticket/configuracion-adjuntos-ticket",
    getConfiguracionAdjuntosUbicacion: "/api/Commons/Oca/configuracion-adjuntos-ubicacion",
    getConfiguracionAdjuntosVisita: "/api/Commons/Oca/configuracion-adjuntos-visita",
    getConfiguracionAdjuntosWo: "/api/Commons/Actuacion/configuracion-adjuntos-wo",
    getDashboardActivos: "/api/Commons/DashboardActivos/dashboard",
    getDashboardActivosForGrid: "/api/Commons/DashboardActivos/grid",
    getDashboardCampana: "/api/Commons/Campana/{id}/dashboard",
    getDashboardKpiGmao: "/api/Commons/DashboardKpiGmao/dashboard",
    getDashboardOcas: "/api/Commons/DashboardOcas/dashboard",
    getDeficienciasCompliance: "/api/Commons/InspeccionVisual/deficiencias-compliance",
    getDeficienciasVisitaMaestra: "/api/Commons/Oca/deficiencias-visita",
    getDetalleActuacion: "/api/Commons/Actuacion/Actuacion",
    getDetalleCampana: "/api/Commons/Campana/{id}",
    getDetallePartnerById: "/api/Commons/Partner/detail/{id}",
    getDetalleTicket: "/api/Commons/Ticket/detalle",
    getDetalleWo: "/api/Commons/Actuacion/Wo",
    getDetalleWosTecnicoMaestroPagos: "/api/Commons/MaestroPagos/DetalleWosTecnicoMaestroPagos",
    getDetallecargadorById: "/api/Commons/Cargador/detail/{id}",
    getDetallecargadorPoiById: "/api/Commons/Cargador/detail-poi/{id}",
    getDocumentosAsociadosOca: "/api/Commons/Oca/ocas/{id}/documentos-asociados",
    getDocumentosAsociadosWo: "/api/Commons/Wo/documentos-asociados-wo",
    getEnumGenerico: "/api/Commons/Actuacion/Tipo",
    getEquiposMedida: "/api/Commons/ActuacionExterna/equipos-medida",
    getEsquemaUnifilarUbicacionActivo: "/api/Commons/Cargador/{id}/esquema-unifilar",
    getEstadisticasTecnicosMaestroPagos: "/api/Commons/MaestroPagos/EstadisticasTecnicosMaestroPagos",
    getEstadoTareaProgramadaForGrid: "/api/Commons/AdminQuely/estado-tareas-programadas/grid",
    getEstadosTicket: "/api/Commons/Ticket/estados-ticket",
    getEventosByCargador: "/api/Commons/Ticket/eventos-cargador",
    getFicherosAdjuntosCentroTransformacion: "/api/Commons/Oca/centros-transformacion/{id}/ficheros-adjuntos",
    getFicherosAdjuntosUbicacion: "/api/Commons/Oca/ubicaciones/{id}/ficheros-adjuntos",
    getFicherosAdjuntosVisita: "/api/Commons/Oca/visitas/{id}/ficheros-adjuntos",
    getGestionTicketsForGrid: "/api/Commons/Ticket/grid",
    getGestorGmaoSelectBox: "/api/Commons/Usuario/selectBoxGestores",
    getGraficaEstadoActualWos: "/api/Commons/Wo/grafica-estado-actual-wos",
    getGraficaRetrasosWos: "/api/Commons/Wo/grafica-retrasos-wos",
    getGridUsuariosGmao: "/api/Commons/Usuario/RejillaGmao",
    getGridUsuariosGmaoConCola: "/api/Commons/Usuario/RejillaGmaoConCola",
    getGruposActuacionesForGrid: "/api/Commons/Campana/{id}/grid-grupos-actuaciones",
    getHistoricoInteroperabilidadForGrid: "/api/Commons/Interoperabilidad/historico/grid",
    getHistoricoOcasUbicacion: "/api/Commons/Oca/ocas/historico-oca-ubicacion/{id}",
    getHistoricoTicket: "/api/Commons/Ticket/historico-inccidencias",
    getImportacionPartnersByCorrelacion: "/api/Commons/Partner/importacion-partners/{correlacion}",
    getInformeTecnicoInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/informe-tecnico",
    getInformesAsociadosActuacion: "/api/Commons/Actuacion/informes-asociados",
    getInspeccionVisualDetalle: "/api/Commons/InspeccionVisual/{id}/detalle",
    getIntervalosInspeccionVisual: "/api/Commons/InspeccionVisual/intervalos",
    getItemsEconomicosCompatibles: "/api/Commons/Actuacion/items-economicos-compatibles",
    getKimSelectBox: "/api/Commons/Usuario/selectBoxKim",
    getListadoAnualMaestroPagos: "/api/Commons/MaestroPagos/ListadoAnualMaestroPagos",
    getListadoCentrosTransformacionForGrid: "/api/Commons/Oca/centros-transformacion/grid",
    getListadoInspeccionesVisualesForGrid: "/api/Commons/InspeccionVisual/grid",
    getListadoInspeccionesVisualesPorCargadorForGrid: "/api/Commons/InspeccionVisual/grid-por-cargador/{idCargador}",
    getListadoMaestroPagosInspeccionesVisualesForGrid: "/api/Commons/MaestroPagos/inspecciones-visuales/grid",
    getListadoOcasForGrid: "/api/Commons/Oca/ocas/grid",
    getListadoOcasSeguimientoForGrid: "/api/Commons/Oca/seguimiento/ocas/grid",
    getListadoPdsInspeccionesVisualesForGrid: "/api/Commons/InspeccionVisual/pds/grid",
    getListadoPdsOcaForGrid: "/api/Commons/Oca/pds-oca/grid",
    getListadoTrabajoTecnico: "/api/Commons/TrabajoTecnico",
    getListadoUbicacionesForGrid: "/api/Commons/Oca/ubicaciones/grid",
    getListadoUbicacionesInspeccionesVisualesForGrid: "/api/Commons/InspeccionVisual/ubicaciones/grid",
    getMedalleroPorPds: "/api/Commons/MaestroPagos/MedalleroPorPds",
    getMediaMedalleroMensualPds: "/api/Commons/MaestroPagos/GetMediaMedalleroMensualPds",
    getMediaMedalleroMensualPdsPorRangoFecha: "/api/Commons/MaestroPagos/GetMediaMedalleroMensualPdsPorRangoFecha",
    getMediaMedalleroMensualPdsPorRangoFechaPorPds: "/api/Commons/MaestroPagos/GetMediaMedalleroMensualPdsPorRangoFechaPorPds",
    getMediaMensualPdsAnonimizado: "/api/Commons/MaestroPagos/MediaMensualPdsAnonimizado",
    getMensajesOca: "/api/Commons/Oca/ocas/{id}/mensajes",
    getModeloPagoPrestador: "/api/Commons/MaestroPagos/ModeloPagoPrestador",
    getModificacionesActivosPeriodoForGrid: "/api/Commons/XCustomer/grid-modificaciones-activos",
    getMotivosCierreFromWo: "/api/Commons/Wo/motivos-cierre-from-wo",
    getMotivosCierreWoCorrectivo: "/api/Commons/Wo/motivos-cierre-wo-correctivo",
    getMspsInteroperabilidadForGrid: "/api/Commons/Interoperabilidad/msps/grid",
    getMspsInteroperabilidadLista: "/api/Commons/Interoperabilidad/msps/lista",
    getNotificaciones: "/api/Commons/Notificacion",
    getObservacionesOca: "/api/Commons/Oca/ocas/{id}/observaciones",
    getOcaDetailCentroTransformacion: "/api/Commons/Oca/ocas/detail-oca-centro-transformacion/{id}",
    getOcaDetailUbicacion: "/api/Commons/Oca/ocas/detail-oca-ubicacion/{id}",
    getOcaSeguimientoComposicionSemanal: "/api/Commons/Oca/seguimiento/composicion-semanal",
    getOcaSeguimientoHeatmapVisita: "/api/Commons/Oca/seguimiento/heatmap-visita",
    getOcaSeguimientoKpis: "/api/Commons/Oca/seguimiento/kpis",
    getOcaSeguimientoSemanas: "/api/Commons/Oca/seguimiento/semanas",
    getOcaSeguimientoTransiciones: "/api/Commons/Oca/seguimiento/transiciones",
    getOrigenesTicket: "/api/Commons/Ticket/origenes-ticket",
    getPagosB2cInstalaciones: "/api/Commons/PagosB2c/instalaciones",
    getPagosB2cMeses: "/api/Commons/PagosB2c/meses",
    getPagosB2cPdteC3: "/api/Commons/PagosB2c/pdte-c3",
    getPagosB2cReparaciones: "/api/Commons/PagosB2c/reparaciones",
    getPagosB2cVisitas: "/api/Commons/PagosB2c/visitas",
    getPartnerDevengadoForGrid: "/api/Commons/RevenueDevengado/grid",
    getPartnerDevengadoPorAnioForGrid: "/api/Commons/RevenueDevengado/grid-por-anio",
    getPartnerDevengadoPorSociedadAnioForGrid: "/api/Commons/RevenueDevengado/grid-por-sociedad-anio",
    getPartnerDevengadoPorSociedadForGrid: "/api/Commons/RevenueDevengado/grid-por-sociedad",
    getPartnerPorUsuarioBd: "/api/Commons/Partner/partner-usuario-bd",
    getPartnersForGrid: "/api/Commons/Partner/grid",
    getPartnersForGridAdmin: "/api/Commons/Partner/grid-admin",
    getPartnersPorUsuario: "/api/Commons/Partner/partners-usuario",
    getPartnersPorUsuarioBdForGrid: "/api/Commons/Partner/grid-partners-usuario-bd",
    getPartnersPorUsuarioForGrid: "/api/Commons/Partner/grid-partners-usuario",
    getPdsByCodigoPostal: "/api/Commons/Pds/by-codigo-postal",
    getPdsById: "/api/Commons/Pds/detail/{id}",
    getPdsPorUsuarioForGrid: "/api/Commons/Pds/grid-pds-usuario",
    getPiezasWo: "/api/Commons/Wo/piezas-wo",
    getPlanificacionTecnicoInspeccionVisual: "/api/Commons/InspeccionVisual/planificacion",
    getPrecioReferenciaInteroperabilidad: "/api/Commons/Interoperabilidad/tarifas/{idTarifa}/precios/referencia",
    getPreciosInteroperabilidadForGrid: "/api/Commons/Interoperabilidad/precios/grid",
    getPrioridadesTicket: "/api/Commons/Ticket/prioridades-ticket",
    getPuedeVerEstadoWoRevenue: "/api/Commons/Partner/puede-ver-estado-wo-revenue",
    getRangoFechaLimiteOcas: "/api/Commons/Oca/ocas/rango-fecha-limite",
    getRecargasGrid: "/api/Commons/Recargas/grid",
    getRecargasGridAdmin: "/api/Commons/Recargas/grid-admin",
    getRecuentoActivosPeriodoForGrid: "/api/Commons/XCustomer/grid-recuento-activos",
    getRecuentoActivosSemanasSelector: "/api/Commons/XCustomer/recuento-activos-semanas",
    getRejillaMaestroPagosPorPrestador: "/api/Commons/MaestroPagos/RejillaMaestroPagosPrestadorWo",
    getRejillaMaestroPagosPorPrestadorPds: "/api/Commons/MaestroPagos/RejillaMaestroPagosPrestadorWoPds",
    getRejillaPiezasWo: "/api/Commons/Wo/RejillaPiezasWo",
    getRejillaWoPorTicket: "/api/Commons/Wo/RejillaWoPorTicket",
    getResponsablesPrestadorSelectBox: "/api/Commons/Usuario/selectBoxResponsables",
    getResponsablesProvinciasSelectBox: "/api/Commons/Usuario/selectBoxResponsablesProvincia",
    getResumenTiempoColas: "/api/Commons/Ticket/resumen-tiempo-colas",
    getRevenueDashboardGraficas: "/api/Commons/RevenueDashboard/graficas",
    getRevenueInformesDashboardForGrid: "/api/Commons/RevenueDashboard/grid",
    getRevenueInformesDashboardPorAnioForGrid: "/api/Commons/RevenueDashboard/grid-por-anio",
    getRevenueInformesDashboardPorSociedadAnioForGrid: "/api/Commons/RevenueDashboard/grid-por-sociedad-anio",
    getRevenueInformesDashboardPorSociedadForGrid: "/api/Commons/RevenueDashboard/grid-por-sociedad",
    getRevenueSelfPuedeVerWoSustituciones: "/api/Commons/Partner/revenue-self/puede-ver-wo-sustituciones",
    getSiguienteCargadorInformeTecnicoIv: "/api/Commons/InspeccionVisual/{id}/informe-tecnico/siguiente-cargador",
    getSiguienteComplianceWo: "/api/Commons/Actuacion/GetSiguienteComplianceFromWo",
    getSiguienteWoFromActuacion: "/api/Commons/Actuacion/GetSiguienteWoFromActuacion",
    getSiguienteWoFromWo: "/api/Commons/Actuacion/GetSiguienteWoFromWo",
    getSubestadosTicket: "/api/Commons/Ticket/subestados-ticket",
    getSuscripcionesForGrid: "/api/Commons/Suscripcion/grid",
    getTarifasInteroperabilidadForGrid: "/api/Commons/Interoperabilidad/tarifas/grid",
    getTarifasInteroperabilidadLista: "/api/Commons/Interoperabilidad/tarifas/lista",
    getTecnicosPrestadorSelectBox: "/api/Commons/Usuario/selectBoxTecnicos",
    getTenants: "/api/Commons/Tenant",
    getTenantsOrderSuscrito: "/api/Commons/Tenant/GetTenantsOrderSuscrito",
    getTenantsRm: "/api/Commons/Tenant/GetTenantsRm",
    getTicketsComplianceInspeccionVisualForGrid: "/api/Commons/InspeccionVisual/{id}/tickets-compliance/grid",
    getTipologiasSubtipologiasIncidencia: "/api/Commons/Wo/tipologias-subtipologias-incidencia",
    getTipologiasSubtipologiasIncidenciaExterno: "/api/Commons/ActuacionExterna/tipologias-subtipologias-incidencia",
    getTiposInfraestructuraCargador: "/api/Commons/Oca/tipos-infraestructura-cargador",
    getTiposTicket: "/api/Commons/Ticket/tipos-ticket",
    getTiposUnavailable: "/api/Commons/Cargador/tipos-unavailable",
    getTiposUrgenciaActuacionSelector: "/api/Commons/Actuacion/tipos-urgencia",
    getTransaccionById: "/api/Commons/Transacciones/{id}/detail",
    getTransaccionesGrid: "/api/Commons/Transacciones/grid",
    getTransaccionesGridAdmin: "/api/Commons/Transacciones/grid-admin",
    getUbicacionById: "/api/Commons/Oca/ubicaciones/detail/{id}",
    getUbicacionesActivos: "/api/Commons/Actuacion/UbicacionesActivos",
    getUsuarioBdSelectBox: "/api/Commons/Usuario/selectBoxBd",
    getUsuariosSelectBox: "/api/Commons/Usuario/selectBox",
    getUsuariosTecnicos: "/api/Commons/ActuacionExterna/tecnicos",
    getValidacionActuacion: "/api/Commons/Actuacion/DatosValidacionActuacion",
    getValidacionWo: "/api/Commons/Actuacion/DatosValidacionWo",
    getVisitasOcaCentroTransformacion: "/api/Commons/Oca/ocas/detail-visita-oca-centro-transformacion/{id}",
    getVisitasOcaUbicacion: "/api/Commons/Oca/ocas/detail-visita-oca-ubicacion/{id}",
    getVolumenPorEmpresasPorRangoFechas: "/api/Commons/MaestroPagos/GetVolumenPorEmpresasPorRangoFechas",
    getdPdsPorUsuario: "/api/Commons/Pds/pds-usuario",
    guardarMspInteroperabilidad: "/api/Commons/Interoperabilidad/msps",
    guardarMspTarifaInteroperabilidad: "/api/Commons/Interoperabilidad/asignaciones",
    guardarPasoCargadorInformeTecnicoInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/informe-tecnico/paso/cargadores/{idCargador}",
    guardarPasoUbicacionInformeTecnicoInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/informe-tecnico/paso/ubicacion",
    guardarRecargaTarifaInteroperabilidad: "/api/Commons/Interoperabilidad/tarifas",
    guardarRecargaTarifaPrecioInteroperabilidad: "/api/Commons/Interoperabilidad/precios",
    importarCertificadosVisita: "/api/Commons/Oca/importar-certificados-visita",
    importarClientesCargadores: "/api/Commons/XCustomer/importar-clientes-cargadores",
    importarRecuentoActivosFromXCustomer: "/api/Commons/XCustomer/importar-recuento-activos-from-xcustomer",
    importarWosUrgentesFromXCustomer: "/api/Commons/XCustomer/importar-wos-urgentes-from-xcustomer",
    inspeccionVisualCreateExterna: "/api/Commons/InspeccionVisual/externa",
    inspeccionVisualCreateInterna: "/api/Commons/InspeccionVisual/interna",
    inspeccionVisualEdit: "/api/Commons/InspeccionVisual/editar",
    inspeccionVisualGet: "/api/Commons/InspeccionVisual/{id}",
    ocaCentroTransformacionCreate: "/api/Commons/Oca/ocas/centro-transformacion",
    ocaCentroTransformacionEdit: "/api/Commons/Oca/ocas/centro-transformacion/editar",
    ocaUbicacionCreate: "/api/Commons/Oca/ocas/ubicacion",
    ocaUbicacionEdit: "/api/Commons/Oca/ocas/ubicacion/editar",
    partnerCreate: "/api/Commons/Partner",
    partnerEdit: "/api/Commons/Partner/Editar",
    pdsCreate: "/api/Commons/Pds",
    pdsEdit: "/api/Commons/Pds/Editar",
    pdsGetRejilla: "/api/Commons/Pds/Rejilla",
    postAdjuntoActuacion: "/api/Commons/Actuacion/{id}/adjunto",
    postAdjuntoExternoWo: "/api/Commons/ActuacionExterna/wo/{idWorkOrder}/adjunto",
    postAdjuntoTicket: "/api/Commons/Ticket/{id}/adjunto",
    postAdjuntoWo: "/api/Commons/Actuacion/wo/{id}/adjunto",
    postCargarFicheroPartners: "/api/Commons/Partner/CargarFicheroPartners",
    postDocumentoTemp: "/api/Commons/Documentos/adjuntar-documento-temp",
    postDocumentoUsuarios: "/api/Commons/Documentos/adjuntar-fichero-usuarios",
    postHistoricoEdicionTicket: "/api/Commons/Ticket/{id}/historico-edicion",
    postInformeEconomicoActuacion: "/api/Commons/ActuacionExterna/{idActuacion}/informe-economico-actuacion",
    postInformeWorkOrder: "/api/Commons/ActuacionExterna/{idWorkOrder}/informe-wo",
    postPagosB2cImportar: "/api/Commons/PagosB2c/importar",
    postPartnersCargarExcels: "/api/Commons/Partner/cargar-excels",
    prepararInformeTecnicoInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/informe-tecnico/preparar",
    previewCalculoCosteActuacion: "/api/Commons/Actuacion/{idActuacion}/preview-calculo-coste",
    programarFechaInspeccionVisual: "/api/Commons/InspeccionVisual/programar-fecha",
    programarFechaVisita: "/api/Commons/Oca/ocas/programar-fecha-visita",
    putEditarImporteFijoTransaccion: "/api/Commons/Partner/transacciones-fijo/{id}/importe",
    putEventoCargador: "/api/Commons/Ticket/put-evento-cargador",
    reabrirTicket: "/api/Commons/Ticket/reabrir-ticket",
    readAllNotificaciones: "/api/Commons/Notificacion/read-all",
    readNotificacion: "/api/Commons/Notificacion/{id}/read",
    refreshCargadorStatus: "/api/Commons/Cargador/{id}/refresh-status",
    resolvePdsNuevaActuacion: "/api/Commons/Actuacion/ResolvePdsNuevaActuacion",
    resumirPeriodicidadInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/compliance/reanudar",
    rolesGetAll: "/api/Commons/Usuario/Roles",
    setAptoInspeccionVisualCargador: "/api/Commons/Cargador/{id}/set-apto-inspeccion-visual",
    setCalidadInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/calidad",
    setCargadorAvailable: "/api/Commons/Cargador/{id}/set-available",
    setCargadorDismissed: "/api/Commons/Cargador/{id}/set-dismissed",
    setCargadorUnavailable: "/api/Commons/Cargador/{id}/set-unavailable",
    setCargadorVisibleInApp: "/api/Commons/Cargador/{id}/visible-in-app",
    setComplianceInspeccionVisual: "/api/Commons/InspeccionVisual/{id}/compliance",
    setComplianceWo: "/api/Commons/Wo/{id}/compliance",
    subestadosGetAll: "/api/Commons/Actuacion/Subestados",
    suscripcionInformesPorUsuario: "/api/Commons/Suscripcion/GetSuscripcionInformesPorUsuario",
    suscripcionesCreate: "/api/Commons/Suscripcion",
    suscripcionesDelete: "/api/Commons/Suscripcion",
    suscripcionesPut: "/api/Commons/Suscripcion",
    tenantSubscribe: "/api/Commons/Tenant/SubscribeTenant",
    tenantUnsubscribe: "/api/Commons/Tenant/UnsubscribeTenant",
    tenantsEstadosSuscripciones: "/api/Commons/Tenant/GetTenantsEstadosSuscripciones",
    tenantsPorUsuario: "/api/Commons/Tenant/GetTenantsPorUsuario",
    ubicacionCreate: "/api/Commons/Oca/ubicaciones",
    ubicacionEdit: "/api/Commons/Oca/ubicaciones/editar",
    updateIntervaloActuacion: "/api/Commons/Actuacion/intervalo",
    usuarioCheckEmail: "/api/Commons/Usuario/{Email}/{IdUsuario}/EmailAvailable",
    usuarioCheckUsername: "/api/Commons/Usuario/{Username}/Available",
    usuarioDelete: "/api/Commons/Usuario/Eliminar",
    usuarioGetCurrentUserProfile: "/api/Commons/Usuario/me/Profile",
    usuarioGetPreferenciasNotificacion: "/api/Commons/Usuario/me/PreferenciasNotificacion",
    usuarioGetRejilla: "/api/Commons/Usuario/RejillaRevenue",
    usuarioGmaoCreate: "/api/Commons/Usuario/CreateUsuarioGmao",
    usuarioGmaoEdit: "/api/Commons/Usuario/EditarGmao",
    usuarioReactivate: "/api/Commons/Usuario/Reactivar",
    usuarioRevenueCreate: "/api/Commons/Usuario/CreateUsuarioRevenue",
    usuarioRevenueEdit: "/api/Commons/Usuario/EditarRevenue",
    usuarioUpdatePreferenciasNotificacion: "/api/Commons/Usuario/me/PreferenciasNotificacion",
    validarActuacion: "/api/Commons/Actuacion/Validar",
    validarWo: "/api/Commons/Actuacion/Validarwo",
    woEdit: "/api/Commons/Actuacion/EditarWo",
    woGetInformeTecnicoFromCargador: "/api/Commons/Wo/{idWo}/informe-tecnico-desde-cargador",
    woGetInformeTecnicoFromTicket: "/api/Commons/Wo/{idWo}/informe-tecnico-desde-ticket",
    woGetInformeTecnicoRevenue: "/api/Commons/Wo/{idWo}/informe-tecnico-revenue",
    woGetInformeTecnicoSustitucionRevenue: "/api/Commons/Wo/{idWo}/informe-tecnico-sustitucion-revenue",
    woGetRejilla: "/api/Commons/Wo/RejillaWo",
    woGetRejillaMaestroPagosWo: "/api/Commons/MaestroPagos/RejillaMaestroPagosWo",
    woGetRejillaPorActuacion: "/api/Commons/Wo/RejillaWoPorActuacion",
    woGetRejillaPorIdCargador: "/api/Commons/Wo/RejillaWoIdCargador",
    woGetRejillaPorIdTicket: "/api/Commons/Wo/RejillaWoIdTicket",
    woGetRejillaWoRevenue: "/api/Commons/Wo/RejillaWoRevenue",
    woGetRejillaWoSustitucion: "/api/Commons/Wo/RejillaWoSustitucion",
    zonasGetAll: "/api/Commons/Pds/Zonas",
}
  
/**
 * ApiApi - axios parameter creator
 * @export
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo activo (cargador)
         * @param {CreateActivoModel} [CreateActivoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activoCreate: async (CreateActivoModel?: CreateActivoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateActivoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nueva actuación
         * @param {CreateActuacionModel} [CreateActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuacionCreate: async (CreateActuacionModel?: CreateActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una actuacion existente
         * @param {EditActuacionModel} [EditActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuacionEdit: async (EditActuacionModel?: EditActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de actuaciones compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuacionesGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sustituye el orden de visita de un técnico en una fecha.
         * @param {ActualizarPlanificacionTecnicoInspeccionVisualModel} [ActualizarPlanificacionTecnicoInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizarPlanificacionTecnicoInspeccionVisual: async (ActualizarPlanificacionTecnicoInspeccionVisualModel?: ActualizarPlanificacionTecnicoInspeccionVisualModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/planificacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ActualizarPlanificacionTecnicoInspeccionVisualModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade cargadores sin ubicación a una ubicación existente.
         * @param {AddCargadoresUbicacionModel} [AddCargadoresUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCargadoresUbicacion: async (AddCargadoresUbicacionModel?: AddCargadoresUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ubicaciones/cargadores/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AddCargadoresUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade un mensaje a la transaccion.
         * @param {string} Id 
         * @param {CreateMensajeTransaccionModel} [CreateMensajeTransaccionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMensajeTransaccion: async (Id: string, CreateMensajeTransaccionModel?: CreateMensajeTransaccionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('addMensajeTransaccion', 'Id', Id)
            const localVarPath = `/api/Commons/Transacciones/{id}/message`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateMensajeTransaccionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Anula una OCA abierta.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anularOca: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('anularOca', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/{id}/anular`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asignar una fecha a una o varias actuaciones
         * @param {AsignarFechaActuacionModel} [AsignarFechaActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asignarFechaActuacion: async (AsignarFechaActuacionModel?: AsignarFechaActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Fecha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AsignarFechaActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna fecha de previsión y técnico a una actuación
         * @param {AsignarPrevisionActuacionExternoModel} [AsignarPrevisionActuacionExternoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asignarPrevisionActuacionExterno: async (AsignarPrevisionActuacionExternoModel?: AsignarPrevisionActuacionExternoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/planificar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AsignarPrevisionActuacionExternoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asignar un técnico a una o varias actuaciones
         * @param {AsignarTecnicoActuacionModel} [AsignarTecnicoActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asignarTecnicoActuacion: async (AsignarTecnicoActuacionModel?: AsignarTecnicoActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AsignarTecnicoActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cambia el estado de la transacción
         * @param {string} Id 
         * @param {string} [NuevoEstado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambiarEstadoTransaccion: async (Id: string, NuevoEstado?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('cambiarEstadoTransaccion', 'Id', Id)
            const localVarPath = `/api/Commons/Transacciones/{id}/cambiar-estado`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (NuevoEstado !== undefined) {
                localVarQueryParameter['nuevoEstado'] = NuevoEstado;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cancela una actuacion existente
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarActuacion: async (Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Cancelar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cancela una petición pendiente de la cola de tareas programadas
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarColaTareaProgramada: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('cancelarColaTareaProgramada', 'Id', Id)
            const localVarPath = `/api/Commons/AdminQuely/cola-tareas-programadas/{id}/cancelar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cancela una wo existente
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarWo: async (Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/CancelarWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un cargador poi existente
         * @param {EditCargadorPoiModel} [EditCargadorPoiModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadorPoiEdit: async (EditCargadorPoiModel?: EditCargadorPoiModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/edit-poi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditCargadorPoiModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se suscribe al Cargador seleccionado
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadorSubscribe: async (IdCargador?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/SubscribeCargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadorUnsubscribe: async (IdCargador?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/UnsubscribeCargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de cargadores con sus estados y suscripciones
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadoresEstadosSuscripciones: async (IdCargador?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/GetCargadoresEstadosSuscripciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtiene un listado de los cargadores suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadoresPorUsuario: async (IdUsuario?: string, Email?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/GetCargadoresPorUsuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un centro de transformación OCA.
         * @param {CreateCentroTransformacionModel} [CreateCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        centroTransformacionCreate: async (CreateCentroTransformacionModel?: CreateCentroTransformacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/centros-transformacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateCentroTransformacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un centro de transformación OCA.
         * @param {EditCentroTransformacionModel} [EditCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        centroTransformacionEdit: async (EditCentroTransformacionModel?: EditCentroTransformacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/centros-transformacion/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditCentroTransformacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cierra una inspección visual persistiendo conclusiones, fecha de cierre y estado Cerrada.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cerrarInspeccionVisual: async (Id: string, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('cerrarInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/cerrar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Comprueba si un número de serie está disponible (no existe en commons.cargador)
         * @param {string} [NumeroSerie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNumeroSerieNuevoDisponible: async (NumeroSerie?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/CheckNumeroSerie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (NumeroSerie !== undefined) {
                localVarQueryParameter['numeroSerie'] = NumeroSerie;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Comprueba si existe un ticket abierto por id de cargador y tipo (1=Asistencia, 2=Incidencia).
         * @param {string} [IdCargador] 
         * @param {number} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTicketByIdCargador: async (IdCargador?: string, IdTipoTicket?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/check-ticket-by-id-cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }

            if (IdTipoTicket !== undefined) {
                localVarQueryParameter['idTipoTicket'] = IdTipoTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Comprueba si existe un ticket abierto por número de serie y tipo (1=Asistencia, 2=Incidencia).
         * @param {string} [SerialNumber] 
         * @param {number} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTicketBySerial: async (SerialNumber?: string, IdTipoTicket?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/check-ticket-by-serial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (SerialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = SerialNumber;
            }

            if (IdTipoTicket !== undefined) {
                localVarQueryParameter['idTipoTicket'] = IdTipoTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Completa horas y liquidaciones Circutor sin modificar pagos consolidados
         * @param {number} [Pagina] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completarDatosPagos: async (Pagina?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/CompletarDatosPagos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Pagina !== undefined) {
                localVarQueryParameter['pagina'] = Pagina;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Completa la corrección del informe técnico de una inspección cerrada y regenera sus informes.
         * @param {string} Id 
         * @param {CompletarInformeTecnicoIvModel} [CompletarInformeTecnicoIvModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completarInformeTecnicoInspeccionVisual: async (Id: string, CompletarInformeTecnicoIvModel?: CompletarInformeTecnicoIvModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('completarInformeTecnicoInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/informe-tecnico/completar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CompletarInformeTecnicoIvModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una observación interna de gestor GMAO en una OCA.
         * @param {CrearObservacionOcaModel} [CrearObservacionOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearObservacionOca: async (CrearObservacionOcaModel?: CrearObservacionOcaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/observaciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CrearObservacionOcaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nueva visita OCA de centro de transformación.
         * @param {CrearVisitaCentroTransformacionModel} [CrearVisitaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearVisitaCentroTransformacion: async (CrearVisitaCentroTransformacionModel?: CrearVisitaCentroTransformacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/visitas-centro-transformacion/nueva`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CrearVisitaCentroTransformacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nueva visita OCA de ubicación.
         * @param {CrearVisitaUbicacionModel} [CrearVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearVisitaUbicacion: async (CrearVisitaUbicacionModel?: CrearVisitaUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/visitas/nueva`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CrearVisitaUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea la work order de deficiencia de una visita OCA de ubicación.
         * @param {CrearWoDeficienciaVisitaModel} [CrearWoDeficienciaVisitaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearWoDeficienciaVisita: async (CrearWoDeficienciaVisitaModel?: CrearWoDeficienciaVisitaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/visitas/crear-wo-deficiencia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CrearWoDeficienciaVisitaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nueva campaña
         * @param {CreateCampanaModel} [CreateCampanaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampana: async (CreateCampanaModel?: CreateCampanaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Campana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateCampanaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Registra un cambio de responsable en el historial del ticket y actualiza el ticket.
         * @param {CreateCargadorEventoCambioResponsableModel} [CreateCargadorEventoCambioResponsableModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCargadorEventoCambioResponsable: async (CreateCargadorEventoCambioResponsableModel?: CreateCargadorEventoCambioResponsableModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/create-cargador-evento-cambio-responsable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateCargadorEventoCambioResponsableModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un periodo privado para un cargador
         * @param {CreateCargadorPeriodoPrivadoModel} [CreateCargadorPeriodoPrivadoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCargadorPeriodoPrivado: async (CreateCargadorPeriodoPrivadoModel?: CreateCargadorPeriodoPrivadoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/periodos-privado`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateCargadorPeriodoPrivadoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo grupo de actuaciones para la campaña
         * @param {string} Id 
         * @param {CreateGrupoActuacionesModel} [CreateGrupoActuacionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrupoActuaciones: async (Id: string, CreateGrupoActuacionesModel?: CreateGrupoActuacionesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('createGrupoActuaciones', 'Id', Id)
            const localVarPath = `/api/Commons/Campana/{id}/grupo-actuacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateGrupoActuacionesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un subestado para una ticket
         * @param {CreateHistoricoTicketModel} [CreateHistoricoTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubestadoHistorico: async (CreateHistoricoTicketModel?: CreateHistoricoTicketModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/create-subestado-historico`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateHistoricoTicketModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una ticket
         * @param {CreateTicketModel} [CreateTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket: async (CreateTicketModel?: CreateTicketModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/create-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateTicketModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nueva work order
         * @param {CreateWoModel} [CreateWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWo: async (CreateWoModel?: CreateWoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateWoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un fichero adjuntado de la actuacion.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdjuntoActuacion: async (Id: string, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteAdjuntoActuacion', 'Id', Id)
            const localVarPath = `/api/Commons/Actuacion/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un fichero adjunto del ticket.
         * @param {string} Id 
         * @param {boolean} [OmitirHistorico] 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdjuntoTicket: async (Id: string, OmitirHistorico?: boolean, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteAdjuntoTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (OmitirHistorico !== undefined) {
                localVarQueryParameter['omitirHistorico'] = OmitirHistorico;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un fichero adjuntado de la work order.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdjuntoWo: async (Id: string, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteAdjuntoWo', 'Id', Id)
            const localVarPath = `/api/Commons/Actuacion/wo/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una campaña existente
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampana: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteCampana', 'Id', Id)
            const localVarPath = `/api/Commons/Campana/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un evento para una ticket
         * @param {string} [IdEventoCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventoCargador: async (IdEventoCargador?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/delete-evento-cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEventoCargador !== undefined) {
                localVarQueryParameter['idEventoCargador'] = IdEventoCargador;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Deshace el compliance OK de una work order del mes en curso
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deshacerComplianceWo: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deshacerComplianceWo', 'Id', Id)
            const localVarPath = `/api/Commons/Wo/{id}/compliance/undo`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {string} [Cuid] 
         * @param {string} [TenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detalleCargador: async (Cuid?: string, TenantId?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/GetCargadorDetalle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Cuid !== undefined) {
                localVarQueryParameter['cuid'] = Cuid;
            }

            if (TenantId !== undefined) {
                localVarQueryParameter['tenantId'] = TenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un enlace temporal al documento indicado
         * @param {string} [Key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentosGenerateTempUrl: async (Key?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Documentos/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Key !== undefined) {
                localVarQueryParameter['key'] = Key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Descarga o previsualiza un documento de Documenta Gestor por URI absoluta.
         * @param {string} [Uri] 
         * @param {string} [Disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentoDg: async (Uri?: string, Disposition?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/documento-dg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Uri !== undefined) {
                localVarQueryParameter['uri'] = Uri;
            }

            if (Disposition !== undefined) {
                localVarQueryParameter['disposition'] = Disposition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Descarga los ficheros adjuntos del ticket en un ZIP.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFilesTicket: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('downloadFilesTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/download-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Descarga el conjunto de ficheros de una work order.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFilesWo: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('downloadFilesWo', 'Id', Id)
            const localVarPath = `/api/Commons/Wo/{id}/download-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza la actuación y finaliza las work orders incluidas, aplicando la autorización por importe cuando corresponda y conservando sus importes y fechas existentes
         * @param {EditActuacionYWorkOrdersModel} [EditActuacionYWorkOrdersModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editActuacionYWorkOrdersExterno: async (EditActuacionYWorkOrdersModel?: EditActuacionYWorkOrdersModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditActuacionYWorkOrdersModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una campaña existente
         * @param {EditCampanaModel} [EditCampanaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCampana: async (EditCampanaModel?: EditCampanaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Campana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditCampanaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un cargador
         * @param {EditCargadorModel} [EditCargadorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCargador: async (EditCargadorModel?: EditCargadorModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditCargadorModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un periodo privado de un cargador
         * @param {EditCargadorPeriodoPrivadoModel} [EditCargadorPeriodoPrivadoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCargadorPeriodoPrivado: async (EditCargadorPeriodoPrivadoModel?: EditCargadorPeriodoPrivadoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/periodos-privado/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditCargadorPeriodoPrivadoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita el informe de la wo
         * @param {EditDatosInformeModel} [EditDatosInformeModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDatosInforme: async (EditDatosInformeModel?: EditDatosInformeModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/EditarDatosInforme`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditDatosInformeModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza la resolución de deficiencias de una visita OCA declarada.
         * @param {EditDeficienciasVisitaUbicacionModel} [EditDeficienciasVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeficienciasVisitaUbicacion: async (EditDeficienciasVisitaUbicacionModel?: EditDeficienciasVisitaUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/visitas/editar-deficiencias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditDeficienciasVisitaUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita el informe técnico de una actuación
         * @param {EditInformeTecnicoModel} [EditInformeTecnicoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInformeTecnico: async (EditInformeTecnicoModel?: EditInformeTecnicoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/EditarInformeTecnico`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditInformeTecnicoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza datos editables de un ticket abierto (estado, subestado, cola, responsable, prioridad, pedido, conformidad, importe) y registra el histórico.
         * @param {boolean} [OmitirHistoricoEdicionDatos] 
         * @param {EditTicketModel} [EditTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTicket: async (OmitirHistoricoEdicionDatos?: boolean, EditTicketModel?: EditTicketModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/edit-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (OmitirHistoricoEdicionDatos !== undefined) {
                localVarQueryParameter['omitirHistoricoEdicionDatos'] = OmitirHistoricoEdicionDatos;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditTicketModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Registra el resultado de una visita OCA de centro de transformación.
         * @param {EditVisitaCentroTransformacionModel} [EditVisitaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editVisitaCentroTransformacion: async (EditVisitaCentroTransformacionModel?: EditVisitaCentroTransformacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/visitas-centro-transformacion/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditVisitaCentroTransformacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Registra el resultado de una visita OCA de ubicación.
         * @param {EditVisitaUbicacionModel} [EditVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editVisitaUbicacion: async (EditVisitaUbicacionModel?: EditVisitaUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/visitas/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditVisitaUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una observación interna de gestor GMAO. Solo el autor puede editarla.
         * @param {string} Id 
         * @param {EditarObservacionOcaModel} [EditarObservacionOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editarObservacionOca: async (Id: string, EditarObservacionOcaModel?: EditarObservacionOcaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editarObservacionOca', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/observaciones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditarObservacionOcaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarMspInteroperabilidad: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('eliminarMspInteroperabilidad', 'Id', Id)
            const localVarPath = `/api/Commons/Interoperabilidad/msps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarMspTarifaInteroperabilidad: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('eliminarMspTarifaInteroperabilidad', 'Id', Id)
            const localVarPath = `/api/Commons/Interoperabilidad/asignaciones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una observación interna de gestor GMAO. Solo el autor puede eliminarla.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarObservacionOca: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('eliminarObservacionOca', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/observaciones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarRecargaTarifaInteroperabilidad: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('eliminarRecargaTarifaInteroperabilidad', 'Id', Id)
            const localVarPath = `/api/Commons/Interoperabilidad/tarifas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarRecargaTarifaPrecioInteroperabilidad: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('eliminarRecargaTarifaPrecioInteroperabilidad', 'Id', Id)
            const localVarPath = `/api/Commons/Interoperabilidad/precios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Encola un job Quartz para ejecución a demanda
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encolarTareaProgramada: async (Id: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('encolarTareaProgramada', 'Id', Id)
            const localVarPath = `/api/Commons/AdminQuely/tareas-programadas/{id}/encolar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Envía un mensaje al chat de una OCA.
         * @param {EnviarMensajeOcaModel} [EnviarMensajeOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarMensajeOca: async (EnviarMensajeOcaModel?: EnviarMensajeOcaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/mensajes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EnviarMensajeOcaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo equipo medida
         * @param {CreateEquipoMedidaModel} [CreateEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaCreate: async (CreateEquipoMedidaModel?: CreateEquipoMedidaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EquipoMedida`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateEquipoMedidaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Borra un equipo de medida
         * @param {DeleteEquipoMedidaModel} [DeleteEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaDelete: async (DeleteEquipoMedidaModel?: DeleteEquipoMedidaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EquipoMedida`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeleteEquipoMedidaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un equipo de medida existente
         * @param {EditEquipoMedidaModel} [EditEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaEdit: async (EditEquipoMedidaModel?: EditEquipoMedidaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EquipoMedida/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditEquipoMedidaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de equipos de medida compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdPdsActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaGetRejilla: async (LoadOptions?: DXLoadOptions, IdPdsActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EquipoMedida/GetRejillaEquipoMedida`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdPdsActuacion !== undefined) {
                localVarQueryParameter['idPdsActuacion'] = IdPdsActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Validar que una actuacion no tenga wo\'s del mismo tipo con el mismo activo
         * @param {string} [IdActuacion] 
         * @param {string} [IdActivo] 
         * @param {TipoWoEnum} [TipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existeCargadorAndTipoEnActuacion: async (IdActuacion?: string, IdActivo?: string, TipoWo?: TipoWoEnum, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/ExisteCargadorEnWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['IdActuacion'] = IdActuacion;
            }

            if (IdActivo !== undefined) {
                localVarQueryParameter['IdActivo'] = IdActivo;
            }

            if (TipoWo !== undefined) {
                localVarQueryParameter['TipoWo'] = TipoWo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * GET de solo lectura. data=true si hay un cargador activo con ese numeroSerie; data=false si no existe y el SN puede usarse como numeroSerieNuevo en sustitución.
         * @summary Indica si un número de serie ya existe como cargador activo (solo consulta, sin efectos laterales)
         * @param {string} [NumeroSerie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existeNumeroSerieExterno: async (NumeroSerie?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/cargadores/existe-numero-serie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (NumeroSerie !== undefined) {
                localVarQueryParameter['numeroSerie'] = NumeroSerie;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet: async (FeatureName: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'FeatureName' is not null or undefined
            assertParamExists('featuresGet', 'FeatureName', FeatureName)
            const localVarPath = `/features/{featureName}`
                .replace(`{${"featureName"}}`, encodeURIComponent(String(FeatureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtienen las fechas de importacioón
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fechasImportacion: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant/GetFechasImportacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Firma una actuacion existente
         * @param {FirmarActuacionModel} [FirmarActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarActuacion: async (FirmarActuacionModel?: FirmarActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/FirmarActuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(FirmarActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary GetCalculoEconomicoActuacion
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInformeEconomicoActuacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('generateInformeEconomicoActuacion', 'Id', Id)
            const localVarPath = `/api/Commons/Actuacion/{id}/generate-informe-economico`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Genera el informe técnico de una work order
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInformeTecnicoWo: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('generateInformeTecnicoWo', 'Id', Id)
            const localVarPath = `/api/Commons/Actuacion/wo/{id}/generate-informe-tecnico`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de los activos para la creación de actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [Direccion] 
         * @param {string} [IdUbicacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivosActuacion: async (LoadOptions?: DXLoadOptions, Direccion?: string, IdUbicacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/ActivosActuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (Direccion !== undefined) {
                localVarQueryParameter['direccion'] = Direccion;
            }

            if (IdUbicacion !== undefined) {
                localVarQueryParameter['idUbicacion'] = IdUbicacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones abiertas
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActuacionesAbiertas: async (Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/abiertas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Page !== undefined) {
                localVarQueryParameter['page'] = Page;
            }

            if (PageSize !== undefined) {
                localVarQueryParameter['pageSize'] = PageSize;
            }

            if (FechaUltimaActualizacion !== undefined) {
                localVarQueryParameter['fechaUltimaActualizacion'] = (FechaUltimaActualizacion as any instanceof Date) ?
                    (FechaUltimaActualizacion as any).toISOString() :
                    FechaUltimaActualizacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones cerradas
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActuacionesCerradas: async (Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/cerradas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Page !== undefined) {
                localVarQueryParameter['page'] = Page;
            }

            if (PageSize !== undefined) {
                localVarQueryParameter['pageSize'] = PageSize;
            }

            if (FechaUltimaActualizacion !== undefined) {
                localVarQueryParameter['fechaUltimaActualizacion'] = (FechaUltimaActualizacion as any instanceof Date) ?
                    (FechaUltimaActualizacion as any).toISOString() :
                    FechaUltimaActualizacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones con incidencia
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActuacionesConIncidencia: async (Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/con-incidencia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Page !== undefined) {
                localVarQueryParameter['page'] = Page;
            }

            if (PageSize !== undefined) {
                localVarQueryParameter['pageSize'] = PageSize;
            }

            if (FechaUltimaActualizacion !== undefined) {
                localVarQueryParameter['fechaUltimaActualizacion'] = (FechaUltimaActualizacion as any instanceof Date) ?
                    (FechaUltimaActualizacion as any).toISOString() :
                    FechaUltimaActualizacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de business models para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBusinessModelsForCombo: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/business-models-combo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de partners para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPartnersForCombo: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/combo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de provincias para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProvincias: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/provincias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsignacionesInteroperabilidadForGrid: async (Options?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/asignaciones/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Options !== undefined) {
                for (const [key, value] of Object.entries(Options)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene campañas para selector, cuyo estado no es el de borrador
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampanas: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Campana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de campañas para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampanasForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Campana/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los canales de entrada del ticket (SAT)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanalesEntrada: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/canales-entrada`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el histórico de cambios de agrupación de estado de un cargador para DevExtreme
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadorHistoricoEstadoGrid: async (IdCargador?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/historico-estado/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los periodos privados de un cargador para DevExtreme
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadorPeriodosPrivadoGrid: async (IdCargador?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/periodos-privado/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresAll: async (Take?: number, Skip?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/All`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['skip'] = Skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores de los tenants seleccionados, utilizando paginación
         * @param {string} [TenantIds] 
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresByTenantId: async (TenantIds?: string, Take?: number, Skip?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/ByTenantId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TenantIds !== undefined) {
                localVarQueryParameter['tenantIds'] = TenantIds;
            }

            if (Take !== undefined) {
                localVarQueryParameter['take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['skip'] = Skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de cargadores involucraddos en una campaña para la grid de Devextreme, con filtros extras.
         * @param {string} Id 
         * @param {Array<string>} [IdsPds] 
         * @param {Array<string>} [IdsPartner] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresCampanaForGrid: async (Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCargadoresCampanaForGrid', 'Id', Id)
            const localVarPath = `/api/Commons/Campana/{id}/grid-cargadores`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdsPds) {
                localVarQueryParameter['IdsPds'] = IdsPds;
            }

            if (IdsPartner) {
                localVarQueryParameter['IdsPartner'] = IdsPartner;
            }

            if (IdsProvincia) {
                localVarQueryParameter['IdsProvincia'] = IdsProvincia;
            }

            if (IdsZona) {
                localVarQueryParameter['IdsZona'] = IdsZona;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los cargadores asociados a un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresCentroTransformacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCargadoresCentroTransformacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/centros-transformacion/{id}/cargadores`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los cargadores de la IV con su estado y aptitud actuales y sus WO asignadas.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresComplianceInspeccionVisual: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCargadoresComplianceInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/compliance/cargadores`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de cargadores dismissed para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresDismissedForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/dismissed/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores de Enel, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresEnel: async (Take?: number, Skip?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/Enel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['skip'] = Skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de cargadores para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de cargadores para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresForGridAdmin: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/grid-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de cargadores, con paginación opcional
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresMobility: async (Take?: number, Skip?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Mobility/cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['skip'] = Skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtiene un listado de los cargadores, ordneados por los suscritos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresOrderSuscrito: async (LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/GetCargadoresOrderSuscrito`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtienen los cargadores
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresRm: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/GetCargadoresRm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene cargadores sin ubicación asignada.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresSinUbicacionForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/sin-ubicacion/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los cargadores asociados a una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresUbicacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCargadoresUbicacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ubicaciones/{id}/cargadores`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de los casos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCasos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Casos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo de ítems de correctivas de Elecnor según la actuación
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsCorrectivasElecnor: async (IdActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/catalogo-elecnor-items-correctivas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo de materiales CIRCUTOR según actuación y tipo de WO
         * @param {string} [IdActuacion] 
         * @param {number} [IdTipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsMaterialesCircutor: async (IdActuacion?: string, IdTipoWo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/catalogo-circutor-items-materiales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }

            if (IdTipoWo !== undefined) {
                localVarQueryParameter['idTipoWo'] = IdTipoWo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo de materiales Elecnor (BT5) según actuación y tipo de WO
         * @param {string} [IdActuacion] 
         * @param {number} [IdTipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsMaterialesElecnor: async (IdActuacion?: string, IdTipoWo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/catalogo-elecnor-items-materiales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }

            if (IdTipoWo !== undefined) {
                localVarQueryParameter['idTipoWo'] = IdTipoWo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo de ítems de preventivas de Elecnor según la actuación
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsPreventivasElecnor: async (IdActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/catalogo-elecnor-items-preventivas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentroTransformacionById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCentroTransformacionById', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/centros-transformacion/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de coches eléctricos, con paginación opcional
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCochesElectricosMobility: async (Take?: number, Skip?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Mobility/coche-electrico`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['skip'] = Skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado DevExtreme de la cola de jobs lanzados a demanda
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColaTareaProgramadaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/AdminQuely/cola-tareas-programadas/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las colas de los usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColaUsuario: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/cola-usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la rejilla de ALTAS de activos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparacionActivosAltaForGrid: async (LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/grid-comparacion-activos-alta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (PeriodoSemanaIni !== undefined) {
                localVarQueryParameter['periodoSemanaIni'] = PeriodoSemanaIni;
            }

            if (PeriodoAnoIni !== undefined) {
                localVarQueryParameter['periodoAnoIni'] = PeriodoAnoIni;
            }

            if (PeriodoSemanaFin !== undefined) {
                localVarQueryParameter['periodoSemanaFin'] = PeriodoSemanaFin;
            }

            if (PeriodoAnoFin !== undefined) {
                localVarQueryParameter['periodoAnoFin'] = PeriodoAnoFin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la rejilla de BAJAS de activos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparacionActivosBajaForGrid: async (LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/grid-comparacion-activos-baja`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (PeriodoSemanaIni !== undefined) {
                localVarQueryParameter['periodoSemanaIni'] = PeriodoSemanaIni;
            }

            if (PeriodoAnoIni !== undefined) {
                localVarQueryParameter['periodoAnoIni'] = PeriodoAnoIni;
            }

            if (PeriodoSemanaFin !== undefined) {
                localVarQueryParameter['periodoSemanaFin'] = PeriodoSemanaFin;
            }

            if (PeriodoAnoFin !== undefined) {
                localVarQueryParameter['periodoAnoFin'] = PeriodoAnoFin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la configuración de los adjuntos de actuación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosActuacion: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/configuracion-adjuntos-actuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de centro de transformación OCA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosCentroTransformacion: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/configuracion-adjuntos-centro-transformacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de ticket (categorías fijas).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosTicket: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/configuracion-adjuntos-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de ubicación OCA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosUbicacion: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/configuracion-adjuntos-ubicacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de visita OCA.
         * @param {boolean} [EsCentroTransformacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosVisita: async (EsCentroTransformacion?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/configuracion-adjuntos-visita`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (EsCentroTransformacion !== undefined) {
                localVarQueryParameter['esCentroTransformacion'] = EsCentroTransformacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la configuración de los adjuntos de las work order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosWo: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/configuracion-adjuntos-wo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard de activos.
         * @param {Array<string>} [IdsPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [IdTipoInfraestructuraCargador] 
         * @param {boolean} [SoloConTicketsAbiertos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardActivos: async (IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DashboardActivos/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdsPartner) {
                localVarQueryParameter['IdsPartner'] = IdsPartner;
            }

            if (IdProvincia !== undefined) {
                localVarQueryParameter['IdProvincia'] = IdProvincia;
            }

            if (IdZona !== undefined) {
                localVarQueryParameter['IdZona'] = IdZona;
            }

            if (IdTipoInfraestructuraCargador !== undefined) {
                localVarQueryParameter['IdTipoInfraestructuraCargador'] = IdTipoInfraestructuraCargador;
            }

            if (SoloConTicketsAbiertos !== undefined) {
                localVarQueryParameter['SoloConTicketsAbiertos'] = SoloConTicketsAbiertos;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de activos para una columna del dashboard (OK, UNAVAILABLE, KO o DISMISSED).
         * @param {Array<string>} [IdsPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [IdTipoInfraestructuraCargador] 
         * @param {boolean} [SoloConTicketsAbiertos] 
         * @param {string} [EstadoAgrupacion] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardActivosForGrid: async (IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, EstadoAgrupacion?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DashboardActivos/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdsPartner) {
                localVarQueryParameter['IdsPartner'] = IdsPartner;
            }

            if (IdProvincia !== undefined) {
                localVarQueryParameter['IdProvincia'] = IdProvincia;
            }

            if (IdZona !== undefined) {
                localVarQueryParameter['IdZona'] = IdZona;
            }

            if (IdTipoInfraestructuraCargador !== undefined) {
                localVarQueryParameter['IdTipoInfraestructuraCargador'] = IdTipoInfraestructuraCargador;
            }

            if (SoloConTicketsAbiertos !== undefined) {
                localVarQueryParameter['SoloConTicketsAbiertos'] = SoloConTicketsAbiertos;
            }

            if (EstadoAgrupacion !== undefined) {
                localVarQueryParameter['estadoAgrupacion'] = EstadoAgrupacion;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos para el dashboard de la campaña dado su id, y filtros extras.
         * @param {string} Id 
         * @param {Array<string>} [IdsPds] 
         * @param {Array<string>} [IdsPartner] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCampana: async (Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDashboardCampana', 'Id', Id)
            const localVarPath = `/api/Commons/Campana/{id}/dashboard`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdsPds) {
                localVarQueryParameter['IdsPds'] = IdsPds;
            }

            if (IdsPartner) {
                localVarQueryParameter['IdsPartner'] = IdsPartner;
            }

            if (IdsProvincia) {
                localVarQueryParameter['IdsProvincia'] = IdsProvincia;
            }

            if (IdsZona) {
                localVarQueryParameter['IdsZona'] = IdsZona;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los KPIs GMAO del dashboard (asistencia, preventivos, OCAs, equipos, IV KIM y energía).
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardKpiGmao: async (FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DashboardKpiGmao/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaInicio !== undefined) {
                localVarQueryParameter['fechaInicio'] = (FechaInicio as any instanceof Date) ?
                    (FechaInicio as any).toISOString() :
                    FechaInicio;
            }

            if (FechaFin !== undefined) {
                localVarQueryParameter['fechaFin'] = (FechaFin as any instanceof Date) ?
                    (FechaFin as any).toISOString() :
                    FechaFin;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }

            if (IdPartner) {
                localVarQueryParameter['idPartner'] = IdPartner;
            }

            if (IdProvincia !== undefined) {
                localVarQueryParameter['idProvincia'] = IdProvincia;
            }

            if (IdZona !== undefined) {
                localVarQueryParameter['idZona'] = IdZona;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard de OCAs.
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [AnioDesde] 
         * @param {number} [AnioHasta] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardOcas: async (IdTipoOca?: TipoOcaEnum, IdProvincia?: number, IdZona?: number, AnioDesde?: number, AnioHasta?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DashboardOcas/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTipoOca !== undefined) {
                localVarQueryParameter['IdTipoOca'] = IdTipoOca;
            }

            if (IdProvincia !== undefined) {
                localVarQueryParameter['IdProvincia'] = IdProvincia;
            }

            if (IdZona !== undefined) {
                localVarQueryParameter['IdZona'] = IdZona;
            }

            if (AnioDesde !== undefined) {
                localVarQueryParameter['AnioDesde'] = AnioDesde;
            }

            if (AnioHasta !== undefined) {
                localVarQueryParameter['AnioHasta'] = AnioHasta;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo de deficiencias de calidad del compliance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeficienciasCompliance: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/deficiencias-compliance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo de deficiencias de visita OCA.
         * @param {string} [Ambito] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeficienciasVisitaMaestra: async (Ambito?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/deficiencias-visita`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Ambito !== undefined) {
                localVarQueryParameter['ambito'] = Ambito;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una actuacion por id
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleActuacion: async (IdActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Actuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una campaña por id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleCampana: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDetalleCampana', 'Id', Id)
            const localVarPath = `/api/Commons/Campana/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el partner dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetallePartnerById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDetallePartnerById', 'Id', Id)
            const localVarPath = `/api/Commons/Partner/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle del ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleTicket: async (IdTicket?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/detalle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTicket !== undefined) {
                localVarQueryParameter['idTicket'] = IdTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una wo por id
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleWo: async (IdWo?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Wo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdWo !== undefined) {
                localVarQueryParameter['idWo'] = IdWo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las WO cerradas y rechazadas de un técnico para el periodo del maestro de pagos
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {string} [IdTecnico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleWosTecnicoMaestroPagos: async (FechaPeriodo?: Date, IdPds?: string, IdTecnico?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/DetalleWosTecnicoMaestroPagos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaPeriodo !== undefined) {
                localVarQueryParameter['fechaPeriodo'] = (FechaPeriodo as any instanceof Date) ?
                    (FechaPeriodo as any).toISOString() :
                    FechaPeriodo;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }

            if (IdTecnico !== undefined) {
                localVarQueryParameter['idTecnico'] = IdTecnico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el cargador dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetallecargadorById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDetallecargadorById', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el poi dado su id de cargador
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetallecargadorPoiById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDetallecargadorPoiById', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/detail-poi/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los documentos de visita asociados a una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosAsociadosOca: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDocumentosAsociadosOca', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/{id}/documentos-asociados`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los documentos para la wo seleccionada
         * @param {string} [IdWorkOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosAsociadosWo: async (IdWorkOrder?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/documentos-asociados-wo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdWorkOrder !== undefined) {
                localVarQueryParameter['idWorkOrder'] = IdWorkOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los valores de un enum.
         * @param {string} [TipoEnum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnumGenerico: async (TipoEnum?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Tipo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoEnum !== undefined) {
                localVarQueryParameter['tipoEnum'] = TipoEnum;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los id de equipos de medida del prestador del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquiposMedida: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/equipos-medida`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el esquema unifilar de la ubicación del activo, si existe.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEsquemaUnifilarUbicacionActivo: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEsquemaUnifilarUbicacionActivo', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/{id}/esquema-unifilar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene estadísticas por técnico del prestador para el periodo (WO cerradas/rechazadas, % incidencia y media)
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadisticasTecnicosMaestroPagos: async (FechaPeriodo?: Date, IdPds?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/EstadisticasTecnicosMaestroPagos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaPeriodo !== undefined) {
                localVarQueryParameter['fechaPeriodo'] = (FechaPeriodo as any instanceof Date) ?
                    (FechaPeriodo as any).toISOString() :
                    FechaPeriodo;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado DevExtreme del catálogo de tareas programadas y su última ejecución
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadoTareaProgramadaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/AdminQuely/estado-tareas-programadas/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los estados de ticket
         * @param {boolean} [IncluirEstadoCerrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadosTicket: async (IncluirEstadoCerrado?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/estados-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IncluirEstadoCerrado !== undefined) {
                localVarQueryParameter['incluirEstadoCerrado'] = IncluirEstadoCerrado;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los eventos de un cargador ordenados por fecha descendente
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventosByCargador: async (IdCargador?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/eventos-cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFicherosAdjuntosCentroTransformacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getFicherosAdjuntosCentroTransformacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/centros-transformacion/{id}/ficheros-adjuntos`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFicherosAdjuntosUbicacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getFicherosAdjuntosUbicacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ubicaciones/{id}/ficheros-adjuntos`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de una visita OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFicherosAdjuntosVisita: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getFicherosAdjuntosVisita', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/visitas/{id}/ficheros-adjuntos`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de tickets para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGestionTicketsForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de gestores GMAO para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGestorGmaoSelectBox: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selectBoxGestores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el estado actual de WOs agrupado por tipo de WO
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraficaEstadoActualWos: async (FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/grafica-estado-actual-wos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaInicio !== undefined) {
                localVarQueryParameter['fechaInicio'] = (FechaInicio as any instanceof Date) ?
                    (FechaInicio as any).toISOString() :
                    FechaInicio;
            }

            if (FechaFin !== undefined) {
                localVarQueryParameter['fechaFin'] = (FechaFin as any instanceof Date) ?
                    (FechaFin as any).toISOString() :
                    FechaFin;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }

            if (IdPartner) {
                localVarQueryParameter['idPartner'] = IdPartner;
            }

            if (IdProvincia !== undefined) {
                localVarQueryParameter['idProvincia'] = IdProvincia;
            }

            if (IdZona !== undefined) {
                localVarQueryParameter['idZona'] = IdZona;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la media de retraso de WOs por tipo de WO y mes
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraficaRetrasosWos: async (FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/grafica-retrasos-wos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaInicio !== undefined) {
                localVarQueryParameter['fechaInicio'] = (FechaInicio as any instanceof Date) ?
                    (FechaInicio as any).toISOString() :
                    FechaInicio;
            }

            if (FechaFin !== undefined) {
                localVarQueryParameter['fechaFin'] = (FechaFin as any instanceof Date) ?
                    (FechaFin as any).toISOString() :
                    FechaFin;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }

            if (IdPartner) {
                localVarQueryParameter['idPartner'] = IdPartner;
            }

            if (IdProvincia !== undefined) {
                localVarQueryParameter['idProvincia'] = IdProvincia;
            }

            if (IdZona !== undefined) {
                localVarQueryParameter['idZona'] = IdZona;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridUsuariosGmao: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/RejillaGmao`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridUsuariosGmaoConCola: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/RejillaGmaoConCola`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado grupos de actuaciones en una campaña para la grid de Devextreme.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGruposActuacionesForGrid: async (Id: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getGruposActuacionesForGrid', 'Id', Id)
            const localVarPath = `/api/Commons/Campana/{id}/grid-grupos-actuaciones`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {string} [TipoEntidad] 
         * @param {string} [EntidadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricoInteroperabilidadForGrid: async (Options?: DXLoadOptions, TipoEntidad?: string, EntidadId?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/historico/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Options !== undefined) {
                for (const [key, value] of Object.entries(Options)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (TipoEntidad !== undefined) {
                localVarQueryParameter['tipoEntidad'] = TipoEntidad;
            }

            if (EntidadId !== undefined) {
                localVarQueryParameter['entidadId'] = EntidadId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el histórico de OCAs de la misma ubicación con visitas y ficheros adjuntos.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricoOcasUbicacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getHistoricoOcasUbicacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/historico-oca-ubicacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el historico de mensajes del ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricoTicket: async (IdTicket?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/historico-inccidencias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTicket !== undefined) {
                localVarQueryParameter['idTicket'] = IdTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un registro de importación de partners por su id de correlación (GUID).
         * @param {string} Correlacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportacionPartnersByCorrelacion: async (Correlacion: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Correlacion' is not null or undefined
            assertParamExists('getImportacionPartnersByCorrelacion', 'Correlacion', Correlacion)
            const localVarPath = `/api/Commons/Partner/importacion-partners/{correlacion}`
                .replace(`{${"correlacion"}}`, encodeURIComponent(String(Correlacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos del informe técnico (wizard) de una inspección visual.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformeTecnicoInspeccionVisual: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getInformeTecnicoInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/informe-tecnico`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los informes asociados a la actuacion
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformesAsociadosActuacion: async (IdActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/informes-asociados`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una inspección visual (cabecera, cargadores y respuestas).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspeccionVisualDetalle: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getInspeccionVisualDetalle', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/detalle`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los tipos de intervalo permitidos al crear o editar una inspección visual.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntervalosInspeccionVisual: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/intervalos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los items económicos compatibles con la potencia del cargador
         * @param {string} [IdCargador] 
         * @param {TipoWoEnum} [TipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemsEconomicosCompatibles: async (IdCargador?: string, TipoWo?: TipoWoEnum, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/items-economicos-compatibles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }

            if (TipoWo !== undefined) {
                localVarQueryParameter['tipoWo'] = TipoWo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios KIM para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKimSelectBox: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selectBoxKim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado anual de MaestroPagos con RazonSocial, ImporteReal, Mes y Anio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoAnualMaestroPagos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/ListadoAnualMaestroPagos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de centros de transformación OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoCentrosTransformacionForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/centros-transformacion/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado de inspecciones visuales para grid DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoInspeccionesVisualesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado de inspecciones visuales en las que está incluido el cargador, con Nº KOs del activo.
         * @param {string} IdCargador 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoInspeccionesVisualesPorCargadorForGrid: async (IdCargador: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdCargador' is not null or undefined
            assertParamExists('getListadoInspeccionesVisualesPorCargadorForGrid', 'IdCargador', IdCargador)
            const localVarPath = `/api/Commons/InspeccionVisual/grid-por-cargador/{idCargador}`
                .replace(`{${"idCargador"}}`, encodeURIComponent(String(IdCargador)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de MaestroPagosInspeccionesVisuales compatible con DevExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoMaestroPagosInspeccionesVisualesForGrid: async (FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/inspecciones-visuales/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaInicio !== undefined) {
                localVarQueryParameter['fechaInicio'] = (FechaInicio as any instanceof Date) ?
                    (FechaInicio as any).toISOString() :
                    FechaInicio;
            }

            if (FechaFin !== undefined) {
                localVarQueryParameter['fechaFin'] = (FechaFin as any instanceof Date) ?
                    (FechaFin as any).toISOString() :
                    FechaFin;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de OCAs para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoOcasForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado de OCAs para rejilla con filtros adicionales desde el seguimiento de ocas.
         * @param {OcaSeguimientoTipoEnum} [Tipo] 
         * @param {string} [Kpi] 
         * @param {string} [EstadoInicial] 
         * @param {string} [EstadoTransitado] 
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoOcasSeguimientoForGrid: async (Tipo?: OcaSeguimientoTipoEnum, Kpi?: string, EstadoInicial?: string, EstadoTransitado?: string, AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/seguimiento/ocas/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Tipo !== undefined) {
                localVarQueryParameter['Tipo'] = Tipo;
            }

            if (Kpi !== undefined) {
                localVarQueryParameter['Kpi'] = Kpi;
            }

            if (EstadoInicial !== undefined) {
                localVarQueryParameter['EstadoInicial'] = EstadoInicial;
            }

            if (EstadoTransitado !== undefined) {
                localVarQueryParameter['EstadoTransitado'] = EstadoTransitado;
            }

            if (AnioComparacion !== undefined) {
                localVarQueryParameter['AnioComparacion'] = AnioComparacion;
            }

            if (SemanaComparacion !== undefined) {
                localVarQueryParameter['SemanaComparacion'] = SemanaComparacion;
            }

            if (IdTipoOca !== undefined) {
                localVarQueryParameter['IdTipoOca'] = IdTipoOca;
            }

            if (IdsProvincia) {
                localVarQueryParameter['IdsProvincia'] = IdsProvincia;
            }

            if (IdsZona) {
                localVarQueryParameter['IdsZona'] = IdsZona;
            }

            if (AnioReferencia !== undefined) {
                localVarQueryParameter['AnioReferencia'] = AnioReferencia;
            }

            if (SemanaReferencia !== undefined) {
                localVarQueryParameter['SemanaReferencia'] = SemanaReferencia;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado de PDS tipo Inspecciones visuales para select.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoPdsInspeccionesVisualesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/pds/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de PDS con tipo prestador OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoPdsOcaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/pds-oca/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado unificado de actuaciones e inspecciones visuales del técnico
         * @param {string} [TrabajoTecnicoType] 
         * @param {number} [IdTrabajoTecnicoSortEnum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoTrabajoTecnico: async (TrabajoTecnicoType?: string, IdTrabajoTecnicoSortEnum?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/TrabajoTecnico`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TrabajoTecnicoType !== undefined) {
                localVarQueryParameter['trabajoTecnicoType'] = TrabajoTecnicoType;
            }

            if (IdTrabajoTecnicoSortEnum !== undefined) {
                localVarQueryParameter['idTrabajoTecnicoSortEnum'] = IdTrabajoTecnicoSortEnum;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de ubicaciones OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoUbicacionesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ubicaciones/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado de ubicaciones para select de inspecciones visuales.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoUbicacionesInspeccionesVisualesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/ubicaciones/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el medallero de pagos para un PDS en un periodo
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedalleroPorPds: async (FechaPeriodo?: Date, IdPds?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/MedalleroPorPds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaPeriodo !== undefined) {
                localVarQueryParameter['fechaPeriodo'] = (FechaPeriodo as any instanceof Date) ?
                    (FechaPeriodo as any).toISOString() :
                    FechaPeriodo;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS
         * @param {number} [Mes] 
         * @param {number} [Anyo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMedalleroMensualPds: async (Mes?: number, Anyo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/GetMediaMedalleroMensualPds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Mes !== undefined) {
                localVarQueryParameter['mes'] = Mes;
            }

            if (Anyo !== undefined) {
                localVarQueryParameter['anyo'] = Anyo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS por rango de fecha
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMedalleroMensualPdsPorRangoFecha: async (MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/GetMediaMedalleroMensualPdsPorRangoFecha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (MesInicio !== undefined) {
                localVarQueryParameter['mesInicio'] = MesInicio;
            }

            if (AnioInicio !== undefined) {
                localVarQueryParameter['anioInicio'] = AnioInicio;
            }

            if (MesFin !== undefined) {
                localVarQueryParameter['mesFin'] = MesFin;
            }

            if (AnioFin !== undefined) {
                localVarQueryParameter['anioFin'] = AnioFin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS por rango de fecha
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMedalleroMensualPdsPorRangoFechaPorPds: async (MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, IdPds?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/GetMediaMedalleroMensualPdsPorRangoFechaPorPds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (MesInicio !== undefined) {
                localVarQueryParameter['mesInicio'] = MesInicio;
            }

            if (AnioInicio !== undefined) {
                localVarQueryParameter['anioInicio'] = AnioInicio;
            }

            if (MesFin !== undefined) {
                localVarQueryParameter['mesFin'] = MesFin;
            }

            if (AnioFin !== undefined) {
                localVarQueryParameter['anioFin'] = AnioFin;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS anonimizados, mostrando el nombre real solo para el PDS solicitado
         * @param {number} [Mes] 
         * @param {number} [Anyo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMensualPdsAnonimizado: async (Mes?: number, Anyo?: number, IdPds?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/MediaMensualPdsAnonimizado`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Mes !== undefined) {
                localVarQueryParameter['mes'] = Mes;
            }

            if (Anyo !== undefined) {
                localVarQueryParameter['anyo'] = Anyo;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los mensajes del chat de una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMensajesOca: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getMensajesOca', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/{id}/mensajes`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el modelo de pago del prestador seleccionado o del propio usuario
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeloPagoPrestador: async (IdPds?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/ModeloPagoPrestador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las modificaciones de CPs por periodo
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModificacionesActivosPeriodoForGrid: async (LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/grid-modificaciones-activos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (PeriodoSemanaIni !== undefined) {
                localVarQueryParameter['periodoSemanaIni'] = PeriodoSemanaIni;
            }

            if (PeriodoAnoIni !== undefined) {
                localVarQueryParameter['periodoAnoIni'] = PeriodoAnoIni;
            }

            if (PeriodoSemanaFin !== undefined) {
                localVarQueryParameter['periodoSemanaFin'] = PeriodoSemanaFin;
            }

            if (PeriodoAnoFin !== undefined) {
                localVarQueryParameter['periodoAnoFin'] = PeriodoAnoFin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los ids de los motivos de cierre para la wo seleccionada
         * @param {string} [IdWorkOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotivosCierreFromWo: async (IdWorkOrder?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/motivos-cierre-from-wo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdWorkOrder !== undefined) {
                localVarQueryParameter['idWorkOrder'] = IdWorkOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los motivos de cierre de Wo para correctivo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotivosCierreWoCorrectivo: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/motivos-cierre-wo-correctivo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMspsInteroperabilidadForGrid: async (Options?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/msps/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Options !== undefined) {
                for (const [key, value] of Object.entries(Options)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMspsInteroperabilidadLista: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/msps/lista`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado de notificaciones del usuario actual (sin leer y leídas).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificaciones: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Notificacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las observaciones internas de gestores GMAO de una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservacionesOca: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getObservacionesOca', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/{id}/observaciones`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una OCA de centro de transformación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaDetailCentroTransformacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getOcaDetailCentroTransformacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/detail-oca-centro-transformacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una OCA de ubicación con sus ficheros.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaDetailUbicacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getOcaDetailUbicacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/detail-oca-ubicacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la composición semanal de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [NumSemanas] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoComposicionSemanal: async (NumSemanas?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/seguimiento/composicion-semanal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (NumSemanas !== undefined) {
                localVarQueryParameter['NumSemanas'] = NumSemanas;
            }

            if (IdTipoOca !== undefined) {
                localVarQueryParameter['IdTipoOca'] = IdTipoOca;
            }

            if (IdsProvincia) {
                localVarQueryParameter['IdsProvincia'] = IdsProvincia;
            }

            if (IdsZona) {
                localVarQueryParameter['IdsZona'] = IdsZona;
            }

            if (AnioReferencia !== undefined) {
                localVarQueryParameter['AnioReferencia'] = AnioReferencia;
            }

            if (SemanaReferencia !== undefined) {
                localVarQueryParameter['SemanaReferencia'] = SemanaReferencia;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el heatmap de visitas de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoHeatmapVisita: async (AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/seguimiento/heatmap-visita`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (AnioComparacion !== undefined) {
                localVarQueryParameter['AnioComparacion'] = AnioComparacion;
            }

            if (SemanaComparacion !== undefined) {
                localVarQueryParameter['SemanaComparacion'] = SemanaComparacion;
            }

            if (IdTipoOca !== undefined) {
                localVarQueryParameter['IdTipoOca'] = IdTipoOca;
            }

            if (IdsProvincia) {
                localVarQueryParameter['IdsProvincia'] = IdsProvincia;
            }

            if (IdsZona) {
                localVarQueryParameter['IdsZona'] = IdsZona;
            }

            if (AnioReferencia !== undefined) {
                localVarQueryParameter['AnioReferencia'] = AnioReferencia;
            }

            if (SemanaReferencia !== undefined) {
                localVarQueryParameter['SemanaReferencia'] = SemanaReferencia;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la información de los KPIs de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoKpis: async (AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/seguimiento/kpis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (AnioComparacion !== undefined) {
                localVarQueryParameter['AnioComparacion'] = AnioComparacion;
            }

            if (SemanaComparacion !== undefined) {
                localVarQueryParameter['SemanaComparacion'] = SemanaComparacion;
            }

            if (IdTipoOca !== undefined) {
                localVarQueryParameter['IdTipoOca'] = IdTipoOca;
            }

            if (IdsProvincia) {
                localVarQueryParameter['IdsProvincia'] = IdsProvincia;
            }

            if (IdsZona) {
                localVarQueryParameter['IdsZona'] = IdsZona;
            }

            if (AnioReferencia !== undefined) {
                localVarQueryParameter['AnioReferencia'] = AnioReferencia;
            }

            if (SemanaReferencia !== undefined) {
                localVarQueryParameter['SemanaReferencia'] = SemanaReferencia;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Catálogo de semanas para seguimiento de ocas, ordenadas por año y semana descendientes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoSemanas: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/seguimiento/semanas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las transiciones de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoTransiciones: async (AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/seguimiento/transiciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (AnioComparacion !== undefined) {
                localVarQueryParameter['AnioComparacion'] = AnioComparacion;
            }

            if (SemanaComparacion !== undefined) {
                localVarQueryParameter['SemanaComparacion'] = SemanaComparacion;
            }

            if (IdTipoOca !== undefined) {
                localVarQueryParameter['IdTipoOca'] = IdTipoOca;
            }

            if (IdsProvincia) {
                localVarQueryParameter['IdsProvincia'] = IdsProvincia;
            }

            if (IdsZona) {
                localVarQueryParameter['IdsZona'] = IdsZona;
            }

            if (AnioReferencia !== undefined) {
                localVarQueryParameter['AnioReferencia'] = AnioReferencia;
            }

            if (SemanaReferencia !== undefined) {
                localVarQueryParameter['SemanaReferencia'] = SemanaReferencia;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los origenes de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrigenesTicket: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/origenes-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rejilla de instalaciones B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cInstalaciones: async (Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/PagosB2c/instalaciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Anio !== undefined) {
                localVarQueryParameter['anio'] = Anio;
            }

            if (Mes !== undefined) {
                localVarQueryParameter['mes'] = Mes;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Lista los meses ya importados de pagos B2C.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cMeses: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/PagosB2c/meses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rejilla de Pdte C3 B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cPdteC3: async (Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/PagosB2c/pdte-c3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Anio !== undefined) {
                localVarQueryParameter['anio'] = Anio;
            }

            if (Mes !== undefined) {
                localVarQueryParameter['mes'] = Mes;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rejilla de reparaciones B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cReparaciones: async (Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/PagosB2c/reparaciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Anio !== undefined) {
                localVarQueryParameter['anio'] = Anio;
            }

            if (Mes !== undefined) {
                localVarQueryParameter['mes'] = Mes;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rejilla de visitas B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cVisitas: async (Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/PagosB2c/visitas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Anio !== undefined) {
                localVarQueryParameter['anio'] = Anio;
            }

            if (Mes !== undefined) {
                localVarQueryParameter['mes'] = Mes;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de devengado mensual por partner para la rejilla general.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDevengado/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el devengado agrupado por partner, año, sociedad y región.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoPorAnioForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDevengado/grid-por-anio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el devengado agrupado por sociedad y año.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoPorSociedadAnioForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDevengado/grid-por-sociedad-anio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el devengado agrupado por sociedad y mes.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoPorSociedadForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDevengado/grid-por-sociedad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de partners para el usuario
         * @param {string} [IdUsuarioBd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPorUsuarioBd: async (IdUsuarioBd?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/partner-usuario-bd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuarioBd !== undefined) {
                localVarQueryParameter['idUsuarioBd'] = IdUsuarioBd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de partners para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de partners para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersForGridAdmin: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/grid-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de partners para el usuario
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersPorUsuario: async (IdUsuario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/partners-usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el partner asociado al usuario BD
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersPorUsuarioBdForGrid: async (LoadOptions?: DXLoadOptions, IdUsuario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/grid-partners-usuario-bd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de partners asociado al usuario
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersPorUsuarioForGrid: async (LoadOptions?: DXLoadOptions, IdUsuario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/grid-partners-usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los pds asogiados a un código postal concreto, por tipo de prestador
         * @param {string} [CodigoPostal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdsByCodigoPostal: async (CodigoPostal?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Pds/by-codigo-postal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (CodigoPostal !== undefined) {
                localVarQueryParameter['codigoPostal'] = CodigoPostal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el pds dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdsById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getPdsById', 'Id', Id)
            const localVarPath = `/api/Commons/Pds/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de pds asociado al usuario
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdsPorUsuarioForGrid: async (LoadOptions?: DXLoadOptions, IdUsuario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Pds/grid-pds-usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las piezas de Wo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiezasWo: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/piezas-wo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Inspecciones de un técnico en una fecha, con su orden de visita.
         * @param {string} [IdTecnico] 
         * @param {string} [FechaProgramada] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanificacionTecnicoInspeccionVisual: async (IdTecnico?: string, FechaProgramada?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/planificacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTecnico !== undefined) {
                localVarQueryParameter['idTecnico'] = IdTecnico;
            }

            if (FechaProgramada !== undefined) {
                localVarQueryParameter['fechaProgramada'] = (FechaProgramada as any instanceof Date) ?
                    (FechaProgramada as any).toISOString().substring(0,10) :
                    FechaProgramada;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {string} IdTarifa 
         * @param {string} [TipoPotencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrecioReferenciaInteroperabilidad: async (IdTarifa: string, TipoPotencia?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdTarifa' is not null or undefined
            assertParamExists('getPrecioReferenciaInteroperabilidad', 'IdTarifa', IdTarifa)
            const localVarPath = `/api/Commons/Interoperabilidad/tarifas/{idTarifa}/precios/referencia`
                .replace(`{${"idTarifa"}}`, encodeURIComponent(String(IdTarifa)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoPotencia !== undefined) {
                localVarQueryParameter['tipoPotencia'] = TipoPotencia;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreciosInteroperabilidadForGrid: async (Options?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/precios/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Options !== undefined) {
                for (const [key, value] of Object.entries(Options)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las prioridades de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrioridadesTicket: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/prioridades-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Indica si se muestra la columna de estado en la rejilla de WO Revenue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPuedeVerEstadoWoRevenue: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/puede-ver-estado-wo-revenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el rango de fechas límite de OCAs accesibles para el usuario.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRangoFechaLimiteOcas: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/rango-fecha-limite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las recargas
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecargasGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Recargas/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las recargas
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecargasGridAdmin: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Recargas/grid-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el recuento de activos por periodo
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecuentoActivosPeriodoForGrid: async (LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/grid-recuento-activos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (PeriodoSemanaIni !== undefined) {
                localVarQueryParameter['periodoSemanaIni'] = PeriodoSemanaIni;
            }

            if (PeriodoAnoIni !== undefined) {
                localVarQueryParameter['periodoAnoIni'] = PeriodoAnoIni;
            }

            if (PeriodoSemanaFin !== undefined) {
                localVarQueryParameter['periodoSemanaFin'] = PeriodoSemanaFin;
            }

            if (PeriodoAnoFin !== undefined) {
                localVarQueryParameter['periodoAnoFin'] = PeriodoAnoFin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las semanas de recuento de activos disponibles para selector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecuentoActivosSemanasSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/recuento-activos-semanas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaMaestroPagosPorPrestador: async (FechaPeriodo?: Date, IdPds?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/RejillaMaestroPagosPrestadorWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaPeriodo !== undefined) {
                localVarQueryParameter['fechaPeriodo'] = (FechaPeriodo as any instanceof Date) ?
                    (FechaPeriodo as any).toISOString() :
                    FechaPeriodo;
            }

            if (IdPds !== undefined) {
                localVarQueryParameter['idPds'] = IdPds;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaPeriodo] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaMaestroPagosPorPrestadorPds: async (FechaPeriodo?: Date, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/RejillaMaestroPagosPrestadorWoPds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaPeriodo !== undefined) {
                localVarQueryParameter['fechaPeriodo'] = (FechaPeriodo as any instanceof Date) ?
                    (FechaPeriodo as any).toISOString() :
                    FechaPeriodo;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de las piezas de Wo compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaPiezasWo: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaPiezasWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaWoPorTicket: async (LoadOptions?: DXLoadOptions, IdTicket?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaWoPorTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdTicket !== undefined) {
                localVarQueryParameter['idTicket'] = IdTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsablesPrestadorSelectBox: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selectBoxResponsables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de responsables de provincias para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsablesProvinciasSelectBox: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selectBoxResponsablesProvincia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el resumen de horas por cola para un ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumenTiempoColas: async (IdTicket?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/resumen-tiempo-colas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTicket !== undefined) {
                localVarQueryParameter['idTicket'] = IdTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard revenue (variable/fijo).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueDashboardGraficas: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDashboard/graficas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de informes revenue para la rejilla general del dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDashboard/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por año, partner, región y sociedad para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardPorAnioForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDashboard/grid-por-anio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por sociedad y año para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardPorSociedadAnioForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDashboard/grid-por-sociedad-anio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por sociedad y periodo para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardPorSociedadForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/RevenueDashboard/grid-por-sociedad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Indica si el usuario revenue self puede ver Work Orders y sustituciones (al menos un partner privado).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueSelfPuedeVerWoSustituciones: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/revenue-self/puede-ver-wo-sustituciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el siguiente cargador del wizard de informe técnico.
         * @param {string} Id 
         * @param {string} [IdCargadorActual] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteCargadorInformeTecnicoIv: async (Id: string, IdCargadorActual?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getSiguienteCargadorInformeTecnicoIv', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/informe-tecnico/siguiente-cargador`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargadorActual !== undefined) {
                localVarQueryParameter['idCargadorActual'] = IdCargadorActual;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
         * @param {number} [IdNumerico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteComplianceWo: async (IdNumerico?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/GetSiguienteComplianceFromWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdNumerico !== undefined) {
                localVarQueryParameter['idNumerico'] = IdNumerico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo de la actuación seleccionada
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteWoFromActuacion: async (IdActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/GetSiguienteWoFromActuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteWoFromWo: async (IdWo?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/GetSiguienteWoFromWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdWo !== undefined) {
                localVarQueryParameter['idWo'] = IdWo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los subestados de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubestadosTicket: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/subestados-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de suscripciones para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuscripcionesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suscripcion/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTarifasInteroperabilidadForGrid: async (Options?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/tarifas/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Options !== undefined) {
                for (const [key, value] of Object.entries(Options)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTarifasInteroperabilidadLista: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/tarifas/lista`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTecnicosPrestadorSelectBox: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selectBoxTecnicos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de todos los tenants, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenants: async (Take?: number, Skip?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['skip'] = Skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtiene un listado de los tenants, ordneados por los suscritos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantsOrderSuscrito: async (LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant/GetTenantsOrderSuscrito`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtienen los tenant
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantsRm: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant/GetTenantsRm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Tickets y KO asociados del compliance de una inspección visual.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsComplianceInspeccionVisualForGrid: async (Id: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getTicketsComplianceInspeccionVisualForGrid', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/tickets-compliance/grid`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo activo de tipología/subtipología de incidencia (selector unificado)
         * @param {boolean} [ExcluirSoloCreacionEdicion] 
         * @param {boolean} [SoloAsistenciaSat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipologiasSubtipologiasIncidencia: async (ExcluirSoloCreacionEdicion?: boolean, SoloAsistenciaSat?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/tipologias-subtipologias-incidencia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (ExcluirSoloCreacionEdicion !== undefined) {
                localVarQueryParameter['excluirSoloCreacionEdicion'] = ExcluirSoloCreacionEdicion;
            }

            if (SoloAsistenciaSat !== undefined) {
                localVarQueryParameter['soloAsistenciaSat'] = SoloAsistenciaSat;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Catálogo de tipologías/subtipologías de incidencia para tipificar WOs
         * @param {boolean} [ExcluirSoloCreacionEdicion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipologiasSubtipologiasIncidenciaExterno: async (ExcluirSoloCreacionEdicion?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/tipologias-subtipologias-incidencia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (ExcluirSoloCreacionEdicion !== undefined) {
                localVarQueryParameter['excluirSoloCreacionEdicion'] = ExcluirSoloCreacionEdicion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el catálogo de tipos de infraestructura de cargador.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposInfraestructuraCargador: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/tipos-infraestructura-cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los tipos de ticket (asistencia / incidencia)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposTicket: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/tipos-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de tipos de indisponibilidad disponibles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposUnavailable: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cargador/tipos-unavailable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de los tipos de urgencia de actuación para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposUrgenciaActuacionSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/tipos-urgencia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de la transaccion dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaccionById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getTransaccionById', 'Id', Id)
            const localVarPath = `/api/Commons/Transacciones/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las transacciones
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaccionesGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Transacciones/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las transacciones
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaccionesGridAdmin: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Transacciones/grid-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUbicacionById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getUbicacionById', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ubicaciones/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de las ubicaciones de los activos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUbicacionesActivos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/UbicacionesActivos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de gestores GMAO para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioBdSelectBox: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selectBoxBd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosSelectBox: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selectBox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los id de usuarios técnicos del prestador del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosTecnicos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ActuacionExterna/tecnicos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos de la validacion de una actuacion
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionActuacion: async (IdActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/DatosValidacionActuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos de la validacion de una wo
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionWo: async (IdWo?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/DatosValidacionWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdWo !== undefined) {
                localVarQueryParameter['idWo'] = IdWo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de las visitas de una OCA de centro de transformación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitasOcaCentroTransformacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getVisitasOcaCentroTransformacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/detail-visita-oca-centro-transformacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de las visitas de una OCA de ubicación con sus ficheros.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitasOcaUbicacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getVisitasOcaUbicacion', 'Id', Id)
            const localVarPath = `/api/Commons/Oca/ocas/detail-visita-oca-ubicacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado agrupado por empresa con porcentaje e importe real
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolumenPorEmpresasPorRangoFechas: async (MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/GetVolumenPorEmpresasPorRangoFechas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (MesInicio !== undefined) {
                localVarQueryParameter['mesInicio'] = MesInicio;
            }

            if (AnioInicio !== undefined) {
                localVarQueryParameter['anioInicio'] = AnioInicio;
            }

            if (MesFin !== undefined) {
                localVarQueryParameter['mesFin'] = MesFin;
            }

            if (AnioFin !== undefined) {
                localVarQueryParameter['anioFin'] = AnioFin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de pds para el usuario
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getdPdsPorUsuario: async (IdUsuario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Pds/pds-usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {GuardarMspInteroperabilidadModel} [GuardarMspInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarMspInteroperabilidad: async (GuardarMspInteroperabilidadModel?: GuardarMspInteroperabilidadModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/msps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(GuardarMspInteroperabilidadModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {GuardarMspTarifaInteroperabilidadModel} [GuardarMspTarifaInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarMspTarifaInteroperabilidad: async (GuardarMspTarifaInteroperabilidadModel?: GuardarMspTarifaInteroperabilidadModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/asignaciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(GuardarMspTarifaInteroperabilidadModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Guarda el paso de un cargador del informe técnico (checks).
         * @param {string} Id 
         * @param {string} IdCargador 
         * @param {GuardarPasoInformeTecnicoIvModel} Datos 
         * @param {Array<File>} [Archivos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarPasoCargadorInformeTecnicoInspeccionVisual: async (Id: string, IdCargador: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('guardarPasoCargadorInformeTecnicoInspeccionVisual', 'Id', Id)
            // verify required parameter 'IdCargador' is not null or undefined
            assertParamExists('guardarPasoCargadorInformeTecnicoInspeccionVisual', 'IdCargador', IdCargador)
            // verify required parameter 'Datos' is not null or undefined
            assertParamExists('guardarPasoCargadorInformeTecnicoInspeccionVisual', 'Datos', Datos)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/informe-tecnico/paso/cargadores/{idCargador}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idCargador"}}`, encodeURIComponent(String(IdCargador)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Datos !== undefined) { 
                localVarFormParams.append('datos', new Blob([JSON.stringify(Datos)], { type: "application/json", }));
            }
                if (Archivos) {
                Archivos.forEach((element) => {
                    localVarFormParams.append('archivos', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Guarda el paso de ubicación del informe técnico (checks + incidencia).
         * @param {string} Id 
         * @param {GuardarPasoInformeTecnicoIvModel} Datos 
         * @param {Array<File>} [Archivos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarPasoUbicacionInformeTecnicoInspeccionVisual: async (Id: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('guardarPasoUbicacionInformeTecnicoInspeccionVisual', 'Id', Id)
            // verify required parameter 'Datos' is not null or undefined
            assertParamExists('guardarPasoUbicacionInformeTecnicoInspeccionVisual', 'Datos', Datos)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/informe-tecnico/paso/ubicacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Datos !== undefined) { 
                localVarFormParams.append('datos', new Blob([JSON.stringify(Datos)], { type: "application/json", }));
            }
                if (Archivos) {
                Archivos.forEach((element) => {
                    localVarFormParams.append('archivos', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {GuardarRecargaTarifaInteroperabilidadModel} [GuardarRecargaTarifaInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarRecargaTarifaInteroperabilidad: async (GuardarRecargaTarifaInteroperabilidadModel?: GuardarRecargaTarifaInteroperabilidadModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/tarifas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(GuardarRecargaTarifaInteroperabilidadModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {GuardarRecargaTarifaPrecioInteroperabilidadModel} [GuardarRecargaTarifaPrecioInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarRecargaTarifaPrecioInteroperabilidad: async (GuardarRecargaTarifaPrecioInteroperabilidadModel?: GuardarRecargaTarifaPrecioInteroperabilidadModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Interoperabilidad/precios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(GuardarRecargaTarifaPrecioInteroperabilidadModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero XLSX para importar los certificados de visita
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarCertificadosVisita: async (Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/importar-certificados-visita`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Importa los pares cliente-cargador de un XLSX inicial
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarClientesCargadores: async (Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/importar-clientes-cargadores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero XLSX para importar el recuento de activos
         * @param {string} [UrlFichero] 
         * @param {number} [NumSemana] 
         * @param {number} [NumMes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarRecuentoActivosFromXCustomer: async (UrlFichero?: string, NumSemana?: number, NumMes?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/importar-recuento-activos-from-xcustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (UrlFichero !== undefined) {
                localVarQueryParameter['urlFichero'] = UrlFichero;
            }

            if (NumSemana !== undefined) {
                localVarQueryParameter['numSemana'] = NumSemana;
            }

            if (NumMes !== undefined) {
                localVarQueryParameter['numMes'] = NumMes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero CSV para importar las WOs urgentes de xCustomer
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarWosUrgentesFromXCustomer: async (Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/XCustomer/importar-wos-urgentes-from-xcustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una inspección visual externa (prestador).
         * @param {CreateInspeccionVisualExternaModel} [CreateInspeccionVisualExternaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualCreateExterna: async (CreateInspeccionVisualExternaModel?: CreateInspeccionVisualExternaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/externa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateInspeccionVisualExternaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una inspección visual interna (Endesa).
         * @param {CreateInspeccionVisualInternaModel} [CreateInspeccionVisualInternaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualCreateInterna: async (CreateInspeccionVisualInternaModel?: CreateInspeccionVisualInternaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/interna`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateInspeccionVisualInternaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita cabecera de una inspección visual.
         * @param {EditInspeccionVisualModel} [EditInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualEdit: async (EditInspeccionVisualModel?: EditInspeccionVisualModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditInspeccionVisualModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la cabecera de una inspección visual para edición.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualGet: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('inspeccionVisualGet', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una OCA de tipo centro de transformación.
         * @param {CreateOcaCentroTransformacionModel} [CreateOcaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaCentroTransformacionCreate: async (CreateOcaCentroTransformacionModel?: CreateOcaCentroTransformacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/centro-transformacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateOcaCentroTransformacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una OCA de tipo centro de transformación.
         * @param {EditOcaCentroTransformacionModel} [EditOcaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaCentroTransformacionEdit: async (EditOcaCentroTransformacionModel?: EditOcaCentroTransformacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/centro-transformacion/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditOcaCentroTransformacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una OCA de tipo ubicación.
         * @param {CreateOcaUbicacionModel} [CreateOcaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaUbicacionCreate: async (CreateOcaUbicacionModel?: CreateOcaUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/ubicacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateOcaUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una OCA de tipo ubicación.
         * @param {EditOcaUbicacionModel} [EditOcaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaUbicacionEdit: async (EditOcaUbicacionModel?: EditOcaUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/ubicacion/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditOcaUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo partner
         * @param {CreatePartnerModel} [CreatePartnerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreate: async (CreatePartnerModel?: CreatePartnerModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreatePartnerModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un partner existente
         * @param {EditPartnerModel} [EditPartnerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEdit: async (EditPartnerModel?: EditPartnerModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditPartnerModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo PDS
         * @param {CreatePdsModel} [CreatePdsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdsCreate: async (CreatePdsModel?: CreatePdsModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Pds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreatePdsModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un PDS existente
         * @param {EditPdsModel} [EditPdsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdsEdit: async (EditPdsModel?: EditPdsModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Pds/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditPdsModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de Pds compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdsGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Pds/Rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un fichero a la actuación.
         * @param {string} Id 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoActuacion: async (Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('postAdjuntoActuacion', 'Id', Id)
            const localVarPath = `/api/Commons/Actuacion/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (TipoDocumento !== undefined) {
                localVarQueryParameter['tipoDocumento'] = TipoDocumento;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un fichero a la work order. Tipos: Cuadro eléctrico, Cargador, Número serie, Prueba termográfica, Informe técnico, Informe económico, Otros.
         * @param {string} IdWorkOrder 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoExternoWo: async (IdWorkOrder: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdWorkOrder' is not null or undefined
            assertParamExists('postAdjuntoExternoWo', 'IdWorkOrder', IdWorkOrder)
            const localVarPath = `/api/Commons/ActuacionExterna/wo/{idWorkOrder}/adjunto`
                .replace(`{${"idWorkOrder"}}`, encodeURIComponent(String(IdWorkOrder)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (TipoDocumento !== undefined) {
                localVarQueryParameter['tipoDocumento'] = TipoDocumento;
            }

            if (Descripcion !== undefined) {
                localVarQueryParameter['descripcion'] = Descripcion;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un fichero al ticket.
         * @param {string} Id 
         * @param {CategoriaAdjuntoTicketApiEnum} [CategoriaDocumento] 
         * @param {string} [Descripcion] 
         * @param {boolean} [OmitirHistorico] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoTicket: async (Id: string, CategoriaDocumento?: CategoriaAdjuntoTicketApiEnum, Descripcion?: string, OmitirHistorico?: boolean, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('postAdjuntoTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (CategoriaDocumento !== undefined) {
                localVarQueryParameter['categoriaDocumento'] = CategoriaDocumento;
            }

            if (Descripcion !== undefined) {
                localVarQueryParameter['descripcion'] = Descripcion;
            }

            if (OmitirHistorico !== undefined) {
                localVarQueryParameter['omitirHistorico'] = OmitirHistorico;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un fichero a la work order.
         * @param {string} Id 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoWo: async (Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('postAdjuntoWo', 'Id', Id)
            const localVarPath = `/api/Commons/Actuacion/wo/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (TipoDocumento !== undefined) {
                localVarQueryParameter['tipoDocumento'] = TipoDocumento;
            }

            if (Descripcion !== undefined) {
                localVarQueryParameter['descripcion'] = Descripcion;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCargarFicheroPartners: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/CargarFicheroPartners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero de forma temporal.
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoTemp: async (Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Documentos/adjuntar-documento-temp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero para crear usuarios
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoUsuarios: async (Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Documentos/adjuntar-fichero-usuarios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un evento de edición de datos del ticket con mensaje y observación combinados.
         * @param {string} Id 
         * @param {CreateHistoricoEdicionTicketModel} [CreateHistoricoEdicionTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHistoricoEdicionTicket: async (Id: string, CreateHistoricoEdicionTicketModel?: CreateHistoricoEdicionTicketModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('postHistoricoEdicionTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/historico-edicion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateHistoricoEdicionTicketModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un informe económico a la actuación
         * @param {string} IdActuacion 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInformeEconomicoActuacion: async (IdActuacion: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdActuacion' is not null or undefined
            assertParamExists('postInformeEconomicoActuacion', 'IdActuacion', IdActuacion)
            const localVarPath = `/api/Commons/ActuacionExterna/{idActuacion}/informe-economico-actuacion`
                .replace(`{${"idActuacion"}}`, encodeURIComponent(String(IdActuacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta el informe de la WO; el económico requiere importe y recalcula el coste sin cerrar la WO
         * @param {string} IdWorkOrder 
         * @param {TipoInformeWoExternoEnum} [TipoInforme] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {number} [ImporteWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInformeWorkOrder: async (IdWorkOrder: string, TipoInforme?: TipoInformeWoExternoEnum, Filename?: string, File?: File, ImporteWo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdWorkOrder' is not null or undefined
            assertParamExists('postInformeWorkOrder', 'IdWorkOrder', IdWorkOrder)
            const localVarPath = `/api/Commons/ActuacionExterna/{idWorkOrder}/informe-wo`
                .replace(`{${"idWorkOrder"}}`, encodeURIComponent(String(IdWorkOrder)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (TipoInforme !== undefined) {
                localVarQueryParameter['tipoInforme'] = TipoInforme;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
            if (ImporteWo !== undefined) { 
                localVarFormParams.append('importeWo', ImporteWo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Importa los 4 Excel de pagos B2C para un mes (reemplaza si ya existe).
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {File} [Instalaciones] 
         * @param {File} [Reparaciones] 
         * @param {File} [Visitas] 
         * @param {File} [PdteC3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPagosB2cImportar: async (Anio?: number, Mes?: number, Instalaciones?: File, Reparaciones?: File, Visitas?: File, PdteC3?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/PagosB2c/importar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Anio !== undefined) { 
                localVarFormParams.append('Anio', Anio as any);
            }
    
            if (Mes !== undefined) { 
                localVarFormParams.append('Mes', Mes as any);
            }
    
            if (Instalaciones !== undefined) { 
                localVarFormParams.append('Instalaciones', Instalaciones as any);
            }
    
            if (Reparaciones !== undefined) { 
                localVarFormParams.append('Reparaciones', Reparaciones as any);
            }
    
            if (Visitas !== undefined) { 
                localVarFormParams.append('Visitas', Visitas as any);
            }
    
            if (PdteC3 !== undefined) { 
                localVarFormParams.append('PdteC3', PdteC3 as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube 3 excels (Activos/Oportunidades/Contactos) y devuelve un preview parseado.
         * @param {string} [IdCorrelacion] 
         * @param {File} [Activos] 
         * @param {File} [Oportunidades] 
         * @param {File} [Contactos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPartnersCargarExcels: async (IdCorrelacion?: string, Activos?: File, Oportunidades?: File, Contactos?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Partner/cargar-excels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (IdCorrelacion !== undefined) { 
                localVarFormParams.append('IdCorrelacion', IdCorrelacion as any);
            }
    
            if (Activos !== undefined) { 
                localVarFormParams.append('Activos', Activos as any);
            }
    
            if (Oportunidades !== undefined) { 
                localVarFormParams.append('Oportunidades', Oportunidades as any);
            }
    
            if (Contactos !== undefined) { 
                localVarFormParams.append('Contactos', Contactos as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Prepara el informe técnico (cargadores y checklist) con datos actuales.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepararInformeTecnicoInspeccionVisual: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('prepararInformeTecnicoInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/informe-tecnico/preparar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary TEMP AL-513 — Preview cálculo coste actuación (sin persistir)
         * @param {string} IdActuacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewCalculoCosteActuacion: async (IdActuacion: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdActuacion' is not null or undefined
            assertParamExists('previewCalculoCosteActuacion', 'IdActuacion', IdActuacion)
            const localVarPath = `/api/Commons/Actuacion/{idActuacion}/preview-calculo-coste`
                .replace(`{${"idActuacion"}}`, encodeURIComponent(String(IdActuacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna fecha de programación y técnico de una o más inspecciones visuales.
         * @param {ProgramarFechaInspeccionVisualModel} [ProgramarFechaInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programarFechaInspeccionVisual: async (ProgramarFechaInspeccionVisualModel?: ProgramarFechaInspeccionVisualModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/InspeccionVisual/programar-fecha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ProgramarFechaInspeccionVisualModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Programa la fecha de la visita pendiente de una OCA.
         * @param {ProgramarFechaVisitaModel} [ProgramarFechaVisitaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programarFechaVisita: async (ProgramarFechaVisitaModel?: ProgramarFechaVisitaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ocas/programar-fecha-visita`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ProgramarFechaVisitaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita el importe de un informe de canon fija (solo Admin Revenue)
         * @param {string} Id 
         * @param {EditarImporteFijoTransaccionModel} [EditarImporteFijoTransaccionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEditarImporteFijoTransaccion: async (Id: string, EditarImporteFijoTransaccionModel?: EditarImporteFijoTransaccionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('putEditarImporteFijoTransaccion', 'Id', Id)
            const localVarPath = `/api/Commons/Partner/transacciones-fijo/{id}/importe`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditarImporteFijoTransaccionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza un evento cargador
         * @param {EditEventoCargadorModel} [EditEventoCargadorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEventoCargador: async (EditEventoCargadorModel?: EditEventoCargadorModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/put-evento-cargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditEventoCargadorModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Reabre un ticket cerrado con un nuevo estado, subestado y cola, registrando el evento en el histórico.
         * @param {ReabrirTicketModel} [ReabrirTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reabrirTicket: async (ReabrirTicketModel?: ReabrirTicketModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/reabrir-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ReabrirTicketModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca todas las notificaciones del usuario como leídas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllNotificaciones: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Notificacion/read-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca una notificación como leída.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotificacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('readNotificacion', 'Id', Id)
            const localVarPath = `/api/Commons/Notificacion/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Refresca el estado del cargador
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCargadorStatus: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('refreshCargadorStatus', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/{id}/refresh-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Resuelve el prestador sugerido al crear actuación (tramo provincia/potencia y código postal)
         * @param {ResolvePdsNuevaActuacionModel} [ResolvePdsNuevaActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePdsNuevaActuacion: async (ResolvePdsNuevaActuacionModel?: ResolvePdsNuevaActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/ResolvePdsNuevaActuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ResolvePdsNuevaActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Reanuda la periodicidad de una IV pausada y crea la siguiente con la fecha objetivo indicada.
         * @param {string} Id 
         * @param {ResumirPeriodicidadInspeccionVisualModel} [ResumirPeriodicidadInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumirPeriodicidadInspeccionVisual: async (Id: string, ResumirPeriodicidadInspeccionVisualModel?: ResumirPeriodicidadInspeccionVisualModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('resumirPeriodicidadInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/compliance/reanudar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ResumirPeriodicidadInspeccionVisualModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesGetAll: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece la aptitud de un cargador para inspecciones visuales
         * @param {string} Id 
         * @param {boolean} [AptoInspeccionVisual] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAptoInspeccionVisualCargador: async (Id: string, AptoInspeccionVisual?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setAptoInspeccionVisualCargador', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/{id}/set-apto-inspeccion-visual`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (AptoInspeccionVisual !== undefined) {
                localVarQueryParameter['aptoInspeccionVisual'] = AptoInspeccionVisual;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Guarda la calidad de una inspección visual sin resolver el compliance.
         * @param {string} Id 
         * @param {SetCalidadInspeccionVisualModel} [SetCalidadInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCalidadInspeccionVisual: async (Id: string, SetCalidadInspeccionVisualModel?: SetCalidadInspeccionVisualModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setCalidadInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/calidad`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SetCalidadInspeccionVisualModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca un cargador como disponible
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorAvailable: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setCargadorAvailable', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/{id}/set-available`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca un cargador como dismissed
         * @param {string} Id 
         * @param {SetCargadorDismissedModel} [SetCargadorDismissedModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorDismissed: async (Id: string, SetCargadorDismissedModel?: SetCargadorDismissedModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setCargadorDismissed', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/{id}/set-dismissed`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SetCargadorDismissedModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece el tipo de indisponibilidad de un cargador
         * @param {string} Id 
         * @param {number} [IdTipoUnavailable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorUnavailable: async (Id: string, IdTipoUnavailable?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setCargadorUnavailable', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/{id}/set-unavailable`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTipoUnavailable !== undefined) {
                localVarQueryParameter['idTipoUnavailable'] = IdTipoUnavailable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca o desmarca un cargador como visible en la app
         * @param {string} Id 
         * @param {boolean} [VisibleInApp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorVisibleInApp: async (Id: string, VisibleInApp?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setCargadorVisibleInApp', 'Id', Id)
            const localVarPath = `/api/Commons/Cargador/{id}/visible-in-app`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (VisibleInApp !== undefined) {
                localVarQueryParameter['visibleInApp'] = VisibleInApp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Resuelve el compliance de una inspección visual externa.
         * @param {string} Id 
         * @param {SetComplianceInspeccionVisualModel} [SetComplianceInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setComplianceInspeccionVisual: async (Id: string, SetComplianceInspeccionVisualModel?: SetComplianceInspeccionVisualModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setComplianceInspeccionVisual', 'Id', Id)
            const localVarPath = `/api/Commons/InspeccionVisual/{id}/compliance`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SetComplianceInspeccionVisualModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece los datos de compliance de una work order
         * @param {string} Id 
         * @param {SetComplianceWoModel} [SetComplianceWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setComplianceWo: async (Id: string, SetComplianceWoModel?: SetComplianceWoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setComplianceWo', 'Id', Id)
            const localVarPath = `/api/Commons/Wo/{id}/compliance`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SetComplianceWoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de subestados
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subestadosGetAll: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Subestados`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtiene un listado de los informes suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionInformesPorUsuario: async (IdUsuario?: string, Email?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suscripcion/GetSuscripcionInformesPorUsuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se cargan las suscripciones para el usuario seleccionado
         * @param {AddSuscripcionPorUsuarioModel} [AddSuscripcionPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionesCreate: async (AddSuscripcionPorUsuarioModel?: AddSuscripcionPorUsuarioModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suscripcion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AddSuscripcionPorUsuarioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se editan las suscripciones para el usuario seleccionado
         * @param {DeleteSuscripcionesPorUsuarioModel} [DeleteSuscripcionesPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionesDelete: async (DeleteSuscripcionesPorUsuarioModel?: DeleteSuscripcionesPorUsuarioModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suscripcion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeleteSuscripcionesPorUsuarioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se editan las suscripciones para el usuario seleccionado
         * @param {EditSuscripcionPorUsuarioModel} [EditSuscripcionPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionesPut: async (EditSuscripcionPorUsuarioModel?: EditSuscripcionPorUsuarioModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suscripcion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditSuscripcionPorUsuarioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se suscribe al tenant seleccionado
         * @param {string} [IdTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantSubscribe: async (IdTenant?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant/SubscribeTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTenant !== undefined) {
                localVarQueryParameter['idTenant'] = IdTenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se desuscribe al tenant seleccionado
         * @param {string} [IdTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUnsubscribe: async (IdTenant?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant/UnsubscribeTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTenant !== undefined) {
                localVarQueryParameter['idTenant'] = IdTenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de tenants con sus estados y suscripciones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsEstadosSuscripciones: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant/GetTenantsEstadosSuscripciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Se obtiene un listado de los tenants suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsPorUsuario: async (IdUsuario?: string, Email?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Tenant/GetTenantsPorUsuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una ubicación OCA.
         * @param {CreateUbicacionModel} [CreateUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ubicacionCreate: async (CreateUbicacionModel?: CreateUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ubicaciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una ubicación OCA.
         * @param {EditUbicacionModel} [EditUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ubicacionEdit: async (EditUbicacionModel?: EditUbicacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oca/ubicaciones/editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditUbicacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza el tipo de intervalo de una actuación
         * @param {UpdateIntervaloActuacionModel} [UpdateIntervaloActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntervaloActuacion: async (UpdateIntervaloActuacionModel?: UpdateIntervaloActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/intervalo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(UpdateIntervaloActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckEmail: async (Email: string, IdUsuario: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Email' is not null or undefined
            assertParamExists('usuarioCheckEmail', 'Email', Email)
            // verify required parameter 'IdUsuario' is not null or undefined
            assertParamExists('usuarioCheckEmail', 'IdUsuario', IdUsuario)
            const localVarPath = `/api/Commons/Usuario/{Email}/{IdUsuario}/EmailAvailable`
                .replace(`{${"Email"}}`, encodeURIComponent(String(Email)))
                .replace(`{${"IdUsuario"}}`, encodeURIComponent(String(IdUsuario)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckUsername: async (Username: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Username' is not null or undefined
            assertParamExists('usuarioCheckUsername', 'Username', Username)
            const localVarPath = `/api/Commons/Usuario/{Username}/Available`
                .replace(`{${"Username"}}`, encodeURIComponent(String(Username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un usuario existente
         * @param {DeleteUserModel} [DeleteUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioDelete: async (DeleteUserModel?: DeleteUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Eliminar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeleteUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetCurrentUserProfile: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/me/Profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las preferencias de notificación del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetPreferenciasNotificacion: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/me/PreferenciasNotificacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/RejillaRevenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserGmaoModel} [CreateUserGmaoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGmaoCreate: async (CreateUserGmaoModel?: CreateUserGmaoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/CreateUsuarioGmao`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateUserGmaoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserGmaoModel} [EditUserGmaoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGmaoEdit: async (EditUserGmaoModel?: EditUserGmaoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/EditarGmao`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditUserGmaoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Reactiva un usuario deshabilitado
         * @param {ReactivateUserModel} [ReactivateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioReactivate: async (ReactivateUserModel?: ReactivateUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Reactivar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ReactivateUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioRevenueCreate: async (CreateUserModel?: CreateUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/CreateUsuarioRevenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioRevenueEdit: async (EditUserModel?: EditUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/EditarRevenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza las preferencias de notificación del usuario actual
         * @param {PreferenciasNotificacionModel} [PreferenciasNotificacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioUpdatePreferenciasNotificacion: async (PreferenciasNotificacionModel?: PreferenciasNotificacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/me/PreferenciasNotificacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(PreferenciasNotificacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Validar una actuacion
         * @param {ValidarActuacionModel} [ValidarActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarActuacion: async (ValidarActuacionModel?: ValidarActuacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Validar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ValidarActuacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Validar una wo
         * @param {ValidarWoModel} [ValidarWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarWo: async (ValidarWoModel?: ValidarWoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/Validarwo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ValidarWoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una wo existente
         * @param {EditWoModel} [EditWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woEdit: async (EditWoModel?: EditWoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Actuacion/EditarWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditWoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Ruta del informe técnico de una WO asociada a un cargador (SAT/activos, sin otros documentos)
         * @param {string} IdWo 
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoFromCargador: async (IdWo: string, IdCargador?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdWo' is not null or undefined
            assertParamExists('woGetInformeTecnicoFromCargador', 'IdWo', IdWo)
            const localVarPath = `/api/Commons/Wo/{idWo}/informe-tecnico-desde-cargador`
                .replace(`{${"idWo"}}`, encodeURIComponent(String(IdWo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Ruta del informe técnico de una WO asociada a un ticket (SAT/ticketing, sin otros documentos)
         * @param {string} IdWo 
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoFromTicket: async (IdWo: string, IdTicket?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdWo' is not null or undefined
            assertParamExists('woGetInformeTecnicoFromTicket', 'IdWo', IdWo)
            const localVarPath = `/api/Commons/Wo/{idWo}/informe-tecnico-desde-ticket`
                .replace(`{${"idWo"}}`, encodeURIComponent(String(IdWo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTicket !== undefined) {
                localVarQueryParameter['idTicket'] = IdTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Ruta del informe técnico de una WO (Revenue Activos, sin otros documentos)
         * @param {string} IdWo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoRevenue: async (IdWo: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdWo' is not null or undefined
            assertParamExists('woGetInformeTecnicoRevenue', 'IdWo', IdWo)
            const localVarPath = `/api/Commons/Wo/{idWo}/informe-tecnico-revenue`
                .replace(`{${"idWo"}}`, encodeURIComponent(String(IdWo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Ruta del informe técnico de una WO con sustitución (solo Revenue, sin otros documentos)
         * @param {string} IdWo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoSustitucionRevenue: async (IdWo: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdWo' is not null or undefined
            assertParamExists('woGetInformeTecnicoSustitucionRevenue', 'IdWo', IdWo)
            const localVarPath = `/api/Commons/Wo/{idWo}/informe-tecnico-sustitucion-revenue`
                .replace(`{${"idWo"}}`, encodeURIComponent(String(IdWo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaMaestroPagosWo: async (FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MaestroPagos/RejillaMaestroPagosWo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaInicio !== undefined) {
                localVarQueryParameter['fechaInicio'] = (FechaInicio as any instanceof Date) ?
                    (FechaInicio as any).toISOString() :
                    FechaInicio;
            }

            if (FechaFin !== undefined) {
                localVarQueryParameter['fechaFin'] = (FechaFin as any instanceof Date) ?
                    (FechaFin as any).toISOString() :
                    FechaFin;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaPorActuacion: async (LoadOptions?: DXLoadOptions, IdActuacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaWoPorActuacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdActuacion !== undefined) {
                localVarQueryParameter['idActuacion'] = IdActuacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdCargador
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaPorIdCargador: async (IdCargador?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaWoIdCargador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCargador !== undefined) {
                localVarQueryParameter['idCargador'] = IdCargador;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdTicket
         * @param {string} [IdTicket] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaPorIdTicket: async (IdTicket?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaWoIdTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTicket !== undefined) {
                localVarQueryParameter['idTicket'] = IdTicket;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado DevExtreme de WO para Revenue (campos limitados)
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaWoRevenue: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaWoRevenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado DevExtreme de WO con sustitución de cargador (Activos)
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaWoSustitucion: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Wo/RejillaWoSustitucion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de zonas del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonasGetAll: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Pds/Zonas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiApi - functional programming interface
 * @export
 */
export const ApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crea un nuevo activo (cargador)
         * @param {CreateActivoModel} [CreateActivoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activoCreate(CreateActivoModel?: CreateActivoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activoCreate(CreateActivoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.activoCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nueva actuación
         * @param {CreateActuacionModel} [CreateActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actuacionCreate(CreateActuacionModel?: CreateActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actuacionCreate(CreateActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.actuacionCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una actuacion existente
         * @param {EditActuacionModel} [EditActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actuacionEdit(EditActuacionModel?: EditActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actuacionEdit(EditActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.actuacionEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de actuaciones compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actuacionesGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actuacionesGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.actuacionesGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sustituye el orden de visita de un técnico en una fecha.
         * @param {ActualizarPlanificacionTecnicoInspeccionVisualModel} [ActualizarPlanificacionTecnicoInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizarPlanificacionTecnicoInspeccionVisual(ActualizarPlanificacionTecnicoInspeccionVisualModel?: ActualizarPlanificacionTecnicoInspeccionVisualModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizarPlanificacionTecnicoInspeccionVisual(ActualizarPlanificacionTecnicoInspeccionVisualModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.actualizarPlanificacionTecnicoInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade cargadores sin ubicación a una ubicación existente.
         * @param {AddCargadoresUbicacionModel} [AddCargadoresUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCargadoresUbicacion(AddCargadoresUbicacionModel?: AddCargadoresUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCargadoresUbicacion(AddCargadoresUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addCargadoresUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade un mensaje a la transaccion.
         * @param {string} Id 
         * @param {CreateMensajeTransaccionModel} [CreateMensajeTransaccionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMensajeTransaccion(Id: string, CreateMensajeTransaccionModel?: CreateMensajeTransaccionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMensajeTransaccion(Id, CreateMensajeTransaccionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addMensajeTransaccion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Anula una OCA abierta.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anularOca(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anularOca(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.anularOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asignar una fecha a una o varias actuaciones
         * @param {AsignarFechaActuacionModel} [AsignarFechaActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asignarFechaActuacion(AsignarFechaActuacionModel?: AsignarFechaActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asignarFechaActuacion(AsignarFechaActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.asignarFechaActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna fecha de previsión y técnico a una actuación
         * @param {AsignarPrevisionActuacionExternoModel} [AsignarPrevisionActuacionExternoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asignarPrevisionActuacionExterno(AsignarPrevisionActuacionExternoModel?: AsignarPrevisionActuacionExternoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asignarPrevisionActuacionExterno(AsignarPrevisionActuacionExternoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.asignarPrevisionActuacionExterno']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asignar un técnico a una o varias actuaciones
         * @param {AsignarTecnicoActuacionModel} [AsignarTecnicoActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asignarTecnicoActuacion(AsignarTecnicoActuacionModel?: AsignarTecnicoActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asignarTecnicoActuacion(AsignarTecnicoActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.asignarTecnicoActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cambia el estado de la transacción
         * @param {string} Id 
         * @param {string} [NuevoEstado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cambiarEstadoTransaccion(Id: string, NuevoEstado?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cambiarEstadoTransaccion(Id, NuevoEstado, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cambiarEstadoTransaccion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancela una actuacion existente
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelarActuacion(Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelarActuacion(Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cancelarActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancela una petición pendiente de la cola de tareas programadas
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelarColaTareaProgramada(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelarColaTareaProgramada(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cancelarColaTareaProgramada']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancela una wo existente
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelarWo(Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelarWo(Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cancelarWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un cargador poi existente
         * @param {EditCargadorPoiModel} [EditCargadorPoiModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cargadorPoiEdit(EditCargadorPoiModel?: EditCargadorPoiModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cargadorPoiEdit(EditCargadorPoiModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cargadorPoiEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se suscribe al Cargador seleccionado
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cargadorSubscribe(IdCargador?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cargadorSubscribe(IdCargador, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cargadorSubscribe']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cargadorUnsubscribe(IdCargador?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cargadorUnsubscribe(IdCargador, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cargadorUnsubscribe']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de cargadores con sus estados y suscripciones
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cargadoresEstadosSuscripciones(IdCargador?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cargadoresEstadosSuscripciones(IdCargador, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cargadoresEstadosSuscripciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtiene un listado de los cargadores suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cargadoresPorUsuario(IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cargadoresPorUsuario(IdUsuario, Email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cargadoresPorUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un centro de transformación OCA.
         * @param {CreateCentroTransformacionModel} [CreateCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async centroTransformacionCreate(CreateCentroTransformacionModel?: CreateCentroTransformacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.centroTransformacionCreate(CreateCentroTransformacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.centroTransformacionCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un centro de transformación OCA.
         * @param {EditCentroTransformacionModel} [EditCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async centroTransformacionEdit(EditCentroTransformacionModel?: EditCentroTransformacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.centroTransformacionEdit(EditCentroTransformacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.centroTransformacionEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cierra una inspección visual persistiendo conclusiones, fecha de cierre y estado Cerrada.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cerrarInspeccionVisual(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cerrarInspeccionVisual(Id, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cerrarInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Comprueba si un número de serie está disponible (no existe en commons.cargador)
         * @param {string} [NumeroSerie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkNumeroSerieNuevoDisponible(NumeroSerie?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkNumeroSerieNuevoDisponible(NumeroSerie, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.checkNumeroSerieNuevoDisponible']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Comprueba si existe un ticket abierto por id de cargador y tipo (1=Asistencia, 2=Incidencia).
         * @param {string} [IdCargador] 
         * @param {number} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkTicketByIdCargador(IdCargador?: string, IdTipoTicket?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkTicketByIdCargador(IdCargador, IdTipoTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.checkTicketByIdCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Comprueba si existe un ticket abierto por número de serie y tipo (1=Asistencia, 2=Incidencia).
         * @param {string} [SerialNumber] 
         * @param {number} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkTicketBySerial(SerialNumber?: string, IdTipoTicket?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkTicketBySerial(SerialNumber, IdTipoTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.checkTicketBySerial']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Completa horas y liquidaciones Circutor sin modificar pagos consolidados
         * @param {number} [Pagina] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completarDatosPagos(Pagina?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultadoCompletarDatosPagosResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completarDatosPagos(Pagina, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.completarDatosPagos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Completa la corrección del informe técnico de una inspección cerrada y regenera sus informes.
         * @param {string} Id 
         * @param {CompletarInformeTecnicoIvModel} [CompletarInformeTecnicoIvModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completarInformeTecnicoInspeccionVisual(Id: string, CompletarInformeTecnicoIvModel?: CompletarInformeTecnicoIvModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completarInformeTecnicoInspeccionVisual(Id, CompletarInformeTecnicoIvModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.completarInformeTecnicoInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una observación interna de gestor GMAO en una OCA.
         * @param {CrearObservacionOcaModel} [CrearObservacionOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crearObservacionOca(CrearObservacionOcaModel?: CrearObservacionOcaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crearObservacionOca(CrearObservacionOcaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.crearObservacionOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nueva visita OCA de centro de transformación.
         * @param {CrearVisitaCentroTransformacionModel} [CrearVisitaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crearVisitaCentroTransformacion(CrearVisitaCentroTransformacionModel?: CrearVisitaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crearVisitaCentroTransformacion(CrearVisitaCentroTransformacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.crearVisitaCentroTransformacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nueva visita OCA de ubicación.
         * @param {CrearVisitaUbicacionModel} [CrearVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crearVisitaUbicacion(CrearVisitaUbicacionModel?: CrearVisitaUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crearVisitaUbicacion(CrearVisitaUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.crearVisitaUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea la work order de deficiencia de una visita OCA de ubicación.
         * @param {CrearWoDeficienciaVisitaModel} [CrearWoDeficienciaVisitaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crearWoDeficienciaVisita(CrearWoDeficienciaVisitaModel?: CrearWoDeficienciaVisitaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crearWoDeficienciaVisita(CrearWoDeficienciaVisitaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.crearWoDeficienciaVisita']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nueva campaña
         * @param {CreateCampanaModel} [CreateCampanaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCampana(CreateCampanaModel?: CreateCampanaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCampana(CreateCampanaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createCampana']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Registra un cambio de responsable en el historial del ticket y actualiza el ticket.
         * @param {CreateCargadorEventoCambioResponsableModel} [CreateCargadorEventoCambioResponsableModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCargadorEventoCambioResponsable(CreateCargadorEventoCambioResponsableModel?: CreateCargadorEventoCambioResponsableModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCargadorEventoCambioResponsable(CreateCargadorEventoCambioResponsableModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createCargadorEventoCambioResponsable']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un periodo privado para un cargador
         * @param {CreateCargadorPeriodoPrivadoModel} [CreateCargadorPeriodoPrivadoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCargadorPeriodoPrivado(CreateCargadorPeriodoPrivadoModel?: CreateCargadorPeriodoPrivadoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCargadorPeriodoPrivado(CreateCargadorPeriodoPrivadoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createCargadorPeriodoPrivado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo grupo de actuaciones para la campaña
         * @param {string} Id 
         * @param {CreateGrupoActuacionesModel} [CreateGrupoActuacionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGrupoActuaciones(Id: string, CreateGrupoActuacionesModel?: CreateGrupoActuacionesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGrupoActuaciones(Id, CreateGrupoActuacionesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createGrupoActuaciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un subestado para una ticket
         * @param {CreateHistoricoTicketModel} [CreateHistoricoTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubestadoHistorico(CreateHistoricoTicketModel?: CreateHistoricoTicketModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubestadoTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubestadoHistorico(CreateHistoricoTicketModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createSubestadoHistorico']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una ticket
         * @param {CreateTicketModel} [CreateTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicket(CreateTicketModel?: CreateTicketModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicket(CreateTicketModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nueva work order
         * @param {CreateWoModel} [CreateWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWo(CreateWoModel?: CreateWoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWo(CreateWoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un fichero adjuntado de la actuacion.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdjuntoActuacion(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdjuntoActuacion(Id, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteAdjuntoActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un fichero adjunto del ticket.
         * @param {string} Id 
         * @param {boolean} [OmitirHistorico] 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdjuntoTicket(Id: string, OmitirHistorico?: boolean, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdjuntoTicket(Id, OmitirHistorico, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteAdjuntoTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un fichero adjuntado de la work order.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdjuntoWo(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdjuntoWo(Id, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteAdjuntoWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una campaña existente
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCampana(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCampana(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteCampana']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un evento para una ticket
         * @param {string} [IdEventoCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventoCargador(IdEventoCargador?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubestadoTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventoCargador(IdEventoCargador, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteEventoCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deshace el compliance OK de una work order del mes en curso
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deshacerComplianceWo(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deshacerComplianceWo(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deshacerComplianceWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {string} [Cuid] 
         * @param {string} [TenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detalleCargador(Cuid?: string, TenantId?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detalleCargador(Cuid, TenantId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.detalleCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un enlace temporal al documento indicado
         * @param {string} [Key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentosGenerateTempUrl(Key?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentosGenerateTempUrl(Key, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.documentosGenerateTempUrl']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Descarga o previsualiza un documento de Documenta Gestor por URI absoluta.
         * @param {string} [Uri] 
         * @param {string} [Disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocumentoDg(Uri?: string, Disposition?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocumentoDg(Uri, Disposition, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.downloadDocumentoDg']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Descarga los ficheros adjuntos del ticket en un ZIP.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFilesTicket(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFilesTicket(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.downloadFilesTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Descarga el conjunto de ficheros de una work order.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFilesWo(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFilesWo(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.downloadFilesWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza la actuación y finaliza las work orders incluidas, aplicando la autorización por importe cuando corresponda y conservando sus importes y fechas existentes
         * @param {EditActuacionYWorkOrdersModel} [EditActuacionYWorkOrdersModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editActuacionYWorkOrdersExterno(EditActuacionYWorkOrdersModel?: EditActuacionYWorkOrdersModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editActuacionYWorkOrdersExterno(EditActuacionYWorkOrdersModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editActuacionYWorkOrdersExterno']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una campaña existente
         * @param {EditCampanaModel} [EditCampanaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCampana(EditCampanaModel?: EditCampanaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCampana(EditCampanaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editCampana']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un cargador
         * @param {EditCargadorModel} [EditCargadorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCargador(EditCargadorModel?: EditCargadorModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCargador(EditCargadorModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un periodo privado de un cargador
         * @param {EditCargadorPeriodoPrivadoModel} [EditCargadorPeriodoPrivadoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCargadorPeriodoPrivado(EditCargadorPeriodoPrivadoModel?: EditCargadorPeriodoPrivadoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCargadorPeriodoPrivado(EditCargadorPeriodoPrivadoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editCargadorPeriodoPrivado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita el informe de la wo
         * @param {EditDatosInformeModel} [EditDatosInformeModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDatosInforme(EditDatosInformeModel?: EditDatosInformeModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDatosInforme(EditDatosInformeModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editDatosInforme']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza la resolución de deficiencias de una visita OCA declarada.
         * @param {EditDeficienciasVisitaUbicacionModel} [EditDeficienciasVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDeficienciasVisitaUbicacion(EditDeficienciasVisitaUbicacionModel?: EditDeficienciasVisitaUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDeficienciasVisitaUbicacion(EditDeficienciasVisitaUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editDeficienciasVisitaUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita el informe técnico de una actuación
         * @param {EditInformeTecnicoModel} [EditInformeTecnicoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editInformeTecnico(EditInformeTecnicoModel?: EditInformeTecnicoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editInformeTecnico(EditInformeTecnicoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editInformeTecnico']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza datos editables de un ticket abierto (estado, subestado, cola, responsable, prioridad, pedido, conformidad, importe) y registra el histórico.
         * @param {boolean} [OmitirHistoricoEdicionDatos] 
         * @param {EditTicketModel} [EditTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTicket(OmitirHistoricoEdicionDatos?: boolean, EditTicketModel?: EditTicketModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editTicket(OmitirHistoricoEdicionDatos, EditTicketModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Registra el resultado de una visita OCA de centro de transformación.
         * @param {EditVisitaCentroTransformacionModel} [EditVisitaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editVisitaCentroTransformacion(EditVisitaCentroTransformacionModel?: EditVisitaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editVisitaCentroTransformacion(EditVisitaCentroTransformacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editVisitaCentroTransformacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Registra el resultado de una visita OCA de ubicación.
         * @param {EditVisitaUbicacionModel} [EditVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editVisitaUbicacion(EditVisitaUbicacionModel?: EditVisitaUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editVisitaUbicacion(EditVisitaUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editVisitaUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una observación interna de gestor GMAO. Solo el autor puede editarla.
         * @param {string} Id 
         * @param {EditarObservacionOcaModel} [EditarObservacionOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editarObservacionOca(Id: string, EditarObservacionOcaModel?: EditarObservacionOcaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editarObservacionOca(Id, EditarObservacionOcaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editarObservacionOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eliminarMspInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eliminarMspInteroperabilidad(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.eliminarMspInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eliminarMspTarifaInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eliminarMspTarifaInteroperabilidad(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.eliminarMspTarifaInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una observación interna de gestor GMAO. Solo el autor puede eliminarla.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eliminarObservacionOca(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eliminarObservacionOca(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.eliminarObservacionOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eliminarRecargaTarifaInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eliminarRecargaTarifaInteroperabilidad(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.eliminarRecargaTarifaInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eliminarRecargaTarifaPrecioInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eliminarRecargaTarifaPrecioInteroperabilidad(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.eliminarRecargaTarifaPrecioInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Encola un job Quartz para ejecución a demanda
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async encolarTareaProgramada(Id: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.encolarTareaProgramada(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.encolarTareaProgramada']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Envía un mensaje al chat de una OCA.
         * @param {EnviarMensajeOcaModel} [EnviarMensajeOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enviarMensajeOca(EnviarMensajeOcaModel?: EnviarMensajeOcaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enviarMensajeOca(EnviarMensajeOcaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.enviarMensajeOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo equipo medida
         * @param {CreateEquipoMedidaModel} [CreateEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async equipoMedidaCreate(CreateEquipoMedidaModel?: CreateEquipoMedidaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.equipoMedidaCreate(CreateEquipoMedidaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.equipoMedidaCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Borra un equipo de medida
         * @param {DeleteEquipoMedidaModel} [DeleteEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async equipoMedidaDelete(DeleteEquipoMedidaModel?: DeleteEquipoMedidaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.equipoMedidaDelete(DeleteEquipoMedidaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.equipoMedidaDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un equipo de medida existente
         * @param {EditEquipoMedidaModel} [EditEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async equipoMedidaEdit(EditEquipoMedidaModel?: EditEquipoMedidaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.equipoMedidaEdit(EditEquipoMedidaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.equipoMedidaEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de equipos de medida compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdPdsActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async equipoMedidaGetRejilla(LoadOptions?: DXLoadOptions, IdPdsActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.equipoMedidaGetRejilla(LoadOptions, IdPdsActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.equipoMedidaGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Validar que una actuacion no tenga wo\'s del mismo tipo con el mismo activo
         * @param {string} [IdActuacion] 
         * @param {string} [IdActivo] 
         * @param {TipoWoEnum} [TipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existeCargadorAndTipoEnActuacion(IdActuacion?: string, IdActivo?: string, TipoWo?: TipoWoEnum, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existeCargadorAndTipoEnActuacion(IdActuacion, IdActivo, TipoWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.existeCargadorAndTipoEnActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * GET de solo lectura. data=true si hay un cargador activo con ese numeroSerie; data=false si no existe y el SN puede usarse como numeroSerieNuevo en sustitución.
         * @summary Indica si un número de serie ya existe como cargador activo (solo consulta, sin efectos laterales)
         * @param {string} [NumeroSerie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existeNumeroSerieExterno(NumeroSerie?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existeNumeroSerieExterno(NumeroSerie, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.existeNumeroSerieExterno']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresGet(FeatureName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.featuresGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresList(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresList(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.featuresList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtienen las fechas de importacioón
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fechasImportacion(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fechasImportacion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.fechasImportacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Firma una actuacion existente
         * @param {FirmarActuacionModel} [FirmarActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmarActuacion(FirmarActuacionModel?: FirmarActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmarActuacion(FirmarActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.firmarActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary GetCalculoEconomicoActuacion
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateInformeEconomicoActuacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateInformeEconomicoActuacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.generateInformeEconomicoActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Genera el informe técnico de una work order
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateInformeTecnicoWo(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateInformeTecnicoWo(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.generateInformeTecnicoWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de los activos para la creación de actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [Direccion] 
         * @param {string} [IdUbicacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivosActuacion(LoadOptions?: DXLoadOptions, Direccion?: string, IdUbicacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivosActuacionRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivosActuacion(LoadOptions, Direccion, IdUbicacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getActivosActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones abiertas
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActuacionesAbiertas(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListadoActuacionesExternasResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActuacionesAbiertas(Page, PageSize, FechaUltimaActualizacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getActuacionesAbiertas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones cerradas
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActuacionesCerradas(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListadoActuacionesExternasResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActuacionesCerradas(Page, PageSize, FechaUltimaActualizacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getActuacionesCerradas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones con incidencia
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActuacionesConIncidencia(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListadoActuacionesExternasResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActuacionesConIncidencia(Page, PageSize, FechaUltimaActualizacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getActuacionesConIncidencia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de business models para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBusinessModelsForCombo(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessModelComboRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBusinessModelsForCombo(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAllBusinessModelsForCombo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de partners para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPartnersForCombo(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerComboRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPartnersForCombo(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAllPartnersForCombo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de provincias para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProvincias(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProvinciaComboRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProvincias(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAllProvincias']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsignacionesInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsignacionesInteroperabilidadForGrid(Options, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAsignacionesInteroperabilidadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene campañas para selector, cuyo estado no es el de borrador
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampanas(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampanas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCampanas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de campañas para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampanasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampanasForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCampanasForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los canales de entrada del ticket (SAT)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanalesEntrada(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanalEntradaRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanalesEntrada(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCanalesEntrada']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el histórico de cambios de agrupación de estado de un cargador para DevExtreme
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadorHistoricoEstadoGrid(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadorHistoricoEstadoGrid(IdCargador, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadorHistoricoEstadoGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los periodos privados de un cargador para DevExtreme
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadorPeriodosPrivadoGrid(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadorPeriodosPrivadoGrid(IdCargador, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadorPeriodosPrivadoGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresAll(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCargadoresModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresAll(Take, Skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores de los tenants seleccionados, utilizando paginación
         * @param {string} [TenantIds] 
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresByTenantId(TenantIds?: string, Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCargadoresModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresByTenantId(TenantIds, Take, Skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresByTenantId']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores involucraddos en una campaña para la grid de Devextreme, con filtros extras.
         * @param {string} Id 
         * @param {Array<string>} [IdsPds] 
         * @param {Array<string>} [IdsPartner] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresCampanaForGrid(Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresCampanaForGrid(Id, IdsPds, IdsPartner, IdsProvincia, IdsZona, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresCampanaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los cargadores asociados a un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadorAsociadoEntidadOcaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresCentroTransformacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresCentroTransformacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los cargadores de la IV con su estado y aptitud actuales y sus WO asignadas.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresComplianceInspeccionVisual(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadoresComplianceInspeccionVisualDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresComplianceInspeccionVisual(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresComplianceInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores dismissed para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresDismissedForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresDismissedForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresDismissedForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores de Enel, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresEnel(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCargadoresModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresEnel(Take, Skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresEnel']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresForGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresForGridAdmin(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresForGridAdmin']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de cargadores, con paginación opcional
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresMobility(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadoresMobilityModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresMobility(Take, Skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresMobility']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtiene un listado de los cargadores, ordneados por los suscritos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresOrderSuscrito(LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresOrderSuscrito(LoadOptions, IdUsuario, Email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresOrderSuscrito']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtienen los cargadores
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresRm(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresRm(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresRm']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene cargadores sin ubicación asignada.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresSinUbicacionForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresSinUbicacionForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresSinUbicacionForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los cargadores asociados a una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadoresUbicacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadorAsociadoEntidadOcaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadoresUbicacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCargadoresUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de los casos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCasos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CasosRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCasos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCasos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo de ítems de correctivas de Elecnor según la actuación
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogoItemsCorrectivasElecnor(IdActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemCorrectivoElecnorDtoListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogoItemsCorrectivasElecnor(IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCatalogoItemsCorrectivasElecnor']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo de materiales CIRCUTOR según actuación y tipo de WO
         * @param {string} [IdActuacion] 
         * @param {number} [IdTipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogoItemsMaterialesCircutor(IdActuacion?: string, IdTipoWo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemMaterialCircutorDtoListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogoItemsMaterialesCircutor(IdActuacion, IdTipoWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCatalogoItemsMaterialesCircutor']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo de materiales Elecnor (BT5) según actuación y tipo de WO
         * @param {string} [IdActuacion] 
         * @param {number} [IdTipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogoItemsMaterialesElecnor(IdActuacion?: string, IdTipoWo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemMaterialElecnorDtoListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogoItemsMaterialesElecnor(IdActuacion, IdTipoWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCatalogoItemsMaterialesElecnor']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo de ítems de preventivas de Elecnor según la actuación
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogoItemsPreventivasElecnor(IdActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemPreventivoElecnorDtoListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogoItemsPreventivasElecnor(IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCatalogoItemsPreventivasElecnor']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCentroTransformacionById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CentroTransformacionRmResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCentroTransformacionById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCentroTransformacionById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de coches eléctricos, con paginación opcional
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCochesElectricosMobility(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadoresMobilityModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCochesElectricosMobility(Take, Skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCochesElectricosMobility']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado DevExtreme de la cola de jobs lanzados a demanda
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getColaTareaProgramadaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getColaTareaProgramadaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getColaTareaProgramadaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las colas de los usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getColaUsuario(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ColaUsuarioRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getColaUsuario(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getColaUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la rejilla de ALTAS de activos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComparacionActivosAltaForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComparacionActivosAltaForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComparacionActivosAltaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la rejilla de BAJAS de activos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComparacionActivosBajaForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComparacionActivosBajaForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComparacionActivosBajaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la configuración de los adjuntos de actuación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguracionAdjuntosActuacion(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfiguracionAdjuntosActuacionModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguracionAdjuntosActuacion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getConfiguracionAdjuntosActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de centro de transformación OCA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguracionAdjuntosCentroTransformacion(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguracionAdjuntosCentroTransformacion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getConfiguracionAdjuntosCentroTransformacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de ticket (categorías fijas).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguracionAdjuntosTicket(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfiguracionAdjuntosTicketModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguracionAdjuntosTicket(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getConfiguracionAdjuntosTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de ubicación OCA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguracionAdjuntosUbicacion(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfiguracionAdjuntosUbicacionModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguracionAdjuntosUbicacion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getConfiguracionAdjuntosUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de visita OCA.
         * @param {boolean} [EsCentroTransformacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguracionAdjuntosVisita(EsCentroTransformacion?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfiguracionAdjuntosVisitaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguracionAdjuntosVisita(EsCentroTransformacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getConfiguracionAdjuntosVisita']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la configuración de los adjuntos de las work order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguracionAdjuntosWo(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfiguracionAdjuntosWoModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguracionAdjuntosWo(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getConfiguracionAdjuntosWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard de activos.
         * @param {Array<string>} [IdsPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [IdTipoInfraestructuraCargador] 
         * @param {boolean} [SoloConTicketsAbiertos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardActivos(IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardActivosModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardActivos(IdsPartner, IdProvincia, IdZona, IdTipoInfraestructuraCargador, SoloConTicketsAbiertos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDashboardActivos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de activos para una columna del dashboard (OK, UNAVAILABLE, KO o DISMISSED).
         * @param {Array<string>} [IdsPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [IdTipoInfraestructuraCargador] 
         * @param {boolean} [SoloConTicketsAbiertos] 
         * @param {string} [EstadoAgrupacion] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardActivosForGrid(IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, EstadoAgrupacion?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardActivosForGrid(IdsPartner, IdProvincia, IdZona, IdTipoInfraestructuraCargador, SoloConTicketsAbiertos, EstadoAgrupacion, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDashboardActivosForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos para el dashboard de la campaña dado su id, y filtros extras.
         * @param {string} Id 
         * @param {Array<string>} [IdsPds] 
         * @param {Array<string>} [IdsPartner] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardCampana(Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardCampanaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardCampana(Id, IdsPds, IdsPartner, IdsProvincia, IdsZona, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDashboardCampana']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los KPIs GMAO del dashboard (asistencia, preventivos, OCAs, equipos, IV KIM y energía).
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardKpiGmao(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardKpiGmaoModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardKpiGmao(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDashboardKpiGmao']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard de OCAs.
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [AnioDesde] 
         * @param {number} [AnioHasta] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardOcas(IdTipoOca?: TipoOcaEnum, IdProvincia?: number, IdZona?: number, AnioDesde?: number, AnioHasta?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardOcasModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardOcas(IdTipoOca, IdProvincia, IdZona, AnioDesde, AnioHasta, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDashboardOcas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo de deficiencias de calidad del compliance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeficienciasCompliance(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeficienciaComplianceRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeficienciasCompliance(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDeficienciasCompliance']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo de deficiencias de visita OCA.
         * @param {string} [Ambito] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeficienciasVisitaMaestra(Ambito?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeficienciaVisitaMaestraModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeficienciasVisitaMaestra(Ambito, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDeficienciasVisitaMaestra']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una actuacion por id
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailActuacionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleActuacion(IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetalleActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una campaña por id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleCampana(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCampanaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleCampana(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetalleCampana']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el partner dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetallePartnerById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailPartnerModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetallePartnerById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetallePartnerById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle del ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleTicket(IdTicket?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleTicketRmResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleTicket(IdTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetalleTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una wo por id
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleWo(IdWo?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailWoModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleWo(IdWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetalleWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las WO cerradas y rechazadas de un técnico para el periodo del maestro de pagos
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {string} [IdTecnico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleWosTecnicoMaestroPagos(FechaPeriodo?: Date, IdPds?: string, IdTecnico?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleWosTecnicoMaestroPagosModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleWosTecnicoMaestroPagos(FechaPeriodo, IdPds, IdTecnico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetalleWosTecnicoMaestroPagos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el cargador dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetallecargadorById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCargadorModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetallecargadorById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetallecargadorById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el poi dado su id de cargador
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetallecargadorPoiById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCargadorPoiModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetallecargadorPoiById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetallecargadorPoiById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los documentos de visita asociados a una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentosAsociadosOca(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentosAsociadosOcaResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentosAsociadosOca(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDocumentosAsociadosOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los documentos para la wo seleccionada
         * @param {string} [IdWorkOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentosAsociadosWo(IdWorkOrder?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentosAsociadosWoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentosAsociadosWo(IdWorkOrder, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDocumentosAsociadosWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los valores de un enum.
         * @param {string} [TipoEnum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnumGenerico(TipoEnum?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdNameItemListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnumGenerico(TipoEnum, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEnumGenerico']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los id de equipos de medida del prestador del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEquiposMedida(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEquiposMedidaPorPdsUsuarioResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEquiposMedida(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEquiposMedida']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el esquema unifilar de la ubicación del activo, si existe.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEsquemaUnifilarUbicacionActivo(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EsquemaUnifilarUbicacionActivoModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEsquemaUnifilarUbicacionActivo(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEsquemaUnifilarUbicacionActivo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene estadísticas por técnico del prestador para el periodo (WO cerradas/rechazadas, % incidencia y media)
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstadisticasTecnicosMaestroPagos(FechaPeriodo?: Date, IdPds?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstadisticasTecnicoMaestroPagosModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstadisticasTecnicosMaestroPagos(FechaPeriodo, IdPds, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEstadisticasTecnicosMaestroPagos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado DevExtreme del catálogo de tareas programadas y su última ejecución
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstadoTareaProgramadaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstadoTareaProgramadaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEstadoTareaProgramadaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los estados de ticket
         * @param {boolean} [IncluirEstadoCerrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstadosTicket(IncluirEstadoCerrado?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstadoTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstadosTicket(IncluirEstadoCerrado, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEstadosTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los eventos de un cargador ordenados por fecha descendente
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventosByCargador(IdCargador?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadorEventoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventosByCargador(IdCargador, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEventosByCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFicherosAdjuntosCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdjuntoCentroTransformacionModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFicherosAdjuntosCentroTransformacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFicherosAdjuntosCentroTransformacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFicherosAdjuntosUbicacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdjuntoUbicacionModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFicherosAdjuntosUbicacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFicherosAdjuntosUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de una visita OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFicherosAdjuntosVisita(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdjuntoVisitaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFicherosAdjuntosVisita(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFicherosAdjuntosVisita']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de tickets para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGestionTicketsForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGestionTicketsForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGestionTicketsForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de gestores GMAO para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGestorGmaoSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGestorGmaoSelectBox(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGestorGmaoSelectBox']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el estado actual de WOs agrupado por tipo de WO
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraficaEstadoActualWos(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraficaEstadoActualWoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraficaEstadoActualWos(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGraficaEstadoActualWos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la media de retraso de WOs por tipo de WO y mes
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraficaRetrasosWos(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraficaRetrasosWosMediaRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraficaRetrasosWos(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGraficaRetrasosWos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridUsuariosGmao(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridUsuariosGmao(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGridUsuariosGmao']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridUsuariosGmaoConCola(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridUsuariosGmaoConCola(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGridUsuariosGmaoConCola']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado grupos de actuaciones en una campaña para la grid de Devextreme.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGruposActuacionesForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGruposActuacionesForGrid(Id, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGruposActuacionesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {string} [TipoEntidad] 
         * @param {string} [EntidadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoricoInteroperabilidadForGrid(Options?: DXLoadOptions, TipoEntidad?: string, EntidadId?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoricoInteroperabilidadForGrid(Options, TipoEntidad, EntidadId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getHistoricoInteroperabilidadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el histórico de OCAs de la misma ubicación con visitas y ficheros adjuntos.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoricoOcasUbicacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricoOcasUbicacionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoricoOcasUbicacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getHistoricoOcasUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el historico de mensajes del ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoricoTicket(IdTicket?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadorEventoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoricoTicket(IdTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getHistoricoTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un registro de importación de partners por su id de correlación (GUID).
         * @param {string} Correlacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportacionPartnersByCorrelacion(Correlacion: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportacionPartnersModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportacionPartnersByCorrelacion(Correlacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getImportacionPartnersByCorrelacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos del informe técnico (wizard) de una inspección visual.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInformeTecnicoInspeccionVisual(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InspeccionVisualDetalleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInformeTecnicoInspeccionVisual(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getInformeTecnicoInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los informes asociados a la actuacion
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInformesAsociadosActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformesActuacionRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInformesAsociadosActuacion(IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getInformesAsociadosActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una inspección visual (cabecera, cargadores y respuestas).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInspeccionVisualDetalle(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InspeccionVisualDetalleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInspeccionVisualDetalle(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getInspeccionVisualDetalle']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los tipos de intervalo permitidos al crear o editar una inspección visual.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntervalosInspeccionVisual(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdNameItemListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntervalosInspeccionVisual(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getIntervalosInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los items económicos compatibles con la potencia del cargador
         * @param {string} [IdCargador] 
         * @param {TipoWoEnum} [TipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemsEconomicosCompatibles(IdCargador?: string, TipoWo?: TipoWoEnum, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemsEconomicosCompatibles(IdCargador, TipoWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getItemsEconomicosCompatibles']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios KIM para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKimSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKimSelectBox(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getKimSelectBox']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado anual de MaestroPagos con RazonSocial, ImporteReal, Mes y Anio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoAnualMaestroPagos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaestroPagosPorPdsMesRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoAnualMaestroPagos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoAnualMaestroPagos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de centros de transformación OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoCentrosTransformacionForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoCentrosTransformacionForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoCentrosTransformacionForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado de inspecciones visuales para grid DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoInspeccionesVisualesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoInspeccionesVisualesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado de inspecciones visuales en las que está incluido el cargador, con Nº KOs del activo.
         * @param {string} IdCargador 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoInspeccionesVisualesPorCargadorForGrid(IdCargador: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoInspeccionesVisualesPorCargadorForGrid(IdCargador, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoInspeccionesVisualesPorCargadorForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de MaestroPagosInspeccionesVisuales compatible con DevExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoMaestroPagosInspeccionesVisualesForGrid(FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoMaestroPagosInspeccionesVisualesForGrid(FechaInicio, FechaFin, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoMaestroPagosInspeccionesVisualesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de OCAs para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoOcasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoOcasForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoOcasForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado de OCAs para rejilla con filtros adicionales desde el seguimiento de ocas.
         * @param {OcaSeguimientoTipoEnum} [Tipo] 
         * @param {string} [Kpi] 
         * @param {string} [EstadoInicial] 
         * @param {string} [EstadoTransitado] 
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoOcasSeguimientoForGrid(Tipo?: OcaSeguimientoTipoEnum, Kpi?: string, EstadoInicial?: string, EstadoTransitado?: string, AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoOcasSeguimientoForGrid(Tipo, Kpi, EstadoInicial, EstadoTransitado, AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoOcasSeguimientoForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado de PDS tipo Inspecciones visuales para select.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoPdsInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoPdsInspeccionesVisualesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoPdsInspeccionesVisualesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de PDS con tipo prestador OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoPdsOcaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoPdsOcaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoPdsOcaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado unificado de actuaciones e inspecciones visuales del técnico
         * @param {string} [TrabajoTecnicoType] 
         * @param {number} [IdTrabajoTecnicoSortEnum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoTrabajoTecnico(TrabajoTecnicoType?: string, IdTrabajoTecnicoSortEnum?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListadoTrabajoTecnicoDtoListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoTrabajoTecnico(TrabajoTecnicoType, IdTrabajoTecnicoSortEnum, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoTrabajoTecnico']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de ubicaciones OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoUbicacionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoUbicacionesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoUbicacionesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado de ubicaciones para select de inspecciones visuales.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoUbicacionesInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoUbicacionesInspeccionesVisualesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoUbicacionesInspeccionesVisualesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el medallero de pagos para un PDS en un periodo
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedalleroPorPds(FechaPeriodo?: Date, IdPds?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedalleroPorPdsModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedalleroPorPds(FechaPeriodo, IdPds, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMedalleroPorPds']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS
         * @param {number} [Mes] 
         * @param {number} [Anyo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaMedalleroMensualPds(Mes?: number, Anyo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaMensualPdsAnonimizadoModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaMedalleroMensualPds(Mes, Anyo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMediaMedalleroMensualPds']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS por rango de fecha
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaMedalleroMensualPdsPorRangoFecha(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaMedalleroPdsPorMesModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaMedalleroMensualPdsPorRangoFecha(MesInicio, AnioInicio, MesFin, AnioFin, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMediaMedalleroMensualPdsPorRangoFecha']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS por rango de fecha
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaMedalleroMensualPdsPorRangoFechaPorPds(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, IdPds?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaMedalleroPdsPorMesModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaMedalleroMensualPdsPorRangoFechaPorPds(MesInicio, AnioInicio, MesFin, AnioFin, IdPds, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMediaMedalleroMensualPdsPorRangoFechaPorPds']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS anonimizados, mostrando el nombre real solo para el PDS solicitado
         * @param {number} [Mes] 
         * @param {number} [Anyo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaMensualPdsAnonimizado(Mes?: number, Anyo?: number, IdPds?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaMensualPdsAnonimizadoModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaMensualPdsAnonimizado(Mes, Anyo, IdPds, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMediaMensualPdsAnonimizado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los mensajes del chat de una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMensajesOca(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MensajeOcaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMensajesOca(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMensajesOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el modelo de pago del prestador seleccionado o del propio usuario
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModeloPagoPrestador(IdPds?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModeloPagoEnumResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModeloPagoPrestador(IdPds, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getModeloPagoPrestador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las modificaciones de CPs por periodo
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModificacionesActivosPeriodoForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModificacionesActivosPeriodoForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getModificacionesActivosPeriodoForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los ids de los motivos de cierre para la wo seleccionada
         * @param {string} [IdWorkOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMotivosCierreFromWo(IdWorkOrder?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMotivosCierreFromWo(IdWorkOrder, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMotivosCierreFromWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los motivos de cierre de Wo para correctivo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMotivosCierreWoCorrectivo(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MotivoCierreWoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMotivosCierreWoCorrectivo(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMotivosCierreWoCorrectivo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMspsInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMspsInteroperabilidadForGrid(Options, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMspsInteroperabilidadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMspsInteroperabilidadLista(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MspRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMspsInteroperabilidadLista(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMspsInteroperabilidadLista']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado de notificaciones del usuario actual (sin leer y leídas).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificaciones(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotificacionesModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificaciones(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getNotificaciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las observaciones internas de gestores GMAO de una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObservacionesOca(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservacionOcaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObservacionesOca(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getObservacionesOca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una OCA de centro de transformación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcaDetailCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcaDetailCentroTransformacionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcaDetailCentroTransformacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOcaDetailCentroTransformacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una OCA de ubicación con sus ficheros.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcaDetailUbicacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcaDetailModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcaDetailUbicacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOcaDetailUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la composición semanal de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [NumSemanas] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcaSeguimientoComposicionSemanal(NumSemanas?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcaSeguimientoComposicionSemanalModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcaSeguimientoComposicionSemanal(NumSemanas, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOcaSeguimientoComposicionSemanal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el heatmap de visitas de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcaSeguimientoHeatmapVisita(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcaSeguimientoHeatmapVisitaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcaSeguimientoHeatmapVisita(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOcaSeguimientoHeatmapVisita']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la información de los KPIs de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcaSeguimientoKpis(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcaSeguimientoKpisModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcaSeguimientoKpis(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOcaSeguimientoKpis']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Catálogo de semanas para seguimiento de ocas, ordenadas por año y semana descendientes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcaSeguimientoSemanas(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcaSeguimientoSemanaModelIEnumerableResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcaSeguimientoSemanas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOcaSeguimientoSemanas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las transiciones de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcaSeguimientoTransiciones(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcaSeguimientoTransicionesModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcaSeguimientoTransiciones(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOcaSeguimientoTransiciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los origenes de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrigenesTicket(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrigenTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrigenesTicket(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOrigenesTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rejilla de instalaciones B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPagosB2cInstalaciones(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPagosB2cInstalaciones(Anio, Mes, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPagosB2cInstalaciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Lista los meses ya importados de pagos B2C.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPagosB2cMeses(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<B2cMesImportadoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPagosB2cMeses(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPagosB2cMeses']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rejilla de Pdte C3 B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPagosB2cPdteC3(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPagosB2cPdteC3(Anio, Mes, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPagosB2cPdteC3']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rejilla de reparaciones B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPagosB2cReparaciones(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPagosB2cReparaciones(Anio, Mes, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPagosB2cReparaciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rejilla de visitas B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPagosB2cVisitas(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPagosB2cVisitas(Anio, Mes, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPagosB2cVisitas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de devengado mensual por partner para la rejilla general.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerDevengadoForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerDevengadoForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnerDevengadoForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el devengado agrupado por partner, año, sociedad y región.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerDevengadoPorAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerDevengadoPorAnioForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnerDevengadoPorAnioForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el devengado agrupado por sociedad y año.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerDevengadoPorSociedadAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerDevengadoPorSociedadAnioForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnerDevengadoPorSociedadAnioForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el devengado agrupado por sociedad y mes.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerDevengadoPorSociedadForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerDevengadoPorSociedadForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnerDevengadoPorSociedadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de partners para el usuario
         * @param {string} [IdUsuarioBd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerPorUsuarioBd(IdUsuarioBd?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerPorUsuarioBd(IdUsuarioBd, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnerPorUsuarioBd']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de partners para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnersForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnersForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnersForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de partners para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnersForGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnersForGridAdmin(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnersForGridAdmin']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de partners para el usuario
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnersPorUsuario(IdUsuario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnersPorUsuario(IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnersPorUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el partner asociado al usuario BD
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnersPorUsuarioBdForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnersPorUsuarioBdForGrid(LoadOptions, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnersPorUsuarioBdForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de partners asociado al usuario
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnersPorUsuarioForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnersPorUsuarioForGrid(LoadOptions, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPartnersPorUsuarioForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los pds asogiados a un código postal concreto, por tipo de prestador
         * @param {string} [CodigoPostal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdsByCodigoPostal(CodigoPostal?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdsByCodigoPostalModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdsByCodigoPostal(CodigoPostal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPdsByCodigoPostal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el pds dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdsById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdsModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdsById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPdsById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de pds asociado al usuario
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdsPorUsuarioForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdsPorUsuarioForGrid(LoadOptions, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPdsPorUsuarioForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las piezas de Wo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPiezasWo(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PiezaWoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPiezasWo(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPiezasWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Inspecciones de un técnico en una fecha, con su orden de visita.
         * @param {string} [IdTecnico] 
         * @param {string} [FechaProgramada] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanificacionTecnicoInspeccionVisual(IdTecnico?: string, FechaProgramada?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanificacionTecnicoInspeccionVisualModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanificacionTecnicoInspeccionVisual(IdTecnico, FechaProgramada, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPlanificacionTecnicoInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} IdTarifa 
         * @param {string} [TipoPotencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrecioReferenciaInteroperabilidad(IdTarifa: string, TipoPotencia?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrecioReferenciaInteroperabilidadResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrecioReferenciaInteroperabilidad(IdTarifa, TipoPotencia, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPrecioReferenciaInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreciosInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreciosInteroperabilidadForGrid(Options, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPreciosInteroperabilidadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las prioridades de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrioridadesTicket(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrioridadTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrioridadesTicket(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPrioridadesTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Indica si se muestra la columna de estado en la rejilla de WO Revenue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPuedeVerEstadoWoRevenue(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPuedeVerEstadoWoRevenue(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPuedeVerEstadoWoRevenue']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el rango de fechas límite de OCAs accesibles para el usuario.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRangoFechaLimiteOcas(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RangoFechaLimiteOcasModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRangoFechaLimiteOcas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRangoFechaLimiteOcas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las recargas
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecargasGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecargasGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRecargasGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las recargas
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecargasGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecargasGridAdmin(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRecargasGridAdmin']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el recuento de activos por periodo
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecuentoActivosPeriodoForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecuentoActivosPeriodoForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRecuentoActivosPeriodoForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las semanas de recuento de activos disponibles para selector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecuentoActivosSemanasSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecuentoActivosSemanaSelectorRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecuentoActivosSemanasSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRecuentoActivosSemanasSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRejillaMaestroPagosPorPrestador(FechaPeriodo?: Date, IdPds?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRejillaMaestroPagosPorPrestador(FechaPeriodo, IdPds, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRejillaMaestroPagosPorPrestador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaPeriodo] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRejillaMaestroPagosPorPrestadorPds(FechaPeriodo?: Date, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRejillaMaestroPagosPorPrestadorPds(FechaPeriodo, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRejillaMaestroPagosPorPrestadorPds']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de las piezas de Wo compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRejillaPiezasWo(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRejillaPiezasWo(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRejillaPiezasWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRejillaWoPorTicket(LoadOptions?: DXLoadOptions, IdTicket?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRejillaWoPorTicket(LoadOptions, IdTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRejillaWoPorTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResponsablesPrestadorSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResponsablesPrestadorSelectBox(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getResponsablesPrestadorSelectBox']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de responsables de provincias para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResponsablesProvinciasSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResponsablesProvinciasSelectBox(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getResponsablesProvinciasSelectBox']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el resumen de horas por cola para un ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResumenTiempoColas(IdTicket?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumenTiempoColasTicketRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResumenTiempoColas(IdTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getResumenTiempoColas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard revenue (variable/fijo).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenueDashboardGraficas(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevenueDashboardGraficasRmResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenueDashboardGraficas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRevenueDashboardGraficas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue para la rejilla general del dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenueInformesDashboardForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenueInformesDashboardForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRevenueInformesDashboardForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por año, partner, región y sociedad para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenueInformesDashboardPorAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenueInformesDashboardPorAnioForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRevenueInformesDashboardPorAnioForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por sociedad y año para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenueInformesDashboardPorSociedadAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenueInformesDashboardPorSociedadAnioForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRevenueInformesDashboardPorSociedadAnioForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por sociedad y periodo para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenueInformesDashboardPorSociedadForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenueInformesDashboardPorSociedadForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRevenueInformesDashboardPorSociedadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Indica si el usuario revenue self puede ver Work Orders y sustituciones (al menos un partner privado).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenueSelfPuedeVerWoSustituciones(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenueSelfPuedeVerWoSustituciones(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRevenueSelfPuedeVerWoSustituciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el siguiente cargador del wizard de informe técnico.
         * @param {string} Id 
         * @param {string} [IdCargadorActual] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiguienteCargadorInformeTecnicoIv(Id: string, IdCargadorActual?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSiguienteCargadorIvModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiguienteCargadorInformeTecnicoIv(Id, IdCargadorActual, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSiguienteCargadorInformeTecnicoIv']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
         * @param {number} [IdNumerico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiguienteComplianceWo(IdNumerico?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSiguienteComplianceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiguienteComplianceWo(IdNumerico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSiguienteComplianceWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo de la actuación seleccionada
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiguienteWoFromActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSiguienteWoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiguienteWoFromActuacion(IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSiguienteWoFromActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiguienteWoFromWo(IdWo?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSiguienteWoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiguienteWoFromWo(IdWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSiguienteWoFromWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los subestados de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubestadosTicket(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubestadoTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubestadosTicket(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSubestadosTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de suscripciones para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuscripcionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuscripcionesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSuscripcionesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTarifasInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTarifasInteroperabilidadForGrid(Options, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTarifasInteroperabilidadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTarifasInteroperabilidadLista(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecargaTarifaRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTarifasInteroperabilidadLista(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTarifasInteroperabilidadLista']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTecnicosPrestadorSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTecnicosPrestadorSelectBox(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTecnicosPrestadorSelectBox']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de todos los tenants, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenants(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTenantsModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenants(Take, Skip, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTenants']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtiene un listado de los tenants, ordneados por los suscritos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantsOrderSuscrito(LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantsOrderSuscrito(LoadOptions, IdUsuario, Email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTenantsOrderSuscrito']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtienen los tenant
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantsRm(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantsRm(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTenantsRm']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Tickets y KO asociados del compliance de una inspección visual.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketsComplianceInspeccionVisualForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketsComplianceInspeccionVisualForGrid(Id, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTicketsComplianceInspeccionVisualForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo activo de tipología/subtipología de incidencia (selector unificado)
         * @param {boolean} [ExcluirSoloCreacionEdicion] 
         * @param {boolean} [SoloAsistenciaSat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTipologiasSubtipologiasIncidencia(ExcluirSoloCreacionEdicion?: boolean, SoloAsistenciaSat?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TipologiaSubtipologiaIncidenciaRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTipologiasSubtipologiasIncidencia(ExcluirSoloCreacionEdicion, SoloAsistenciaSat, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTipologiasSubtipologiasIncidencia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Catálogo de tipologías/subtipologías de incidencia para tipificar WOs
         * @param {boolean} [ExcluirSoloCreacionEdicion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTipologiasSubtipologiasIncidenciaExterno(ExcluirSoloCreacionEdicion?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTipologiasSubtipologiasIncidenciaExterno(ExcluirSoloCreacionEdicion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTipologiasSubtipologiasIncidenciaExterno']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el catálogo de tipos de infraestructura de cargador.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTiposInfraestructuraCargador(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TipoInfraestructuraCargadorModelIListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTiposInfraestructuraCargador(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTiposInfraestructuraCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los tipos de ticket (asistencia / incidencia)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTiposTicket(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TipoTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTiposTicket(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTiposTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de tipos de indisponibilidad disponibles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTiposUnavailable(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadorTipoUnavailableDtoIListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTiposUnavailable(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTiposUnavailable']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de los tipos de urgencia de actuación para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTiposUrgenciaActuacionSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTiposUrgenciaActuacionSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTiposUrgenciaActuacionSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de la transaccion dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransaccionById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailTransaccionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaccionById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTransaccionById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las transacciones
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransaccionesGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaccionesGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTransaccionesGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las transacciones
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransaccionesGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaccionesGridAdmin(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTransaccionesGridAdmin']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUbicacionById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UbicacionRmResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUbicacionById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUbicacionById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de las ubicaciones de los activos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUbicacionesActivos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UbicacionesActivosRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUbicacionesActivos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUbicacionesActivos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de gestores GMAO para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarioBdSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarioBdSelectBox(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuarioBdSelectBox']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuariosSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuariosSelectBox(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuariosSelectBox']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los id de usuarios técnicos del prestador del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuariosTecnicos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuariosTecnicos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuariosTecnicos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos de la validacion de una actuacion
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidacionActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidacionWoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidacionActuacion(IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getValidacionActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos de la validacion de una wo
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidacionWo(IdWo?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidacionWoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidacionWo(IdWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getValidacionWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de las visitas de una OCA de centro de transformación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisitasOcaCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitaOcaDetailModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitasOcaCentroTransformacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getVisitasOcaCentroTransformacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de las visitas de una OCA de ubicación con sus ficheros.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisitasOcaUbicacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitaOcaDetailModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitasOcaUbicacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getVisitasOcaUbicacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado agrupado por empresa con porcentaje e importe real
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolumenPorEmpresasPorRangoFechas(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraficoVolumenPorEmpresaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolumenPorEmpresasPorRangoFechas(MesInicio, AnioInicio, MesFin, AnioFin, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getVolumenPorEmpresasPorRangoFechas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de pds para el usuario
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getdPdsPorUsuario(IdUsuario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getdPdsPorUsuario(IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getdPdsPorUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {GuardarMspInteroperabilidadModel} [GuardarMspInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarMspInteroperabilidad(GuardarMspInteroperabilidadModel?: GuardarMspInteroperabilidadModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarMspInteroperabilidad(GuardarMspInteroperabilidadModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.guardarMspInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {GuardarMspTarifaInteroperabilidadModel} [GuardarMspTarifaInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarMspTarifaInteroperabilidad(GuardarMspTarifaInteroperabilidadModel?: GuardarMspTarifaInteroperabilidadModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarMspTarifaInteroperabilidad(GuardarMspTarifaInteroperabilidadModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.guardarMspTarifaInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Guarda el paso de un cargador del informe técnico (checks).
         * @param {string} Id 
         * @param {string} IdCargador 
         * @param {GuardarPasoInformeTecnicoIvModel} Datos 
         * @param {Array<File>} [Archivos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarPasoCargadorInformeTecnicoInspeccionVisual(Id: string, IdCargador: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarPasoCargadorInformeTecnicoInspeccionVisual(Id, IdCargador, Datos, Archivos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.guardarPasoCargadorInformeTecnicoInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Guarda el paso de ubicación del informe técnico (checks + incidencia).
         * @param {string} Id 
         * @param {GuardarPasoInformeTecnicoIvModel} Datos 
         * @param {Array<File>} [Archivos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarPasoUbicacionInformeTecnicoInspeccionVisual(Id: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarPasoUbicacionInformeTecnicoInspeccionVisual(Id, Datos, Archivos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.guardarPasoUbicacionInformeTecnicoInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {GuardarRecargaTarifaInteroperabilidadModel} [GuardarRecargaTarifaInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarRecargaTarifaInteroperabilidad(GuardarRecargaTarifaInteroperabilidadModel?: GuardarRecargaTarifaInteroperabilidadModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarRecargaTarifaInteroperabilidad(GuardarRecargaTarifaInteroperabilidadModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.guardarRecargaTarifaInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {GuardarRecargaTarifaPrecioInteroperabilidadModel} [GuardarRecargaTarifaPrecioInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarRecargaTarifaPrecioInteroperabilidad(GuardarRecargaTarifaPrecioInteroperabilidadModel?: GuardarRecargaTarifaPrecioInteroperabilidadModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarRecargaTarifaPrecioInteroperabilidad(GuardarRecargaTarifaPrecioInteroperabilidadModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.guardarRecargaTarifaPrecioInteroperabilidad']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero XLSX para importar los certificados de visita
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importarCertificadosVisita(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importarCertificadosVisita(Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importarCertificadosVisita']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Importa los pares cliente-cargador de un XLSX inicial
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importarClientesCargadores(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importarClientesCargadores(Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importarClientesCargadores']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero XLSX para importar el recuento de activos
         * @param {string} [UrlFichero] 
         * @param {number} [NumSemana] 
         * @param {number} [NumMes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importarRecuentoActivosFromXCustomer(UrlFichero?: string, NumSemana?: number, NumMes?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importarRecuentoActivosFromXCustomer(UrlFichero, NumSemana, NumMes, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importarRecuentoActivosFromXCustomer']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero CSV para importar las WOs urgentes de xCustomer
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importarWosUrgentesFromXCustomer(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importarWosUrgentesFromXCustomer(Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importarWosUrgentesFromXCustomer']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una inspección visual externa (prestador).
         * @param {CreateInspeccionVisualExternaModel} [CreateInspeccionVisualExternaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspeccionVisualCreateExterna(CreateInspeccionVisualExternaModel?: CreateInspeccionVisualExternaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspeccionVisualCreateExterna(CreateInspeccionVisualExternaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.inspeccionVisualCreateExterna']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una inspección visual interna (Endesa).
         * @param {CreateInspeccionVisualInternaModel} [CreateInspeccionVisualInternaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspeccionVisualCreateInterna(CreateInspeccionVisualInternaModel?: CreateInspeccionVisualInternaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspeccionVisualCreateInterna(CreateInspeccionVisualInternaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.inspeccionVisualCreateInterna']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita cabecera de una inspección visual.
         * @param {EditInspeccionVisualModel} [EditInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspeccionVisualEdit(EditInspeccionVisualModel?: EditInspeccionVisualModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspeccionVisualEdit(EditInspeccionVisualModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.inspeccionVisualEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la cabecera de una inspección visual para edición.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspeccionVisualGet(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InspeccionVisualCabeceraModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspeccionVisualGet(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.inspeccionVisualGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una OCA de tipo centro de transformación.
         * @param {CreateOcaCentroTransformacionModel} [CreateOcaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ocaCentroTransformacionCreate(CreateOcaCentroTransformacionModel?: CreateOcaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ocaCentroTransformacionCreate(CreateOcaCentroTransformacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ocaCentroTransformacionCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una OCA de tipo centro de transformación.
         * @param {EditOcaCentroTransformacionModel} [EditOcaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ocaCentroTransformacionEdit(EditOcaCentroTransformacionModel?: EditOcaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ocaCentroTransformacionEdit(EditOcaCentroTransformacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ocaCentroTransformacionEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una OCA de tipo ubicación.
         * @param {CreateOcaUbicacionModel} [CreateOcaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ocaUbicacionCreate(CreateOcaUbicacionModel?: CreateOcaUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ocaUbicacionCreate(CreateOcaUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ocaUbicacionCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una OCA de tipo ubicación.
         * @param {EditOcaUbicacionModel} [EditOcaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ocaUbicacionEdit(EditOcaUbicacionModel?: EditOcaUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ocaUbicacionEdit(EditOcaUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ocaUbicacionEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo partner
         * @param {CreatePartnerModel} [CreatePartnerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerCreate(CreatePartnerModel?: CreatePartnerModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerCreate(CreatePartnerModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.partnerCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un partner existente
         * @param {EditPartnerModel} [EditPartnerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerEdit(EditPartnerModel?: EditPartnerModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerEdit(EditPartnerModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.partnerEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo PDS
         * @param {CreatePdsModel} [CreatePdsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdsCreate(CreatePdsModel?: CreatePdsModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdsCreate(CreatePdsModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.pdsCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un PDS existente
         * @param {EditPdsModel} [EditPdsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdsEdit(EditPdsModel?: EditPdsModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdsEdit(EditPdsModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.pdsEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de Pds compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdsGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdsGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.pdsGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un fichero a la actuación.
         * @param {string} Id 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdjuntoActuacion(Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdjuntoActuacion(Id, TipoDocumento, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postAdjuntoActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un fichero a la work order. Tipos: Cuadro eléctrico, Cargador, Número serie, Prueba termográfica, Informe técnico, Informe económico, Otros.
         * @param {string} IdWorkOrder 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdjuntoExternoWo(IdWorkOrder: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdjuntoExternoWo(IdWorkOrder, TipoDocumento, Descripcion, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postAdjuntoExternoWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un fichero al ticket.
         * @param {string} Id 
         * @param {CategoriaAdjuntoTicketApiEnum} [CategoriaDocumento] 
         * @param {string} [Descripcion] 
         * @param {boolean} [OmitirHistorico] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdjuntoTicket(Id: string, CategoriaDocumento?: CategoriaAdjuntoTicketApiEnum, Descripcion?: string, OmitirHistorico?: boolean, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdjuntoTicket(Id, CategoriaDocumento, Descripcion, OmitirHistorico, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postAdjuntoTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un fichero a la work order.
         * @param {string} Id 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdjuntoWo(Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdjuntoWo(Id, TipoDocumento, Descripcion, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postAdjuntoWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCargarFicheroPartners(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCargarFicheroPartners(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postCargarFicheroPartners']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero de forma temporal.
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentoTemp(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentoTemp(Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postDocumentoTemp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero para crear usuarios
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentoUsuarios(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentoUsuarios(Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postDocumentoUsuarios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un evento de edición de datos del ticket con mensaje y observación combinados.
         * @param {string} Id 
         * @param {CreateHistoricoEdicionTicketModel} [CreateHistoricoEdicionTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postHistoricoEdicionTicket(Id: string, CreateHistoricoEdicionTicketModel?: CreateHistoricoEdicionTicketModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postHistoricoEdicionTicket(Id, CreateHistoricoEdicionTicketModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postHistoricoEdicionTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un informe económico a la actuación
         * @param {string} IdActuacion 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInformeEconomicoActuacion(IdActuacion: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInformeEconomicoActuacion(IdActuacion, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postInformeEconomicoActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta el informe de la WO; el económico requiere importe y recalcula el coste sin cerrar la WO
         * @param {string} IdWorkOrder 
         * @param {TipoInformeWoExternoEnum} [TipoInforme] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {number} [ImporteWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInformeWorkOrder(IdWorkOrder: string, TipoInforme?: TipoInformeWoExternoEnum, Filename?: string, File?: File, ImporteWo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInformeWorkOrder(IdWorkOrder, TipoInforme, Filename, File, ImporteWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postInformeWorkOrder']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Importa los 4 Excel de pagos B2C para un mes (reemplaza si ya existe).
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {File} [Instalaciones] 
         * @param {File} [Reparaciones] 
         * @param {File} [Visitas] 
         * @param {File} [PdteC3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPagosB2cImportar(Anio?: number, Mes?: number, Instalaciones?: File, Reparaciones?: File, Visitas?: File, PdteC3?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPagosB2cImportar(Anio, Mes, Instalaciones, Reparaciones, Visitas, PdteC3, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postPagosB2cImportar']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube 3 excels (Activos/Oportunidades/Contactos) y devuelve un preview parseado.
         * @param {string} [IdCorrelacion] 
         * @param {File} [Activos] 
         * @param {File} [Oportunidades] 
         * @param {File} [Contactos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPartnersCargarExcels(IdCorrelacion?: string, Activos?: File, Oportunidades?: File, Contactos?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPartnersCargarExcels(IdCorrelacion, Activos, Oportunidades, Contactos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postPartnersCargarExcels']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Prepara el informe técnico (cargadores y checklist) con datos actuales.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepararInformeTecnicoInspeccionVisual(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepararInformeTecnicoInspeccionVisual(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.prepararInformeTecnicoInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary TEMP AL-513 — Preview cálculo coste actuación (sin persistir)
         * @param {string} IdActuacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewCalculoCosteActuacion(IdActuacion: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewCalculoCosteActuacionRmResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewCalculoCosteActuacion(IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.previewCalculoCosteActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna fecha de programación y técnico de una o más inspecciones visuales.
         * @param {ProgramarFechaInspeccionVisualModel} [ProgramarFechaInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async programarFechaInspeccionVisual(ProgramarFechaInspeccionVisualModel?: ProgramarFechaInspeccionVisualModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.programarFechaInspeccionVisual(ProgramarFechaInspeccionVisualModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.programarFechaInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Programa la fecha de la visita pendiente de una OCA.
         * @param {ProgramarFechaVisitaModel} [ProgramarFechaVisitaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async programarFechaVisita(ProgramarFechaVisitaModel?: ProgramarFechaVisitaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.programarFechaVisita(ProgramarFechaVisitaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.programarFechaVisita']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita el importe de un informe de canon fija (solo Admin Revenue)
         * @param {string} Id 
         * @param {EditarImporteFijoTransaccionModel} [EditarImporteFijoTransaccionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEditarImporteFijoTransaccion(Id: string, EditarImporteFijoTransaccionModel?: EditarImporteFijoTransaccionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEditarImporteFijoTransaccion(Id, EditarImporteFijoTransaccionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.putEditarImporteFijoTransaccion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza un evento cargador
         * @param {EditEventoCargadorModel} [EditEventoCargadorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEventoCargador(EditEventoCargadorModel?: EditEventoCargadorModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubestadoTicketsRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEventoCargador(EditEventoCargadorModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.putEventoCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Reabre un ticket cerrado con un nuevo estado, subestado y cola, registrando el evento en el histórico.
         * @param {ReabrirTicketModel} [ReabrirTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reabrirTicket(ReabrirTicketModel?: ReabrirTicketModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reabrirTicket(ReabrirTicketModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.reabrirTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca todas las notificaciones del usuario como leídas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAllNotificaciones(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAllNotificaciones(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.readAllNotificaciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca una notificación como leída.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readNotificacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readNotificacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.readNotificacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Refresca el estado del cargador
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshCargadorStatus(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusCargadorModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshCargadorStatus(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.refreshCargadorStatus']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Resuelve el prestador sugerido al crear actuación (tramo provincia/potencia y código postal)
         * @param {ResolvePdsNuevaActuacionModel} [ResolvePdsNuevaActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolvePdsNuevaActuacion(ResolvePdsNuevaActuacionModel?: ResolvePdsNuevaActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolvePdsNuevaActuacionRmResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolvePdsNuevaActuacion(ResolvePdsNuevaActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.resolvePdsNuevaActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Reanuda la periodicidad de una IV pausada y crea la siguiente con la fecha objetivo indicada.
         * @param {string} Id 
         * @param {ResumirPeriodicidadInspeccionVisualModel} [ResumirPeriodicidadInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumirPeriodicidadInspeccionVisual(Id: string, ResumirPeriodicidadInspeccionVisualModel?: ResumirPeriodicidadInspeccionVisualModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumirPeriodicidadInspeccionVisual(Id, ResumirPeriodicidadInspeccionVisualModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.resumirPeriodicidadInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesGetAll(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolesRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesGetAll(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rolesGetAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece la aptitud de un cargador para inspecciones visuales
         * @param {string} Id 
         * @param {boolean} [AptoInspeccionVisual] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAptoInspeccionVisualCargador(Id: string, AptoInspeccionVisual?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAptoInspeccionVisualCargador(Id, AptoInspeccionVisual, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setAptoInspeccionVisualCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Guarda la calidad de una inspección visual sin resolver el compliance.
         * @param {string} Id 
         * @param {SetCalidadInspeccionVisualModel} [SetCalidadInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCalidadInspeccionVisual(Id: string, SetCalidadInspeccionVisualModel?: SetCalidadInspeccionVisualModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCalidadInspeccionVisual(Id, SetCalidadInspeccionVisualModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setCalidadInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca un cargador como disponible
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCargadorAvailable(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCargadorAvailable(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setCargadorAvailable']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca un cargador como dismissed
         * @param {string} Id 
         * @param {SetCargadorDismissedModel} [SetCargadorDismissedModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCargadorDismissed(Id: string, SetCargadorDismissedModel?: SetCargadorDismissedModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCargadorDismissed(Id, SetCargadorDismissedModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setCargadorDismissed']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece el tipo de indisponibilidad de un cargador
         * @param {string} Id 
         * @param {number} [IdTipoUnavailable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCargadorUnavailable(Id: string, IdTipoUnavailable?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCargadorUnavailable(Id, IdTipoUnavailable, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setCargadorUnavailable']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca o desmarca un cargador como visible en la app
         * @param {string} Id 
         * @param {boolean} [VisibleInApp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCargadorVisibleInApp(Id: string, VisibleInApp?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCargadorVisibleInApp(Id, VisibleInApp, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setCargadorVisibleInApp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Resuelve el compliance de una inspección visual externa.
         * @param {string} Id 
         * @param {SetComplianceInspeccionVisualModel} [SetComplianceInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setComplianceInspeccionVisual(Id: string, SetComplianceInspeccionVisualModel?: SetComplianceInspeccionVisualModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setComplianceInspeccionVisual(Id, SetComplianceInspeccionVisualModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setComplianceInspeccionVisual']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece los datos de compliance de una work order
         * @param {string} Id 
         * @param {SetComplianceWoModel} [SetComplianceWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setComplianceWo(Id: string, SetComplianceWoModel?: SetComplianceWoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setComplianceWo(Id, SetComplianceWoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setComplianceWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de subestados
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subestadosGetAll(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubestadosRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subestadosGetAll(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.subestadosGetAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtiene un listado de los informes suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suscripcionInformesPorUsuario(IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suscripcionInformesPorUsuario(IdUsuario, Email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.suscripcionInformesPorUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se cargan las suscripciones para el usuario seleccionado
         * @param {AddSuscripcionPorUsuarioModel} [AddSuscripcionPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suscripcionesCreate(AddSuscripcionPorUsuarioModel?: AddSuscripcionPorUsuarioModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suscripcionesCreate(AddSuscripcionPorUsuarioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.suscripcionesCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se editan las suscripciones para el usuario seleccionado
         * @param {DeleteSuscripcionesPorUsuarioModel} [DeleteSuscripcionesPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suscripcionesDelete(DeleteSuscripcionesPorUsuarioModel?: DeleteSuscripcionesPorUsuarioModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suscripcionesDelete(DeleteSuscripcionesPorUsuarioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.suscripcionesDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se editan las suscripciones para el usuario seleccionado
         * @param {EditSuscripcionPorUsuarioModel} [EditSuscripcionPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suscripcionesPut(EditSuscripcionPorUsuarioModel?: EditSuscripcionPorUsuarioModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suscripcionesPut(EditSuscripcionPorUsuarioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.suscripcionesPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se suscribe al tenant seleccionado
         * @param {string} [IdTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantSubscribe(IdTenant?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantSubscribe(IdTenant, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.tenantSubscribe']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se desuscribe al tenant seleccionado
         * @param {string} [IdTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUnsubscribe(IdTenant?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUnsubscribe(IdTenant, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.tenantUnsubscribe']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de tenants con sus estados y suscripciones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsEstadosSuscripciones(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsEstadosSuscripciones(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.tenantsEstadosSuscripciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Se obtiene un listado de los tenants suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsPorUsuario(IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsPorUsuario(IdUsuario, Email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.tenantsPorUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una ubicación OCA.
         * @param {CreateUbicacionModel} [CreateUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ubicacionCreate(CreateUbicacionModel?: CreateUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ubicacionCreate(CreateUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ubicacionCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una ubicación OCA.
         * @param {EditUbicacionModel} [EditUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ubicacionEdit(EditUbicacionModel?: EditUbicacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ubicacionEdit(EditUbicacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ubicacionEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza el tipo de intervalo de una actuación
         * @param {UpdateIntervaloActuacionModel} [UpdateIntervaloActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIntervaloActuacion(UpdateIntervaloActuacionModel?: UpdateIntervaloActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIntervaloActuacion(UpdateIntervaloActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.updateIntervaloActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioCheckEmail(Email: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioCheckEmail(Email, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioCheckEmail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioCheckUsername(Username: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioCheckUsername(Username, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioCheckUsername']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un usuario existente
         * @param {DeleteUserModel} [DeleteUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioDelete(DeleteUserModel?: DeleteUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioDelete(DeleteUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGetCurrentUserProfile(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGetCurrentUserProfile(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGetCurrentUserProfile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las preferencias de notificación del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGetPreferenciasNotificacion(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreferenciasNotificacionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGetPreferenciasNotificacion(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGetPreferenciasNotificacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserGmaoModel} [CreateUserGmaoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGmaoCreate(CreateUserGmaoModel?: CreateUserGmaoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGmaoCreate(CreateUserGmaoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGmaoCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserGmaoModel} [EditUserGmaoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGmaoEdit(EditUserGmaoModel?: EditUserGmaoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGmaoEdit(EditUserGmaoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGmaoEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Reactiva un usuario deshabilitado
         * @param {ReactivateUserModel} [ReactivateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioReactivate(ReactivateUserModel?: ReactivateUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioReactivate(ReactivateUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioReactivate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioRevenueCreate(CreateUserModel?: CreateUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioRevenueCreate(CreateUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioRevenueCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioRevenueEdit(EditUserModel?: EditUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioRevenueEdit(EditUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioRevenueEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza las preferencias de notificación del usuario actual
         * @param {PreferenciasNotificacionModel} [PreferenciasNotificacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioUpdatePreferenciasNotificacion(PreferenciasNotificacionModel?: PreferenciasNotificacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreferenciasNotificacionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioUpdatePreferenciasNotificacion(PreferenciasNotificacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioUpdatePreferenciasNotificacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Validar una actuacion
         * @param {ValidarActuacionModel} [ValidarActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validarActuacion(ValidarActuacionModel?: ValidarActuacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validarActuacion(ValidarActuacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.validarActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Validar una wo
         * @param {ValidarWoModel} [ValidarWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validarWo(ValidarWoModel?: ValidarWoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validarWo(ValidarWoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.validarWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una wo existente
         * @param {EditWoModel} [EditWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woEdit(EditWoModel?: EditWoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woEdit(EditWoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO asociada a un cargador (SAT/activos, sin otros documentos)
         * @param {string} IdWo 
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetInformeTecnicoFromCargador(IdWo: string, IdCargador?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetInformeTecnicoFromCargador(IdWo, IdCargador, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetInformeTecnicoFromCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO asociada a un ticket (SAT/ticketing, sin otros documentos)
         * @param {string} IdWo 
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetInformeTecnicoFromTicket(IdWo: string, IdTicket?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetInformeTecnicoFromTicket(IdWo, IdTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetInformeTecnicoFromTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO (Revenue Activos, sin otros documentos)
         * @param {string} IdWo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetInformeTecnicoRevenue(IdWo: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetInformeTecnicoRevenue(IdWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetInformeTecnicoRevenue']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO con sustitución (solo Revenue, sin otros documentos)
         * @param {string} IdWo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetInformeTecnicoSustitucionRevenue(IdWo: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetInformeTecnicoSustitucionRevenue(IdWo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetInformeTecnicoSustitucionRevenue']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetRejillaMaestroPagosWo(FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetRejillaMaestroPagosWo(FechaInicio, FechaFin, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetRejillaMaestroPagosWo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetRejillaPorActuacion(LoadOptions?: DXLoadOptions, IdActuacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetRejillaPorActuacion(LoadOptions, IdActuacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetRejillaPorActuacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdCargador
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetRejillaPorIdCargador(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetRejillaPorIdCargador(IdCargador, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetRejillaPorIdCargador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdTicket
         * @param {string} [IdTicket] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetRejillaPorIdTicket(IdTicket?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetRejillaPorIdTicket(IdTicket, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetRejillaPorIdTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado DevExtreme de WO para Revenue (campos limitados)
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetRejillaWoRevenue(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetRejillaWoRevenue(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetRejillaWoRevenue']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado DevExtreme de WO con sustitución de cargador (Activos)
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async woGetRejillaWoSustitucion(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.woGetRejillaWoSustitucion(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.woGetRejillaWoSustitucion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de zonas del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonasGetAll(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZonasRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonasGetAll(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.zonasGetAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ApiApi - factory interface
 * @export
 */
export const ApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Crea un nuevo activo (cargador)
         * @param {CreateActivoModel} [CreateActivoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activoCreate(CreateActivoModel?: CreateActivoModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.activoCreate(CreateActivoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nueva actuación
         * @param {CreateActuacionModel} [CreateActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuacionCreate(CreateActuacionModel?: CreateActuacionModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.actuacionCreate(CreateActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una actuacion existente
         * @param {EditActuacionModel} [EditActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuacionEdit(EditActuacionModel?: EditActuacionModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.actuacionEdit(EditActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de actuaciones compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actuacionesGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.actuacionesGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sustituye el orden de visita de un técnico en una fecha.
         * @param {ActualizarPlanificacionTecnicoInspeccionVisualModel} [ActualizarPlanificacionTecnicoInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizarPlanificacionTecnicoInspeccionVisual(ActualizarPlanificacionTecnicoInspeccionVisualModel?: ActualizarPlanificacionTecnicoInspeccionVisualModel, options?: any): AxiosPromise<void> {
            return localVarFp.actualizarPlanificacionTecnicoInspeccionVisual(ActualizarPlanificacionTecnicoInspeccionVisualModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade cargadores sin ubicación a una ubicación existente.
         * @param {AddCargadoresUbicacionModel} [AddCargadoresUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCargadoresUbicacion(AddCargadoresUbicacionModel?: AddCargadoresUbicacionModel, options?: any): AxiosPromise<void> {
            return localVarFp.addCargadoresUbicacion(AddCargadoresUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade un mensaje a la transaccion.
         * @param {string} Id 
         * @param {CreateMensajeTransaccionModel} [CreateMensajeTransaccionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMensajeTransaccion(Id: string, CreateMensajeTransaccionModel?: CreateMensajeTransaccionModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addMensajeTransaccion(Id, CreateMensajeTransaccionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Anula una OCA abierta.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anularOca(Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.anularOca(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asignar una fecha a una o varias actuaciones
         * @param {AsignarFechaActuacionModel} [AsignarFechaActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asignarFechaActuacion(AsignarFechaActuacionModel?: AsignarFechaActuacionModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.asignarFechaActuacion(AsignarFechaActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna fecha de previsión y técnico a una actuación
         * @param {AsignarPrevisionActuacionExternoModel} [AsignarPrevisionActuacionExternoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asignarPrevisionActuacionExterno(AsignarPrevisionActuacionExternoModel?: AsignarPrevisionActuacionExternoModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.asignarPrevisionActuacionExterno(AsignarPrevisionActuacionExternoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asignar un técnico a una o varias actuaciones
         * @param {AsignarTecnicoActuacionModel} [AsignarTecnicoActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asignarTecnicoActuacion(AsignarTecnicoActuacionModel?: AsignarTecnicoActuacionModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.asignarTecnicoActuacion(AsignarTecnicoActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cambia el estado de la transacción
         * @param {string} Id 
         * @param {string} [NuevoEstado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambiarEstadoTransaccion(Id: string, NuevoEstado?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.cambiarEstadoTransaccion(Id, NuevoEstado, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancela una actuacion existente
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarActuacion(Body?: string, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.cancelarActuacion(Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancela una petición pendiente de la cola de tareas programadas
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarColaTareaProgramada(Id: string, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.cancelarColaTareaProgramada(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancela una wo existente
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarWo(Body?: string, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.cancelarWo(Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un cargador poi existente
         * @param {EditCargadorPoiModel} [EditCargadorPoiModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadorPoiEdit(EditCargadorPoiModel?: EditCargadorPoiModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.cargadorPoiEdit(EditCargadorPoiModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se suscribe al Cargador seleccionado
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadorSubscribe(IdCargador?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.cargadorSubscribe(IdCargador, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadorUnsubscribe(IdCargador?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.cargadorUnsubscribe(IdCargador, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de cargadores con sus estados y suscripciones
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadoresEstadosSuscripciones(IdCargador?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.cargadoresEstadosSuscripciones(IdCargador, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtiene un listado de los cargadores suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cargadoresPorUsuario(IdUsuario?: string, Email?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.cargadoresPorUsuario(IdUsuario, Email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un centro de transformación OCA.
         * @param {CreateCentroTransformacionModel} [CreateCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        centroTransformacionCreate(CreateCentroTransformacionModel?: CreateCentroTransformacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.centroTransformacionCreate(CreateCentroTransformacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un centro de transformación OCA.
         * @param {EditCentroTransformacionModel} [EditCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        centroTransformacionEdit(EditCentroTransformacionModel?: EditCentroTransformacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.centroTransformacionEdit(EditCentroTransformacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cierra una inspección visual persistiendo conclusiones, fecha de cierre y estado Cerrada.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cerrarInspeccionVisual(Id: string, Body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.cerrarInspeccionVisual(Id, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comprueba si un número de serie está disponible (no existe en commons.cargador)
         * @param {string} [NumeroSerie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNumeroSerieNuevoDisponible(NumeroSerie?: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.checkNumeroSerieNuevoDisponible(NumeroSerie, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comprueba si existe un ticket abierto por id de cargador y tipo (1=Asistencia, 2=Incidencia).
         * @param {string} [IdCargador] 
         * @param {number} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTicketByIdCargador(IdCargador?: string, IdTipoTicket?: number, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.checkTicketByIdCargador(IdCargador, IdTipoTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comprueba si existe un ticket abierto por número de serie y tipo (1=Asistencia, 2=Incidencia).
         * @param {string} [SerialNumber] 
         * @param {number} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTicketBySerial(SerialNumber?: string, IdTipoTicket?: number, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.checkTicketBySerial(SerialNumber, IdTipoTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Completa horas y liquidaciones Circutor sin modificar pagos consolidados
         * @param {number} [Pagina] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completarDatosPagos(Pagina?: number, options?: any): AxiosPromise<ResultadoCompletarDatosPagosResponseDTO> {
            return localVarFp.completarDatosPagos(Pagina, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Completa la corrección del informe técnico de una inspección cerrada y regenera sus informes.
         * @param {string} Id 
         * @param {CompletarInformeTecnicoIvModel} [CompletarInformeTecnicoIvModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completarInformeTecnicoInspeccionVisual(Id: string, CompletarInformeTecnicoIvModel?: CompletarInformeTecnicoIvModel, options?: any): AxiosPromise<void> {
            return localVarFp.completarInformeTecnicoInspeccionVisual(Id, CompletarInformeTecnicoIvModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una observación interna de gestor GMAO en una OCA.
         * @param {CrearObservacionOcaModel} [CrearObservacionOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearObservacionOca(CrearObservacionOcaModel?: CrearObservacionOcaModel, options?: any): AxiosPromise<void> {
            return localVarFp.crearObservacionOca(CrearObservacionOcaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nueva visita OCA de centro de transformación.
         * @param {CrearVisitaCentroTransformacionModel} [CrearVisitaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearVisitaCentroTransformacion(CrearVisitaCentroTransformacionModel?: CrearVisitaCentroTransformacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.crearVisitaCentroTransformacion(CrearVisitaCentroTransformacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nueva visita OCA de ubicación.
         * @param {CrearVisitaUbicacionModel} [CrearVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearVisitaUbicacion(CrearVisitaUbicacionModel?: CrearVisitaUbicacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.crearVisitaUbicacion(CrearVisitaUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea la work order de deficiencia de una visita OCA de ubicación.
         * @param {CrearWoDeficienciaVisitaModel} [CrearWoDeficienciaVisitaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crearWoDeficienciaVisita(CrearWoDeficienciaVisitaModel?: CrearWoDeficienciaVisitaModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.crearWoDeficienciaVisita(CrearWoDeficienciaVisitaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nueva campaña
         * @param {CreateCampanaModel} [CreateCampanaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampana(CreateCampanaModel?: CreateCampanaModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.createCampana(CreateCampanaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registra un cambio de responsable en el historial del ticket y actualiza el ticket.
         * @param {CreateCargadorEventoCambioResponsableModel} [CreateCargadorEventoCambioResponsableModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCargadorEventoCambioResponsable(CreateCargadorEventoCambioResponsableModel?: CreateCargadorEventoCambioResponsableModel, options?: any): AxiosPromise<void> {
            return localVarFp.createCargadorEventoCambioResponsable(CreateCargadorEventoCambioResponsableModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un periodo privado para un cargador
         * @param {CreateCargadorPeriodoPrivadoModel} [CreateCargadorPeriodoPrivadoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCargadorPeriodoPrivado(CreateCargadorPeriodoPrivadoModel?: CreateCargadorPeriodoPrivadoModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.createCargadorPeriodoPrivado(CreateCargadorPeriodoPrivadoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo grupo de actuaciones para la campaña
         * @param {string} Id 
         * @param {CreateGrupoActuacionesModel} [CreateGrupoActuacionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrupoActuaciones(Id: string, CreateGrupoActuacionesModel?: CreateGrupoActuacionesModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.createGrupoActuaciones(Id, CreateGrupoActuacionesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un subestado para una ticket
         * @param {CreateHistoricoTicketModel} [CreateHistoricoTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubestadoHistorico(CreateHistoricoTicketModel?: CreateHistoricoTicketModel, options?: any): AxiosPromise<SubestadoTicketsRmListResponseDTO> {
            return localVarFp.createSubestadoHistorico(CreateHistoricoTicketModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una ticket
         * @param {CreateTicketModel} [CreateTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket(CreateTicketModel?: CreateTicketModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.createTicket(CreateTicketModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nueva work order
         * @param {CreateWoModel} [CreateWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWo(CreateWoModel?: CreateWoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.createWo(CreateWoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un fichero adjuntado de la actuacion.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdjuntoActuacion(Id: string, Body?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteAdjuntoActuacion(Id, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un fichero adjunto del ticket.
         * @param {string} Id 
         * @param {boolean} [OmitirHistorico] 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdjuntoTicket(Id: string, OmitirHistorico?: boolean, Body?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteAdjuntoTicket(Id, OmitirHistorico, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un fichero adjuntado de la work order.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdjuntoWo(Id: string, Body?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteAdjuntoWo(Id, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una campaña existente
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampana(Id: string, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.deleteCampana(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un evento para una ticket
         * @param {string} [IdEventoCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventoCargador(IdEventoCargador?: string, options?: any): AxiosPromise<SubestadoTicketsRmListResponseDTO> {
            return localVarFp.deleteEventoCargador(IdEventoCargador, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deshace el compliance OK de una work order del mes en curso
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deshacerComplianceWo(Id: string, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.deshacerComplianceWo(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {string} [Cuid] 
         * @param {string} [TenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detalleCargador(Cuid?: string, TenantId?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.detalleCargador(Cuid, TenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un enlace temporal al documento indicado
         * @param {string} [Key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentosGenerateTempUrl(Key?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.documentosGenerateTempUrl(Key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Descarga o previsualiza un documento de Documenta Gestor por URI absoluta.
         * @param {string} [Uri] 
         * @param {string} [Disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentoDg(Uri?: string, Disposition?: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.downloadDocumentoDg(Uri, Disposition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Descarga los ficheros adjuntos del ticket en un ZIP.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFilesTicket(Id: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.downloadFilesTicket(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Descarga el conjunto de ficheros de una work order.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFilesWo(Id: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.downloadFilesWo(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza la actuación y finaliza las work orders incluidas, aplicando la autorización por importe cuando corresponda y conservando sus importes y fechas existentes
         * @param {EditActuacionYWorkOrdersModel} [EditActuacionYWorkOrdersModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editActuacionYWorkOrdersExterno(EditActuacionYWorkOrdersModel?: EditActuacionYWorkOrdersModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.editActuacionYWorkOrdersExterno(EditActuacionYWorkOrdersModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una campaña existente
         * @param {EditCampanaModel} [EditCampanaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCampana(EditCampanaModel?: EditCampanaModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editCampana(EditCampanaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un cargador
         * @param {EditCargadorModel} [EditCargadorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCargador(EditCargadorModel?: EditCargadorModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editCargador(EditCargadorModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un periodo privado de un cargador
         * @param {EditCargadorPeriodoPrivadoModel} [EditCargadorPeriodoPrivadoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCargadorPeriodoPrivado(EditCargadorPeriodoPrivadoModel?: EditCargadorPeriodoPrivadoModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.editCargadorPeriodoPrivado(EditCargadorPeriodoPrivadoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita el informe de la wo
         * @param {EditDatosInformeModel} [EditDatosInformeModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDatosInforme(EditDatosInformeModel?: EditDatosInformeModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editDatosInforme(EditDatosInformeModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza la resolución de deficiencias de una visita OCA declarada.
         * @param {EditDeficienciasVisitaUbicacionModel} [EditDeficienciasVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeficienciasVisitaUbicacion(EditDeficienciasVisitaUbicacionModel?: EditDeficienciasVisitaUbicacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.editDeficienciasVisitaUbicacion(EditDeficienciasVisitaUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita el informe técnico de una actuación
         * @param {EditInformeTecnicoModel} [EditInformeTecnicoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInformeTecnico(EditInformeTecnicoModel?: EditInformeTecnicoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editInformeTecnico(EditInformeTecnicoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza datos editables de un ticket abierto (estado, subestado, cola, responsable, prioridad, pedido, conformidad, importe) y registra el histórico.
         * @param {boolean} [OmitirHistoricoEdicionDatos] 
         * @param {EditTicketModel} [EditTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTicket(OmitirHistoricoEdicionDatos?: boolean, EditTicketModel?: EditTicketModel, options?: any): AxiosPromise<void> {
            return localVarFp.editTicket(OmitirHistoricoEdicionDatos, EditTicketModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registra el resultado de una visita OCA de centro de transformación.
         * @param {EditVisitaCentroTransformacionModel} [EditVisitaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editVisitaCentroTransformacion(EditVisitaCentroTransformacionModel?: EditVisitaCentroTransformacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.editVisitaCentroTransformacion(EditVisitaCentroTransformacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registra el resultado de una visita OCA de ubicación.
         * @param {EditVisitaUbicacionModel} [EditVisitaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editVisitaUbicacion(EditVisitaUbicacionModel?: EditVisitaUbicacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.editVisitaUbicacion(EditVisitaUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una observación interna de gestor GMAO. Solo el autor puede editarla.
         * @param {string} Id 
         * @param {EditarObservacionOcaModel} [EditarObservacionOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editarObservacionOca(Id: string, EditarObservacionOcaModel?: EditarObservacionOcaModel, options?: any): AxiosPromise<void> {
            return localVarFp.editarObservacionOca(Id, EditarObservacionOcaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarMspInteroperabilidad(Id: string, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.eliminarMspInteroperabilidad(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarMspTarifaInteroperabilidad(Id: string, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.eliminarMspTarifaInteroperabilidad(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una observación interna de gestor GMAO. Solo el autor puede eliminarla.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarObservacionOca(Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.eliminarObservacionOca(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarRecargaTarifaInteroperabilidad(Id: string, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.eliminarRecargaTarifaInteroperabilidad(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eliminarRecargaTarifaPrecioInteroperabilidad(Id: string, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.eliminarRecargaTarifaPrecioInteroperabilidad(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Encola un job Quartz para ejecución a demanda
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encolarTareaProgramada(Id: number, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.encolarTareaProgramada(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envía un mensaje al chat de una OCA.
         * @param {EnviarMensajeOcaModel} [EnviarMensajeOcaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarMensajeOca(EnviarMensajeOcaModel?: EnviarMensajeOcaModel, options?: any): AxiosPromise<void> {
            return localVarFp.enviarMensajeOca(EnviarMensajeOcaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo equipo medida
         * @param {CreateEquipoMedidaModel} [CreateEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaCreate(CreateEquipoMedidaModel?: CreateEquipoMedidaModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.equipoMedidaCreate(CreateEquipoMedidaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Borra un equipo de medida
         * @param {DeleteEquipoMedidaModel} [DeleteEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaDelete(DeleteEquipoMedidaModel?: DeleteEquipoMedidaModel, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.equipoMedidaDelete(DeleteEquipoMedidaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un equipo de medida existente
         * @param {EditEquipoMedidaModel} [EditEquipoMedidaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaEdit(EditEquipoMedidaModel?: EditEquipoMedidaModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.equipoMedidaEdit(EditEquipoMedidaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de equipos de medida compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdPdsActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        equipoMedidaGetRejilla(LoadOptions?: DXLoadOptions, IdPdsActuacion?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.equipoMedidaGetRejilla(LoadOptions, IdPdsActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validar que una actuacion no tenga wo\'s del mismo tipo con el mismo activo
         * @param {string} [IdActuacion] 
         * @param {string} [IdActivo] 
         * @param {TipoWoEnum} [TipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existeCargadorAndTipoEnActuacion(IdActuacion?: string, IdActivo?: string, TipoWo?: TipoWoEnum, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.existeCargadorAndTipoEnActuacion(IdActuacion, IdActivo, TipoWo, options).then((request) => request(axios, basePath));
        },
        /**
         * GET de solo lectura. data=true si hay un cargador activo con ese numeroSerie; data=false si no existe y el SN puede usarse como numeroSerieNuevo en sustitución.
         * @summary Indica si un número de serie ya existe como cargador activo (solo consulta, sin efectos laterales)
         * @param {string} [NumeroSerie] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existeNumeroSerieExterno(NumeroSerie?: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.existeNumeroSerieExterno(NumeroSerie, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet(FeatureName: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.featuresGet(FeatureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList(options?: any): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.featuresList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtienen las fechas de importacioón
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fechasImportacion(options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.fechasImportacion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Firma una actuacion existente
         * @param {FirmarActuacionModel} [FirmarActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarActuacion(FirmarActuacionModel?: FirmarActuacionModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.firmarActuacion(FirmarActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetCalculoEconomicoActuacion
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInformeEconomicoActuacion(Id: string, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.generateInformeEconomicoActuacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Genera el informe técnico de una work order
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInformeTecnicoWo(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.generateInformeTecnicoWo(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de los activos para la creación de actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [Direccion] 
         * @param {string} [IdUbicacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivosActuacion(LoadOptions?: DXLoadOptions, Direccion?: string, IdUbicacion?: string, options?: any): AxiosPromise<ActivosActuacionRmListResponseDTO> {
            return localVarFp.getActivosActuacion(LoadOptions, Direccion, IdUbicacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones abiertas
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActuacionesAbiertas(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: any): AxiosPromise<GetListadoActuacionesExternasResponseResponseDTO> {
            return localVarFp.getActuacionesAbiertas(Page, PageSize, FechaUltimaActualizacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones cerradas
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActuacionesCerradas(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: any): AxiosPromise<GetListadoActuacionesExternasResponseResponseDTO> {
            return localVarFp.getActuacionesCerradas(Page, PageSize, FechaUltimaActualizacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
         * @summary Obtiene actuaciones con incidencia
         * @param {number} [Page] 
         * @param {number} [PageSize] 
         * @param {Date} [FechaUltimaActualizacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActuacionesConIncidencia(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: any): AxiosPromise<GetListadoActuacionesExternasResponseResponseDTO> {
            return localVarFp.getActuacionesConIncidencia(Page, PageSize, FechaUltimaActualizacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de business models para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBusinessModelsForCombo(options?: any): AxiosPromise<BusinessModelComboRmListResponseDTO> {
            return localVarFp.getAllBusinessModelsForCombo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de partners para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPartnersForCombo(options?: any): AxiosPromise<PartnerComboRmListResponseDTO> {
            return localVarFp.getAllPartnersForCombo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de provincias para desplegables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProvincias(options?: any): AxiosPromise<ProvinciaComboRmListResponseDTO> {
            return localVarFp.getAllProvincias(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsignacionesInteroperabilidadForGrid(Options?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getAsignacionesInteroperabilidadForGrid(Options, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene campañas para selector, cuyo estado no es el de borrador
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampanas(options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getCampanas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de campañas para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampanasForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCampanasForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los canales de entrada del ticket (SAT)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanalesEntrada(options?: any): AxiosPromise<CanalEntradaRmListResponseDTO> {
            return localVarFp.getCanalesEntrada(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el histórico de cambios de agrupación de estado de un cargador para DevExtreme
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadorHistoricoEstadoGrid(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadorHistoricoEstadoGrid(IdCargador, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los periodos privados de un cargador para DevExtreme
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadorPeriodosPrivadoGrid(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadorPeriodosPrivadoGrid(IdCargador, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresAll(Take?: number, Skip?: number, options?: any): AxiosPromise<GetCargadoresModelResponseDTO> {
            return localVarFp.getCargadoresAll(Take, Skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores de los tenants seleccionados, utilizando paginación
         * @param {string} [TenantIds] 
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresByTenantId(TenantIds?: string, Take?: number, Skip?: number, options?: any): AxiosPromise<GetCargadoresModelResponseDTO> {
            return localVarFp.getCargadoresByTenantId(TenantIds, Take, Skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores involucraddos en una campaña para la grid de Devextreme, con filtros extras.
         * @param {string} Id 
         * @param {Array<string>} [IdsPds] 
         * @param {Array<string>} [IdsPartner] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresCampanaForGrid(Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadoresCampanaForGrid(Id, IdsPds, IdsPartner, IdsProvincia, IdsZona, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los cargadores asociados a un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresCentroTransformacion(Id: string, options?: any): AxiosPromise<CargadorAsociadoEntidadOcaModelListResponseDTO> {
            return localVarFp.getCargadoresCentroTransformacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los cargadores de la IV con su estado y aptitud actuales y sus WO asignadas.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresComplianceInspeccionVisual(Id: string, options?: any): AxiosPromise<CargadoresComplianceInspeccionVisualDtoResponseDTO> {
            return localVarFp.getCargadoresComplianceInspeccionVisual(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores dismissed para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresDismissedForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadoresDismissedForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de todos los cargadores de Enel, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresEnel(Take?: number, Skip?: number, options?: any): AxiosPromise<GetCargadoresModelResponseDTO> {
            return localVarFp.getCargadoresEnel(Take, Skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadoresForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de cargadores para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresForGridAdmin(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadoresForGridAdmin(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de cargadores, con paginación opcional
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresMobility(Take?: number, Skip?: number, options?: any): AxiosPromise<CargadoresMobilityModelResponseDTO> {
            return localVarFp.getCargadoresMobility(Take, Skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtiene un listado de los cargadores, ordneados por los suscritos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresOrderSuscrito(LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadoresOrderSuscrito(LoadOptions, IdUsuario, Email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtienen los cargadores
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresRm(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadoresRm(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene cargadores sin ubicación asignada.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresSinUbicacionForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getCargadoresSinUbicacionForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los cargadores asociados a una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadoresUbicacion(Id: string, options?: any): AxiosPromise<CargadorAsociadoEntidadOcaModelListResponseDTO> {
            return localVarFp.getCargadoresUbicacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de los casos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCasos(options?: any): AxiosPromise<CasosRmListResponseDTO> {
            return localVarFp.getCasos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo de ítems de correctivas de Elecnor según la actuación
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsCorrectivasElecnor(IdActuacion?: string, options?: any): AxiosPromise<ItemCorrectivoElecnorDtoListResponseDTO> {
            return localVarFp.getCatalogoItemsCorrectivasElecnor(IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo de materiales CIRCUTOR según actuación y tipo de WO
         * @param {string} [IdActuacion] 
         * @param {number} [IdTipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsMaterialesCircutor(IdActuacion?: string, IdTipoWo?: number, options?: any): AxiosPromise<ItemMaterialCircutorDtoListResponseDTO> {
            return localVarFp.getCatalogoItemsMaterialesCircutor(IdActuacion, IdTipoWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo de materiales Elecnor (BT5) según actuación y tipo de WO
         * @param {string} [IdActuacion] 
         * @param {number} [IdTipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsMaterialesElecnor(IdActuacion?: string, IdTipoWo?: number, options?: any): AxiosPromise<ItemMaterialElecnorDtoListResponseDTO> {
            return localVarFp.getCatalogoItemsMaterialesElecnor(IdActuacion, IdTipoWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo de ítems de preventivas de Elecnor según la actuación
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoItemsPreventivasElecnor(IdActuacion?: string, options?: any): AxiosPromise<ItemPreventivoElecnorDtoListResponseDTO> {
            return localVarFp.getCatalogoItemsPreventivasElecnor(IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentroTransformacionById(Id: string, options?: any): AxiosPromise<CentroTransformacionRmResponseDTO> {
            return localVarFp.getCentroTransformacionById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de coches eléctricos, con paginación opcional
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCochesElectricosMobility(Take?: number, Skip?: number, options?: any): AxiosPromise<CargadoresMobilityModelResponseDTO> {
            return localVarFp.getCochesElectricosMobility(Take, Skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado DevExtreme de la cola de jobs lanzados a demanda
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColaTareaProgramadaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getColaTareaProgramadaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las colas de los usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColaUsuario(options?: any): AxiosPromise<ColaUsuarioRmListResponseDTO> {
            return localVarFp.getColaUsuario(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la rejilla de ALTAS de activos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparacionActivosAltaForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getComparacionActivosAltaForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la rejilla de BAJAS de activos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparacionActivosBajaForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getComparacionActivosBajaForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la configuración de los adjuntos de actuación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosActuacion(options?: any): AxiosPromise<ConfiguracionAdjuntosActuacionModelListResponseDTO> {
            return localVarFp.getConfiguracionAdjuntosActuacion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de centro de transformación OCA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosCentroTransformacion(options?: any): AxiosPromise<ConfiguracionAdjuntosCentroTransformacionModelListResponseDTO> {
            return localVarFp.getConfiguracionAdjuntosCentroTransformacion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de ticket (categorías fijas).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosTicket(options?: any): AxiosPromise<ConfiguracionAdjuntosTicketModelListResponseDTO> {
            return localVarFp.getConfiguracionAdjuntosTicket(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de ubicación OCA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosUbicacion(options?: any): AxiosPromise<ConfiguracionAdjuntosUbicacionModelListResponseDTO> {
            return localVarFp.getConfiguracionAdjuntosUbicacion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la configuración de adjuntos de visita OCA.
         * @param {boolean} [EsCentroTransformacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosVisita(EsCentroTransformacion?: boolean, options?: any): AxiosPromise<ConfiguracionAdjuntosVisitaModelListResponseDTO> {
            return localVarFp.getConfiguracionAdjuntosVisita(EsCentroTransformacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la configuración de los adjuntos de las work order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguracionAdjuntosWo(options?: any): AxiosPromise<ConfiguracionAdjuntosWoModelListResponseDTO> {
            return localVarFp.getConfiguracionAdjuntosWo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard de activos.
         * @param {Array<string>} [IdsPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [IdTipoInfraestructuraCargador] 
         * @param {boolean} [SoloConTicketsAbiertos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardActivos(IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, options?: any): AxiosPromise<DashboardActivosModelResponseDTO> {
            return localVarFp.getDashboardActivos(IdsPartner, IdProvincia, IdZona, IdTipoInfraestructuraCargador, SoloConTicketsAbiertos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de activos para una columna del dashboard (OK, UNAVAILABLE, KO o DISMISSED).
         * @param {Array<string>} [IdsPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [IdTipoInfraestructuraCargador] 
         * @param {boolean} [SoloConTicketsAbiertos] 
         * @param {string} [EstadoAgrupacion] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardActivosForGrid(IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, EstadoAgrupacion?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getDashboardActivosForGrid(IdsPartner, IdProvincia, IdZona, IdTipoInfraestructuraCargador, SoloConTicketsAbiertos, EstadoAgrupacion, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos para el dashboard de la campaña dado su id, y filtros extras.
         * @param {string} Id 
         * @param {Array<string>} [IdsPds] 
         * @param {Array<string>} [IdsPartner] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCampana(Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, options?: any): AxiosPromise<DashboardCampanaModelResponseDTO> {
            return localVarFp.getDashboardCampana(Id, IdsPds, IdsPartner, IdsProvincia, IdsZona, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los KPIs GMAO del dashboard (asistencia, preventivos, OCAs, equipos, IV KIM y energía).
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardKpiGmao(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: any): AxiosPromise<DashboardKpiGmaoModelResponseDTO> {
            return localVarFp.getDashboardKpiGmao(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard de OCAs.
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {number} [AnioDesde] 
         * @param {number} [AnioHasta] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardOcas(IdTipoOca?: TipoOcaEnum, IdProvincia?: number, IdZona?: number, AnioDesde?: number, AnioHasta?: number, options?: any): AxiosPromise<DashboardOcasModelResponseDTO> {
            return localVarFp.getDashboardOcas(IdTipoOca, IdProvincia, IdZona, AnioDesde, AnioHasta, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo de deficiencias de calidad del compliance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeficienciasCompliance(options?: any): AxiosPromise<DeficienciaComplianceRmListResponseDTO> {
            return localVarFp.getDeficienciasCompliance(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo de deficiencias de visita OCA.
         * @param {string} [Ambito] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeficienciasVisitaMaestra(Ambito?: string, options?: any): AxiosPromise<DeficienciaVisitaMaestraModelListResponseDTO> {
            return localVarFp.getDeficienciasVisitaMaestra(Ambito, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una actuacion por id
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleActuacion(IdActuacion?: string, options?: any): AxiosPromise<DetailActuacionModelResponseDTO> {
            return localVarFp.getDetalleActuacion(IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una campaña por id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleCampana(Id: string, options?: any): AxiosPromise<DetailCampanaModelResponseDTO> {
            return localVarFp.getDetalleCampana(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el partner dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetallePartnerById(Id: string, options?: any): AxiosPromise<DetailPartnerModelResponseDTO> {
            return localVarFp.getDetallePartnerById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle del ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleTicket(IdTicket?: string, options?: any): AxiosPromise<DetalleTicketRmResponseDTO> {
            return localVarFp.getDetalleTicket(IdTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una wo por id
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleWo(IdWo?: string, options?: any): AxiosPromise<DetailWoModelResponseDTO> {
            return localVarFp.getDetalleWo(IdWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las WO cerradas y rechazadas de un técnico para el periodo del maestro de pagos
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {string} [IdTecnico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleWosTecnicoMaestroPagos(FechaPeriodo?: Date, IdPds?: string, IdTecnico?: string, options?: any): AxiosPromise<DetalleWosTecnicoMaestroPagosModelResponseDTO> {
            return localVarFp.getDetalleWosTecnicoMaestroPagos(FechaPeriodo, IdPds, IdTecnico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el cargador dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetallecargadorById(Id: string, options?: any): AxiosPromise<DetailCargadorModelResponseDTO> {
            return localVarFp.getDetallecargadorById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el poi dado su id de cargador
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetallecargadorPoiById(Id: string, options?: any): AxiosPromise<DetailCargadorPoiModelResponseDTO> {
            return localVarFp.getDetallecargadorPoiById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los documentos de visita asociados a una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosAsociadosOca(Id: string, options?: any): AxiosPromise<DocumentosAsociadosOcaResponseDTO> {
            return localVarFp.getDocumentosAsociadosOca(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los documentos para la wo seleccionada
         * @param {string} [IdWorkOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosAsociadosWo(IdWorkOrder?: string, options?: any): AxiosPromise<DocumentosAsociadosWoResponseDTO> {
            return localVarFp.getDocumentosAsociadosWo(IdWorkOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los valores de un enum.
         * @param {string} [TipoEnum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnumGenerico(TipoEnum?: string, options?: any): AxiosPromise<IdNameItemListResponseDTO> {
            return localVarFp.getEnumGenerico(TipoEnum, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los id de equipos de medida del prestador del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquiposMedida(options?: any): AxiosPromise<GetEquiposMedidaPorPdsUsuarioResponseResponseDTO> {
            return localVarFp.getEquiposMedida(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el esquema unifilar de la ubicación del activo, si existe.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEsquemaUnifilarUbicacionActivo(Id: string, options?: any): AxiosPromise<EsquemaUnifilarUbicacionActivoModelResponseDTO> {
            return localVarFp.getEsquemaUnifilarUbicacionActivo(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene estadísticas por técnico del prestador para el periodo (WO cerradas/rechazadas, % incidencia y media)
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadisticasTecnicosMaestroPagos(FechaPeriodo?: Date, IdPds?: string, options?: any): AxiosPromise<EstadisticasTecnicoMaestroPagosModelListResponseDTO> {
            return localVarFp.getEstadisticasTecnicosMaestroPagos(FechaPeriodo, IdPds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado DevExtreme del catálogo de tareas programadas y su última ejecución
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadoTareaProgramadaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getEstadoTareaProgramadaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los estados de ticket
         * @param {boolean} [IncluirEstadoCerrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstadosTicket(IncluirEstadoCerrado?: boolean, options?: any): AxiosPromise<EstadoTicketsRmListResponseDTO> {
            return localVarFp.getEstadosTicket(IncluirEstadoCerrado, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los eventos de un cargador ordenados por fecha descendente
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventosByCargador(IdCargador?: string, options?: any): AxiosPromise<CargadorEventoRmListResponseDTO> {
            return localVarFp.getEventosByCargador(IdCargador, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de un centro de transformación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFicherosAdjuntosCentroTransformacion(Id: string, options?: any): AxiosPromise<AdjuntoCentroTransformacionModelListResponseDTO> {
            return localVarFp.getFicherosAdjuntosCentroTransformacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFicherosAdjuntosUbicacion(Id: string, options?: any): AxiosPromise<AdjuntoUbicacionModelListResponseDTO> {
            return localVarFp.getFicherosAdjuntosUbicacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los ficheros adjuntos de una visita OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFicherosAdjuntosVisita(Id: string, options?: any): AxiosPromise<AdjuntoVisitaModelListResponseDTO> {
            return localVarFp.getFicherosAdjuntosVisita(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de tickets para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGestionTicketsForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getGestionTicketsForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de gestores GMAO para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGestorGmaoSelectBox(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getGestorGmaoSelectBox(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el estado actual de WOs agrupado por tipo de WO
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraficaEstadoActualWos(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: any): AxiosPromise<GraficaEstadoActualWoRmListResponseDTO> {
            return localVarFp.getGraficaEstadoActualWos(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la media de retraso de WOs por tipo de WO y mes
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {string} [IdPds] 
         * @param {Array<string>} [IdPartner] 
         * @param {number} [IdProvincia] 
         * @param {number} [IdZona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraficaRetrasosWos(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: any): AxiosPromise<GraficaRetrasosWosMediaRmListResponseDTO> {
            return localVarFp.getGraficaRetrasosWos(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridUsuariosGmao(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getGridUsuariosGmao(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridUsuariosGmaoConCola(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getGridUsuariosGmaoConCola(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado grupos de actuaciones en una campaña para la grid de Devextreme.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGruposActuacionesForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getGruposActuacionesForGrid(Id, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {string} [TipoEntidad] 
         * @param {string} [EntidadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricoInteroperabilidadForGrid(Options?: DXLoadOptions, TipoEntidad?: string, EntidadId?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getHistoricoInteroperabilidadForGrid(Options, TipoEntidad, EntidadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el histórico de OCAs de la misma ubicación con visitas y ficheros adjuntos.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricoOcasUbicacion(Id: string, options?: any): AxiosPromise<HistoricoOcasUbicacionModelResponseDTO> {
            return localVarFp.getHistoricoOcasUbicacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el historico de mensajes del ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricoTicket(IdTicket?: string, options?: any): AxiosPromise<CargadorEventoRmListResponseDTO> {
            return localVarFp.getHistoricoTicket(IdTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un registro de importación de partners por su id de correlación (GUID).
         * @param {string} Correlacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportacionPartnersByCorrelacion(Correlacion: string, options?: any): AxiosPromise<ImportacionPartnersModelResponseDTO> {
            return localVarFp.getImportacionPartnersByCorrelacion(Correlacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos del informe técnico (wizard) de una inspección visual.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformeTecnicoInspeccionVisual(Id: string, options?: any): AxiosPromise<InspeccionVisualDetalleModelResponseDTO> {
            return localVarFp.getInformeTecnicoInspeccionVisual(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los informes asociados a la actuacion
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformesAsociadosActuacion(IdActuacion?: string, options?: any): AxiosPromise<InformesActuacionRmListResponseDTO> {
            return localVarFp.getInformesAsociadosActuacion(IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una inspección visual (cabecera, cargadores y respuestas).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspeccionVisualDetalle(Id: string, options?: any): AxiosPromise<InspeccionVisualDetalleModelResponseDTO> {
            return localVarFp.getInspeccionVisualDetalle(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los tipos de intervalo permitidos al crear o editar una inspección visual.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntervalosInspeccionVisual(options?: any): AxiosPromise<IdNameItemListResponseDTO> {
            return localVarFp.getIntervalosInspeccionVisual(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los items económicos compatibles con la potencia del cargador
         * @param {string} [IdCargador] 
         * @param {TipoWoEnum} [TipoWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemsEconomicosCompatibles(IdCargador?: string, TipoWo?: TipoWoEnum, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.getItemsEconomicosCompatibles(IdCargador, TipoWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios KIM para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKimSelectBox(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getKimSelectBox(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado anual de MaestroPagos con RazonSocial, ImporteReal, Mes y Anio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoAnualMaestroPagos(options?: any): AxiosPromise<MaestroPagosPorPdsMesRmListResponseDTO> {
            return localVarFp.getListadoAnualMaestroPagos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de centros de transformación OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoCentrosTransformacionForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoCentrosTransformacionForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado de inspecciones visuales para grid DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoInspeccionesVisualesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado de inspecciones visuales en las que está incluido el cargador, con Nº KOs del activo.
         * @param {string} IdCargador 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoInspeccionesVisualesPorCargadorForGrid(IdCargador: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoInspeccionesVisualesPorCargadorForGrid(IdCargador, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de MaestroPagosInspeccionesVisuales compatible con DevExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoMaestroPagosInspeccionesVisualesForGrid(FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoMaestroPagosInspeccionesVisualesForGrid(FechaInicio, FechaFin, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de OCAs para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoOcasForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoOcasForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado de OCAs para rejilla con filtros adicionales desde el seguimiento de ocas.
         * @param {OcaSeguimientoTipoEnum} [Tipo] 
         * @param {string} [Kpi] 
         * @param {string} [EstadoInicial] 
         * @param {string} [EstadoTransitado] 
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoOcasSeguimientoForGrid(Tipo?: OcaSeguimientoTipoEnum, Kpi?: string, EstadoInicial?: string, EstadoTransitado?: string, AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoOcasSeguimientoForGrid(Tipo, Kpi, EstadoInicial, EstadoTransitado, AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado de PDS tipo Inspecciones visuales para select.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoPdsInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoPdsInspeccionesVisualesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de PDS con tipo prestador OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoPdsOcaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoPdsOcaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado unificado de actuaciones e inspecciones visuales del técnico
         * @param {string} [TrabajoTecnicoType] 
         * @param {number} [IdTrabajoTecnicoSortEnum] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoTrabajoTecnico(TrabajoTecnicoType?: string, IdTrabajoTecnicoSortEnum?: number, options?: any): AxiosPromise<ListadoTrabajoTecnicoDtoListResponseDTO> {
            return localVarFp.getListadoTrabajoTecnico(TrabajoTecnicoType, IdTrabajoTecnicoSortEnum, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de ubicaciones OCA para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoUbicacionesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoUbicacionesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado de ubicaciones para select de inspecciones visuales.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoUbicacionesInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getListadoUbicacionesInspeccionesVisualesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el medallero de pagos para un PDS en un periodo
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedalleroPorPds(FechaPeriodo?: Date, IdPds?: string, options?: any): AxiosPromise<MedalleroPorPdsModelResponseDTO> {
            return localVarFp.getMedalleroPorPds(FechaPeriodo, IdPds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS
         * @param {number} [Mes] 
         * @param {number} [Anyo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMedalleroMensualPds(Mes?: number, Anyo?: number, options?: any): AxiosPromise<MediaMensualPdsAnonimizadoModelListResponseDTO> {
            return localVarFp.getMediaMedalleroMensualPds(Mes, Anyo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS por rango de fecha
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMedalleroMensualPdsPorRangoFecha(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options?: any): AxiosPromise<MediaMedalleroPdsPorMesModelListResponseDTO> {
            return localVarFp.getMediaMedalleroMensualPdsPorRangoFecha(MesInicio, AnioInicio, MesFin, AnioFin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS por rango de fecha
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMedalleroMensualPdsPorRangoFechaPorPds(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, IdPds?: string, options?: any): AxiosPromise<MediaMedalleroPdsPorMesModelListResponseDTO> {
            return localVarFp.getMediaMedalleroMensualPdsPorRangoFechaPorPds(MesInicio, AnioInicio, MesFin, AnioFin, IdPds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la media mensual de todos los PDS anonimizados, mostrando el nombre real solo para el PDS solicitado
         * @param {number} [Mes] 
         * @param {number} [Anyo] 
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaMensualPdsAnonimizado(Mes?: number, Anyo?: number, IdPds?: string, options?: any): AxiosPromise<MediaMensualPdsAnonimizadoModelListResponseDTO> {
            return localVarFp.getMediaMensualPdsAnonimizado(Mes, Anyo, IdPds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los mensajes del chat de una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMensajesOca(Id: string, options?: any): AxiosPromise<MensajeOcaModelListResponseDTO> {
            return localVarFp.getMensajesOca(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el modelo de pago del prestador seleccionado o del propio usuario
         * @param {string} [IdPds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeloPagoPrestador(IdPds?: string, options?: any): AxiosPromise<ModeloPagoEnumResponseDTO> {
            return localVarFp.getModeloPagoPrestador(IdPds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las modificaciones de CPs por periodo
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModificacionesActivosPeriodoForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getModificacionesActivosPeriodoForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los ids de los motivos de cierre para la wo seleccionada
         * @param {string} [IdWorkOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotivosCierreFromWo(IdWorkOrder?: string, options?: any): AxiosPromise<Int32ListResponseDTO> {
            return localVarFp.getMotivosCierreFromWo(IdWorkOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los motivos de cierre de Wo para correctivo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotivosCierreWoCorrectivo(options?: any): AxiosPromise<MotivoCierreWoRmListResponseDTO> {
            return localVarFp.getMotivosCierreWoCorrectivo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMspsInteroperabilidadForGrid(Options?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getMspsInteroperabilidadForGrid(Options, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMspsInteroperabilidadLista(options?: any): AxiosPromise<MspRmListResponseDTO> {
            return localVarFp.getMspsInteroperabilidadLista(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado de notificaciones del usuario actual (sin leer y leídas).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificaciones(options?: any): AxiosPromise<GetNotificacionesModelResponseDTO> {
            return localVarFp.getNotificaciones(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las observaciones internas de gestores GMAO de una OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservacionesOca(Id: string, options?: any): AxiosPromise<ObservacionOcaModelListResponseDTO> {
            return localVarFp.getObservacionesOca(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una OCA de centro de transformación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaDetailCentroTransformacion(Id: string, options?: any): AxiosPromise<OcaDetailCentroTransformacionModelResponseDTO> {
            return localVarFp.getOcaDetailCentroTransformacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una OCA de ubicación con sus ficheros.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaDetailUbicacion(Id: string, options?: any): AxiosPromise<OcaDetailModelResponseDTO> {
            return localVarFp.getOcaDetailUbicacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la composición semanal de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [NumSemanas] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoComposicionSemanal(NumSemanas?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: any): AxiosPromise<OcaSeguimientoComposicionSemanalModelResponseDTO> {
            return localVarFp.getOcaSeguimientoComposicionSemanal(NumSemanas, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el heatmap de visitas de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoHeatmapVisita(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: any): AxiosPromise<OcaSeguimientoHeatmapVisitaModelResponseDTO> {
            return localVarFp.getOcaSeguimientoHeatmapVisita(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la información de los KPIs de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoKpis(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: any): AxiosPromise<OcaSeguimientoKpisModelResponseDTO> {
            return localVarFp.getOcaSeguimientoKpis(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Catálogo de semanas para seguimiento de ocas, ordenadas por año y semana descendientes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoSemanas(options?: any): AxiosPromise<OcaSeguimientoSemanaModelIEnumerableResponseDTO> {
            return localVarFp.getOcaSeguimientoSemanas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las transiciones de seguimiento de ocas, con los filtros proporcionados.
         * @param {number} [AnioComparacion] 
         * @param {number} [SemanaComparacion] 
         * @param {TipoOcaEnum} [IdTipoOca] 
         * @param {Array<number>} [IdsProvincia] 
         * @param {Array<number>} [IdsZona] 
         * @param {number} [AnioReferencia] 
         * @param {number} [SemanaReferencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcaSeguimientoTransiciones(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: any): AxiosPromise<OcaSeguimientoTransicionesModelResponseDTO> {
            return localVarFp.getOcaSeguimientoTransiciones(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los origenes de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrigenesTicket(options?: any): AxiosPromise<OrigenTicketsRmListResponseDTO> {
            return localVarFp.getOrigenesTicket(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rejilla de instalaciones B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cInstalaciones(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPagosB2cInstalaciones(Anio, Mes, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lista los meses ya importados de pagos B2C.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cMeses(options?: any): AxiosPromise<B2cMesImportadoRmListResponseDTO> {
            return localVarFp.getPagosB2cMeses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rejilla de Pdte C3 B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cPdteC3(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPagosB2cPdteC3(Anio, Mes, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rejilla de reparaciones B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cReparaciones(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPagosB2cReparaciones(Anio, Mes, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rejilla de visitas B2C por mes.
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagosB2cVisitas(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPagosB2cVisitas(Anio, Mes, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de devengado mensual por partner para la rejilla general.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnerDevengadoForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el devengado agrupado por partner, año, sociedad y región.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoPorAnioForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnerDevengadoPorAnioForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el devengado agrupado por sociedad y año.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoPorSociedadAnioForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnerDevengadoPorSociedadAnioForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el devengado agrupado por sociedad y mes.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDevengadoPorSociedadForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnerDevengadoPorSociedadForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de partners para el usuario
         * @param {string} [IdUsuarioBd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPorUsuarioBd(IdUsuarioBd?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnerPorUsuarioBd(IdUsuarioBd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de partners para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnersForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de partners para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersForGridAdmin(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnersForGridAdmin(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de partners para el usuario
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersPorUsuario(IdUsuario?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnersPorUsuario(IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el partner asociado al usuario BD
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersPorUsuarioBdForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnersPorUsuarioBdForGrid(LoadOptions, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de partners asociado al usuario
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersPorUsuarioForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPartnersPorUsuarioForGrid(LoadOptions, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los pds asogiados a un código postal concreto, por tipo de prestador
         * @param {string} [CodigoPostal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdsByCodigoPostal(CodigoPostal?: string, options?: any): AxiosPromise<PdsByCodigoPostalModelResponseDTO> {
            return localVarFp.getPdsByCodigoPostal(CodigoPostal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el pds dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdsById(Id: string, options?: any): AxiosPromise<PdsModelResponseDTO> {
            return localVarFp.getPdsById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de pds asociado al usuario
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdsPorUsuarioForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPdsPorUsuarioForGrid(LoadOptions, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las piezas de Wo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiezasWo(options?: any): AxiosPromise<PiezaWoRmListResponseDTO> {
            return localVarFp.getPiezasWo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inspecciones de un técnico en una fecha, con su orden de visita.
         * @param {string} [IdTecnico] 
         * @param {string} [FechaProgramada] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanificacionTecnicoInspeccionVisual(IdTecnico?: string, FechaProgramada?: string, options?: any): AxiosPromise<PlanificacionTecnicoInspeccionVisualModelListResponseDTO> {
            return localVarFp.getPlanificacionTecnicoInspeccionVisual(IdTecnico, FechaProgramada, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} IdTarifa 
         * @param {string} [TipoPotencia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrecioReferenciaInteroperabilidad(IdTarifa: string, TipoPotencia?: string, options?: any): AxiosPromise<PrecioReferenciaInteroperabilidadResponseDTO> {
            return localVarFp.getPrecioReferenciaInteroperabilidad(IdTarifa, TipoPotencia, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreciosInteroperabilidadForGrid(Options?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getPreciosInteroperabilidadForGrid(Options, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las prioridades de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrioridadesTicket(options?: any): AxiosPromise<PrioridadTicketsRmListResponseDTO> {
            return localVarFp.getPrioridadesTicket(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Indica si se muestra la columna de estado en la rejilla de WO Revenue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPuedeVerEstadoWoRevenue(options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.getPuedeVerEstadoWoRevenue(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el rango de fechas límite de OCAs accesibles para el usuario.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRangoFechaLimiteOcas(options?: any): AxiosPromise<RangoFechaLimiteOcasModelResponseDTO> {
            return localVarFp.getRangoFechaLimiteOcas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las recargas
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecargasGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRecargasGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las recargas
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecargasGridAdmin(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRecargasGridAdmin(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el recuento de activos por periodo
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [PeriodoSemanaIni] 
         * @param {number} [PeriodoAnoIni] 
         * @param {number} [PeriodoSemanaFin] 
         * @param {number} [PeriodoAnoFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecuentoActivosPeriodoForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRecuentoActivosPeriodoForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las semanas de recuento de activos disponibles para selector
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecuentoActivosSemanasSelector(options?: any): AxiosPromise<RecuentoActivosSemanaSelectorRmListResponseDTO> {
            return localVarFp.getRecuentoActivosSemanasSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaPeriodo] 
         * @param {string} [IdPds] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaMaestroPagosPorPrestador(FechaPeriodo?: Date, IdPds?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRejillaMaestroPagosPorPrestador(FechaPeriodo, IdPds, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaPeriodo] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaMaestroPagosPorPrestadorPds(FechaPeriodo?: Date, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRejillaMaestroPagosPorPrestadorPds(FechaPeriodo, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de las piezas de Wo compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaPiezasWo(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRejillaPiezasWo(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRejillaWoPorTicket(LoadOptions?: DXLoadOptions, IdTicket?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRejillaWoPorTicket(LoadOptions, IdTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsablesPrestadorSelectBox(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getResponsablesPrestadorSelectBox(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de responsables de provincias para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsablesProvinciasSelectBox(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getResponsablesProvinciasSelectBox(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el resumen de horas por cola para un ticket
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumenTiempoColas(IdTicket?: string, options?: any): AxiosPromise<ResumenTiempoColasTicketRmListResponseDTO> {
            return localVarFp.getResumenTiempoColas(IdTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos agregados para las gráficas donut del dashboard revenue (variable/fijo).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueDashboardGraficas(options?: any): AxiosPromise<RevenueDashboardGraficasRmResponseDTO> {
            return localVarFp.getRevenueDashboardGraficas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue para la rejilla general del dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRevenueInformesDashboardForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por año, partner, región y sociedad para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardPorAnioForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRevenueInformesDashboardPorAnioForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por sociedad y año para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardPorSociedadAnioForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRevenueInformesDashboardPorSociedadAnioForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de informes revenue agrupados por sociedad y periodo para el dashboard.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueInformesDashboardPorSociedadForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRevenueInformesDashboardPorSociedadForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Indica si el usuario revenue self puede ver Work Orders y sustituciones (al menos un partner privado).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueSelfPuedeVerWoSustituciones(options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.getRevenueSelfPuedeVerWoSustituciones(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el siguiente cargador del wizard de informe técnico.
         * @param {string} Id 
         * @param {string} [IdCargadorActual] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteCargadorInformeTecnicoIv(Id: string, IdCargadorActual?: string, options?: any): AxiosPromise<DatosSiguienteCargadorIvModelResponseDTO> {
            return localVarFp.getSiguienteCargadorInformeTecnicoIv(Id, IdCargadorActual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
         * @param {number} [IdNumerico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteComplianceWo(IdNumerico?: number, options?: any): AxiosPromise<DatosSiguienteComplianceResponseDTO> {
            return localVarFp.getSiguienteComplianceWo(IdNumerico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo de la actuación seleccionada
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteWoFromActuacion(IdActuacion?: string, options?: any): AxiosPromise<DatosSiguienteWoResponseDTO> {
            return localVarFp.getSiguienteWoFromActuacion(IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiguienteWoFromWo(IdWo?: string, options?: any): AxiosPromise<DatosSiguienteWoResponseDTO> {
            return localVarFp.getSiguienteWoFromWo(IdWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los subestados de ticket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubestadosTicket(options?: any): AxiosPromise<SubestadoTicketsRmListResponseDTO> {
            return localVarFp.getSubestadosTicket(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de suscripciones para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuscripcionesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getSuscripcionesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DXLoadOptions} [Options] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTarifasInteroperabilidadForGrid(Options?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTarifasInteroperabilidadForGrid(Options, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTarifasInteroperabilidadLista(options?: any): AxiosPromise<RecargaTarifaRmListResponseDTO> {
            return localVarFp.getTarifasInteroperabilidadLista(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTecnicosPrestadorSelectBox(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTecnicosPrestadorSelectBox(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de todos los tenants, utilizando paginación
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenants(Take?: number, Skip?: number, options?: any): AxiosPromise<GetTenantsModelResponseDTO> {
            return localVarFp.getTenants(Take, Skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtiene un listado de los tenants, ordneados por los suscritos
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantsOrderSuscrito(LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTenantsOrderSuscrito(LoadOptions, IdUsuario, Email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtienen los tenant
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantsRm(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTenantsRm(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tickets y KO asociados del compliance de una inspección visual.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsComplianceInspeccionVisualForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTicketsComplianceInspeccionVisualForGrid(Id, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo activo de tipología/subtipología de incidencia (selector unificado)
         * @param {boolean} [ExcluirSoloCreacionEdicion] 
         * @param {boolean} [SoloAsistenciaSat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipologiasSubtipologiasIncidencia(ExcluirSoloCreacionEdicion?: boolean, SoloAsistenciaSat?: boolean, options?: any): AxiosPromise<TipologiaSubtipologiaIncidenciaRmListResponseDTO> {
            return localVarFp.getTipologiasSubtipologiasIncidencia(ExcluirSoloCreacionEdicion, SoloAsistenciaSat, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Catálogo de tipologías/subtipologías de incidencia para tipificar WOs
         * @param {boolean} [ExcluirSoloCreacionEdicion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipologiasSubtipologiasIncidenciaExterno(ExcluirSoloCreacionEdicion?: boolean, options?: any): AxiosPromise<GetTipologiasSubtipologiasIncidenciaExternoResponseResponseDTO> {
            return localVarFp.getTipologiasSubtipologiasIncidenciaExterno(ExcluirSoloCreacionEdicion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el catálogo de tipos de infraestructura de cargador.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposInfraestructuraCargador(options?: any): AxiosPromise<TipoInfraestructuraCargadorModelIListResponseDTO> {
            return localVarFp.getTiposInfraestructuraCargador(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los tipos de ticket (asistencia / incidencia)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposTicket(options?: any): AxiosPromise<TipoTicketsRmListResponseDTO> {
            return localVarFp.getTiposTicket(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de tipos de indisponibilidad disponibles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposUnavailable(options?: any): AxiosPromise<CargadorTipoUnavailableDtoIListResponseDTO> {
            return localVarFp.getTiposUnavailable(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de los tipos de urgencia de actuación para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposUrgenciaActuacionSelector(options?: any): AxiosPromise<SelectBoxEntityModelArrayResponseDTO> {
            return localVarFp.getTiposUrgenciaActuacionSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de la transaccion dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaccionById(Id: string, options?: any): AxiosPromise<DetailTransaccionModelResponseDTO> {
            return localVarFp.getTransaccionById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las transacciones
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaccionesGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTransaccionesGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las transacciones
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaccionesGridAdmin(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTransaccionesGridAdmin(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una ubicación OCA.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUbicacionById(Id: string, options?: any): AxiosPromise<UbicacionRmResponseDTO> {
            return localVarFp.getUbicacionById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de las ubicaciones de los activos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUbicacionesActivos(options?: any): AxiosPromise<UbicacionesActivosRmListResponseDTO> {
            return localVarFp.getUbicacionesActivos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de gestores GMAO para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioBdSelectBox(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getUsuarioBdSelectBox(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para SelectBox
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosSelectBox(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getUsuariosSelectBox(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los id de usuarios técnicos del prestador del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosTecnicos(options?: any): AxiosPromise<GetUsuariosTecnicosPorPdsUsuarioResponseResponseDTO> {
            return localVarFp.getUsuariosTecnicos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos de la validacion de una actuacion
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionActuacion(IdActuacion?: string, options?: any): AxiosPromise<ValidacionWoRmListResponseDTO> {
            return localVarFp.getValidacionActuacion(IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos de la validacion de una wo
         * @param {string} [IdWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionWo(IdWo?: string, options?: any): AxiosPromise<ValidacionWoRmListResponseDTO> {
            return localVarFp.getValidacionWo(IdWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de las visitas de una OCA de centro de transformación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitasOcaCentroTransformacion(Id: string, options?: any): AxiosPromise<VisitaOcaDetailModelListResponseDTO> {
            return localVarFp.getVisitasOcaCentroTransformacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de las visitas de una OCA de ubicación con sus ficheros.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitasOcaUbicacion(Id: string, options?: any): AxiosPromise<VisitaOcaDetailModelListResponseDTO> {
            return localVarFp.getVisitasOcaUbicacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado agrupado por empresa con porcentaje e importe real
         * @param {number} [MesInicio] 
         * @param {number} [AnioInicio] 
         * @param {number} [MesFin] 
         * @param {number} [AnioFin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolumenPorEmpresasPorRangoFechas(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options?: any): AxiosPromise<GraficoVolumenPorEmpresaModelListResponseDTO> {
            return localVarFp.getVolumenPorEmpresasPorRangoFechas(MesInicio, AnioInicio, MesFin, AnioFin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de pds para el usuario
         * @param {string} [IdUsuario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getdPdsPorUsuario(IdUsuario?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getdPdsPorUsuario(IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GuardarMspInteroperabilidadModel} [GuardarMspInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarMspInteroperabilidad(GuardarMspInteroperabilidadModel?: GuardarMspInteroperabilidadModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.guardarMspInteroperabilidad(GuardarMspInteroperabilidadModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GuardarMspTarifaInteroperabilidadModel} [GuardarMspTarifaInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarMspTarifaInteroperabilidad(GuardarMspTarifaInteroperabilidadModel?: GuardarMspTarifaInteroperabilidadModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.guardarMspTarifaInteroperabilidad(GuardarMspTarifaInteroperabilidadModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Guarda el paso de un cargador del informe técnico (checks).
         * @param {string} Id 
         * @param {string} IdCargador 
         * @param {GuardarPasoInformeTecnicoIvModel} Datos 
         * @param {Array<File>} [Archivos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarPasoCargadorInformeTecnicoInspeccionVisual(Id: string, IdCargador: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.guardarPasoCargadorInformeTecnicoInspeccionVisual(Id, IdCargador, Datos, Archivos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Guarda el paso de ubicación del informe técnico (checks + incidencia).
         * @param {string} Id 
         * @param {GuardarPasoInformeTecnicoIvModel} Datos 
         * @param {Array<File>} [Archivos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarPasoUbicacionInformeTecnicoInspeccionVisual(Id: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.guardarPasoUbicacionInformeTecnicoInspeccionVisual(Id, Datos, Archivos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GuardarRecargaTarifaInteroperabilidadModel} [GuardarRecargaTarifaInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarRecargaTarifaInteroperabilidad(GuardarRecargaTarifaInteroperabilidadModel?: GuardarRecargaTarifaInteroperabilidadModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.guardarRecargaTarifaInteroperabilidad(GuardarRecargaTarifaInteroperabilidadModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GuardarRecargaTarifaPrecioInteroperabilidadModel} [GuardarRecargaTarifaPrecioInteroperabilidadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarRecargaTarifaPrecioInteroperabilidad(GuardarRecargaTarifaPrecioInteroperabilidadModel?: GuardarRecargaTarifaPrecioInteroperabilidadModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.guardarRecargaTarifaPrecioInteroperabilidad(GuardarRecargaTarifaPrecioInteroperabilidadModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero XLSX para importar los certificados de visita
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarCertificadosVisita(Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.importarCertificadosVisita(Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Importa los pares cliente-cargador de un XLSX inicial
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarClientesCargadores(Filename?: string, File?: File, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.importarClientesCargadores(Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero XLSX para importar el recuento de activos
         * @param {string} [UrlFichero] 
         * @param {number} [NumSemana] 
         * @param {number} [NumMes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarRecuentoActivosFromXCustomer(UrlFichero?: string, NumSemana?: number, NumMes?: number, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.importarRecuentoActivosFromXCustomer(UrlFichero, NumSemana, NumMes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero CSV para importar las WOs urgentes de xCustomer
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importarWosUrgentesFromXCustomer(Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.importarWosUrgentesFromXCustomer(Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una inspección visual externa (prestador).
         * @param {CreateInspeccionVisualExternaModel} [CreateInspeccionVisualExternaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualCreateExterna(CreateInspeccionVisualExternaModel?: CreateInspeccionVisualExternaModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.inspeccionVisualCreateExterna(CreateInspeccionVisualExternaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una inspección visual interna (Endesa).
         * @param {CreateInspeccionVisualInternaModel} [CreateInspeccionVisualInternaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualCreateInterna(CreateInspeccionVisualInternaModel?: CreateInspeccionVisualInternaModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.inspeccionVisualCreateInterna(CreateInspeccionVisualInternaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita cabecera de una inspección visual.
         * @param {EditInspeccionVisualModel} [EditInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualEdit(EditInspeccionVisualModel?: EditInspeccionVisualModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.inspeccionVisualEdit(EditInspeccionVisualModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la cabecera de una inspección visual para edición.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspeccionVisualGet(Id: string, options?: any): AxiosPromise<InspeccionVisualCabeceraModelResponseDTO> {
            return localVarFp.inspeccionVisualGet(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una OCA de tipo centro de transformación.
         * @param {CreateOcaCentroTransformacionModel} [CreateOcaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaCentroTransformacionCreate(CreateOcaCentroTransformacionModel?: CreateOcaCentroTransformacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.ocaCentroTransformacionCreate(CreateOcaCentroTransformacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una OCA de tipo centro de transformación.
         * @param {EditOcaCentroTransformacionModel} [EditOcaCentroTransformacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaCentroTransformacionEdit(EditOcaCentroTransformacionModel?: EditOcaCentroTransformacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.ocaCentroTransformacionEdit(EditOcaCentroTransformacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una OCA de tipo ubicación.
         * @param {CreateOcaUbicacionModel} [CreateOcaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaUbicacionCreate(CreateOcaUbicacionModel?: CreateOcaUbicacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.ocaUbicacionCreate(CreateOcaUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una OCA de tipo ubicación.
         * @param {EditOcaUbicacionModel} [EditOcaUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocaUbicacionEdit(EditOcaUbicacionModel?: EditOcaUbicacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.ocaUbicacionEdit(EditOcaUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo partner
         * @param {CreatePartnerModel} [CreatePartnerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreate(CreatePartnerModel?: CreatePartnerModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.partnerCreate(CreatePartnerModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un partner existente
         * @param {EditPartnerModel} [EditPartnerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEdit(EditPartnerModel?: EditPartnerModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.partnerEdit(EditPartnerModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo PDS
         * @param {CreatePdsModel} [CreatePdsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdsCreate(CreatePdsModel?: CreatePdsModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.pdsCreate(CreatePdsModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un PDS existente
         * @param {EditPdsModel} [EditPdsModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdsEdit(EditPdsModel?: EditPdsModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.pdsEdit(EditPdsModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de Pds compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdsGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.pdsGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un fichero a la actuación.
         * @param {string} Id 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoActuacion(Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postAdjuntoActuacion(Id, TipoDocumento, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un fichero a la work order. Tipos: Cuadro eléctrico, Cargador, Número serie, Prueba termográfica, Informe técnico, Informe económico, Otros.
         * @param {string} IdWorkOrder 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoExternoWo(IdWorkOrder: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options?: any): AxiosPromise<void> {
            return localVarFp.postAdjuntoExternoWo(IdWorkOrder, TipoDocumento, Descripcion, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un fichero al ticket.
         * @param {string} Id 
         * @param {CategoriaAdjuntoTicketApiEnum} [CategoriaDocumento] 
         * @param {string} [Descripcion] 
         * @param {boolean} [OmitirHistorico] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoTicket(Id: string, CategoriaDocumento?: CategoriaAdjuntoTicketApiEnum, Descripcion?: string, OmitirHistorico?: boolean, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postAdjuntoTicket(Id, CategoriaDocumento, Descripcion, OmitirHistorico, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un fichero a la work order.
         * @param {string} Id 
         * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdjuntoWo(Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postAdjuntoWo(Id, TipoDocumento, Descripcion, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se desuscribe al Cargador seleccionado
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCargarFicheroPartners(options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.postCargarFicheroPartners(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero de forma temporal.
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoTemp(Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postDocumentoTemp(Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero para crear usuarios
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoUsuarios(Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postDocumentoUsuarios(Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un evento de edición de datos del ticket con mensaje y observación combinados.
         * @param {string} Id 
         * @param {CreateHistoricoEdicionTicketModel} [CreateHistoricoEdicionTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHistoricoEdicionTicket(Id: string, CreateHistoricoEdicionTicketModel?: CreateHistoricoEdicionTicketModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postHistoricoEdicionTicket(Id, CreateHistoricoEdicionTicketModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un informe económico a la actuación
         * @param {string} IdActuacion 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInformeEconomicoActuacion(IdActuacion: string, Filename?: string, File?: File, options?: any): AxiosPromise<void> {
            return localVarFp.postInformeEconomicoActuacion(IdActuacion, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta el informe de la WO; el económico requiere importe y recalcula el coste sin cerrar la WO
         * @param {string} IdWorkOrder 
         * @param {TipoInformeWoExternoEnum} [TipoInforme] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {number} [ImporteWo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInformeWorkOrder(IdWorkOrder: string, TipoInforme?: TipoInformeWoExternoEnum, Filename?: string, File?: File, ImporteWo?: number, options?: any): AxiosPromise<void> {
            return localVarFp.postInformeWorkOrder(IdWorkOrder, TipoInforme, Filename, File, ImporteWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Importa los 4 Excel de pagos B2C para un mes (reemplaza si ya existe).
         * @param {number} [Anio] 
         * @param {number} [Mes] 
         * @param {File} [Instalaciones] 
         * @param {File} [Reparaciones] 
         * @param {File} [Visitas] 
         * @param {File} [PdteC3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPagosB2cImportar(Anio?: number, Mes?: number, Instalaciones?: File, Reparaciones?: File, Visitas?: File, PdteC3?: File, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.postPagosB2cImportar(Anio, Mes, Instalaciones, Reparaciones, Visitas, PdteC3, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube 3 excels (Activos/Oportunidades/Contactos) y devuelve un preview parseado.
         * @param {string} [IdCorrelacion] 
         * @param {File} [Activos] 
         * @param {File} [Oportunidades] 
         * @param {File} [Contactos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPartnersCargarExcels(IdCorrelacion?: string, Activos?: File, Oportunidades?: File, Contactos?: File, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.postPartnersCargarExcels(IdCorrelacion, Activos, Oportunidades, Contactos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prepara el informe técnico (cargadores y checklist) con datos actuales.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepararInformeTecnicoInspeccionVisual(Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.prepararInformeTecnicoInspeccionVisual(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TEMP AL-513 — Preview cálculo coste actuación (sin persistir)
         * @param {string} IdActuacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewCalculoCosteActuacion(IdActuacion: string, options?: any): AxiosPromise<PreviewCalculoCosteActuacionRmResponseDTO> {
            return localVarFp.previewCalculoCosteActuacion(IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna fecha de programación y técnico de una o más inspecciones visuales.
         * @param {ProgramarFechaInspeccionVisualModel} [ProgramarFechaInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programarFechaInspeccionVisual(ProgramarFechaInspeccionVisualModel?: ProgramarFechaInspeccionVisualModel, options?: any): AxiosPromise<void> {
            return localVarFp.programarFechaInspeccionVisual(ProgramarFechaInspeccionVisualModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Programa la fecha de la visita pendiente de una OCA.
         * @param {ProgramarFechaVisitaModel} [ProgramarFechaVisitaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programarFechaVisita(ProgramarFechaVisitaModel?: ProgramarFechaVisitaModel, options?: any): AxiosPromise<void> {
            return localVarFp.programarFechaVisita(ProgramarFechaVisitaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita el importe de un informe de canon fija (solo Admin Revenue)
         * @param {string} Id 
         * @param {EditarImporteFijoTransaccionModel} [EditarImporteFijoTransaccionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEditarImporteFijoTransaccion(Id: string, EditarImporteFijoTransaccionModel?: EditarImporteFijoTransaccionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.putEditarImporteFijoTransaccion(Id, EditarImporteFijoTransaccionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza un evento cargador
         * @param {EditEventoCargadorModel} [EditEventoCargadorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEventoCargador(EditEventoCargadorModel?: EditEventoCargadorModel, options?: any): AxiosPromise<SubestadoTicketsRmListResponseDTO> {
            return localVarFp.putEventoCargador(EditEventoCargadorModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reabre un ticket cerrado con un nuevo estado, subestado y cola, registrando el evento en el histórico.
         * @param {ReabrirTicketModel} [ReabrirTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reabrirTicket(ReabrirTicketModel?: ReabrirTicketModel, options?: any): AxiosPromise<void> {
            return localVarFp.reabrirTicket(ReabrirTicketModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca todas las notificaciones del usuario como leídas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllNotificaciones(options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.readAllNotificaciones(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca una notificación como leída.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotificacion(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.readNotificacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresca el estado del cargador
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCargadorStatus(Id: string, options?: any): AxiosPromise<StatusCargadorModelResponseDTO> {
            return localVarFp.refreshCargadorStatus(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resuelve el prestador sugerido al crear actuación (tramo provincia/potencia y código postal)
         * @param {ResolvePdsNuevaActuacionModel} [ResolvePdsNuevaActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePdsNuevaActuacion(ResolvePdsNuevaActuacionModel?: ResolvePdsNuevaActuacionModel, options?: any): AxiosPromise<ResolvePdsNuevaActuacionRmResponseDTO> {
            return localVarFp.resolvePdsNuevaActuacion(ResolvePdsNuevaActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reanuda la periodicidad de una IV pausada y crea la siguiente con la fecha objetivo indicada.
         * @param {string} Id 
         * @param {ResumirPeriodicidadInspeccionVisualModel} [ResumirPeriodicidadInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumirPeriodicidadInspeccionVisual(Id: string, ResumirPeriodicidadInspeccionVisualModel?: ResumirPeriodicidadInspeccionVisualModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.resumirPeriodicidadInspeccionVisual(Id, ResumirPeriodicidadInspeccionVisualModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesGetAll(options?: any): AxiosPromise<RolesRmListResponseDTO> {
            return localVarFp.rolesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece la aptitud de un cargador para inspecciones visuales
         * @param {string} Id 
         * @param {boolean} [AptoInspeccionVisual] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAptoInspeccionVisualCargador(Id: string, AptoInspeccionVisual?: boolean, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.setAptoInspeccionVisualCargador(Id, AptoInspeccionVisual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Guarda la calidad de una inspección visual sin resolver el compliance.
         * @param {string} Id 
         * @param {SetCalidadInspeccionVisualModel} [SetCalidadInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCalidadInspeccionVisual(Id: string, SetCalidadInspeccionVisualModel?: SetCalidadInspeccionVisualModel, options?: any): AxiosPromise<void> {
            return localVarFp.setCalidadInspeccionVisual(Id, SetCalidadInspeccionVisualModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca un cargador como disponible
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorAvailable(Id: string, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.setCargadorAvailable(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca un cargador como dismissed
         * @param {string} Id 
         * @param {SetCargadorDismissedModel} [SetCargadorDismissedModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorDismissed(Id: string, SetCargadorDismissedModel?: SetCargadorDismissedModel, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.setCargadorDismissed(Id, SetCargadorDismissedModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece el tipo de indisponibilidad de un cargador
         * @param {string} Id 
         * @param {number} [IdTipoUnavailable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorUnavailable(Id: string, IdTipoUnavailable?: number, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.setCargadorUnavailable(Id, IdTipoUnavailable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca o desmarca un cargador como visible en la app
         * @param {string} Id 
         * @param {boolean} [VisibleInApp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCargadorVisibleInApp(Id: string, VisibleInApp?: boolean, options?: any): AxiosPromise<UnitResponseDTO> {
            return localVarFp.setCargadorVisibleInApp(Id, VisibleInApp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resuelve el compliance de una inspección visual externa.
         * @param {string} Id 
         * @param {SetComplianceInspeccionVisualModel} [SetComplianceInspeccionVisualModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setComplianceInspeccionVisual(Id: string, SetComplianceInspeccionVisualModel?: SetComplianceInspeccionVisualModel, options?: any): AxiosPromise<void> {
            return localVarFp.setComplianceInspeccionVisual(Id, SetComplianceInspeccionVisualModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece los datos de compliance de una work order
         * @param {string} Id 
         * @param {SetComplianceWoModel} [SetComplianceWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setComplianceWo(Id: string, SetComplianceWoModel?: SetComplianceWoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.setComplianceWo(Id, SetComplianceWoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de subestados
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subestadosGetAll(options?: any): AxiosPromise<SubestadosRmListResponseDTO> {
            return localVarFp.subestadosGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtiene un listado de los informes suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionInformesPorUsuario(IdUsuario?: string, Email?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.suscripcionInformesPorUsuario(IdUsuario, Email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se cargan las suscripciones para el usuario seleccionado
         * @param {AddSuscripcionPorUsuarioModel} [AddSuscripcionPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionesCreate(AddSuscripcionPorUsuarioModel?: AddSuscripcionPorUsuarioModel, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.suscripcionesCreate(AddSuscripcionPorUsuarioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se editan las suscripciones para el usuario seleccionado
         * @param {DeleteSuscripcionesPorUsuarioModel} [DeleteSuscripcionesPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionesDelete(DeleteSuscripcionesPorUsuarioModel?: DeleteSuscripcionesPorUsuarioModel, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.suscripcionesDelete(DeleteSuscripcionesPorUsuarioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se editan las suscripciones para el usuario seleccionado
         * @param {EditSuscripcionPorUsuarioModel} [EditSuscripcionPorUsuarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suscripcionesPut(EditSuscripcionPorUsuarioModel?: EditSuscripcionPorUsuarioModel, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.suscripcionesPut(EditSuscripcionPorUsuarioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se suscribe al tenant seleccionado
         * @param {string} [IdTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantSubscribe(IdTenant?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.tenantSubscribe(IdTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se desuscribe al tenant seleccionado
         * @param {string} [IdTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUnsubscribe(IdTenant?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.tenantUnsubscribe(IdTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de tenants con sus estados y suscripciones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsEstadosSuscripciones(options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.tenantsEstadosSuscripciones(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Se obtiene un listado de los tenants suscritos del usuario
         * @param {string} [IdUsuario] 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsPorUsuario(IdUsuario?: string, Email?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.tenantsPorUsuario(IdUsuario, Email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una ubicación OCA.
         * @param {CreateUbicacionModel} [CreateUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ubicacionCreate(CreateUbicacionModel?: CreateUbicacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.ubicacionCreate(CreateUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una ubicación OCA.
         * @param {EditUbicacionModel} [EditUbicacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ubicacionEdit(EditUbicacionModel?: EditUbicacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.ubicacionEdit(EditUbicacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza el tipo de intervalo de una actuación
         * @param {UpdateIntervaloActuacionModel} [UpdateIntervaloActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntervaloActuacion(UpdateIntervaloActuacionModel?: UpdateIntervaloActuacionModel, options?: any): AxiosPromise<GuidResponseDTO> {
            return localVarFp.updateIntervaloActuacion(UpdateIntervaloActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckEmail(Email: string, IdUsuario: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.usuarioCheckEmail(Email, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckUsername(Username: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.usuarioCheckUsername(Username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un usuario existente
         * @param {DeleteUserModel} [DeleteUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioDelete(DeleteUserModel?: DeleteUserModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.usuarioDelete(DeleteUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetCurrentUserProfile(options?: any): AxiosPromise<UserProfileResponseResponseDTO> {
            return localVarFp.usuarioGetCurrentUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las preferencias de notificación del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetPreferenciasNotificacion(options?: any): AxiosPromise<PreferenciasNotificacionModelResponseDTO> {
            return localVarFp.usuarioGetPreferenciasNotificacion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.usuarioGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserGmaoModel} [CreateUserGmaoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGmaoCreate(CreateUserGmaoModel?: CreateUserGmaoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.usuarioGmaoCreate(CreateUserGmaoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserGmaoModel} [EditUserGmaoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGmaoEdit(EditUserGmaoModel?: EditUserGmaoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.usuarioGmaoEdit(EditUserGmaoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reactiva un usuario deshabilitado
         * @param {ReactivateUserModel} [ReactivateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioReactivate(ReactivateUserModel?: ReactivateUserModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.usuarioReactivate(ReactivateUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioRevenueCreate(CreateUserModel?: CreateUserModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.usuarioRevenueCreate(CreateUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioRevenueEdit(EditUserModel?: EditUserModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.usuarioRevenueEdit(EditUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza las preferencias de notificación del usuario actual
         * @param {PreferenciasNotificacionModel} [PreferenciasNotificacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioUpdatePreferenciasNotificacion(PreferenciasNotificacionModel?: PreferenciasNotificacionModel, options?: any): AxiosPromise<PreferenciasNotificacionModelResponseDTO> {
            return localVarFp.usuarioUpdatePreferenciasNotificacion(PreferenciasNotificacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validar una actuacion
         * @param {ValidarActuacionModel} [ValidarActuacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarActuacion(ValidarActuacionModel?: ValidarActuacionModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.validarActuacion(ValidarActuacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validar una wo
         * @param {ValidarWoModel} [ValidarWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarWo(ValidarWoModel?: ValidarWoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.validarWo(ValidarWoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una wo existente
         * @param {EditWoModel} [EditWoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woEdit(EditWoModel?: EditWoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.woEdit(EditWoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO asociada a un cargador (SAT/activos, sin otros documentos)
         * @param {string} IdWo 
         * @param {string} [IdCargador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoFromCargador(IdWo: string, IdCargador?: string, options?: any): AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO> {
            return localVarFp.woGetInformeTecnicoFromCargador(IdWo, IdCargador, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO asociada a un ticket (SAT/ticketing, sin otros documentos)
         * @param {string} IdWo 
         * @param {string} [IdTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoFromTicket(IdWo: string, IdTicket?: string, options?: any): AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO> {
            return localVarFp.woGetInformeTecnicoFromTicket(IdWo, IdTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO (Revenue Activos, sin otros documentos)
         * @param {string} IdWo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoRevenue(IdWo: string, options?: any): AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO> {
            return localVarFp.woGetInformeTecnicoRevenue(IdWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruta del informe técnico de una WO con sustitución (solo Revenue, sin otros documentos)
         * @param {string} IdWo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetInformeTecnicoSustitucionRevenue(IdWo: string, options?: any): AxiosPromise<InformeTecnicoSustitucionRevenueDtoResponseDTO> {
            return localVarFp.woGetInformeTecnicoSustitucionRevenue(IdWo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.woGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
         * @param {Date} [FechaInicio] 
         * @param {Date} [FechaFin] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaMaestroPagosWo(FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.woGetRejillaMaestroPagosWo(FechaInicio, FechaFin, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdActuacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaPorActuacion(LoadOptions?: DXLoadOptions, IdActuacion?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.woGetRejillaPorActuacion(LoadOptions, IdActuacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdCargador
         * @param {string} [IdCargador] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaPorIdCargador(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.woGetRejillaPorIdCargador(IdCargador, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdTicket
         * @param {string} [IdTicket] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaPorIdTicket(IdTicket?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.woGetRejillaPorIdTicket(IdTicket, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado DevExtreme de WO para Revenue (campos limitados)
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaWoRevenue(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.woGetRejillaWoRevenue(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado DevExtreme de WO con sustitución de cargador (Activos)
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        woGetRejillaWoSustitucion(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.woGetRejillaWoSustitucion(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de zonas del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonasGetAll(options?: any): AxiosPromise<ZonasRmListResponseDTO> {
            return localVarFp.zonasGetAll(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
export class ApiApi extends BaseAPI {
    /**
     * 
     * @summary Crea un nuevo activo (cargador)
     * @param {CreateActivoModel} [CreateActivoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public activoCreate(CreateActivoModel?: CreateActivoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).activoCreate(CreateActivoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nueva actuación
     * @param {CreateActuacionModel} [CreateActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public actuacionCreate(CreateActuacionModel?: CreateActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).actuacionCreate(CreateActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una actuacion existente
     * @param {EditActuacionModel} [EditActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public actuacionEdit(EditActuacionModel?: EditActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).actuacionEdit(EditActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de actuaciones compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public actuacionesGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).actuacionesGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sustituye el orden de visita de un técnico en una fecha.
     * @param {ActualizarPlanificacionTecnicoInspeccionVisualModel} [ActualizarPlanificacionTecnicoInspeccionVisualModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public actualizarPlanificacionTecnicoInspeccionVisual(ActualizarPlanificacionTecnicoInspeccionVisualModel?: ActualizarPlanificacionTecnicoInspeccionVisualModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).actualizarPlanificacionTecnicoInspeccionVisual(ActualizarPlanificacionTecnicoInspeccionVisualModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade cargadores sin ubicación a una ubicación existente.
     * @param {AddCargadoresUbicacionModel} [AddCargadoresUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addCargadoresUbicacion(AddCargadoresUbicacionModel?: AddCargadoresUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addCargadoresUbicacion(AddCargadoresUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade un mensaje a la transaccion.
     * @param {string} Id 
     * @param {CreateMensajeTransaccionModel} [CreateMensajeTransaccionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addMensajeTransaccion(Id: string, CreateMensajeTransaccionModel?: CreateMensajeTransaccionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addMensajeTransaccion(Id, CreateMensajeTransaccionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Anula una OCA abierta.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public anularOca(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).anularOca(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asignar una fecha a una o varias actuaciones
     * @param {AsignarFechaActuacionModel} [AsignarFechaActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public asignarFechaActuacion(AsignarFechaActuacionModel?: AsignarFechaActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).asignarFechaActuacion(AsignarFechaActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna fecha de previsión y técnico a una actuación
     * @param {AsignarPrevisionActuacionExternoModel} [AsignarPrevisionActuacionExternoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public asignarPrevisionActuacionExterno(AsignarPrevisionActuacionExternoModel?: AsignarPrevisionActuacionExternoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).asignarPrevisionActuacionExterno(AsignarPrevisionActuacionExternoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asignar un técnico a una o varias actuaciones
     * @param {AsignarTecnicoActuacionModel} [AsignarTecnicoActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public asignarTecnicoActuacion(AsignarTecnicoActuacionModel?: AsignarTecnicoActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).asignarTecnicoActuacion(AsignarTecnicoActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cambia el estado de la transacción
     * @param {string} Id 
     * @param {string} [NuevoEstado] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cambiarEstadoTransaccion(Id: string, NuevoEstado?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cambiarEstadoTransaccion(Id, NuevoEstado, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancela una actuacion existente
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cancelarActuacion(Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cancelarActuacion(Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancela una petición pendiente de la cola de tareas programadas
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cancelarColaTareaProgramada(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cancelarColaTareaProgramada(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancela una wo existente
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cancelarWo(Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cancelarWo(Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un cargador poi existente
     * @param {EditCargadorPoiModel} [EditCargadorPoiModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cargadorPoiEdit(EditCargadorPoiModel?: EditCargadorPoiModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cargadorPoiEdit(EditCargadorPoiModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se suscribe al Cargador seleccionado
     * @param {string} [IdCargador] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cargadorSubscribe(IdCargador?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cargadorSubscribe(IdCargador, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se desuscribe al Cargador seleccionado
     * @param {string} [IdCargador] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cargadorUnsubscribe(IdCargador?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cargadorUnsubscribe(IdCargador, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de cargadores con sus estados y suscripciones
     * @param {string} [IdCargador] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cargadoresEstadosSuscripciones(IdCargador?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cargadoresEstadosSuscripciones(IdCargador, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtiene un listado de los cargadores suscritos del usuario
     * @param {string} [IdUsuario] 
     * @param {string} [Email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cargadoresPorUsuario(IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cargadoresPorUsuario(IdUsuario, Email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un centro de transformación OCA.
     * @param {CreateCentroTransformacionModel} [CreateCentroTransformacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public centroTransformacionCreate(CreateCentroTransformacionModel?: CreateCentroTransformacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).centroTransformacionCreate(CreateCentroTransformacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un centro de transformación OCA.
     * @param {EditCentroTransformacionModel} [EditCentroTransformacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public centroTransformacionEdit(EditCentroTransformacionModel?: EditCentroTransformacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).centroTransformacionEdit(EditCentroTransformacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cierra una inspección visual persistiendo conclusiones, fecha de cierre y estado Cerrada.
     * @param {string} Id 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cerrarInspeccionVisual(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cerrarInspeccionVisual(Id, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comprueba si un número de serie está disponible (no existe en commons.cargador)
     * @param {string} [NumeroSerie] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public checkNumeroSerieNuevoDisponible(NumeroSerie?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).checkNumeroSerieNuevoDisponible(NumeroSerie, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comprueba si existe un ticket abierto por id de cargador y tipo (1=Asistencia, 2=Incidencia).
     * @param {string} [IdCargador] 
     * @param {number} [IdTipoTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public checkTicketByIdCargador(IdCargador?: string, IdTipoTicket?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).checkTicketByIdCargador(IdCargador, IdTipoTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comprueba si existe un ticket abierto por número de serie y tipo (1=Asistencia, 2=Incidencia).
     * @param {string} [SerialNumber] 
     * @param {number} [IdTipoTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public checkTicketBySerial(SerialNumber?: string, IdTipoTicket?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).checkTicketBySerial(SerialNumber, IdTipoTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Completa horas y liquidaciones Circutor sin modificar pagos consolidados
     * @param {number} [Pagina] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public completarDatosPagos(Pagina?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).completarDatosPagos(Pagina, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Completa la corrección del informe técnico de una inspección cerrada y regenera sus informes.
     * @param {string} Id 
     * @param {CompletarInformeTecnicoIvModel} [CompletarInformeTecnicoIvModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public completarInformeTecnicoInspeccionVisual(Id: string, CompletarInformeTecnicoIvModel?: CompletarInformeTecnicoIvModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).completarInformeTecnicoInspeccionVisual(Id, CompletarInformeTecnicoIvModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una observación interna de gestor GMAO en una OCA.
     * @param {CrearObservacionOcaModel} [CrearObservacionOcaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public crearObservacionOca(CrearObservacionOcaModel?: CrearObservacionOcaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).crearObservacionOca(CrearObservacionOcaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nueva visita OCA de centro de transformación.
     * @param {CrearVisitaCentroTransformacionModel} [CrearVisitaCentroTransformacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public crearVisitaCentroTransformacion(CrearVisitaCentroTransformacionModel?: CrearVisitaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).crearVisitaCentroTransformacion(CrearVisitaCentroTransformacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nueva visita OCA de ubicación.
     * @param {CrearVisitaUbicacionModel} [CrearVisitaUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public crearVisitaUbicacion(CrearVisitaUbicacionModel?: CrearVisitaUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).crearVisitaUbicacion(CrearVisitaUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea la work order de deficiencia de una visita OCA de ubicación.
     * @param {CrearWoDeficienciaVisitaModel} [CrearWoDeficienciaVisitaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public crearWoDeficienciaVisita(CrearWoDeficienciaVisitaModel?: CrearWoDeficienciaVisitaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).crearWoDeficienciaVisita(CrearWoDeficienciaVisitaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nueva campaña
     * @param {CreateCampanaModel} [CreateCampanaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createCampana(CreateCampanaModel?: CreateCampanaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createCampana(CreateCampanaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registra un cambio de responsable en el historial del ticket y actualiza el ticket.
     * @param {CreateCargadorEventoCambioResponsableModel} [CreateCargadorEventoCambioResponsableModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createCargadorEventoCambioResponsable(CreateCargadorEventoCambioResponsableModel?: CreateCargadorEventoCambioResponsableModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createCargadorEventoCambioResponsable(CreateCargadorEventoCambioResponsableModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un periodo privado para un cargador
     * @param {CreateCargadorPeriodoPrivadoModel} [CreateCargadorPeriodoPrivadoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createCargadorPeriodoPrivado(CreateCargadorPeriodoPrivadoModel?: CreateCargadorPeriodoPrivadoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createCargadorPeriodoPrivado(CreateCargadorPeriodoPrivadoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo grupo de actuaciones para la campaña
     * @param {string} Id 
     * @param {CreateGrupoActuacionesModel} [CreateGrupoActuacionesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createGrupoActuaciones(Id: string, CreateGrupoActuacionesModel?: CreateGrupoActuacionesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createGrupoActuaciones(Id, CreateGrupoActuacionesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un subestado para una ticket
     * @param {CreateHistoricoTicketModel} [CreateHistoricoTicketModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createSubestadoHistorico(CreateHistoricoTicketModel?: CreateHistoricoTicketModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createSubestadoHistorico(CreateHistoricoTicketModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una ticket
     * @param {CreateTicketModel} [CreateTicketModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createTicket(CreateTicketModel?: CreateTicketModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createTicket(CreateTicketModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nueva work order
     * @param {CreateWoModel} [CreateWoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createWo(CreateWoModel?: CreateWoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createWo(CreateWoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un fichero adjuntado de la actuacion.
     * @param {string} Id 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteAdjuntoActuacion(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteAdjuntoActuacion(Id, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un fichero adjunto del ticket.
     * @param {string} Id 
     * @param {boolean} [OmitirHistorico] 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteAdjuntoTicket(Id: string, OmitirHistorico?: boolean, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteAdjuntoTicket(Id, OmitirHistorico, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un fichero adjuntado de la work order.
     * @param {string} Id 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteAdjuntoWo(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteAdjuntoWo(Id, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una campaña existente
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteCampana(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteCampana(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un evento para una ticket
     * @param {string} [IdEventoCargador] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteEventoCargador(IdEventoCargador?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteEventoCargador(IdEventoCargador, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deshace el compliance OK de una work order del mes en curso
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deshacerComplianceWo(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deshacerComplianceWo(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se desuscribe al Cargador seleccionado
     * @param {string} [Cuid] 
     * @param {string} [TenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public detalleCargador(Cuid?: string, TenantId?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).detalleCargador(Cuid, TenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un enlace temporal al documento indicado
     * @param {string} [Key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public documentosGenerateTempUrl(Key?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).documentosGenerateTempUrl(Key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Descarga o previsualiza un documento de Documenta Gestor por URI absoluta.
     * @param {string} [Uri] 
     * @param {string} [Disposition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public downloadDocumentoDg(Uri?: string, Disposition?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).downloadDocumentoDg(Uri, Disposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Descarga los ficheros adjuntos del ticket en un ZIP.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public downloadFilesTicket(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).downloadFilesTicket(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Descarga el conjunto de ficheros de una work order.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public downloadFilesWo(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).downloadFilesWo(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza la actuación y finaliza las work orders incluidas, aplicando la autorización por importe cuando corresponda y conservando sus importes y fechas existentes
     * @param {EditActuacionYWorkOrdersModel} [EditActuacionYWorkOrdersModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editActuacionYWorkOrdersExterno(EditActuacionYWorkOrdersModel?: EditActuacionYWorkOrdersModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editActuacionYWorkOrdersExterno(EditActuacionYWorkOrdersModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una campaña existente
     * @param {EditCampanaModel} [EditCampanaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editCampana(EditCampanaModel?: EditCampanaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editCampana(EditCampanaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un cargador
     * @param {EditCargadorModel} [EditCargadorModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editCargador(EditCargadorModel?: EditCargadorModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editCargador(EditCargadorModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un periodo privado de un cargador
     * @param {EditCargadorPeriodoPrivadoModel} [EditCargadorPeriodoPrivadoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editCargadorPeriodoPrivado(EditCargadorPeriodoPrivadoModel?: EditCargadorPeriodoPrivadoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editCargadorPeriodoPrivado(EditCargadorPeriodoPrivadoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita el informe de la wo
     * @param {EditDatosInformeModel} [EditDatosInformeModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editDatosInforme(EditDatosInformeModel?: EditDatosInformeModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editDatosInforme(EditDatosInformeModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza la resolución de deficiencias de una visita OCA declarada.
     * @param {EditDeficienciasVisitaUbicacionModel} [EditDeficienciasVisitaUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editDeficienciasVisitaUbicacion(EditDeficienciasVisitaUbicacionModel?: EditDeficienciasVisitaUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editDeficienciasVisitaUbicacion(EditDeficienciasVisitaUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita el informe técnico de una actuación
     * @param {EditInformeTecnicoModel} [EditInformeTecnicoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editInformeTecnico(EditInformeTecnicoModel?: EditInformeTecnicoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editInformeTecnico(EditInformeTecnicoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza datos editables de un ticket abierto (estado, subestado, cola, responsable, prioridad, pedido, conformidad, importe) y registra el histórico.
     * @param {boolean} [OmitirHistoricoEdicionDatos] 
     * @param {EditTicketModel} [EditTicketModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editTicket(OmitirHistoricoEdicionDatos?: boolean, EditTicketModel?: EditTicketModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editTicket(OmitirHistoricoEdicionDatos, EditTicketModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registra el resultado de una visita OCA de centro de transformación.
     * @param {EditVisitaCentroTransformacionModel} [EditVisitaCentroTransformacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editVisitaCentroTransformacion(EditVisitaCentroTransformacionModel?: EditVisitaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editVisitaCentroTransformacion(EditVisitaCentroTransformacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registra el resultado de una visita OCA de ubicación.
     * @param {EditVisitaUbicacionModel} [EditVisitaUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editVisitaUbicacion(EditVisitaUbicacionModel?: EditVisitaUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editVisitaUbicacion(EditVisitaUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una observación interna de gestor GMAO. Solo el autor puede editarla.
     * @param {string} Id 
     * @param {EditarObservacionOcaModel} [EditarObservacionOcaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editarObservacionOca(Id: string, EditarObservacionOcaModel?: EditarObservacionOcaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editarObservacionOca(Id, EditarObservacionOcaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public eliminarMspInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).eliminarMspInteroperabilidad(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public eliminarMspTarifaInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).eliminarMspTarifaInteroperabilidad(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una observación interna de gestor GMAO. Solo el autor puede eliminarla.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public eliminarObservacionOca(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).eliminarObservacionOca(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public eliminarRecargaTarifaInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).eliminarRecargaTarifaInteroperabilidad(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public eliminarRecargaTarifaPrecioInteroperabilidad(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).eliminarRecargaTarifaPrecioInteroperabilidad(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Encola un job Quartz para ejecución a demanda
     * @param {number} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public encolarTareaProgramada(Id: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).encolarTareaProgramada(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envía un mensaje al chat de una OCA.
     * @param {EnviarMensajeOcaModel} [EnviarMensajeOcaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public enviarMensajeOca(EnviarMensajeOcaModel?: EnviarMensajeOcaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).enviarMensajeOca(EnviarMensajeOcaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo equipo medida
     * @param {CreateEquipoMedidaModel} [CreateEquipoMedidaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public equipoMedidaCreate(CreateEquipoMedidaModel?: CreateEquipoMedidaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).equipoMedidaCreate(CreateEquipoMedidaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Borra un equipo de medida
     * @param {DeleteEquipoMedidaModel} [DeleteEquipoMedidaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public equipoMedidaDelete(DeleteEquipoMedidaModel?: DeleteEquipoMedidaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).equipoMedidaDelete(DeleteEquipoMedidaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un equipo de medida existente
     * @param {EditEquipoMedidaModel} [EditEquipoMedidaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public equipoMedidaEdit(EditEquipoMedidaModel?: EditEquipoMedidaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).equipoMedidaEdit(EditEquipoMedidaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de equipos de medida compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdPdsActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public equipoMedidaGetRejilla(LoadOptions?: DXLoadOptions, IdPdsActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).equipoMedidaGetRejilla(LoadOptions, IdPdsActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validar que una actuacion no tenga wo\'s del mismo tipo con el mismo activo
     * @param {string} [IdActuacion] 
     * @param {string} [IdActivo] 
     * @param {TipoWoEnum} [TipoWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public existeCargadorAndTipoEnActuacion(IdActuacion?: string, IdActivo?: string, TipoWo?: TipoWoEnum, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).existeCargadorAndTipoEnActuacion(IdActuacion, IdActivo, TipoWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GET de solo lectura. data=true si hay un cargador activo con ese numeroSerie; data=false si no existe y el SN puede usarse como numeroSerieNuevo en sustitución.
     * @summary Indica si un número de serie ya existe como cargador activo (solo consulta, sin efectos laterales)
     * @param {string} [NumeroSerie] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public existeNumeroSerieExterno(NumeroSerie?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).existeNumeroSerieExterno(NumeroSerie, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene valor de activación de una feature
     * @param {string} FeatureName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).featuresGet(FeatureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de feature flags y valor de activación
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public featuresList(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).featuresList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtienen las fechas de importacioón
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public fechasImportacion(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).fechasImportacion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Firma una actuacion existente
     * @param {FirmarActuacionModel} [FirmarActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public firmarActuacion(FirmarActuacionModel?: FirmarActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).firmarActuacion(FirmarActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetCalculoEconomicoActuacion
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public generateInformeEconomicoActuacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).generateInformeEconomicoActuacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Genera el informe técnico de una work order
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public generateInformeTecnicoWo(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).generateInformeTecnicoWo(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de los activos para la creación de actuación
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [Direccion] 
     * @param {string} [IdUbicacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getActivosActuacion(LoadOptions?: DXLoadOptions, Direccion?: string, IdUbicacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getActivosActuacion(LoadOptions, Direccion, IdUbicacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
     * @summary Obtiene actuaciones abiertas
     * @param {number} [Page] 
     * @param {number} [PageSize] 
     * @param {Date} [FechaUltimaActualizacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getActuacionesAbiertas(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getActuacionesAbiertas(Page, PageSize, FechaUltimaActualizacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
     * @summary Obtiene actuaciones cerradas
     * @param {number} [Page] 
     * @param {number} [PageSize] 
     * @param {Date} [FechaUltimaActualizacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getActuacionesCerradas(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getActuacionesCerradas(Page, PageSize, FechaUltimaActualizacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query opcional fechaUltimaActualizacion: devuelve actuaciones cuya fecha de última actualización, o la de alguna de sus WO, sea posterior a ese valor. El array wos incluye todas las WO de la actuación.
     * @summary Obtiene actuaciones con incidencia
     * @param {number} [Page] 
     * @param {number} [PageSize] 
     * @param {Date} [FechaUltimaActualizacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getActuacionesConIncidencia(Page?: number, PageSize?: number, FechaUltimaActualizacion?: Date, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getActuacionesConIncidencia(Page, PageSize, FechaUltimaActualizacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de business models para desplegables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAllBusinessModelsForCombo(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAllBusinessModelsForCombo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de partners para desplegables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAllPartnersForCombo(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAllPartnersForCombo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de provincias para desplegables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAllProvincias(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAllProvincias(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DXLoadOptions} [Options] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAsignacionesInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAsignacionesInteroperabilidadForGrid(Options, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene campañas para selector, cuyo estado no es el de borrador
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCampanas(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCampanas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de campañas para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCampanasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCampanasForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los canales de entrada del ticket (SAT)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCanalesEntrada(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCanalesEntrada(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el histórico de cambios de agrupación de estado de un cargador para DevExtreme
     * @param {string} [IdCargador] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadorHistoricoEstadoGrid(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadorHistoricoEstadoGrid(IdCargador, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los periodos privados de un cargador para DevExtreme
     * @param {string} [IdCargador] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadorPeriodosPrivadoGrid(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadorPeriodosPrivadoGrid(IdCargador, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de todos los cargadores, utilizando paginación
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresAll(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresAll(Take, Skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de todos los cargadores de los tenants seleccionados, utilizando paginación
     * @param {string} [TenantIds] 
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresByTenantId(TenantIds?: string, Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresByTenantId(TenantIds, Take, Skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de cargadores involucraddos en una campaña para la grid de Devextreme, con filtros extras.
     * @param {string} Id 
     * @param {Array<string>} [IdsPds] 
     * @param {Array<string>} [IdsPartner] 
     * @param {Array<number>} [IdsProvincia] 
     * @param {Array<number>} [IdsZona] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresCampanaForGrid(Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresCampanaForGrid(Id, IdsPds, IdsPartner, IdsProvincia, IdsZona, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los cargadores asociados a un centro de transformación OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresCentroTransformacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los cargadores de la IV con su estado y aptitud actuales y sus WO asignadas.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresComplianceInspeccionVisual(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresComplianceInspeccionVisual(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de cargadores dismissed para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresDismissedForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresDismissedForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de todos los cargadores de Enel, utilizando paginación
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresEnel(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresEnel(Take, Skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de cargadores para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de cargadores para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresForGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresForGridAdmin(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de cargadores, con paginación opcional
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresMobility(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresMobility(Take, Skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtiene un listado de los cargadores, ordneados por los suscritos
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdUsuario] 
     * @param {string} [Email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresOrderSuscrito(LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresOrderSuscrito(LoadOptions, IdUsuario, Email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtienen los cargadores
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresRm(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresRm(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene cargadores sin ubicación asignada.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresSinUbicacionForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresSinUbicacionForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los cargadores asociados a una ubicación OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCargadoresUbicacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCargadoresUbicacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de los casos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCasos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCasos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo de ítems de correctivas de Elecnor según la actuación
     * @param {string} [IdActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCatalogoItemsCorrectivasElecnor(IdActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCatalogoItemsCorrectivasElecnor(IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo de materiales CIRCUTOR según actuación y tipo de WO
     * @param {string} [IdActuacion] 
     * @param {number} [IdTipoWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCatalogoItemsMaterialesCircutor(IdActuacion?: string, IdTipoWo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCatalogoItemsMaterialesCircutor(IdActuacion, IdTipoWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo de materiales Elecnor (BT5) según actuación y tipo de WO
     * @param {string} [IdActuacion] 
     * @param {number} [IdTipoWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCatalogoItemsMaterialesElecnor(IdActuacion?: string, IdTipoWo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCatalogoItemsMaterialesElecnor(IdActuacion, IdTipoWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo de ítems de preventivas de Elecnor según la actuación
     * @param {string} [IdActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCatalogoItemsPreventivasElecnor(IdActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCatalogoItemsPreventivasElecnor(IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de un centro de transformación OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCentroTransformacionById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCentroTransformacionById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de coches eléctricos, con paginación opcional
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCochesElectricosMobility(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCochesElectricosMobility(Take, Skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado DevExtreme de la cola de jobs lanzados a demanda
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getColaTareaProgramadaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getColaTareaProgramadaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las colas de los usuarios
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getColaUsuario(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getColaUsuario(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la rejilla de ALTAS de activos
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {number} [PeriodoSemanaIni] 
     * @param {number} [PeriodoAnoIni] 
     * @param {number} [PeriodoSemanaFin] 
     * @param {number} [PeriodoAnoFin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComparacionActivosAltaForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComparacionActivosAltaForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la rejilla de BAJAS de activos
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {number} [PeriodoSemanaIni] 
     * @param {number} [PeriodoAnoIni] 
     * @param {number} [PeriodoSemanaFin] 
     * @param {number} [PeriodoAnoFin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComparacionActivosBajaForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComparacionActivosBajaForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la configuración de los adjuntos de actuación
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getConfiguracionAdjuntosActuacion(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getConfiguracionAdjuntosActuacion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la configuración de adjuntos de centro de transformación OCA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getConfiguracionAdjuntosCentroTransformacion(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getConfiguracionAdjuntosCentroTransformacion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la configuración de adjuntos de ticket (categorías fijas).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getConfiguracionAdjuntosTicket(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getConfiguracionAdjuntosTicket(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la configuración de adjuntos de ubicación OCA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getConfiguracionAdjuntosUbicacion(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getConfiguracionAdjuntosUbicacion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la configuración de adjuntos de visita OCA.
     * @param {boolean} [EsCentroTransformacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getConfiguracionAdjuntosVisita(EsCentroTransformacion?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getConfiguracionAdjuntosVisita(EsCentroTransformacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la configuración de los adjuntos de las work order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getConfiguracionAdjuntosWo(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getConfiguracionAdjuntosWo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos agregados para las gráficas donut del dashboard de activos.
     * @param {Array<string>} [IdsPartner] 
     * @param {number} [IdProvincia] 
     * @param {number} [IdZona] 
     * @param {number} [IdTipoInfraestructuraCargador] 
     * @param {boolean} [SoloConTicketsAbiertos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDashboardActivos(IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDashboardActivos(IdsPartner, IdProvincia, IdZona, IdTipoInfraestructuraCargador, SoloConTicketsAbiertos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de activos para una columna del dashboard (OK, UNAVAILABLE, KO o DISMISSED).
     * @param {Array<string>} [IdsPartner] 
     * @param {number} [IdProvincia] 
     * @param {number} [IdZona] 
     * @param {number} [IdTipoInfraestructuraCargador] 
     * @param {boolean} [SoloConTicketsAbiertos] 
     * @param {string} [EstadoAgrupacion] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDashboardActivosForGrid(IdsPartner?: Array<string>, IdProvincia?: number, IdZona?: number, IdTipoInfraestructuraCargador?: number, SoloConTicketsAbiertos?: boolean, EstadoAgrupacion?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDashboardActivosForGrid(IdsPartner, IdProvincia, IdZona, IdTipoInfraestructuraCargador, SoloConTicketsAbiertos, EstadoAgrupacion, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos para el dashboard de la campaña dado su id, y filtros extras.
     * @param {string} Id 
     * @param {Array<string>} [IdsPds] 
     * @param {Array<string>} [IdsPartner] 
     * @param {Array<number>} [IdsProvincia] 
     * @param {Array<number>} [IdsZona] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDashboardCampana(Id: string, IdsPds?: Array<string>, IdsPartner?: Array<string>, IdsProvincia?: Array<number>, IdsZona?: Array<number>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDashboardCampana(Id, IdsPds, IdsPartner, IdsProvincia, IdsZona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los KPIs GMAO del dashboard (asistencia, preventivos, OCAs, equipos, IV KIM y energía).
     * @param {Date} [FechaInicio] 
     * @param {Date} [FechaFin] 
     * @param {string} [IdPds] 
     * @param {Array<string>} [IdPartner] 
     * @param {number} [IdProvincia] 
     * @param {number} [IdZona] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDashboardKpiGmao(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDashboardKpiGmao(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos agregados para las gráficas donut del dashboard de OCAs.
     * @param {TipoOcaEnum} [IdTipoOca] 
     * @param {number} [IdProvincia] 
     * @param {number} [IdZona] 
     * @param {number} [AnioDesde] 
     * @param {number} [AnioHasta] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDashboardOcas(IdTipoOca?: TipoOcaEnum, IdProvincia?: number, IdZona?: number, AnioDesde?: number, AnioHasta?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDashboardOcas(IdTipoOca, IdProvincia, IdZona, AnioDesde, AnioHasta, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo de deficiencias de calidad del compliance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDeficienciasCompliance(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDeficienciasCompliance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo de deficiencias de visita OCA.
     * @param {string} [Ambito] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDeficienciasVisitaMaestra(Ambito?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDeficienciasVisitaMaestra(Ambito, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una actuacion por id
     * @param {string} [IdActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetalleActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetalleActuacion(IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una campaña por id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetalleCampana(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetalleCampana(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el partner dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetallePartnerById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetallePartnerById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle del ticket
     * @param {string} [IdTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetalleTicket(IdTicket?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetalleTicket(IdTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una wo por id
     * @param {string} [IdWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetalleWo(IdWo?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetalleWo(IdWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las WO cerradas y rechazadas de un técnico para el periodo del maestro de pagos
     * @param {Date} [FechaPeriodo] 
     * @param {string} [IdPds] 
     * @param {string} [IdTecnico] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetalleWosTecnicoMaestroPagos(FechaPeriodo?: Date, IdPds?: string, IdTecnico?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetalleWosTecnicoMaestroPagos(FechaPeriodo, IdPds, IdTecnico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el cargador dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetallecargadorById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetallecargadorById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el poi dado su id de cargador
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetallecargadorPoiById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetallecargadorPoiById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los documentos de visita asociados a una OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDocumentosAsociadosOca(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDocumentosAsociadosOca(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los documentos para la wo seleccionada
     * @param {string} [IdWorkOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDocumentosAsociadosWo(IdWorkOrder?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDocumentosAsociadosWo(IdWorkOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los valores de un enum.
     * @param {string} [TipoEnum] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEnumGenerico(TipoEnum?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEnumGenerico(TipoEnum, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los id de equipos de medida del prestador del usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEquiposMedida(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEquiposMedida(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el esquema unifilar de la ubicación del activo, si existe.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEsquemaUnifilarUbicacionActivo(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEsquemaUnifilarUbicacionActivo(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene estadísticas por técnico del prestador para el periodo (WO cerradas/rechazadas, % incidencia y media)
     * @param {Date} [FechaPeriodo] 
     * @param {string} [IdPds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEstadisticasTecnicosMaestroPagos(FechaPeriodo?: Date, IdPds?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEstadisticasTecnicosMaestroPagos(FechaPeriodo, IdPds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado DevExtreme del catálogo de tareas programadas y su última ejecución
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEstadoTareaProgramadaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEstadoTareaProgramadaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los estados de ticket
     * @param {boolean} [IncluirEstadoCerrado] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEstadosTicket(IncluirEstadoCerrado?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEstadosTicket(IncluirEstadoCerrado, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los eventos de un cargador ordenados por fecha descendente
     * @param {string} [IdCargador] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEventosByCargador(IdCargador?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEventosByCargador(IdCargador, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los ficheros adjuntos de un centro de transformación OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFicherosAdjuntosCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFicherosAdjuntosCentroTransformacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los ficheros adjuntos de una ubicación OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFicherosAdjuntosUbicacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFicherosAdjuntosUbicacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los ficheros adjuntos de una visita OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFicherosAdjuntosVisita(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFicherosAdjuntosVisita(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de tickets para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGestionTicketsForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGestionTicketsForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de gestores GMAO para SelectBox
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGestorGmaoSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGestorGmaoSelectBox(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el estado actual de WOs agrupado por tipo de WO
     * @param {Date} [FechaInicio] 
     * @param {Date} [FechaFin] 
     * @param {string} [IdPds] 
     * @param {Array<string>} [IdPartner] 
     * @param {number} [IdProvincia] 
     * @param {number} [IdZona] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGraficaEstadoActualWos(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGraficaEstadoActualWos(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la media de retraso de WOs por tipo de WO y mes
     * @param {Date} [FechaInicio] 
     * @param {Date} [FechaFin] 
     * @param {string} [IdPds] 
     * @param {Array<string>} [IdPartner] 
     * @param {number} [IdProvincia] 
     * @param {number} [IdZona] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGraficaRetrasosWos(FechaInicio?: Date, FechaFin?: Date, IdPds?: string, IdPartner?: Array<string>, IdProvincia?: number, IdZona?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGraficaRetrasosWos(FechaInicio, FechaFin, IdPds, IdPartner, IdProvincia, IdZona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de usuarios compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGridUsuariosGmao(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGridUsuariosGmao(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de usuarios compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGridUsuariosGmaoConCola(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGridUsuariosGmaoConCola(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado grupos de actuaciones en una campaña para la grid de Devextreme.
     * @param {string} Id 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGruposActuacionesForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGruposActuacionesForGrid(Id, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DXLoadOptions} [Options] 
     * @param {string} [TipoEntidad] 
     * @param {string} [EntidadId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getHistoricoInteroperabilidadForGrid(Options?: DXLoadOptions, TipoEntidad?: string, EntidadId?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getHistoricoInteroperabilidadForGrid(Options, TipoEntidad, EntidadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el histórico de OCAs de la misma ubicación con visitas y ficheros adjuntos.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getHistoricoOcasUbicacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getHistoricoOcasUbicacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el historico de mensajes del ticket
     * @param {string} [IdTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getHistoricoTicket(IdTicket?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getHistoricoTicket(IdTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un registro de importación de partners por su id de correlación (GUID).
     * @param {string} Correlacion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getImportacionPartnersByCorrelacion(Correlacion: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getImportacionPartnersByCorrelacion(Correlacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos del informe técnico (wizard) de una inspección visual.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getInformeTecnicoInspeccionVisual(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getInformeTecnicoInspeccionVisual(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los informes asociados a la actuacion
     * @param {string} [IdActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getInformesAsociadosActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getInformesAsociadosActuacion(IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una inspección visual (cabecera, cargadores y respuestas).
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getInspeccionVisualDetalle(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getInspeccionVisualDetalle(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los tipos de intervalo permitidos al crear o editar una inspección visual.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getIntervalosInspeccionVisual(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getIntervalosInspeccionVisual(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los items económicos compatibles con la potencia del cargador
     * @param {string} [IdCargador] 
     * @param {TipoWoEnum} [TipoWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getItemsEconomicosCompatibles(IdCargador?: string, TipoWo?: TipoWoEnum, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getItemsEconomicosCompatibles(IdCargador, TipoWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios KIM para SelectBox
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getKimSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getKimSelectBox(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado anual de MaestroPagos con RazonSocial, ImporteReal, Mes y Anio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoAnualMaestroPagos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoAnualMaestroPagos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de centros de transformación OCA para la grid de DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoCentrosTransformacionForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoCentrosTransformacionForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado de inspecciones visuales para grid DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoInspeccionesVisualesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado de inspecciones visuales en las que está incluido el cargador, con Nº KOs del activo.
     * @param {string} IdCargador 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoInspeccionesVisualesPorCargadorForGrid(IdCargador: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoInspeccionesVisualesPorCargadorForGrid(IdCargador, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de MaestroPagosInspeccionesVisuales compatible con DevExtreme, filtrado por una fecha inicio y una fecha fin
     * @param {Date} [FechaInicio] 
     * @param {Date} [FechaFin] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoMaestroPagosInspeccionesVisualesForGrid(FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoMaestroPagosInspeccionesVisualesForGrid(FechaInicio, FechaFin, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de OCAs para la grid de DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoOcasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoOcasForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado de OCAs para rejilla con filtros adicionales desde el seguimiento de ocas.
     * @param {OcaSeguimientoTipoEnum} [Tipo] 
     * @param {string} [Kpi] 
     * @param {string} [EstadoInicial] 
     * @param {string} [EstadoTransitado] 
     * @param {number} [AnioComparacion] 
     * @param {number} [SemanaComparacion] 
     * @param {TipoOcaEnum} [IdTipoOca] 
     * @param {Array<number>} [IdsProvincia] 
     * @param {Array<number>} [IdsZona] 
     * @param {number} [AnioReferencia] 
     * @param {number} [SemanaReferencia] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoOcasSeguimientoForGrid(Tipo?: OcaSeguimientoTipoEnum, Kpi?: string, EstadoInicial?: string, EstadoTransitado?: string, AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoOcasSeguimientoForGrid(Tipo, Kpi, EstadoInicial, EstadoTransitado, AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado de PDS tipo Inspecciones visuales para select.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoPdsInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoPdsInspeccionesVisualesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de PDS con tipo prestador OCA para la grid de DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoPdsOcaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoPdsOcaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado unificado de actuaciones e inspecciones visuales del técnico
     * @param {string} [TrabajoTecnicoType] 
     * @param {number} [IdTrabajoTecnicoSortEnum] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoTrabajoTecnico(TrabajoTecnicoType?: string, IdTrabajoTecnicoSortEnum?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoTrabajoTecnico(TrabajoTecnicoType, IdTrabajoTecnicoSortEnum, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de ubicaciones OCA para la grid de DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoUbicacionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoUbicacionesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado de ubicaciones para select de inspecciones visuales.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoUbicacionesInspeccionesVisualesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoUbicacionesInspeccionesVisualesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el medallero de pagos para un PDS en un periodo
     * @param {Date} [FechaPeriodo] 
     * @param {string} [IdPds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMedalleroPorPds(FechaPeriodo?: Date, IdPds?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMedalleroPorPds(FechaPeriodo, IdPds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la media mensual de todos los PDS
     * @param {number} [Mes] 
     * @param {number} [Anyo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMediaMedalleroMensualPds(Mes?: number, Anyo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMediaMedalleroMensualPds(Mes, Anyo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la media mensual de todos los PDS por rango de fecha
     * @param {number} [MesInicio] 
     * @param {number} [AnioInicio] 
     * @param {number} [MesFin] 
     * @param {number} [AnioFin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMediaMedalleroMensualPdsPorRangoFecha(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMediaMedalleroMensualPdsPorRangoFecha(MesInicio, AnioInicio, MesFin, AnioFin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la media mensual de todos los PDS por rango de fecha
     * @param {number} [MesInicio] 
     * @param {number} [AnioInicio] 
     * @param {number} [MesFin] 
     * @param {number} [AnioFin] 
     * @param {string} [IdPds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMediaMedalleroMensualPdsPorRangoFechaPorPds(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, IdPds?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMediaMedalleroMensualPdsPorRangoFechaPorPds(MesInicio, AnioInicio, MesFin, AnioFin, IdPds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la media mensual de todos los PDS anonimizados, mostrando el nombre real solo para el PDS solicitado
     * @param {number} [Mes] 
     * @param {number} [Anyo] 
     * @param {string} [IdPds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMediaMensualPdsAnonimizado(Mes?: number, Anyo?: number, IdPds?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMediaMensualPdsAnonimizado(Mes, Anyo, IdPds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los mensajes del chat de una OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMensajesOca(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMensajesOca(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el modelo de pago del prestador seleccionado o del propio usuario
     * @param {string} [IdPds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getModeloPagoPrestador(IdPds?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getModeloPagoPrestador(IdPds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las modificaciones de CPs por periodo
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {number} [PeriodoSemanaIni] 
     * @param {number} [PeriodoAnoIni] 
     * @param {number} [PeriodoSemanaFin] 
     * @param {number} [PeriodoAnoFin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getModificacionesActivosPeriodoForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getModificacionesActivosPeriodoForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los ids de los motivos de cierre para la wo seleccionada
     * @param {string} [IdWorkOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMotivosCierreFromWo(IdWorkOrder?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMotivosCierreFromWo(IdWorkOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los motivos de cierre de Wo para correctivo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMotivosCierreWoCorrectivo(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMotivosCierreWoCorrectivo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DXLoadOptions} [Options] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMspsInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMspsInteroperabilidadForGrid(Options, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMspsInteroperabilidadLista(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMspsInteroperabilidadLista(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado de notificaciones del usuario actual (sin leer y leídas).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getNotificaciones(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getNotificaciones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las observaciones internas de gestores GMAO de una OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getObservacionesOca(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getObservacionesOca(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una OCA de centro de transformación.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOcaDetailCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOcaDetailCentroTransformacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una OCA de ubicación con sus ficheros.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOcaDetailUbicacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOcaDetailUbicacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la composición semanal de seguimiento de ocas, con los filtros proporcionados.
     * @param {number} [NumSemanas] 
     * @param {TipoOcaEnum} [IdTipoOca] 
     * @param {Array<number>} [IdsProvincia] 
     * @param {Array<number>} [IdsZona] 
     * @param {number} [AnioReferencia] 
     * @param {number} [SemanaReferencia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOcaSeguimientoComposicionSemanal(NumSemanas?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOcaSeguimientoComposicionSemanal(NumSemanas, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el heatmap de visitas de seguimiento de ocas, con los filtros proporcionados.
     * @param {number} [AnioComparacion] 
     * @param {number} [SemanaComparacion] 
     * @param {TipoOcaEnum} [IdTipoOca] 
     * @param {Array<number>} [IdsProvincia] 
     * @param {Array<number>} [IdsZona] 
     * @param {number} [AnioReferencia] 
     * @param {number} [SemanaReferencia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOcaSeguimientoHeatmapVisita(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOcaSeguimientoHeatmapVisita(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la información de los KPIs de seguimiento de ocas, con los filtros proporcionados.
     * @param {number} [AnioComparacion] 
     * @param {number} [SemanaComparacion] 
     * @param {TipoOcaEnum} [IdTipoOca] 
     * @param {Array<number>} [IdsProvincia] 
     * @param {Array<number>} [IdsZona] 
     * @param {number} [AnioReferencia] 
     * @param {number} [SemanaReferencia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOcaSeguimientoKpis(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOcaSeguimientoKpis(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Catálogo de semanas para seguimiento de ocas, ordenadas por año y semana descendientes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOcaSeguimientoSemanas(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOcaSeguimientoSemanas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las transiciones de seguimiento de ocas, con los filtros proporcionados.
     * @param {number} [AnioComparacion] 
     * @param {number} [SemanaComparacion] 
     * @param {TipoOcaEnum} [IdTipoOca] 
     * @param {Array<number>} [IdsProvincia] 
     * @param {Array<number>} [IdsZona] 
     * @param {number} [AnioReferencia] 
     * @param {number} [SemanaReferencia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOcaSeguimientoTransiciones(AnioComparacion?: number, SemanaComparacion?: number, IdTipoOca?: TipoOcaEnum, IdsProvincia?: Array<number>, IdsZona?: Array<number>, AnioReferencia?: number, SemanaReferencia?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOcaSeguimientoTransiciones(AnioComparacion, SemanaComparacion, IdTipoOca, IdsProvincia, IdsZona, AnioReferencia, SemanaReferencia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los origenes de ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOrigenesTicket(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOrigenesTicket(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rejilla de instalaciones B2C por mes.
     * @param {number} [Anio] 
     * @param {number} [Mes] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPagosB2cInstalaciones(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPagosB2cInstalaciones(Anio, Mes, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lista los meses ya importados de pagos B2C.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPagosB2cMeses(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPagosB2cMeses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rejilla de Pdte C3 B2C por mes.
     * @param {number} [Anio] 
     * @param {number} [Mes] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPagosB2cPdteC3(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPagosB2cPdteC3(Anio, Mes, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rejilla de reparaciones B2C por mes.
     * @param {number} [Anio] 
     * @param {number} [Mes] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPagosB2cReparaciones(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPagosB2cReparaciones(Anio, Mes, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rejilla de visitas B2C por mes.
     * @param {number} [Anio] 
     * @param {number} [Mes] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPagosB2cVisitas(Anio?: number, Mes?: number, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPagosB2cVisitas(Anio, Mes, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de devengado mensual por partner para la rejilla general.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnerDevengadoForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnerDevengadoForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el devengado agrupado por partner, año, sociedad y región.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnerDevengadoPorAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnerDevengadoPorAnioForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el devengado agrupado por sociedad y año.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnerDevengadoPorSociedadAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnerDevengadoPorSociedadAnioForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el devengado agrupado por sociedad y mes.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnerDevengadoPorSociedadForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnerDevengadoPorSociedadForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de partners para el usuario
     * @param {string} [IdUsuarioBd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnerPorUsuarioBd(IdUsuarioBd?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnerPorUsuarioBd(IdUsuarioBd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de partners para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnersForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnersForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de partners para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnersForGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnersForGridAdmin(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de partners para el usuario
     * @param {string} [IdUsuario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnersPorUsuario(IdUsuario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnersPorUsuario(IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el partner asociado al usuario BD
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdUsuario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnersPorUsuarioBdForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnersPorUsuarioBdForGrid(LoadOptions, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de partners asociado al usuario
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdUsuario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPartnersPorUsuarioForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPartnersPorUsuarioForGrid(LoadOptions, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los pds asogiados a un código postal concreto, por tipo de prestador
     * @param {string} [CodigoPostal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPdsByCodigoPostal(CodigoPostal?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPdsByCodigoPostal(CodigoPostal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el pds dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPdsById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPdsById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de pds asociado al usuario
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdUsuario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPdsPorUsuarioForGrid(LoadOptions?: DXLoadOptions, IdUsuario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPdsPorUsuarioForGrid(LoadOptions, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las piezas de Wo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPiezasWo(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPiezasWo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inspecciones de un técnico en una fecha, con su orden de visita.
     * @param {string} [IdTecnico] 
     * @param {string} [FechaProgramada] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPlanificacionTecnicoInspeccionVisual(IdTecnico?: string, FechaProgramada?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPlanificacionTecnicoInspeccionVisual(IdTecnico, FechaProgramada, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} IdTarifa 
     * @param {string} [TipoPotencia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPrecioReferenciaInteroperabilidad(IdTarifa: string, TipoPotencia?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPrecioReferenciaInteroperabilidad(IdTarifa, TipoPotencia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DXLoadOptions} [Options] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPreciosInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPreciosInteroperabilidadForGrid(Options, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las prioridades de ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPrioridadesTicket(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPrioridadesTicket(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Indica si se muestra la columna de estado en la rejilla de WO Revenue.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPuedeVerEstadoWoRevenue(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPuedeVerEstadoWoRevenue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el rango de fechas límite de OCAs accesibles para el usuario.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRangoFechaLimiteOcas(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRangoFechaLimiteOcas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las recargas
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRecargasGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRecargasGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las recargas
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRecargasGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRecargasGridAdmin(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el recuento de activos por periodo
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {number} [PeriodoSemanaIni] 
     * @param {number} [PeriodoAnoIni] 
     * @param {number} [PeriodoSemanaFin] 
     * @param {number} [PeriodoAnoFin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRecuentoActivosPeriodoForGrid(LoadOptions?: DXLoadOptions, PeriodoSemanaIni?: number, PeriodoAnoIni?: number, PeriodoSemanaFin?: number, PeriodoAnoFin?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRecuentoActivosPeriodoForGrid(LoadOptions, PeriodoSemanaIni, PeriodoAnoIni, PeriodoSemanaFin, PeriodoAnoFin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las semanas de recuento de activos disponibles para selector
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRecuentoActivosSemanasSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRecuentoActivosSemanasSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
     * @param {Date} [FechaPeriodo] 
     * @param {string} [IdPds] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRejillaMaestroPagosPorPrestador(FechaPeriodo?: Date, IdPds?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRejillaMaestroPagosPorPrestador(FechaPeriodo, IdPds, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
     * @param {Date} [FechaPeriodo] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRejillaMaestroPagosPorPrestadorPds(FechaPeriodo?: Date, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRejillaMaestroPagosPorPrestadorPds(FechaPeriodo, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de las piezas de Wo compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRejillaPiezasWo(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRejillaPiezasWo(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRejillaWoPorTicket(LoadOptions?: DXLoadOptions, IdTicket?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRejillaWoPorTicket(LoadOptions, IdTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios para SelectBox
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getResponsablesPrestadorSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getResponsablesPrestadorSelectBox(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de responsables de provincias para SelectBox
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getResponsablesProvinciasSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getResponsablesProvinciasSelectBox(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el resumen de horas por cola para un ticket
     * @param {string} [IdTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getResumenTiempoColas(IdTicket?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getResumenTiempoColas(IdTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos agregados para las gráficas donut del dashboard revenue (variable/fijo).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRevenueDashboardGraficas(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRevenueDashboardGraficas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de informes revenue para la rejilla general del dashboard.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRevenueInformesDashboardForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRevenueInformesDashboardForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de informes revenue agrupados por año, partner, región y sociedad para el dashboard.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRevenueInformesDashboardPorAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRevenueInformesDashboardPorAnioForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de informes revenue agrupados por sociedad y año para el dashboard.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRevenueInformesDashboardPorSociedadAnioForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRevenueInformesDashboardPorSociedadAnioForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de informes revenue agrupados por sociedad y periodo para el dashboard.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRevenueInformesDashboardPorSociedadForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRevenueInformesDashboardPorSociedadForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Indica si el usuario revenue self puede ver Work Orders y sustituciones (al menos un partner privado).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRevenueSelfPuedeVerWoSustituciones(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRevenueSelfPuedeVerWoSustituciones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el siguiente cargador del wizard de informe técnico.
     * @param {string} Id 
     * @param {string} [IdCargadorActual] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSiguienteCargadorInformeTecnicoIv(Id: string, IdCargadorActual?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSiguienteCargadorInformeTecnicoIv(Id, IdCargadorActual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
     * @param {number} [IdNumerico] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSiguienteComplianceWo(IdNumerico?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSiguienteComplianceWo(IdNumerico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el id de la siguiente Wo de la actuación seleccionada
     * @param {string} [IdActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSiguienteWoFromActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSiguienteWoFromActuacion(IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el id de la siguiente Wo a partir de una Wo de la misma actuacion
     * @param {string} [IdWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSiguienteWoFromWo(IdWo?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSiguienteWoFromWo(IdWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los subestados de ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSubestadosTicket(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSubestadosTicket(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de suscripciones para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSuscripcionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSuscripcionesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DXLoadOptions} [Options] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTarifasInteroperabilidadForGrid(Options?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTarifasInteroperabilidadForGrid(Options, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTarifasInteroperabilidadLista(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTarifasInteroperabilidadLista(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios para SelectBox
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTecnicosPrestadorSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTecnicosPrestadorSelectBox(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de todos los tenants, utilizando paginación
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTenants(Take?: number, Skip?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTenants(Take, Skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtiene un listado de los tenants, ordneados por los suscritos
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdUsuario] 
     * @param {string} [Email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTenantsOrderSuscrito(LoadOptions?: DXLoadOptions, IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTenantsOrderSuscrito(LoadOptions, IdUsuario, Email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtienen los tenant
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTenantsRm(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTenantsRm(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Tickets y KO asociados del compliance de una inspección visual.
     * @param {string} Id 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTicketsComplianceInspeccionVisualForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTicketsComplianceInspeccionVisualForGrid(Id, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo activo de tipología/subtipología de incidencia (selector unificado)
     * @param {boolean} [ExcluirSoloCreacionEdicion] 
     * @param {boolean} [SoloAsistenciaSat] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTipologiasSubtipologiasIncidencia(ExcluirSoloCreacionEdicion?: boolean, SoloAsistenciaSat?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTipologiasSubtipologiasIncidencia(ExcluirSoloCreacionEdicion, SoloAsistenciaSat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Catálogo de tipologías/subtipologías de incidencia para tipificar WOs
     * @param {boolean} [ExcluirSoloCreacionEdicion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTipologiasSubtipologiasIncidenciaExterno(ExcluirSoloCreacionEdicion?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTipologiasSubtipologiasIncidenciaExterno(ExcluirSoloCreacionEdicion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el catálogo de tipos de infraestructura de cargador.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTiposInfraestructuraCargador(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTiposInfraestructuraCargador(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los tipos de ticket (asistencia / incidencia)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTiposTicket(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTiposTicket(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de tipos de indisponibilidad disponibles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTiposUnavailable(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTiposUnavailable(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de los tipos de urgencia de actuación para su uso en un selector.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTiposUrgenciaActuacionSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTiposUrgenciaActuacionSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de la transaccion dado su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTransaccionById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTransaccionById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las transacciones
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTransaccionesGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTransaccionesGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las transacciones
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTransaccionesGridAdmin(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTransaccionesGridAdmin(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una ubicación OCA.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUbicacionById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUbicacionById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de las ubicaciones de los activos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUbicacionesActivos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUbicacionesActivos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de gestores GMAO para SelectBox
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuarioBdSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuarioBdSelectBox(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios para SelectBox
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuariosSelectBox(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuariosSelectBox(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los id de usuarios técnicos del prestador del usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuariosTecnicos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuariosTecnicos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos de la validacion de una actuacion
     * @param {string} [IdActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getValidacionActuacion(IdActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getValidacionActuacion(IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos de la validacion de una wo
     * @param {string} [IdWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getValidacionWo(IdWo?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getValidacionWo(IdWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de las visitas de una OCA de centro de transformación.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getVisitasOcaCentroTransformacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getVisitasOcaCentroTransformacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de las visitas de una OCA de ubicación con sus ficheros.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getVisitasOcaUbicacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getVisitasOcaUbicacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado agrupado por empresa con porcentaje e importe real
     * @param {number} [MesInicio] 
     * @param {number} [AnioInicio] 
     * @param {number} [MesFin] 
     * @param {number} [AnioFin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getVolumenPorEmpresasPorRangoFechas(MesInicio?: number, AnioInicio?: number, MesFin?: number, AnioFin?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getVolumenPorEmpresasPorRangoFechas(MesInicio, AnioInicio, MesFin, AnioFin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de pds para el usuario
     * @param {string} [IdUsuario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getdPdsPorUsuario(IdUsuario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getdPdsPorUsuario(IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GuardarMspInteroperabilidadModel} [GuardarMspInteroperabilidadModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public guardarMspInteroperabilidad(GuardarMspInteroperabilidadModel?: GuardarMspInteroperabilidadModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).guardarMspInteroperabilidad(GuardarMspInteroperabilidadModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GuardarMspTarifaInteroperabilidadModel} [GuardarMspTarifaInteroperabilidadModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public guardarMspTarifaInteroperabilidad(GuardarMspTarifaInteroperabilidadModel?: GuardarMspTarifaInteroperabilidadModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).guardarMspTarifaInteroperabilidad(GuardarMspTarifaInteroperabilidadModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Guarda el paso de un cargador del informe técnico (checks).
     * @param {string} Id 
     * @param {string} IdCargador 
     * @param {GuardarPasoInformeTecnicoIvModel} Datos 
     * @param {Array<File>} [Archivos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public guardarPasoCargadorInformeTecnicoInspeccionVisual(Id: string, IdCargador: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).guardarPasoCargadorInformeTecnicoInspeccionVisual(Id, IdCargador, Datos, Archivos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Guarda el paso de ubicación del informe técnico (checks + incidencia).
     * @param {string} Id 
     * @param {GuardarPasoInformeTecnicoIvModel} Datos 
     * @param {Array<File>} [Archivos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public guardarPasoUbicacionInformeTecnicoInspeccionVisual(Id: string, Datos: GuardarPasoInformeTecnicoIvModel, Archivos?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).guardarPasoUbicacionInformeTecnicoInspeccionVisual(Id, Datos, Archivos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GuardarRecargaTarifaInteroperabilidadModel} [GuardarRecargaTarifaInteroperabilidadModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public guardarRecargaTarifaInteroperabilidad(GuardarRecargaTarifaInteroperabilidadModel?: GuardarRecargaTarifaInteroperabilidadModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).guardarRecargaTarifaInteroperabilidad(GuardarRecargaTarifaInteroperabilidadModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GuardarRecargaTarifaPrecioInteroperabilidadModel} [GuardarRecargaTarifaPrecioInteroperabilidadModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public guardarRecargaTarifaPrecioInteroperabilidad(GuardarRecargaTarifaPrecioInteroperabilidadModel?: GuardarRecargaTarifaPrecioInteroperabilidadModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).guardarRecargaTarifaPrecioInteroperabilidad(GuardarRecargaTarifaPrecioInteroperabilidadModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero XLSX para importar los certificados de visita
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importarCertificadosVisita(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importarCertificadosVisita(Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Importa los pares cliente-cargador de un XLSX inicial
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importarClientesCargadores(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importarClientesCargadores(Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero XLSX para importar el recuento de activos
     * @param {string} [UrlFichero] 
     * @param {number} [NumSemana] 
     * @param {number} [NumMes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importarRecuentoActivosFromXCustomer(UrlFichero?: string, NumSemana?: number, NumMes?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importarRecuentoActivosFromXCustomer(UrlFichero, NumSemana, NumMes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero CSV para importar las WOs urgentes de xCustomer
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importarWosUrgentesFromXCustomer(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importarWosUrgentesFromXCustomer(Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una inspección visual externa (prestador).
     * @param {CreateInspeccionVisualExternaModel} [CreateInspeccionVisualExternaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public inspeccionVisualCreateExterna(CreateInspeccionVisualExternaModel?: CreateInspeccionVisualExternaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).inspeccionVisualCreateExterna(CreateInspeccionVisualExternaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una inspección visual interna (Endesa).
     * @param {CreateInspeccionVisualInternaModel} [CreateInspeccionVisualInternaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public inspeccionVisualCreateInterna(CreateInspeccionVisualInternaModel?: CreateInspeccionVisualInternaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).inspeccionVisualCreateInterna(CreateInspeccionVisualInternaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita cabecera de una inspección visual.
     * @param {EditInspeccionVisualModel} [EditInspeccionVisualModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public inspeccionVisualEdit(EditInspeccionVisualModel?: EditInspeccionVisualModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).inspeccionVisualEdit(EditInspeccionVisualModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la cabecera de una inspección visual para edición.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public inspeccionVisualGet(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).inspeccionVisualGet(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una OCA de tipo centro de transformación.
     * @param {CreateOcaCentroTransformacionModel} [CreateOcaCentroTransformacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ocaCentroTransformacionCreate(CreateOcaCentroTransformacionModel?: CreateOcaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ocaCentroTransformacionCreate(CreateOcaCentroTransformacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una OCA de tipo centro de transformación.
     * @param {EditOcaCentroTransformacionModel} [EditOcaCentroTransformacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ocaCentroTransformacionEdit(EditOcaCentroTransformacionModel?: EditOcaCentroTransformacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ocaCentroTransformacionEdit(EditOcaCentroTransformacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una OCA de tipo ubicación.
     * @param {CreateOcaUbicacionModel} [CreateOcaUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ocaUbicacionCreate(CreateOcaUbicacionModel?: CreateOcaUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ocaUbicacionCreate(CreateOcaUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una OCA de tipo ubicación.
     * @param {EditOcaUbicacionModel} [EditOcaUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ocaUbicacionEdit(EditOcaUbicacionModel?: EditOcaUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ocaUbicacionEdit(EditOcaUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo partner
     * @param {CreatePartnerModel} [CreatePartnerModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public partnerCreate(CreatePartnerModel?: CreatePartnerModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).partnerCreate(CreatePartnerModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un partner existente
     * @param {EditPartnerModel} [EditPartnerModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public partnerEdit(EditPartnerModel?: EditPartnerModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).partnerEdit(EditPartnerModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo PDS
     * @param {CreatePdsModel} [CreatePdsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public pdsCreate(CreatePdsModel?: CreatePdsModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).pdsCreate(CreatePdsModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un PDS existente
     * @param {EditPdsModel} [EditPdsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public pdsEdit(EditPdsModel?: EditPdsModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).pdsEdit(EditPdsModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de Pds compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public pdsGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).pdsGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un fichero a la actuación.
     * @param {string} Id 
     * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postAdjuntoActuacion(Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postAdjuntoActuacion(Id, TipoDocumento, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un fichero a la work order. Tipos: Cuadro eléctrico, Cargador, Número serie, Prueba termográfica, Informe técnico, Informe económico, Otros.
     * @param {string} IdWorkOrder 
     * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
     * @param {string} [Descripcion] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postAdjuntoExternoWo(IdWorkOrder: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postAdjuntoExternoWo(IdWorkOrder, TipoDocumento, Descripcion, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un fichero al ticket.
     * @param {string} Id 
     * @param {CategoriaAdjuntoTicketApiEnum} [CategoriaDocumento] 
     * @param {string} [Descripcion] 
     * @param {boolean} [OmitirHistorico] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postAdjuntoTicket(Id: string, CategoriaDocumento?: CategoriaAdjuntoTicketApiEnum, Descripcion?: string, OmitirHistorico?: boolean, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postAdjuntoTicket(Id, CategoriaDocumento, Descripcion, OmitirHistorico, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un fichero a la work order.
     * @param {string} Id 
     * @param {TipoAdjuntoIntervencionEnum} [TipoDocumento] 
     * @param {string} [Descripcion] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postAdjuntoWo(Id: string, TipoDocumento?: TipoAdjuntoIntervencionEnum, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postAdjuntoWo(Id, TipoDocumento, Descripcion, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se desuscribe al Cargador seleccionado
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postCargarFicheroPartners(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postCargarFicheroPartners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero de forma temporal.
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postDocumentoTemp(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postDocumentoTemp(Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero para crear usuarios
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postDocumentoUsuarios(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postDocumentoUsuarios(Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un evento de edición de datos del ticket con mensaje y observación combinados.
     * @param {string} Id 
     * @param {CreateHistoricoEdicionTicketModel} [CreateHistoricoEdicionTicketModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postHistoricoEdicionTicket(Id: string, CreateHistoricoEdicionTicketModel?: CreateHistoricoEdicionTicketModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postHistoricoEdicionTicket(Id, CreateHistoricoEdicionTicketModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un informe económico a la actuación
     * @param {string} IdActuacion 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postInformeEconomicoActuacion(IdActuacion: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postInformeEconomicoActuacion(IdActuacion, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta el informe de la WO; el económico requiere importe y recalcula el coste sin cerrar la WO
     * @param {string} IdWorkOrder 
     * @param {TipoInformeWoExternoEnum} [TipoInforme] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {number} [ImporteWo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postInformeWorkOrder(IdWorkOrder: string, TipoInforme?: TipoInformeWoExternoEnum, Filename?: string, File?: File, ImporteWo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postInformeWorkOrder(IdWorkOrder, TipoInforme, Filename, File, ImporteWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Importa los 4 Excel de pagos B2C para un mes (reemplaza si ya existe).
     * @param {number} [Anio] 
     * @param {number} [Mes] 
     * @param {File} [Instalaciones] 
     * @param {File} [Reparaciones] 
     * @param {File} [Visitas] 
     * @param {File} [PdteC3] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postPagosB2cImportar(Anio?: number, Mes?: number, Instalaciones?: File, Reparaciones?: File, Visitas?: File, PdteC3?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postPagosB2cImportar(Anio, Mes, Instalaciones, Reparaciones, Visitas, PdteC3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube 3 excels (Activos/Oportunidades/Contactos) y devuelve un preview parseado.
     * @param {string} [IdCorrelacion] 
     * @param {File} [Activos] 
     * @param {File} [Oportunidades] 
     * @param {File} [Contactos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postPartnersCargarExcels(IdCorrelacion?: string, Activos?: File, Oportunidades?: File, Contactos?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postPartnersCargarExcels(IdCorrelacion, Activos, Oportunidades, Contactos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prepara el informe técnico (cargadores y checklist) con datos actuales.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public prepararInformeTecnicoInspeccionVisual(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).prepararInformeTecnicoInspeccionVisual(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary TEMP AL-513 — Preview cálculo coste actuación (sin persistir)
     * @param {string} IdActuacion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public previewCalculoCosteActuacion(IdActuacion: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).previewCalculoCosteActuacion(IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna fecha de programación y técnico de una o más inspecciones visuales.
     * @param {ProgramarFechaInspeccionVisualModel} [ProgramarFechaInspeccionVisualModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public programarFechaInspeccionVisual(ProgramarFechaInspeccionVisualModel?: ProgramarFechaInspeccionVisualModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).programarFechaInspeccionVisual(ProgramarFechaInspeccionVisualModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Programa la fecha de la visita pendiente de una OCA.
     * @param {ProgramarFechaVisitaModel} [ProgramarFechaVisitaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public programarFechaVisita(ProgramarFechaVisitaModel?: ProgramarFechaVisitaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).programarFechaVisita(ProgramarFechaVisitaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita el importe de un informe de canon fija (solo Admin Revenue)
     * @param {string} Id 
     * @param {EditarImporteFijoTransaccionModel} [EditarImporteFijoTransaccionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public putEditarImporteFijoTransaccion(Id: string, EditarImporteFijoTransaccionModel?: EditarImporteFijoTransaccionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).putEditarImporteFijoTransaccion(Id, EditarImporteFijoTransaccionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza un evento cargador
     * @param {EditEventoCargadorModel} [EditEventoCargadorModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public putEventoCargador(EditEventoCargadorModel?: EditEventoCargadorModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).putEventoCargador(EditEventoCargadorModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reabre un ticket cerrado con un nuevo estado, subestado y cola, registrando el evento en el histórico.
     * @param {ReabrirTicketModel} [ReabrirTicketModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public reabrirTicket(ReabrirTicketModel?: ReabrirTicketModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).reabrirTicket(ReabrirTicketModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca todas las notificaciones del usuario como leídas.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public readAllNotificaciones(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).readAllNotificaciones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca una notificación como leída.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public readNotificacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).readNotificacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresca el estado del cargador
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public refreshCargadorStatus(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).refreshCargadorStatus(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resuelve el prestador sugerido al crear actuación (tramo provincia/potencia y código postal)
     * @param {ResolvePdsNuevaActuacionModel} [ResolvePdsNuevaActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public resolvePdsNuevaActuacion(ResolvePdsNuevaActuacionModel?: ResolvePdsNuevaActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).resolvePdsNuevaActuacion(ResolvePdsNuevaActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reanuda la periodicidad de una IV pausada y crea la siguiente con la fecha objetivo indicada.
     * @param {string} Id 
     * @param {ResumirPeriodicidadInspeccionVisualModel} [ResumirPeriodicidadInspeccionVisualModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public resumirPeriodicidadInspeccionVisual(Id: string, ResumirPeriodicidadInspeccionVisualModel?: ResumirPeriodicidadInspeccionVisualModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).resumirPeriodicidadInspeccionVisual(Id, ResumirPeriodicidadInspeccionVisualModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de roles del sistema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rolesGetAll(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rolesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece la aptitud de un cargador para inspecciones visuales
     * @param {string} Id 
     * @param {boolean} [AptoInspeccionVisual] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setAptoInspeccionVisualCargador(Id: string, AptoInspeccionVisual?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setAptoInspeccionVisualCargador(Id, AptoInspeccionVisual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Guarda la calidad de una inspección visual sin resolver el compliance.
     * @param {string} Id 
     * @param {SetCalidadInspeccionVisualModel} [SetCalidadInspeccionVisualModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setCalidadInspeccionVisual(Id: string, SetCalidadInspeccionVisualModel?: SetCalidadInspeccionVisualModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setCalidadInspeccionVisual(Id, SetCalidadInspeccionVisualModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca un cargador como disponible
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setCargadorAvailable(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setCargadorAvailable(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca un cargador como dismissed
     * @param {string} Id 
     * @param {SetCargadorDismissedModel} [SetCargadorDismissedModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setCargadorDismissed(Id: string, SetCargadorDismissedModel?: SetCargadorDismissedModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setCargadorDismissed(Id, SetCargadorDismissedModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece el tipo de indisponibilidad de un cargador
     * @param {string} Id 
     * @param {number} [IdTipoUnavailable] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setCargadorUnavailable(Id: string, IdTipoUnavailable?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setCargadorUnavailable(Id, IdTipoUnavailable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca o desmarca un cargador como visible en la app
     * @param {string} Id 
     * @param {boolean} [VisibleInApp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setCargadorVisibleInApp(Id: string, VisibleInApp?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setCargadorVisibleInApp(Id, VisibleInApp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resuelve el compliance de una inspección visual externa.
     * @param {string} Id 
     * @param {SetComplianceInspeccionVisualModel} [SetComplianceInspeccionVisualModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setComplianceInspeccionVisual(Id: string, SetComplianceInspeccionVisualModel?: SetComplianceInspeccionVisualModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setComplianceInspeccionVisual(Id, SetComplianceInspeccionVisualModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece los datos de compliance de una work order
     * @param {string} Id 
     * @param {SetComplianceWoModel} [SetComplianceWoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setComplianceWo(Id: string, SetComplianceWoModel?: SetComplianceWoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setComplianceWo(Id, SetComplianceWoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de subestados
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public subestadosGetAll(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).subestadosGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtiene un listado de los informes suscritos del usuario
     * @param {string} [IdUsuario] 
     * @param {string} [Email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public suscripcionInformesPorUsuario(IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).suscripcionInformesPorUsuario(IdUsuario, Email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se cargan las suscripciones para el usuario seleccionado
     * @param {AddSuscripcionPorUsuarioModel} [AddSuscripcionPorUsuarioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public suscripcionesCreate(AddSuscripcionPorUsuarioModel?: AddSuscripcionPorUsuarioModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).suscripcionesCreate(AddSuscripcionPorUsuarioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se editan las suscripciones para el usuario seleccionado
     * @param {DeleteSuscripcionesPorUsuarioModel} [DeleteSuscripcionesPorUsuarioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public suscripcionesDelete(DeleteSuscripcionesPorUsuarioModel?: DeleteSuscripcionesPorUsuarioModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).suscripcionesDelete(DeleteSuscripcionesPorUsuarioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se editan las suscripciones para el usuario seleccionado
     * @param {EditSuscripcionPorUsuarioModel} [EditSuscripcionPorUsuarioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public suscripcionesPut(EditSuscripcionPorUsuarioModel?: EditSuscripcionPorUsuarioModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).suscripcionesPut(EditSuscripcionPorUsuarioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se suscribe al tenant seleccionado
     * @param {string} [IdTenant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public tenantSubscribe(IdTenant?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).tenantSubscribe(IdTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se desuscribe al tenant seleccionado
     * @param {string} [IdTenant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public tenantUnsubscribe(IdTenant?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).tenantUnsubscribe(IdTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de tenants con sus estados y suscripciones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public tenantsEstadosSuscripciones(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).tenantsEstadosSuscripciones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Se obtiene un listado de los tenants suscritos del usuario
     * @param {string} [IdUsuario] 
     * @param {string} [Email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public tenantsPorUsuario(IdUsuario?: string, Email?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).tenantsPorUsuario(IdUsuario, Email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una ubicación OCA.
     * @param {CreateUbicacionModel} [CreateUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ubicacionCreate(CreateUbicacionModel?: CreateUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ubicacionCreate(CreateUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una ubicación OCA.
     * @param {EditUbicacionModel} [EditUbicacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ubicacionEdit(EditUbicacionModel?: EditUbicacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ubicacionEdit(EditUbicacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza el tipo de intervalo de una actuación
     * @param {UpdateIntervaloActuacionModel} [UpdateIntervaloActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public updateIntervaloActuacion(UpdateIntervaloActuacionModel?: UpdateIntervaloActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).updateIntervaloActuacion(UpdateIntervaloActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un email de usuario está disponible
     * @param {string} Email 
     * @param {string} IdUsuario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioCheckEmail(Email: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioCheckEmail(Email, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un nombre de usuario está disponible
     * @param {string} Username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioCheckUsername(Username: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioCheckUsername(Username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un usuario existente
     * @param {DeleteUserModel} [DeleteUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioDelete(DeleteUserModel?: DeleteUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioDelete(DeleteUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el perfil del usuario actual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGetCurrentUserProfile(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGetCurrentUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las preferencias de notificación del usuario actual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGetPreferenciasNotificacion(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGetPreferenciasNotificacion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de usuarios compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo usuario
     * @param {CreateUserGmaoModel} [CreateUserGmaoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGmaoCreate(CreateUserGmaoModel?: CreateUserGmaoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGmaoCreate(CreateUserGmaoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un usuario existente
     * @param {EditUserGmaoModel} [EditUserGmaoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGmaoEdit(EditUserGmaoModel?: EditUserGmaoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGmaoEdit(EditUserGmaoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reactiva un usuario deshabilitado
     * @param {ReactivateUserModel} [ReactivateUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioReactivate(ReactivateUserModel?: ReactivateUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioReactivate(ReactivateUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo usuario
     * @param {CreateUserModel} [CreateUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioRevenueCreate(CreateUserModel?: CreateUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioRevenueCreate(CreateUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un usuario existente
     * @param {EditUserModel} [EditUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioRevenueEdit(EditUserModel?: EditUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioRevenueEdit(EditUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza las preferencias de notificación del usuario actual
     * @param {PreferenciasNotificacionModel} [PreferenciasNotificacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioUpdatePreferenciasNotificacion(PreferenciasNotificacionModel?: PreferenciasNotificacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioUpdatePreferenciasNotificacion(PreferenciasNotificacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validar una actuacion
     * @param {ValidarActuacionModel} [ValidarActuacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public validarActuacion(ValidarActuacionModel?: ValidarActuacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).validarActuacion(ValidarActuacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validar una wo
     * @param {ValidarWoModel} [ValidarWoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public validarWo(ValidarWoModel?: ValidarWoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).validarWo(ValidarWoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una wo existente
     * @param {EditWoModel} [EditWoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woEdit(EditWoModel?: EditWoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woEdit(EditWoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruta del informe técnico de una WO asociada a un cargador (SAT/activos, sin otros documentos)
     * @param {string} IdWo 
     * @param {string} [IdCargador] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetInformeTecnicoFromCargador(IdWo: string, IdCargador?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetInformeTecnicoFromCargador(IdWo, IdCargador, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruta del informe técnico de una WO asociada a un ticket (SAT/ticketing, sin otros documentos)
     * @param {string} IdWo 
     * @param {string} [IdTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetInformeTecnicoFromTicket(IdWo: string, IdTicket?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetInformeTecnicoFromTicket(IdWo, IdTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruta del informe técnico de una WO (Revenue Activos, sin otros documentos)
     * @param {string} IdWo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetInformeTecnicoRevenue(IdWo: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetInformeTecnicoRevenue(IdWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruta del informe técnico de una WO con sustitución (solo Revenue, sin otros documentos)
     * @param {string} IdWo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetInformeTecnicoSustitucionRevenue(IdWo: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetInformeTecnicoSustitucionRevenue(IdWo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme, sin filtrar por el Id de la actuación
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por una fecha inicio y una fecha fin
     * @param {Date} [FechaInicio] 
     * @param {Date} [FechaFin] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetRejillaMaestroPagosWo(FechaInicio?: Date, FechaFin?: Date, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetRejillaMaestroPagosWo(FechaInicio, FechaFin, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdActuacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetRejillaPorActuacion(LoadOptions?: DXLoadOptions, IdActuacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetRejillaPorActuacion(LoadOptions, IdActuacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdCargador
     * @param {string} [IdCargador] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetRejillaPorIdCargador(IdCargador?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetRejillaPorIdCargador(IdCargador, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de wo compatible con DexExtreme, filtrado por el IdTicket
     * @param {string} [IdTicket] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetRejillaPorIdTicket(IdTicket?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetRejillaPorIdTicket(IdTicket, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado DevExtreme de WO para Revenue (campos limitados)
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetRejillaWoRevenue(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetRejillaWoRevenue(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado DevExtreme de WO con sustitución de cargador (Activos)
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public woGetRejillaWoSustitucion(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).woGetRejillaWoSustitucion(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de zonas del sistema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public zonasGetAll(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).zonasGetAll(options).then((request) => request(this.axios, this.basePath));
    }
}



